/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 123);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return quarterPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return exp; });
/* unused harmony export floor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return pow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return tan; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
/* harmony export (immutable) */ __webpack_exports__["m"] = haversin;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_creator__ = __webpack_require__(41);
/* unused harmony reexport creator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_local__ = __webpack_require__(228);
/* unused harmony reexport local */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_matcher__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_matcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_mouse__ = __webpack_require__(229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_namespace__ = __webpack_require__(42);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_namespace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_namespaces__ = __webpack_require__(43);
/* unused harmony reexport namespaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_select__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__src_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_selectAll__ = __webpack_require__(258);
/* unused harmony reexport selectAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_selection_index__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__src_selection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_selector__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__src_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_selectorAll__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_10__src_selectorAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_selection_style__ = __webpack_require__(101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_11__src_selection_style__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_touch__ = __webpack_require__(259);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_12__src_touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_touches__ = __webpack_require__(260);
/* unused harmony reexport touches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_window__ = __webpack_require__(48);
/* unused harmony reexport window */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_selection_on__ = __webpack_require__(45);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__src_selection_on__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_15__src_selection_on__["a"]; });


















/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(118);
var isBuffer = __webpack_require__(335);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__datum__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__on__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__dispatch__ = __webpack_require__(257);






























var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["b" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_26__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_27__on__["b" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_28__dispatch__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["b"] = (selection);


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCHEDULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STARTING; });
/* unused harmony export STARTED */
/* unused harmony export RUNNING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENDED; });
/* harmony export (immutable) */ __webpack_exports__["g"] = init;
/* harmony export (immutable) */ __webpack_exports__["h"] = set;
/* harmony export (immutable) */ __webpack_exports__["f"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_timer__ = __webpack_require__(105);



var emptyOn = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ __webpack_exports__["e"] = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
  return schedule;
}

function set(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" /* timer */])(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projection;
/* harmony export (immutable) */ __webpack_exports__["b"] = projectionMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clip_circle__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clip_rectangle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compose__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotation__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fit__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resample__ = __webpack_require__(215);











var transformRadians = Object(__WEBPACK_IMPORTED_MODULE_7__transform__["a" /* transformer */])({
  point: function(x, y) {
    this.stream.point(x * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], y * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
  }
});

function transformRotate(rotate) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__transform__["a" /* transformer */])({
    point: function(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */], // clip angle
      x0 = null, y0, x1, y1, postclip = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */], // clip extent
      delta2 = 0.5, projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };

  projection.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };

  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? Object(__WEBPACK_IMPORTED_MODULE_1__clip_circle__["a" /* default */])(theta = _ * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]) : (theta = null, __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */]), reset()) : theta * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */];
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_2__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], phi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], recenter()) : [lambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], phi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaPhi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaGamma = _.length > 2 ? _[2] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */] : 0, recenter()) : [deltaLambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaPhi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaGamma * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2 = _ * _), reset()) : Object(__WEBPACK_IMPORTED_MODULE_5__math__["u" /* sqrt */])(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["a" /* fitExtent */])(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["b" /* fitSize */])(projection, size, object);
  };

  function recenter() {
    projectRotate = Object(__WEBPACK_IMPORTED_MODULE_3__compose__["a" /* default */])(rotate = Object(__WEBPACK_IMPORTED_MODULE_6__rotation__["b" /* rotateRadians */])(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() {}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(79);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(14);
/* unused harmony reexport ascending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(80);
/* unused harmony reexport bisector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(188);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(189);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(82);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(84);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(190);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(193);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(194);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(88);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(195);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(196);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(197);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(89);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(81);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(199);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(35);
/* unused harmony reexport quantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(86);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(200);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(201);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(202);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(90);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(83);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(203);
/* unused harmony reexport zip */





























/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transition;
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["b"] = newId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attr__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attrTween__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delay__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__duration__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ease__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__merge__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__on__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__remove__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__select__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectAll__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selection__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styleTween__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__text__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__transition__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tween__ = __webpack_require__(23);



















var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */])().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: __WEBPACK_IMPORTED_MODULE_10__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_11__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_6__filter__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_7__merge__["a" /* default */],
  selection: __WEBPACK_IMPORTED_MODULE_12__selection__["a" /* default */],
  transition: __WEBPACK_IMPORTED_MODULE_16__transition__["a" /* default */],
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: __WEBPACK_IMPORTED_MODULE_8__on__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_1__attr__["a" /* default */],
  attrTween: __WEBPACK_IMPORTED_MODULE_2__attrTween__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */],
  styleTween: __WEBPACK_IMPORTED_MODULE_14__styleTween__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_15__text__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_9__remove__["a" /* default */],
  tween: __WEBPACK_IMPORTED_MODULE_17__tween__["a" /* default */],
  delay: __WEBPACK_IMPORTED_MODULE_3__delay__["a" /* default */],
  duration: __WEBPACK_IMPORTED_MODULE_4__duration__["a" /* default */],
  ease: __WEBPACK_IMPORTED_MODULE_5__ease__["a" /* default */]
};


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(66);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(34);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(64);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(67);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(19);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(68);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(174);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_10__src_zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(63);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(179);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(180);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(181);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(182);
/* unused harmony reexport interpolateCubehelix */
/* unused harmony reexport interpolateCubehelixLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(183);
/* unused harmony reexport quantize */



















/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Adder;
});

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(65);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = spherical;
/* harmony export (immutable) */ __webpack_exports__["a"] = cartesian;
/* harmony export (immutable) */ __webpack_exports__["d"] = cartesianDot;
/* harmony export (immutable) */ __webpack_exports__["c"] = cartesianCross;
/* harmony export (immutable) */ __webpack_exports__["b"] = cartesianAddInPlace;
/* harmony export (immutable) */ __webpack_exports__["f"] = cartesianScale;
/* harmony export (immutable) */ __webpack_exports__["e"] = cartesianNormalizeInPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


function spherical(cartesian) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(cartesian[1], cartesian[0]), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  return [cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = azimuthalRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = azimuthalInvert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x),
        cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y),
        k = scale(cx * cy);
    return [
      k * cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x),
      k * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y),
        c = angle(z),
        sc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c),
        cc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(c);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x * sc, z * cc),
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z && y * sc / z)
    ];
  }
}


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rotateRadians;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



function rotationIdentity(lambda, phi) {
  return [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]) ? (deltaPhi || deltaGamma ? Object(__WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */])(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaPhi),
      sinDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaPhi),
      cosDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaGamma),
      sinDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ __webpack_exports__["a"] = (function(rotate) {
  rotate = rotateRadians(rotate[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate.length > 2 ? rotate[2] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */] : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  };

  return forward;
});


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clipRectangle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffer__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rejoin__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(8);






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 0 : 3
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x1) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 2 : 1
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[1] - y0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = Object(__WEBPACK_IMPORTED_MODULE_1__buffer__["a" /* default */])(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["b" /* merge */])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          Object(__WEBPACK_IMPORTED_MODULE_3__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (Object(__WEBPACK_IMPORTED_MODULE_2__line__["a" /* default */])(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformer;
/* unused harmony default export */ var _unused_webpack_default_export = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tweenValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(4);


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(node, id).value[name];
  };
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(52);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 25 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(138);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(30)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(65);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(33);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(17);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__ = __webpack_require__(216);




function conicEqualAreaRaw(y0, y1) {
  var sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0), n = (sy0 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return Object(__WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__["a" /* cylindricalEqualAreaRaw */])(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c) / n;

  function project(x, y) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c - 2 * n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)) / n;
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x *= n), r0 - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(r0y)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(r0y), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(5);



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] / 3,
      m = Object(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* projectionMutator */])(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi1 = _[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */]) : [phi0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], phi1 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  return p;
}


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fitExtent;
/* harmony export (immutable) */ __webpack_exports__["b"] = fitSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_bounds__ = __webpack_require__(94);



function fitExtent(projection, extent, object) {
  var w = extent[1][0] - extent[0][0],
      h = extent[1][1] - extent[0][1],
      clip = projection.clipExtent && projection.clipExtent();

  projection
      .scale(150)
      .translate([0, 0]);

  if (clip != null) projection.clipExtent(null);

  Object(__WEBPACK_IMPORTED_MODULE_0__stream__["a" /* default */])(object, projection.stream(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */]));

  var b = __WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */].result(),
      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;

  if (clip != null) projection.clipExtent(clip);

  return projection
      .scale(k * 150)
      .translate([x, y]);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mercatorRaw;
/* harmony export (immutable) */ __webpack_exports__["b"] = mercatorProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotation__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(5);




function mercatorRaw(lambda, phi) {
  return [lambda, Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(y)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
});

function mercatorProjection(project) {
  var m = Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] * scale(),
        t = m(Object(__WEBPACK_IMPORTED_MODULE_1__rotation__["a" /* default */])(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(43);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(43);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */][prefix], local: name} : name;
});


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(45);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["c" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return event; });
/* harmony export (immutable) */ __webpack_exports__["a"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dispatch__ = __webpack_require__(263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dispatch__["a"]; });



/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = now;
/* harmony export (immutable) */ __webpack_exports__["a"] = Timer;
/* harmony export (immutable) */ __webpack_exports__["c"] = timer;
/* unused harmony export timerFlush */
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(2);
var normalizeHeaderName = __webpack_require__(337);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(119);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(119);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.3
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
/*  */

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */


/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

var emptyObject = Object.freeze({});

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid$1 = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid$1++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.functionalContext = undefined;
  this.functionalOptions = undefined;
  this.functionalScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode, deep) {
  var componentOptions = vnode.componentOptions;
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.isCloned = true;
  if (deep) {
    if (vnode.children) {
      cloned.children = cloneVNodes(vnode.children, true);
    }
    if (componentOptions && componentOptions.children) {
      componentOptions.children = cloneVNodes(componentOptions.children, true);
    }
  }
  return cloned
}

function cloneVNodes (vnodes, deep) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i], deep);
  }
  return res
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
]
.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    var lower = key.toLowerCase();
    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
      warn(
        'Do not use built-in or reserved HTML elements as component ' +
        'id: ' + key
      );
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (false) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if (inBrowser && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both micro and macro tasks.
// In < 2.4 we used micro tasks everywhere, but there are some scenarios where
// micro tasks have too high a priority and fires in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using macro tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use micro task by default, but expose a way to force macro task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) Task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine MicroTask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a Task instead of a MicroTask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, cur, old, event;
  for (name in on) {
    cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.functionalContext === context) &&
      data && data.slot != null
    ) {
      var name = child.data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return node.isComment || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  vm._watcher = new Watcher(vm, updateComponent, noop);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = (parentVnode.data && parentVnode.data.attrs) || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options
) {
  this.vm = vm;
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
var seenObjects = new _Set();
function traverse (val) {
  seenObjects.clear();
  _traverse(val, seenObjects);
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || !Object.isExtensible(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  keyOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(keyOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    observerState.shouldConvert = false;
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    observerState.shouldConvert = true;
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
        ? Reflect.ownKeys(inject).filter(function (key) {
          /* istanbul ignore next */
          return Object.getOwnPropertyDescriptor(inject, key).enumerable
        })
        : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias,
  eventKeyName
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (keyCodes) {
    if (Array.isArray(keyCodes)) {
      return keyCodes.indexOf(eventKeyCode) === -1
    } else {
      return keyCodes !== eventKeyCode
    }
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  // static trees can be rendered once and cached on the contructor options
  // so every instance shares the same cached trees
  var options = this.$options;
  var cached = options.cached || (options.cached = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = options.staticRenderFns[index].call(this._renderProxy, null, this);
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm = Object.create(parent);
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode) {
        vnode.functionalScopeId = options._scopeId;
        vnode.functionalContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    vnode.functionalContext = contextVm;
    vnode.functionalOptions = options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }

  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var vnodeComponentOptions = vnode.componentOptions;
  var options = {
    _isComponent: true,
    parent: parent,
    propsData: vnodeComponentOptions.propsData,
    _componentTag: vnodeComponentOptions.tag,
    _parentVnode: vnode,
    _parentListeners: vnodeComponentOptions.listeners,
    _renderChildren: vnodeComponentOptions.children,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnodeComponentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    warn(
      'Avoid using non-primitive value as key, ' +
      'use string/number value instead.',
      context
    );
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force))) {
        applyNS(child, ns, force);
      }
    }
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // if the parent didn't update, the slot nodes will be the ones from
      // last render. They need to be cloned to ensure "freshness" for this render.
      for (var key in vm.$slots) {
        var slot = vm.$slots[key];
        if (slot._rendered) {
          vm.$slots[key] = cloneVNodes(slot, true /* deep */);
        }
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  opts.parent = options.parent;
  opts.propsData = options.propsData;
  opts._parentVnode = options._parentVnode;
  opts._parentListeners = options._parentListeners;
  opts._renderChildren = options._renderChildren;
  opts._componentTag = options._componentTag;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;
  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn(
          'Invalid component name: "' + name + '". Component names ' +
          'can only contain alphanumeric characters and the hyphen, ' +
          'and must start with a letter.'
        );
      }
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          if (type === 'component' && config.isReservedTag(id)) {
            warn(
              'Do not use built-in or reserved HTML elements as component ' +
              'id: ' + id
            );
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && cached$$1 !== current) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var vnode = getFirstComponentChild(this.$slots.default);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      if (name && (
        (this.exclude && matches(this.exclude, name)) ||
        (this.include && !matches(this.include, name))
      )) {
        return vnode
      }

      var ref = this;
      var cache = ref.cache;
      var keys = ref.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

Vue$3.version = '2.5.3';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);



var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  var inPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          inPre++;
        }
        if (
          !inPre &&
          !vnode.ns &&
          !(
            config.ignoredElements.length &&
            config.ignoredElements.some(function (ignore) {
              return isRegExp(ignore)
                ? ignore.test(tag)
                : ignore === tag
            })
          ) &&
          config.isUnknownElement(tag)
        ) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        inPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.functionalScopeId)) {
      nodeOps.setAttribute(vnode.elm, i, '');
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setAttribute(vnode.elm, i, '');
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.functionalContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
        } else {
          vnodeToMove = oldCh[idxInOld];
          /* istanbul ignore if */
          if (false) {
            warn(
              'It seems there are duplicate keys that is causing an update error. ' +
              'Make sure each v-for item has a unique key.'
            );
          }
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var bailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  var isRenderedModule = makeMap('attrs,style,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue) {
    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.elm = elm;
      vnode.isAsyncPlaceholder = true;
      return true
    }
    if (false) {
      if (!assertNodeMatch(elm, vnode)) {
        return false
      }
    }
    vnode.elm = elm;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                bailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                bailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        for (var key in data) {
          if (!isRenderedModule(key)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode) {
    if (isDef(vnode.tag)) {
      return (
        vnode.tag.indexOf('vue-component') === 0 ||
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE9 || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

/*  */















// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.

/*  */

/**
 * Cross-platform code generation for component v-model
 */


/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */

/*  */

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isDirty(elm, checkVal) ||
    isInputChanged(elm, checkVal)
  ))
}

function isDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isInputChanged (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers) && modifiers.number) {
    return toNumber(value) !== toNumber(newVal)
  }
  if (isDef(modifiers) && modifiers.trim) {
    return value.trim() !== newVal.trim()
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$options._renderChildren;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
Vue$3.nextTick(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if (false) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if (false
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

/* harmony default export */ __webpack_exports__["default"] = (Vue$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(25), __webpack_require__(124).setImmediate))

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 56 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(58);
var defined = __webpack_require__(59);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(155);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export feature */
/* harmony export (immutable) */ __webpack_exports__["b"] = object;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reverse__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transform__ = __webpack_require__(168);



/* harmony default export */ __webpack_exports__["a"] = (function(topology, o) {
  return o.type === "GeometryCollection"
      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature(topology, o); })}
      : feature(topology, o);
});

function feature(topology, o) {
  var id = o.id,
      bbox = o.bbox,
      properties = o.properties == null ? {} : o.properties,
      geometry = object(topology, o);
  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
}

function object(topology, o) {
  var transformPoint = Object(__WEBPACK_IMPORTED_MODULE_1__transform__["a" /* default */])(topology.transform),
      arcs = topology.arcs;

  function arc(i, points) {
    if (points.length) points.pop();
    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
      points.push(transformPoint(a[k], k));
    }
    if (i < 0) Object(__WEBPACK_IMPORTED_MODULE_0__reverse__["a" /* default */])(points, n);
  }

  function point(p) {
    return transformPoint(p);
  }

  function line(arcs) {
    var points = [];
    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
    return points;
  }

  function ring(arcs) {
    var points = line(arcs);
    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
    return points;
  }

  function polygon(arcs) {
    return arcs.map(ring);
  }

  function geometry(o) {
    var type = o.type, coordinates;
    switch (type) {
      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
      case "Point": coordinates = point(o.coordinates); break;
      case "MultiPoint": coordinates = o.coordinates.map(point); break;
      case "LineString": coordinates = line(o.arcs); break;
      case "MultiLineString": coordinates = o.arcs.map(line); break;
      case "Polygon": coordinates = polygon(o.arcs); break;
      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
      default: return null;
    }
    return {type: type, coordinates: coordinates};
  }

  return geometry(o);
}


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(31);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(31);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(19);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areaRingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areaStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(12);





var areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  sphere: function() {
    areaSum.add(__WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]), sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi);
}

function areaPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(adLambda),
      v = k * sdLambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(adLambda);
  areaRingSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  areaSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, areaStream);
  return areaSum * 2;
});


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rotation__ = __webpack_require__(20);





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      sinRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])([cosRadius, -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(t), -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(point), point[0] -= cosRadius;
  Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianNormalizeInPlace */])(point);
  var radius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) % __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var center = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([0, 0]),
      radius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(90),
      precision = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */], x[1] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */];
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */],
        p = precision.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */];
    ring = [];
    rotate = Object(__WEBPACK_IMPORTED_MODULE_3__rotation__["b" /* rotateRadians */])(-c[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], -c[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : precision;
  };

  return circle;
});


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */],
          delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - lambda0);
      if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) { // line crosses antimeridian
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - sign0) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda0 -= sign0 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; // handle degeneracies
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - sign1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda1 -= sign1 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */];
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0 - lambda1);
  return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(sinLambda0Lambda1) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]
      ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* atan */])((Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi0) * (cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi1)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda1)
          - Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi1) * (cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi0)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */];
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(0, phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(0, -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(from[0] - to[0]) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) {
    var lambda = from[0] < to[0] ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */];
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rejoin__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygonContains__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(8);






/* harmony default export */ __webpack_exports__["a"] = (function(pointVisible, clipLine, interpolate, start) {
  return function(sink) {
    var line = clipLine(sink),
        ringBuffer = Object(__WEBPACK_IMPORTED_MODULE_0__buffer__["a" /* default */])(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["b" /* merge */])(segments);
        var startInside = Object(__WEBPACK_IMPORTED_MODULE_3__polygonContains__["a" /* default */])(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          Object(__WEBPACK_IMPORTED_MODULE_1__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - b[1]);
}


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointEqual__ = __webpack_require__(77);


function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ __webpack_exports__["a"] = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (Object(__WEBPACK_IMPORTED_MODULE_0__pointEqual__["a" /* default */])(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] && Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */];
});


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);




var sum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(lambda), -Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
        sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi0),
        cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
          sinPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi1),
          cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */],
          k = sinPhi0 * sinPhi1;

      sum.add(Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* atan2 */])(k * sign * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(absDelta), cosPhi0 * cosPhi1 + k * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(absDelta)));
      angle += antimeridian ? delta + sign * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point0), Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point1));
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(arc);
        var intersection = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(normal, arc);
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] || angle < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] && sum < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) ^ (winding & 1);
});


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(80);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(14);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(83);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(17);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pointEqual__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(74);






/* harmony default export */ __webpack_exports__["a"] = (function(radius) {
  var cr = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      delta = 6 * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */],
      smallRadius = cr > 0,
      notHemisphere = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(cr) > __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    Object(__WEBPACK_IMPORTED_MODULE_1__circle__["a" /* circleStream */])(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point2) || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point1, point2)) {
            point1[0] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            point1[1] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(a),
        pb = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(pa, pb),
        n2n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(n1, n2),
        A = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n1, c1),
        B = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n2, c2);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, u),
        uu = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(u, u),
        t2 = w * w - uu * (Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, A) - 1);

    if (t2 < 0) return;

    var t = Object(__WEBPACK_IMPORTED_MODULE_2__math__["u" /* sqrt */])(t2),
        q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w - t) / uu);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q, A);
    q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */],
        meridian = polar || delta < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(q[0] - lambda0) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w + t) / uu);
      Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q1, A);
      return [q, Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */], radius - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]]);
});


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__length__ = __webpack_require__(93);


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return Object(__WEBPACK_IMPORTED_MODULE_0__length__["a" /* default */])(object);
});


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(12);





var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: lengthLineStart,
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */]
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
}

function lengthPointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi), cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda - lambda0),
      cosDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(delta),
      sinDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  lengthSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, lengthStream);
  return +lengthSum;
});


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(7);


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (boundsStream);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conicEqualArea__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__conicEqualArea__["a" /* default */])()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = equirectangularRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(5);


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(equirectangularRaw)
      .scale(152.63);
});


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["b"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = styleValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(48);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = yesdrag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noevent__ = __webpack_require__(103);



/* harmony default export */ __webpack_exports__["a"] = (function(view) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["f" /* select */])(view).on("dragstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
});

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["f" /* select */])(view).on("dragstart.drag", null);
  if (noclick) {
    selection.on("click.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
    setTimeout(function() { selection.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_schedule__ = __webpack_require__(4);


/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["d" /* STARTING */] && schedule.state < __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["b" /* ENDING */];
    schedule.state = __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["a" /* ENDED */];
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_timer__ = __webpack_require__(50);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["c"]; });
/* unused harmony reexport timerFlush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_timeout__ = __webpack_require__(271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_interval__ = __webpack_require__(272);
/* unused harmony reexport interval */







/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var c;
  return (typeof b === "number" ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateNumber */]
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateRgb */]
      : (c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateRgb */])
      : __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["e" /* interpolateString */])(a, b);
});


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transform;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
/* unused harmony export default */
function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity = new Transform(1, 0, 0);

transform.prototype = Transform.prototype;

function transform(node) {
  return node.__zoom || identity;
}


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(309);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateNumber */]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(316);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(111);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(315);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(52);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(115);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["m" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(115);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(334);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);
var settle = __webpack_require__(338);
var buildURL = __webpack_require__(340);
var parseHeaders = __webpack_require__(341);
var isURLSameOrigin = __webpack_require__(342);
var createError = __webpack_require__(120);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(343);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(344);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(339);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(126);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#au-sentiment-widget',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(125);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25), __webpack_require__(55)))

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ea8262e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(376);
function injectStyle (ssrContext) {
  __webpack_require__(127)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ea8262e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mapboundaries_json__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mapboundaries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_mapboundaries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_emojiData_json__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_emojiData_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_emojiData_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoadingOverlay_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MapSVG_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EmojiLegend_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            geodata: __WEBPACK_IMPORTED_MODULE_0__store_mapboundaries_json___default.a,
            results: null,
            emojiData: __WEBPACK_IMPORTED_MODULE_1__store_emojiData_json___default.a,
            fullscreen: false,
            environ: null,
            resultDate: 1558166400000 // 6pm, 18th of May, 2019 local epoch timestamp in milliseconds. www.epochconverter.com
            //resultDate: 1556162760000 // test date
        };
    },
    components: {
        MapSVG: __WEBPACK_IMPORTED_MODULE_3__components_MapSVG_vue__["a" /* default */],
        EmojiLegend: __WEBPACK_IMPORTED_MODULE_4__components_EmojiLegend_vue__["a" /* default */],
        LoadingOverlay: __WEBPACK_IMPORTED_MODULE_2__components_LoadingOverlay_vue__["a" /* default */]
    },
    computed: {
        title: function title() {
            var title = "How does this campaign make you feel?",
                titleElectionNight = "How do the election results make you feel?";
            return Date.now() > this.resultDate ? titleElectionNight : title;
        }
    },
    mounted: function mounted() {
        // console.log('that',this);
    },
    created: function created() {
        this.whatEnvironment();
        this.getOverall();
    },

    methods: {
        whatEnvironment: function whatEnvironment() {
            var envParam = (location.search.match(/env=([^&]+)/) || [])[1],
                uatDomain = location.host.match('uat.com.au') && 'uat',
                env = envParam || uatDomain || "production" || 'development';

            this.environ = env;
        },
        onFullscreen: function onFullscreen(isFullscreen) {
            //console.log('onFullscreen', isFullscreen)
            this.fullscreen = isFullscreen;
        },
        closeElecPoll: function closeElecPoll() {
            this.getOverall();
        },
        getOverall: function getOverall() {
            var _this = this;

            var uatUrl = 'https://d3l0ncuayaqpnv.cloudfront.net/static/overall-sentiment.json',
                prodUrl = 'https://d1pg15zwxj87d2.cloudfront.net/static/overall-sentiment.json',

            //getUrl = this.environ == "development" ||  ? uatUrl : prodUrl ;
            getUrl = this.environ.match(/development|uat/) ? uatUrl : prodUrl;

            //axios.get('https://znj95mx1a2.execute-api.ap-southeast-2.amazonaws.com/uat/api/overall')
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(getUrl).then(function (response) {
                _this.results = response.data.data;
            })
            //.catch(function (error) {
            .catch(function (error) {
                console.log(error);
                setTimeout(function () {
                    return _this.getOverall();
                }, 6000);
            });
        }
    },
    watch: {
        fullscreen: function fullscreen() {
            document.body.setAttribute('asw-fullscreen', this.fullscreen);
        }
    }
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = {"type":"Topology","arcs":[[[44449,18681],[-6,-27],[-35,5],[-9,-51],[-29,-12],[-54,-1],[-6,-32],[-47,1],[-3,20],[-167,36],[-11,13],[-76,10],[-11,-51],[-28,-26],[-30,0],[-18,-22],[-12,-68],[-42,-4],[-12,53],[19,26],[-21,31],[17,24],[7,79],[22,36],[26,-12],[47,92],[-5,37],[8,46],[-22,34],[-49,29],[0,19],[-40,15],[-29,32],[-91,2],[-111,16]],[[43631,19031],[16,110],[-40,7],[-13,32],[83,43],[-20,16],[-63,3],[33,43],[-60,33],[63,81],[8,75],[-33,35],[-48,28],[28,58],[-4,30],[26,14],[7,103],[-23,12],[-6,34],[-42,40],[-26,7],[-18,37],[59,35],[11,28],[0,56],[-11,71],[46,36]],[[43604,20098],[43,-39],[86,66],[40,-30],[57,18],[35,-13],[45,15],[-3,-112],[19,-29],[69,-8],[39,18],[23,-13]],[[44057,19971],[14,-35],[-5,-37],[-31,-41],[-3,-30],[38,-32]],[[44070,19796],[17,-29],[72,-18],[14,-31]],[[44173,19718],[-14,-43],[24,-71],[-27,-58],[43,-91],[-23,-38],[4,-31],[53,-28]],[[44233,19358],[0,-74],[-33,-34],[-4,-36],[-21,-28],[25,-43],[54,-6],[-4,-27]],[[44250,19110],[-33,-5],[-13,-34],[32,-25],[12,-58],[2,-85],[21,9],[83,-9],[16,-116],[-1,0],[5,-4]],[[44374,18783],[-6,-46],[42,-36],[39,-20]],[[45014,19338],[-14,-56],[-8,-104],[-21,-14],[-36,84],[8,38],[-12,40],[9,52],[-9,35],[31,21],[72,22],[4,-32],[-24,-86]],[[44740,18905],[-16,-132]],[[44724,18773],[-21,17],[-51,-2]],[[44652,18788],[-54,58],[-7,22]],[[44591,18868],[43,-5],[6,99]],[[44640,18962],[49,35],[10,20]],[[44699,19017],[46,-71],[-5,-41]],[[44854,18672],[-6,-2]],[[44848,18670],[-8,42],[-118,28]],[[44722,18740],[2,33]],[[44740,18905],[16,16],[62,-3],[2,-39],[29,2],[-6,-44],[25,-26],[5,-101],[14,-46],[-33,8]],[[45025,19026],[41,-29],[65,-26],[-45,-99],[-32,-99],[-12,-58],[-9,-85],[-24,1],[-8,-15],[-15,2],[-7,20],[-13,18],[7,53],[24,22],[-9,56],[0,91],[-16,24],[27,31],[26,93]],[[44640,18962],[-57,1],[7,-32],[-54,-2]],[[44536,18929],[-3,-3]],[[44533,18926],[-29,30],[17,44]],[[44521,19000],[90,7],[29,-42],[0,-3]],[[42074,23577],[-70,17],[-24,-16],[-49,5],[-25,17],[-21,40],[-76,87],[-24,-20],[16,-37],[-42,-8],[-44,7],[-38,25],[20,25],[47,30],[-2,30],[-35,-5],[-29,61],[-8,37],[-37,13],[-23,-26],[-35,24],[43,44],[14,54],[-26,16],[-81,11],[-51,29],[-38,5],[-59,-44],[-32,28],[-13,38],[-61,4],[11,48],[-50,1],[-8,-31],[-27,-19],[-40,10],[-44,27],[9,49],[-62,30],[-57,8],[-53,-39],[-53,-13],[-13,-41],[-52,-25],[-40,9],[-21,-22],[-128,-36],[-23,13],[11,34],[-6,31],[-49,28],[-34,53],[11,31],[-7,51],[-16,26],[-37,21],[-42,3],[-46,-73],[-3,-24],[-57,-28],[-35,-76],[-86,-18],[-87,5],[-24,-27],[-52,-14],[-6,-36],[37,-50],[-23,-33],[-20,-1],[-65,-81],[-32,20],[-28,-21],[-11,-29],[24,-29],[2,-43],[-49,-32],[-54,8],[-32,-8],[-12,36],[-35,-18],[7,-28],[-34,-22],[-2,-50],[-27,-32],[-23,-2],[0,-37],[-17,-31],[-55,-20],[-48,4],[-3,52],[55,43],[-25,72],[22,32],[-22,39],[-53,19],[11,49],[78,64],[-19,14],[65,85],[-50,37],[28,139],[-48,1],[-9,66],[-13,26],[1,50],[-93,11],[-148,-96],[-54,89],[102,92],[3,35],[-31,46],[-116,-16],[-5,-38],[-56,-20],[-83,27],[-50,31],[-4,35],[-42,20],[-32,-1],[-72,-29],[-24,-36],[-70,-42],[-26,3],[-30,-21],[-39,-51],[-63,-49],[-3,-27],[-82,-12],[-9,30],[-33,-34],[-6,-47],[-30,-17],[-3,-37],[-54,27],[-8,-18],[25,-32],[-40,-21],[4,-38],[-51,-48],[-52,-32],[-48,-46],[-82,-11],[-19,-17],[1,-40],[29,-40],[-9,-28],[15,-25],[-7,-32]],[[38181,23758],[-138,13],[-4,16],[-93,22],[5,33],[-155,23],[-8,-66],[-87,13],[23,35],[10,59],[-24,59],[-53,23],[-28,29],[-13,44],[9,69],[-35,51],[-66,38],[-34,39],[3,19],[-28,29],[-67,-8],[-23,11],[-17,49],[-22,31],[26,51],[-165,15],[25,244],[18,-1],[14,58],[-26,13],[-46,-37],[-45,23],[-39,8],[-47,-16],[15,51],[-193,21],[14,115],[-78,10],[21,131],[-6,48],[10,73],[-47,22]],[[36787,25218],[8,96],[31,-4],[6,34],[144,-12],[11,116],[-104,9],[10,102],[-64,6],[16,233],[11,117],[43,-5],[20,16],[218,-21],[-7,-61],[62,-109],[56,-5],[41,-15],[10,134],[182,-19],[-6,-32],[117,-32],[86,-7],[1,80],[40,56],[-5,17],[43,51],[6,32],[-41,56],[11,37],[39,43],[50,36],[-3,50],[-12,15],[-71,25],[-21,28],[17,24],[-37,85],[13,43],[-1,39],[27,39],[-34,92],[14,39],[-16,87],[65,29],[11,34],[44,19],[6,76],[23,21],[-11,45],[40,17],[27,-27],[32,-2],[24,-25],[21,17],[48,-17],[33,53],[35,23],[35,3],[42,37],[24,65],[-12,29],[9,29],[45,24],[5,45]],[[38244,27228],[60,-24],[-9,-39],[75,-26],[12,106],[95,-7],[24,54],[32,4],[39,33],[53,3],[40,-10],[32,-24],[12,-32],[64,-94],[33,-7],[21,46],[44,-26],[32,-51],[57,-28],[4,-46],[75,29],[47,-66],[18,32],[39,6],[47,-43],[36,11],[36,-22],[39,13],[1,-34],[38,-13],[38,-55],[12,-57],[27,8],[37,-12],[36,-47],[0,-32],[22,-35],[23,-2],[62,-39],[40,-41],[3,-51],[16,-10],[25,-51],[7,-46],[-51,-10],[-17,-49],[155,-16],[36,-9],[13,14],[57,-3],[98,-24],[95,-55],[72,-2],[45,-10],[49,6],[17,-21],[-6,-42],[27,-2]],[[40278,26280],[44,-51],[38,-10],[53,-41],[2,-65],[24,-36],[-3,-46],[-20,-18],[-13,-71],[15,-27],[49,40],[19,-33],[33,12],[-13,-49],[66,-23],[51,24],[2,-42],[-36,-38],[-15,-34],[17,-56],[4,-57],[-27,-28],[-3,-53],[44,-49],[-11,-43],[5,-61],[25,-69],[39,-50],[-8,-54],[29,-68],[33,-113],[31,-36],[-4,-24],[31,-18],[31,-38],[6,-30],[81,8],[37,-31],[-19,-13],[-3,-49],[30,8],[14,47],[30,-2],[44,-42],[21,-57],[21,-31],[82,-54],[60,-112],[16,19],[-22,42],[-9,62],[-20,27],[-80,189],[34,159],[23,42],[46,36],[33,16],[53,-34],[16,-68],[60,-51],[7,-53],[39,-23],[-20,-35],[52,-41],[85,-19],[39,-41],[78,-47],[48,-49],[62,-17],[47,-28],[53,-4],[-28,49],[-12,54],[-26,32],[8,52],[0,64],[29,40],[22,-15],[44,-3],[27,-44],[33,6],[9,-58],[17,-30],[48,-8],[14,-26],[-33,-23],[-3,-31],[-45,26],[-33,5],[20,-53],[19,-24],[33,-3],[27,-31],[36,66],[11,-28],[-10,-33],[-1,-71],[26,-7],[4,-31],[30,-13],[-22,-83],[-28,-163],[5,-59],[-15,-22],[-7,-111],[-22,-56],[-1,-37],[47,-49],[-4,-36],[44,-57],[-5,-22],[-34,-37],[-3,-62],[27,-65],[62,-76],[-24,-31],[-66,2]],[[41470,25747],[19,14],[42,-28],[-30,-18],[-31,32]],[[41738,25050],[-19,32],[21,17],[33,-22],[5,-38],[34,-40],[-15,-28],[-65,-40],[4,45],[-19,52],[21,22]],[[42239,23945],[32,44],[15,-36],[-47,-8]],[[41050,25162],[14,99],[26,-12],[20,-58],[-5,-90],[-17,-31],[-28,25],[-18,53],[8,14]],[[41177,25169],[-42,-30],[-13,23],[18,21],[37,-14]],[[38244,27228],[-21,16],[-26,63],[12,70],[-4,54],[-15,64],[-22,41],[21,72],[-35,65],[-9,47],[-39,65],[20,63],[-25,28],[-182,154],[-33,-12],[9,96],[-28,42],[30,52],[0,37],[-22,34],[28,23],[8,50],[-22,39],[-52,9],[-30,-9],[-8,-40],[-30,35],[-8,25],[-38,27],[-42,-20],[2,21],[-36,16]],[[37647,28455],[3,26],[-47,2],[77,56]],[[37680,28539],[51,-39],[17,-3],[89,26],[34,67],[36,23],[22,-56],[-13,-53],[22,-51],[75,-75],[110,-13],[14,-16],[63,28],[130,-21],[23,6],[24,40],[27,-92],[66,-73],[21,-42],[22,-100],[34,-29],[-32,-61],[16,-37],[32,-36],[37,-26],[10,-22],[73,-21],[29,11],[18,27],[-11,32],[-28,26],[17,44],[-6,18],[76,3],[31,-35],[-2,-53],[14,-70],[25,-39],[59,-48],[70,-7],[29,36],[62,8],[32,-64],[59,-19],[26,14],[39,-17],[18,-29],[30,0],[3,-34],[-33,-9],[-7,-33],[50,-28],[-1,-30],[29,-13],[43,-50],[96,-16],[35,27],[-21,81],[37,12],[30,-30],[31,-4],[54,-56],[7,-65],[33,-28],[35,11],[40,-23],[-5,-62],[43,25],[42,6],[25,-14],[18,-60],[25,0],[29,-37],[-12,-18],[9,-59],[49,-64],[2,-18],[44,-36],[-75,-10],[-12,28],[-23,2],[-8,47],[12,24],[-41,30],[-18,-18],[8,-38],[-21,-17],[-56,-8],[-9,-42],[-28,-36],[-18,-43],[25,-14],[12,-43],[24,-7],[-13,-33],[29,-22],[-2,-32],[52,-18],[0,-27],[27,-24],[31,-1],[-21,-44],[30,-16],[7,-56],[46,21],[5,-24],[27,-16],[32,7],[69,-31],[26,17],[-10,-92],[77,0],[19,-23],[59,-6],[3,-31],[27,-8],[27,-50],[21,-2],[-9,-61],[-31,-64],[-22,-15]],[[40562,26591],[-5,30],[31,2],[-1,-33],[-25,1]],[[39961,27534],[39,57],[28,-5],[-3,-87],[-47,-6],[-17,41]],[[40084,27319],[-43,-13],[-7,36],[-30,12],[30,39],[26,50],[18,-49],[34,-14],[32,-46],[-60,-15]],[[39501,27657],[1,-28],[-34,4],[-5,70],[19,10],[22,-28],[-3,-28]],[[44528,19065],[-1,-9],[-24,-42]],[[44503,19014],[-30,-9],[-27,18],[-31,-29],[-67,-1],[-26,19],[-42,1],[-15,35],[6,43],[-21,19]],[[44233,19358],[52,3],[54,-13],[25,-28],[-8,-51],[113,-17],[34,-42],[46,-19]],[[44549,19191],[2,-38],[-30,-63],[7,-25]],[[45024,18593],[-21,-127],[-22,41],[21,29],[22,57]],[[44988,18361],[-77,-22]],[[44911,18339],[-24,10],[-33,76]],[[44854,18425],[24,31],[-17,58],[-38,27],[-19,47],[-30,45],[25,32],[49,5]],[[44854,18672],[71,-22],[39,5],[12,-15],[4,-17],[10,-9],[24,-3],[-13,-41],[-45,-6],[-16,-32],[8,-77],[33,-33],[7,-61]],[[44057,19971],[56,2],[38,-17],[76,70],[29,-15],[13,79],[41,5],[12,-23],[62,27],[58,37],[50,13],[71,-13],[29,-40],[43,-25]],[[44635,20071],[8,-56],[-6,-58],[10,-80]],[[44647,19877],[9,-38],[-10,-22],[-89,2],[-25,39],[-24,1],[-44,29],[-37,2],[-32,-22],[-38,-7],[-55,8],[-2,30],[-53,10],[-18,-27],[-37,44],[-34,7],[-41,-50],[24,-16],[-44,-66],[-27,-5]],[[44577,19519],[-28,4],[-17,-22],[-110,36],[-51,-2],[-1,99],[-49,50],[-23,2],[-14,35],[-33,-22],[-78,19]],[[44647,19877],[35,-21],[-1,-107],[16,-34],[-29,-4],[-18,-42],[4,-33],[-55,-54],[-22,-35],[0,-28]],[[43843,22064],[-45,-54],[-53,-34],[-12,-29],[-29,11],[-27,-25],[17,-42],[-68,6],[11,-38],[-33,-27],[-28,33],[-59,-9],[21,-61],[-23,-34],[-32,20],[-70,-53],[-15,-58],[10,-45],[23,-55],[1,-65],[40,-16],[30,-40],[101,-17],[3,-34],[33,-35],[60,-9],[22,-34]],[[43721,21320],[-14,-35],[15,-25],[-4,-45],[-61,11],[-24,-8],[-31,-33],[-2,-32],[-59,-28],[2,-33],[-22,-6],[-58,15],[-3,-27],[-30,-30],[5,-42],[-37,-13],[17,-66],[-12,-35],[-64,-78],[-31,-2],[-42,74],[-38,14],[-20,36],[-36,-13],[-18,-30],[19,-139],[-35,-49],[-7,-70],[-21,-32],[13,-23],[-16,-30],[86,-97],[30,-2],[6,-31],[44,11],[27,-48],[8,-52],[-15,-26],[104,-13],[-5,-39],[36,-4],[3,-30]],[[43431,20215],[27,-28],[-45,-39],[-81,18],[-35,31],[-69,-11],[1,22],[-123,9],[-2,-18],[-51,-6],[-148,21],[-34,0],[-89,-67],[-42,59],[-27,-21],[-66,-4],[-24,13],[-93,-65],[8,-35],[-146,19],[42,97],[24,137],[-78,10],[-55,-2],[7,71],[56,27],[47,37],[27,-21],[25,11],[-13,52],[-59,-7],[-33,30],[-57,10],[-36,81],[-56,-7],[-15,10],[-78,-60],[-67,9],[-29,79],[-43,0],[-58,14],[9,101],[18,38],[-58,76],[18,14],[4,48],[-20,32],[19,25],[-10,29],[-70,8],[-24,16],[-51,-7],[-32,19],[-12,26],[-42,9],[-11,-74],[-20,-16],[17,-68],[-9,-47],[-43,-38],[-51,-10],[-5,28],[-61,14],[-3,-20],[-117,18],[8,-30],[-44,-19],[-50,33],[-12,-21],[-33,-1],[-31,-25],[-7,-36],[-35,21],[-32,-4],[-73,34],[0,-1],[-81,-31],[-63,-12],[19,-37],[-18,-16],[-34,64],[-61,-26],[-36,-26],[-72,9],[-10,-68],[-109,13],[7,49],[-91,11],[-41,-19],[-41,-31],[-28,-48],[-241,29],[-7,20],[35,56],[-48,39],[-47,51],[7,29],[-78,-18],[-19,22],[-49,13],[47,87],[34,-32],[96,71],[-44,57],[-40,18],[45,33],[-96,119],[-42,-16],[-74,15],[-64,29],[-64,56],[9,52],[36,37],[-15,37],[-70,-5],[-18,-32],[-26,32],[-47,13],[-38,27],[-53,7],[-73,-13],[-73,13],[-90,46],[-13,45],[-65,61],[-25,32],[-59,3],[-49,72],[-35,24],[-11,69],[-19,32],[-70,19],[-47,21],[-41,45],[-17,42],[-53,31],[-35,53],[-98,5],[-57,-48],[-41,-3],[-3,-27],[-34,-11],[-39,-31],[-20,17],[-42,-12],[-27,-23],[-12,-31],[-73,-7],[-108,12],[-36,-27],[-170,14],[2,39],[-55,3],[3,38],[-210,11],[-23,50],[30,21],[13,32],[23,15],[-8,31],[-39,37],[-18,53],[-29,8],[-26,-36],[-37,5],[-23,-19],[-6,-30],[-38,14],[-21,29],[-43,23],[-2,32],[-61,100],[-6,30],[-27,17],[0,42],[51,21],[24,-2],[54,28],[19,-49],[34,18],[50,-2],[10,33],[56,10],[10,36],[29,11],[26,40],[6,48],[28,54],[4,44],[79,34],[25,26],[26,1],[40,29],[81,8],[-10,30],[14,29],[-19,94],[38,18],[42,43],[-3,48],[-12,35],[2,53],[-34,16],[-4,104],[5,92],[38,64],[55,31],[-12,66],[-15,36],[6,63],[24,39]],[[42074,23577],[38,-29],[59,-26],[14,-23],[47,32],[98,-27],[26,-68],[86,-53],[42,-90],[-17,-23],[37,-60],[18,-9],[86,-13],[29,-27],[24,1],[18,-55],[102,-95],[44,-8],[50,-27],[-4,-27],[22,-27],[-2,-30],[33,2],[4,38],[60,14],[56,-48],[-2,54],[-54,36],[-3,33],[40,1],[107,-67],[28,-29],[22,-73],[48,-52],[58,-10],[68,-80],[64,-212],[40,-80],[22,-23],[45,-71],[62,-68],[57,-29],[49,-45],[51,-33],[64,-21],[28,11],[19,-18],[-19,-28],[5,-31]],[[42669,23254],[54,-38],[20,-62],[-28,-10],[-7,60],[-27,-1],[-12,51]],[[42610,23275],[-56,-42],[-34,30],[-79,131],[-83,48],[-15,59],[-22,20],[-37,76],[34,14],[10,29],[45,3],[46,-46],[64,-25],[46,-1],[39,20],[1,-43],[-12,-42],[0,-51],[16,-39],[52,-48],[13,-60],[-28,-33]],[[44854,18425],[-27,-18],[-27,25],[-71,3],[10,47],[-33,59],[-1,41],[-48,27],[-33,-28],[-81,-8],[20,61],[-31,21],[15,33]],[[44547,18688],[92,-24],[29,37],[39,4],[15,35]],[[44591,18868],[-38,29]],[[44553,18897],[-21,28]],[[44532,18925],[4,4]],[[43582,18473],[-82,15],[-21,-11],[-46,28],[-80,-17],[-52,1],[-32,19],[-118,12],[-111,-42],[-8,-34],[-32,-22],[-56,3],[7,52],[-62,27],[-56,47],[-44,5],[-25,42],[-56,55],[-12,45],[-19,1],[-20,74],[-60,73],[4,21],[-67,38],[-3,-20],[-133,20],[-6,50],[12,88],[122,-9],[-5,-18],[128,-18],[11,97],[22,145],[126,-83],[10,89],[-11,2],[16,106],[68,-18],[47,1],[14,81],[22,30],[25,0],[5,32],[74,40],[66,-6],[22,-19],[-13,-99],[37,-45],[21,-49],[43,-15],[32,-65],[46,-37],[11,-25],[-19,-47],[33,-5],[0,-36],[19,-18],[30,13],[14,43],[38,25],[31,-40],[17,-58],[-10,-25]],[[43496,19012],[-46,-16],[-10,-38],[-49,-20],[-23,-56],[37,-27],[14,-24],[-7,-50],[-19,-25],[-33,4],[9,-37],[32,0],[29,-59],[26,-4],[44,-33],[14,-31],[50,-16],[18,-32],[0,-75]],[[37647,28455],[-2,-19],[-60,12],[-19,-77],[-33,3],[13,62],[-14,45],[-54,5],[-38,-9],[-26,8],[-16,-102],[-34,-14],[-58,45],[-32,5],[-16,59],[-33,26],[-25,76],[19,40],[54,1],[52,40],[0,27],[20,31]],[[37345,28719],[32,-32],[41,-7],[23,-19],[76,-33],[40,15],[48,-5],[25,-64],[16,1],[34,-36]],[[37406,29192],[32,8],[34,-53],[-17,-14],[-51,5],[-10,39],[12,15]],[[37706,28671],[-25,-29],[-35,24],[-13,55],[80,0],[9,-37],[-16,-13]],[[44333,21248],[-41,-12],[-39,4],[-11,37],[-64,-6],[-38,8],[-53,-16],[-32,16],[-84,14],[-62,-29],[-46,18],[17,61],[-29,14],[-69,-1],[-32,-10],[-29,-26]],[[43843,22064],[9,45],[31,-15],[55,-52],[12,-29],[17,-89],[-10,-35],[7,-40],[55,-94],[22,-48],[28,-28],[52,-30],[-20,-37],[59,-74],[66,-24],[86,3],[56,-23],[39,4],[27,-15],[-14,-26],[18,-56],[-9,-16],[12,-50],[-58,-33],[-22,-45],[-28,-9]],[[36787,25218],[-168,23],[-123,22],[0,21],[-121,9],[8,127],[-46,6],[15,39],[6,113],[18,86],[13,10],[5,56],[-161,11],[-4,-51],[-105,11],[-19,-180],[-173,21],[-20,42],[-87,9],[-14,-134],[-87,9],[8,-60],[-140,15],[-15,-152],[-158,16],[-5,-62],[-49,5],[-16,-136],[-23,8],[-240,21],[1,24],[-115,10],[21,111],[-165,16],[-6,60],[-92,9],[6,89],[-163,22],[6,75],[-128,13],[-164,10],[-167,16],[20,183],[-355,35],[2,40],[31,299],[-191,15],[-209,-170],[-51,-46],[-12,14],[-90,-74],[-52,61],[-134,-112],[27,-31],[-75,-62],[6,67],[-179,16],[-5,-56],[-177,10],[4,34],[-119,12],[4,54],[-78,9],[-100,3],[-6,-179],[-19,-143],[-343,28],[-2,-17],[-176,15],[3,44],[-83,6],[-30,-250],[-196,17],[-22,-46],[10,-86],[-106,8],[-17,-228],[78,-84],[-9,-16],[-184,-153],[133,-154],[-60,-42],[-13,14],[-48,3],[14,-84],[16,-15],[6,-54],[-9,-29],[8,-36],[-151,-125],[39,-12],[28,-30],[-135,-114],[25,-27],[-139,-110],[8,-10],[-78,-62],[-44,40],[-64,36],[-99,-86],[-177,-134],[-80,-85],[16,-126],[-224,24],[-242,23],[-8,-74],[8,-33],[-82,-61],[33,-75],[-285,17],[-191,9],[13,176],[-201,13],[49,42],[-182,192],[-58,-49],[-52,53],[-196,-166],[24,-33],[-206,-158],[-160,174],[-142,-108],[-42,3],[-476,37]],[[27861,23559],[0,122]],[[27861,23681],[0,369],[0,612]],[[27861,24662],[0,95],[0,94]],[[27861,24851],[0,292],[0,196]],[[27861,25339],[0,92],[0,98]],[[27861,25529],[0,97],[0,98],[0,57],[0,138]],[[27861,25919],[0,98],[-1,195],[0,97],[0,196]],[[27860,26505],[0,306]],[[27860,26811],[0,279],[0,489],[-1,571]],[[27859,28150],[0,390],[0,195],[0,98],[0,24]],[[27859,28857],[1,152],[5,260],[0,545]],[[27865,29814],[0,420],[0,499]],[[27865,30733],[0,539],[0,460]],[[27865,31732],[2,-2],[4,-2],[4,-3],[10,-6],[12,-16],[13,-6],[20,-28],[66,-61],[84,-54],[79,-25],[54,-30],[64,0],[62,-40],[54,-7],[70,1],[97,17],[32,-11],[20,-23],[87,-35],[94,-44],[69,-23],[19,9],[32,-15],[62,-4],[42,-24],[6,-44],[41,-48],[86,-45],[-19,-51],[16,-106],[18,-54],[40,-84],[44,-53],[44,-29],[61,-27],[84,0],[67,-31],[61,-44],[17,-33],[49,-20],[26,-39],[39,-24],[75,-12],[39,-33],[62,-2],[128,-54],[19,-16],[13,-48],[39,-34],[66,-17],[51,-1],[127,24],[13,-5],[100,21],[77,11],[77,44],[16,-8],[60,21],[55,34],[72,32],[45,44],[43,32],[29,-3],[37,40],[65,23],[58,86],[30,112],[7,67],[40,102],[9,63],[-11,59],[29,83],[42,34],[60,83],[17,75],[37,17],[78,83],[41,76],[13,80],[46,53],[25,54],[9,43],[-19,40],[33,86],[29,96],[4,47],[83,146],[10,51],[-22,42],[-20,88],[0,44],[26,88]],[[31659,32559],[111,-5],[19,-45],[92,15],[145,-33],[120,9],[56,-17],[23,43],[188,-162],[156,0],[148,121],[13,-72],[97,1],[174,-60],[26,-46],[22,-18],[47,-5],[30,-39],[40,-35],[53,-3],[26,-43],[140,-56],[42,-56],[7,-39],[45,-21],[11,-46],[74,-33],[60,-49],[34,4],[36,-24],[39,-1],[51,-19],[31,-28],[45,4],[37,-43],[26,29],[30,-24],[24,10],[27,-25],[62,2],[25,22],[101,-26],[38,69],[31,-4],[7,31],[36,21],[19,38],[38,30],[47,-7],[50,23],[111,-40],[20,-46],[2,-30],[40,-32],[78,-12],[38,19],[18,26],[29,-2],[13,-23],[56,16],[78,-31],[17,-24],[45,11],[30,-37],[28,-6],[20,-65],[74,-20],[39,2],[20,-64],[28,6],[0,28],[27,20],[3,49],[41,7],[29,-7],[44,19],[3,-23],[39,7],[42,-25],[38,25],[41,73],[90,11],[32,67],[38,54],[25,-38],[39,-32],[37,-5],[29,16],[3,25],[30,15],[64,-64],[7,-45],[92,-54],[34,54],[21,-3],[32,-46],[18,-56],[-2,-51],[60,3],[14,-58],[27,-20],[-38,-40],[50,-61],[-41,-33],[40,-84],[57,-53],[20,2],[36,-23],[1,-25],[-18,-47],[60,-32],[20,55],[30,-7],[42,22],[-4,31],[15,21]],[[36509,31267],[12,35],[21,4],[32,35],[25,-31],[25,-3],[48,48],[28,-28],[-27,-45],[7,-15],[-33,-38],[-16,-66],[1,-40],[26,-27],[15,-35],[21,-15],[23,-95],[5,-41],[25,-32],[15,-59],[42,-66],[29,-20],[-9,-58],[14,-37],[-9,-52],[25,-46],[48,-54],[15,-48],[-39,-52],[-10,-41],[8,-48],[-23,-42],[26,-61],[-16,-36],[-8,-102],[-23,-24],[-38,-66],[-9,-37],[-24,-44],[-1,-61],[21,-105],[25,-24],[60,-77],[37,-23],[25,-33],[13,-60],[21,-31],[25,3],[16,-31],[35,4],[89,-36],[8,-34],[-14,-102],[-34,-75],[-27,-116],[-1,-58],[15,-45],[29,-29],[24,-47],[29,-12],[18,-35],[28,-12],[36,-55],[59,-48],[48,-24]],[[37091,29448],[-61,6],[-32,14],[-23,46],[1,64],[-56,82],[-57,34],[-33,43],[42,16],[45,-14],[53,-38],[31,-7],[29,55],[47,1],[-19,-95],[34,-45],[28,-8],[-9,-39],[33,-24],[-27,-38],[-2,-43],[-24,-10]],[[29450,31051],[-30,23],[13,28],[42,31],[15,35],[25,6],[21,40],[43,-53],[13,-43],[-4,-37],[-43,-22],[-40,3],[-6,23],[-39,-6],[-10,-28]],[[29128,31401],[-44,-23],[-4,39],[42,18],[6,-34]],[[29181,31511],[-43,0],[-8,31],[35,41],[16,-72]],[[29186,31590],[-27,-3],[-17,39],[11,29],[51,41],[15,47],[39,45],[67,43],[25,-6],[28,14],[64,9],[50,-1],[69,39],[25,26],[62,-17],[49,-52],[29,-2],[25,-33],[-10,-66],[-31,20],[-72,-42],[-23,62],[-39,16],[-14,-34],[-34,2],[-31,-74],[-5,-58],[-24,0],[8,-44],[-39,-8],[-26,41],[-26,-39],[-50,-47],[-56,-27],[-45,3],[-38,27],[-10,50]],[[31659,32559],[10,140],[26,128],[35,130],[19,22],[40,112],[14,62],[20,26],[13,51],[6,66],[31,40],[26,15],[11,46],[-10,20],[30,60],[8,41],[-7,39],[-35,47],[-45,111],[-25,130],[-15,115],[0,58],[-30,124],[29,130],[36,91],[21,80],[-10,91],[5,50],[-36,71],[-61,63],[-38,59],[-9,28],[-2,66],[25,109],[15,133],[22,101],[30,76],[44,50],[37,96],[65,93],[16,45],[-18,55],[-25,15],[-11,36],[-20,17],[-17,79],[-1,73],[-34,39],[20,52],[31,42],[23,-3],[41,41],[27,5],[53,64],[41,112],[12,60],[63,-18],[17,26],[-42,5],[-9,29],[32,6],[31,27],[-17,28],[-57,-13],[-10,17],[-37,15],[-28,44],[-50,20],[-26,-49],[-28,0],[-41,-25],[-36,22],[28,80],[36,75],[43,120],[17,75],[32,48],[98,225],[33,55],[38,38],[3,-38],[24,-39],[27,-62],[28,34],[40,-21],[20,24],[-12,30],[-33,40],[-32,3],[-1,37],[22,146],[18,51],[22,20],[20,102],[40,139],[50,126],[23,86],[9,72],[0,76],[-7,24],[22,28],[9,76],[11,19],[-14,97],[-21,67],[11,38],[65,40],[23,-8],[35,14],[43,-9],[38,14],[36,26],[16,43],[30,29],[36,98],[25,24],[56,3],[33,24],[34,-39],[53,-23],[-73,-108],[-30,-24],[3,-58],[81,49],[31,-28],[-8,-49],[65,-13],[14,-31],[34,3],[38,-29],[4,-39],[41,-55],[2,-64],[12,-29],[-17,-81],[21,-81],[20,-2],[48,-76],[5,-31],[-40,-59],[-6,-49],[14,-19],[-4,-79],[19,-32],[7,-56],[4,-131],[-11,-50],[4,-65],[59,-52],[41,-12],[27,-36],[52,-7],[38,10],[42,25],[35,2],[29,-17],[1,-26],[42,-57],[-57,-117],[-45,-77],[-7,-49],[10,-25],[-17,-81],[-4,-50],[16,-14],[112,-8],[39,-36],[43,-16],[12,-68],[-2,-73],[34,-46],[53,-11],[44,-37],[24,1],[24,-30],[-38,-50],[2,-20],[-26,-85],[-26,-56],[2,-39],[-10,-65],[28,-13],[36,40],[47,20],[18,-17],[40,5],[46,19],[-34,-68],[-16,-61],[18,-66],[-2,-58],[-11,-60],[2,-42],[18,-32],[-6,-101],[12,-74],[13,-33],[47,-26],[17,-47],[0,-37],[-18,-58],[8,-60],[-30,-49],[-16,-60],[0,-73],[-15,-63],[23,-68],[42,-53],[36,-124],[9,-17],[54,-40],[26,-134],[-6,-63],[14,-54],[22,-47],[17,-78],[23,-50],[36,-55],[54,-47],[53,-25],[93,-5],[91,27],[38,24],[41,51],[41,23],[33,68],[-3,74],[24,7],[39,-19],[9,-22],[61,-22],[29,4],[94,47],[44,43],[29,73],[27,-1],[48,-73],[41,-39],[-17,-51],[5,-57],[16,-12],[46,13],[-1,-32],[-22,-57],[-2,-54],[53,-45],[20,-45],[26,-8],[75,13],[7,-52],[64,-25],[79,0],[46,-85],[-1,-49],[58,-45],[24,-33],[73,-9],[26,-27],[72,-21],[49,8],[0,-56],[47,-49],[19,-34],[77,5],[3,-32],[-56,-55],[-30,-41],[-46,-97],[3,-61],[37,-74],[44,-2],[38,29],[9,-39],[-71,-50],[7,-42],[-9,-33],[-45,-48],[-10,-49],[37,-17],[13,-30],[-15,-44],[19,-27],[35,-8],[-1,-102],[49,-78],[7,-58],[-18,-44],[28,-43],[-22,-55],[1,-25],[52,-34],[26,-38],[7,-29],[33,-45],[8,-46],[-13,-60],[-20,-56],[4,-31],[27,-12],[15,-71],[-72,-78],[2,-58],[-14,-51],[7,-41],[59,-13],[4,-43],[57,-85],[2,-16],[48,-53],[17,-49],[46,-16],[54,-44],[15,-46],[41,-27],[26,-53],[32,-27],[-10,-45],[18,-39]],[[32632,38723],[28,-14],[10,-29],[-34,-29],[-31,-5],[-35,39],[17,31],[45,7]],[[32676,39222],[14,-22],[-14,-35],[-64,-69],[-12,17],[-55,17],[-33,46],[24,27],[7,32],[28,21],[37,5],[68,-39]],[[32467,38525],[-34,30],[-2,65],[21,29],[42,18],[32,35],[54,-62],[32,-60],[-75,-33],[-32,-52],[-31,10],[-7,20]],[[33102,40128],[31,12],[61,-6],[-49,-34],[-13,-22],[-39,-10],[-55,-1],[-66,25],[1,23],[51,26],[29,-12],[49,-1]],[[32662,39903],[-58,5],[2,18],[56,-23]],[[32580,40229],[-59,5],[-59,15],[3,18],[91,33],[23,-34],[23,10],[32,-11],[-11,-29],[-43,-7]],[[32454,39314],[56,14],[11,-54],[-5,-50],[-25,-33],[-35,1],[-8,26],[-34,16],[-11,33],[38,47],[13,0]],[[34837,34480],[-40,8],[36,38],[4,-46]],[[44521,19000],[-18,14]],[[44528,19065],[30,-9],[28,41],[-10,32],[29,30]],[[44605,19159],[-3,-30],[19,-36],[82,-36],[-4,-40]],[[44565,19302],[-61,-4],[16,-62],[29,-45]],[[44577,19519],[3,-18],[63,-59],[21,-32],[-7,-27],[-56,-32],[-36,-49]],[[44677,19699],[-1,-78],[32,-120],[43,-85],[7,-32],[-44,-18],[-38,74],[-37,27],[-10,83],[-16,28],[58,58],[6,63]],[[44859,18038],[25,54],[43,36],[13,59],[-19,22],[3,45]],[[44924,18254],[45,22],[31,-49],[26,-4]],[[45026,18223],[34,-58],[50,-47],[20,-5]],[[45130,18113],[-2,-3],[-1,-2],[-10,0],[-52,19],[-8,0],[-1,0],[-2,-5],[-12,-11],[-39,-27],[-10,-11],[-4,-5],[-29,-33],[-23,-11],[-50,10],[-7,-1],[-5,1],[-2,-1]],[[44873,18033],[-14,5]],[[44924,18254],[-35,42],[22,43]],[[44988,18361],[18,-19],[20,-119]],[[44652,18788],[-11,-29],[-84,6]],[[44557,18765],[-32,25],[-35,57]],[[44490,18847],[63,50]],[[44557,18765],[-6,-52]],[[44551,18713],[-88,34],[-18,-34],[4,-32]],[[44374,18783],[74,79],[42,-15]],[[44565,19302],[-3,-28],[66,-32],[30,9],[-9,-74],[-44,-18]],[[44547,18688],[4,25]],[[44533,18926],[-1,-1]],[[43604,20098],[-1,69],[-51,28],[-1,16],[-52,23],[-7,-26],[-61,7]],[[44333,21248],[28,-5],[33,36],[47,17],[6,-20],[-29,-30],[9,-45],[-37,-27],[3,-67],[21,-16],[-4,-73],[33,-26],[-4,-34],[63,-35],[15,-40],[35,-28],[12,-57],[-28,-47],[25,-22],[-28,-19],[30,-25],[31,87],[-13,59],[28,28],[11,-60],[29,-53],[33,-26],[30,-6],[-17,-74],[-41,-108],[-40,-140],[-15,-83],[1,-59],[15,-39],[44,-1],[-24,-139]],[[44566,21375],[16,31],[3,45],[-11,54],[-1,59],[-53,4],[43,53],[44,21],[103,90],[38,52],[35,65],[5,62],[-63,104],[-60,41],[66,76],[75,49],[19,-3],[-7,-127],[6,-81],[21,-56],[45,-45],[29,-5],[-1,-75],[-153,-337],[-74,-171],[-42,-112],[-33,-123],[2,-65],[10,-42],[-13,-41],[-53,7],[-38,64],[-6,50],[-28,100],[-23,21],[7,40],[41,52],[-1,68],[52,75]],[[44448,21254],[32,-7],[-22,-33],[-32,20],[22,20]],[[44859,18038],[-22,-1]],[[44837,18037],[-1,-1],[-2,-3],[-2,0],[-2,-1],[-2,0],[-21,-9],[-26,-21],[-10,3],[0,0],[-2,1],[-9,9],[-8,-3],[-7,3],[-1,1],[-3,4],[-4,2],[-1,1],[-7,-1],[-3,0],[-2,-3],[0,-1],[0,-4],[-1,0],[-1,-2],[-2,-8],[1,-3],[2,-4],[-5,-8],[-9,-7],[3,-7],[3,-5],[-15,-6],[0,-3],[-7,-5],[-4,0],[-1,-1],[0,-3],[0,-4],[-1,-2],[-1,0],[-9,-5],[-6,-1],[-4,-4],[0,-1],[0,-1],[0,0],[5,-11],[-4,-6],[-6,-5],[-1,0],[-1,-1],[-1,0],[-3,-7]],[[44656,17904],[-8,-11]],[[44648,17893],[-2,0],[-15,4],[-1,0],[0,1],[-4,-1],[-4,0],[-12,5],[-2,1],[-4,3],[-5,4],[-13,2],[-3,0],[-2,2],[-1,0],[-2,0],[-6,-4],[-3,1],[-25,2],[-22,2],[0,0],[-3,1],[-13,4],[0,0],[-5,3],[-2,0],[-1,0],[-8,0],[0,0],[-7,-2],[-3,0],[-1,0],[-8,-1],[0,0],[-2,-1],[-5,1],[-5,-1],[0,0],[-4,-3],[0,0],[-1,0],[-5,4],[-3,2],[-2,1],[-1,1],[-5,0],[-2,1],[-2,1],[-2,0],[-24,14],[-4,3],[-3,2],[-2,1],[-4,3],[-1,-1],[-1,-1],[-2,-1],[-3,0],[-8,-1],[-19,1],[-1,-2],[-3,-4],[-5,-4],[-8,1],[-4,-1],[-1,-1],[0,-1],[-1,-2],[-1,-2],[0,-1],[-2,-1],[-1,-5],[-2,-4],[-13,-6],[-3,-3],[0,-1],[0,-1],[0,-1],[0,-1],[0,-2],[0,-1],[-3,-3],[-3,-2],[-3,0],[-1,0],[-10,2],[-2,0],[0,0],[-5,4],[0,0],[-3,1],[-1,1],[-6,0],[-2,-2],[-1,0],[-2,0],[-2,-1],[-1,-1],[-4,-1],[-6,-4],[2,-2],[0,0],[2,-2],[0,-2],[-3,-2],[0,-1],[-2,-1],[-6,-1],[-2,0],[-6,4],[-1,0],[-4,0],[-2,3],[-17,14],[-4,1],[0,0],[-4,1],[-1,1],[-7,0],[-26,16],[-14,11],[-3,6],[-6,4],[-31,2],[-2,3],[-13,13],[-3,14],[-1,0],[-2,1],[-1,1],[0,1],[0,1],[0,4],[0,0],[0,1],[-2,3],[-3,3],[-1,-1],[0,-1],[-2,-2],[-1,-1],[-2,-1],[-5,-5],[-5,-9],[0,-1],[-1,-2],[4,-18],[-5,-9]],[[44081,17944],[0,-3]],[[44081,17941],[-4,-5],[-4,-6],[-7,-7],[0,-1],[0,-2],[-1,0],[0,0],[-3,-5],[-2,2],[-4,5],[-2,7],[-11,4],[-1,0],[-3,0],[-2,0],[-4,7],[-1,-2],[-1,-2],[-1,0],[-2,0],[-6,3],[0,0],[-1,1],[-1,3],[-1,2],[-5,3],[-6,2],[-3,3],[-3,0],[-1,4],[1,2],[4,4],[0,2],[-1,3],[2,11],[2,4],[1,2],[1,9],[0,1],[2,4],[0,2],[-1,1],[-3,2],[0,0],[-5,2],[-1,0],[-3,0],[0,0],[-10,12],[-3,0],[0,0],[-3,2],[-5,-2],[-2,0],[-3,-2],[-3,-1],[-2,0]],[[43969,18015],[-9,0]],[[43960,18015],[-16,58],[-35,33],[-18,55],[-16,19],[5,50],[-28,14],[-17,54],[14,47],[-99,18],[-25,-16],[-68,29],[-30,25],[-19,43],[-26,29]],[[43496,19012],[74,-25],[12,-16],[54,37],[-5,23]],[[43960,18015],[-3,-3]],[[43957,18012],[-3,-2],[-6,0],[-19,-8],[0,-2],[0,-1],[-2,-5],[-1,-2],[-4,-6],[0,0],[-6,-3],[-1,-1],[0,-1],[0,-1],[0,-1],[-1,-1],[-1,0],[-1,-1],[-2,-9],[-2,-5],[0,0],[-5,-1],[-6,1],[-1,0],[-6,-2],[-1,0],[-1,1],[-1,0],[-4,1],[-4,0],[-1,0],[0,-1],[-1,-2],[0,-3],[0,-1],[0,0],[0,-3],[-1,-2],[0,-1],[-2,-2],[0,-1],[0,-2],[-1,-3],[1,-1],[3,-8],[2,-4],[1,-2],[2,-2],[0,-1],[-3,-5],[-1,-2],[-2,-2],[-3,-3],[-4,-3],[-3,-2],[-3,-2],[-1,-1],[0,-1],[-3,-5],[-1,-2],[-1,-1],[-1,-3],[-4,-6],[-25,-3],[-53,-1],[-3,1],[-12,-3],[-15,-13],[-4,-9],[0,-1],[-44,-26],[-39,-44],[-8,3],[-51,15],[-47,-35],[-5,-1],[-30,-6],[-10,-2],[-12,-7],[-1,-5],[-18,-15],[-65,-38],[-5,1],[-11,26],[-25,-33],[12,-47],[22,-17],[5,-26],[21,-67],[12,2],[4,-2],[5,-1],[3,0],[0,0],[8,2],[7,-5],[-1,-5],[2,-4],[2,0],[5,-7],[7,3],[2,-1],[2,1],[1,0]],[[43488,17516],[2,-1],[2,-1]],[[43492,17514],[0,0],[0,-1],[1,-1]],[[43493,17512],[0,-2],[-2,-15]],[[43491,17495],[-25,-39],[-2,-55],[-6,-46],[0,-4],[-10,-14],[-13,-23],[3,0],[13,-4],[2,1],[9,0],[-2,-2],[-15,-40],[-1,-1],[-61,-30],[-35,-6],[-2,-1],[-10,-3],[-78,21],[0,0],[-3,0],[-7,-1],[-5,-4],[-1,0],[-1,0],[-1,-2],[-1,-1],[-1,-3],[-1,-4],[-1,-13],[-1,-1],[1,-5],[4,-7],[-2,-3],[-1,0],[-2,-4]],[[43235,17201],[1,-2],[-2,-8]],[[43234,17191],[-2,-3],[-8,-4],[-13,4]],[[43211,17188],[-8,17],[-34,-16],[-15,29],[-29,50],[-3,23],[-12,2],[-41,-25],[-13,-19],[-65,-21],[-48,-23],[-28,-9],[0,0],[-3,-1],[0,-5],[0,-2],[-1,-4],[-7,-13],[-3,-9],[-5,-5],[-2,-1],[-3,-1],[-9,-11],[-3,-2],[-1,-2],[-15,-19],[-1,-1],[-4,-14],[0,-10],[-1,-9],[-3,-8],[-1,-2],[0,-1],[0,-2],[13,-15],[-1,-2],[-1,-1],[0,0],[-3,0],[-7,-5],[0,-1],[-3,-4],[-1,-4],[-1,-2],[-2,-3],[-1,-1],[-1,0],[0,0],[-6,-2],[-2,0],[-14,-8],[-1,0],[-4,-13],[-2,-6],[-1,-3],[-23,-24],[-6,-7],[-3,-5],[-4,-2],[-14,-2],[-3,-3],[-2,-4],[-4,-8],[-2,-7],[-4,-6],[-1,-1],[-2,-1],[-9,0],[-9,0],[-18,3],[-21,-4],[-9,1],[-10,7],[-8,4],[-6,1],[0,1],[-4,5],[-1,8],[6,19],[-3,8],[-8,9],[-9,12],[-8,2],[-3,2],[-8,7],[0,0],[-2,15],[0,0],[-3,17],[9,14],[5,15],[0,3],[-3,10],[0,2],[-3,3],[-12,4],[-2,3],[0,1],[0,0],[5,7],[3,2],[3,3],[3,8],[0,1],[0,5],[0,1],[0,3],[-2,3],[-6,12],[0,4],[0,1],[4,3],[1,2],[2,2],[-7,6],[-3,8],[7,8],[2,10],[0,3],[-6,11],[-8,6],[-2,0],[0,1],[-7,3],[-3,1],[-1,1],[-8,5],[-8,4],[-5,17],[-2,4],[-3,1],[-1,0],[0,0],[-7,-4],[-8,3],[-1,0],[-2,1],[-1,1],[-12,16],[-11,9],[-27,7],[-8,10],[-4,3],[-3,1],[-28,6],[-1,0],[-3,5],[-3,2],[-12,4],[-1,2],[-10,5],[-2,1],[0,1],[-2,7],[0,0],[-1,0],[-4,-1],[-1,-1],[-1,1],[-5,2],[-15,-2],[-3,-2],[-2,-1],[-9,-6],[-17,2],[-4,-2],[-6,7],[-1,0],[0,3],[4,2],[-2,4],[-2,2],[-1,1],[-1,1],[-1,2],[1,9],[4,24],[-19,6],[2,6],[0,3],[0,4],[-4,8],[-1,1],[9,7],[-3,14],[-4,5],[-5,4],[-4,3],[-3,2],[-7,5],[-3,1],[-3,1],[-8,0],[-29,6],[-16,-3],[-17,12],[-6,9],[-6,19],[-6,3],[-50,7],[-21,11],[-6,5],[-1,4],[-1,0],[0,1],[0,0],[-1,1],[0,1],[-7,2],[-27,6],[-2,6],[-36,17],[-10,3],[-28,13],[-1,0],[-13,-1],[-7,0],[-26,-16],[-19,-7],[-12,-9],[-4,6],[-18,-1],[-22,-9],[-4,-4],[-12,-4],[0,0],[0,1],[1,0],[-1,2],[-29,5],[-19,10],[-25,-6],[-12,1],[-24,-10],[-2,5],[2,1],[1,0],[5,2],[1,0],[0,0],[-6,9],[-9,-1],[-3,-5]],[[41772,17539],[-35,3],[-7,-7]],[[41730,17535],[-9,4],[-41,0],[-15,11],[-7,17],[-14,9],[-14,-7],[-5,2],[-3,8],[-16,7],[0,1],[0,0],[0,1],[0,1],[0,0],[0,0],[0,1],[0,2],[0,1],[0,0],[1,2],[-1,0],[0,1],[-1,1],[-1,0],[0,1],[-1,0],[-1,1],[-2,0],[0,1],[0,1],[0,0],[2,2],[1,1],[1,0],[0,1],[0,0],[1,2],[0,1],[1,0],[0,2],[0,1],[0,0],[-1,1],[-1,0],[-1,0],[0,0],[-1,0],[-1,0],[0,0],[-1,0],[0,1],[0,0],[0,7],[0,2],[-4,-1],[-4,0],[-4,2],[-1,2],[-2,9],[-18,7],[-20,20],[-21,16],[-2,3],[-5,3],[-4,-2],[-41,-14],[-1,-1],[-14,-3],[1,-4],[-6,2],[-47,-14],[-1,-2],[-8,0],[6,3],[-3,2],[-7,2],[6,7],[-13,-7],[-1,0],[-1,0],[-7,10],[-13,-1],[2,4],[-4,0],[-9,-11],[-1,2],[-9,-5],[-9,1],[-10,0],[-1,-6],[-14,3],[-2,1],[-9,2],[0,0],[1,-13],[0,-1],[-7,-3],[0,0],[-5,-5],[-12,3],[0,3],[-12,-1],[0,0],[-5,-10],[-3,1],[-1,0],[-14,3],[-2,0],[-10,1],[-7,-1],[-9,3],[-2,-3],[-10,-7],[-6,-6],[-5,0],[-1,-3],[-1,-4],[-6,-2],[-1,0],[-14,-8],[-7,0],[-1,-1],[-3,-1],[-1,1],[-1,-3],[-3,1],[-2,3],[-5,-1],[-5,0],[-2,-3],[-1,-1],[-2,-1],[-2,-1],[0,-2],[-2,-1],[-8,7],[0,-1],[-3,0],[-2,0],[0,1],[-8,2],[-2,0],[-1,0],[-2,2],[-1,-2],[-4,0],[-1,-1],[0,1],[-4,-4],[0,-1],[-6,-4],[3,-1],[-2,-2],[-6,-2],[0,2],[-7,3],[-5,1],[5,3],[-7,0],[1,-1],[-3,3],[-2,-1],[-6,2],[1,3],[-6,5],[-5,-3],[-7,5],[0,-1],[-1,-1],[0,0],[0,-3],[-2,1],[-3,1],[0,0],[-7,-4],[-7,1],[-3,3],[-1,2],[-7,0],[-2,0],[-2,-1],[-13,-9],[-2,1],[0,1],[-3,3],[-1,-1],[-4,1],[-3,1],[-5,-2],[-1,1],[-8,-3],[-9,-4],[0,0],[-2,0],[-2,2],[-2,2],[-4,-3],[-2,2],[0,1],[-4,-4],[-4,3],[0,-3],[-1,0],[-3,1],[0,0],[-5,-2],[-1,1],[-2,2],[-4,0],[-2,1],[0,0],[-2,-1],[-1,1],[-1,0],[-3,-4],[0,-2],[0,0],[0,-2],[-4,4],[-3,-3],[-4,0],[0,1],[-6,-1],[-4,4],[1,2],[3,1],[-5,2],[-4,0],[-2,-1],[1,-1],[-5,-3],[-1,-1],[-1,-1],[-1,3],[0,1],[-5,-1],[-2,-2],[-2,-2],[0,-1],[0,-6],[0,0],[4,2],[-5,-3],[0,-2],[1,-6],[-10,-1],[-2,-1],[0,-1],[-5,1],[0,0],[-1,2],[1,1],[0,0],[-1,1],[-2,-1],[-4,-3],[-5,-2],[-2,-1],[-2,3],[-3,-1],[-1,0],[1,1],[0,1],[-2,0],[-2,1],[4,4],[0,0],[0,1],[0,1],[0,1],[-3,1],[-5,6],[-7,10],[-1,-1],[-2,-5],[-1,0],[-2,1],[-5,2],[-2,1],[0,1],[-6,12],[-2,1],[0,1],[-2,1],[-2,-2],[-2,4],[-2,1],[-13,0],[-3,-3],[0,0],[-3,-1],[-2,-1],[-4,-1],[-2,1],[0,2],[-3,0],[-1,-1],[0,8],[-1,3],[-1,3],[-2,-1],[-1,0],[0,0],[-1,0],[-2,0],[0,-1],[-2,4],[2,5],[-7,5],[-9,2],[0,0],[-8,2],[0,1],[-4,-1],[-7,0],[-3,0],[-2,-2],[-3,-1],[-2,-1],[0,-2],[-1,-2],[-1,1],[-4,0],[0,-1],[-2,2],[-9,2],[-6,1],[-1,-1],[0,1],[-8,1],[-2,-1],[-7,-6],[-3,0],[0,0],[-1,2],[-2,-1],[-1,0],[0,0],[0,-2],[-2,0],[0,1],[0,3],[-1,2],[-2,-1],[-2,2],[-2,0],[0,-1],[-2,0],[-1,2],[-2,-2],[1,-3],[-1,-2],[0,0],[-1,0],[0,1],[-1,1],[-2,1],[-2,-3],[-1,2],[-2,0],[-1,-2],[-2,-1],[0,-1],[0,-1],[-11,0],[-1,0],[2,-3],[-1,-2],[-1,-2],[0,0],[0,0],[-1,-3],[-3,4],[-2,-5],[-3,-1],[-1,1],[-2,-2],[0,0],[-1,0],[-2,2],[0,0],[0,-4],[0,-1],[-1,1],[0,0],[0,1],[-4,3],[-1,1],[0,0],[-3,-1],[-3,0],[-1,-3],[0,0],[0,-1],[-1,1],[-3,0],[1,-3],[1,-1],[0,-1],[-2,-1],[-2,-6],[-3,0],[0,-1],[-1,0],[0,0],[-2,0],[-1,-3],[-3,-1],[-1,-1],[0,-1],[-1,-4],[2,-2],[0,-1],[-1,-2],[1,-1],[2,0],[-6,-5],[-2,-1],[0,-1],[0,0],[-1,0],[0,-1],[-1,0],[-3,0],[-1,-1],[-1,-1],[0,0],[-1,-2],[0,-1],[0,0],[1,-2],[1,-1],[1,0],[0,-1],[1,0],[1,-1],[0,0],[-1,-1],[0,0],[-1,0],[0,-1],[0,-2],[-1,1],[0,0],[0,-3],[-1,0],[0,-4],[-2,-2],[0,0],[0,-1],[0,-1],[-1,0],[-3,-3],[-5,-1],[-1,0],[0,-4],[5,0],[0,0],[-1,-3],[-2,1],[-2,0],[-2,0],[0,-4],[0,-1],[0,-2],[-1,0],[-1,-1],[-5,-1],[0,-1],[1,-1],[0,-1],[1,-2],[1,2],[1,1],[0,-2],[-2,-2],[-2,-1],[-4,-3],[-2,-2],[-2,-3],[-2,0],[-3,1],[-3,-2],[-2,0],[-1,0],[0,-1],[-1,-5],[-2,-12],[0,0],[-5,-4],[-1,3],[-1,1],[0,1],[-1,1],[-7,1],[-2,-2],[-3,2],[0,0],[-2,0],[0,2],[-3,-1],[-4,-1],[-2,3],[-2,3],[-3,0],[-1,0],[-4,-4],[-1,0],[0,0],[-1,-1],[1,-2],[-1,-1],[-2,-1],[0,1],[-2,1],[-1,-2],[-1,-1],[0,-3],[1,0],[-1,-1],[-2,0],[-3,0],[-1,0],[-2,1],[0,0],[-1,-1],[-6,-1],[0,0],[-3,0],[-1,-1],[-1,-1],[3,-4],[-3,-3],[0,-2],[0,-1],[-3,0],[-3,0],[-3,-2],[1,-1],[-3,-2],[0,-1],[-1,-1],[0,0],[-1,0],[0,2],[-1,2],[-1,0],[0,0],[-1,-2],[-3,1],[0,0],[-2,-1],[-1,2],[0,-1],[0,0],[-2,0],[-1,0],[-1,0],[-3,2],[-1,0],[-3,-1],[-7,-5],[-2,-3],[0,-1],[-2,-3],[-2,-1],[0,-3],[1,-1],[0,-1],[-1,0],[0,-1],[-1,0],[-7,-6],[-2,-2],[0,0],[-1,0],[-1,1],[-2,-1],[-1,0],[-2,0],[-1,-2],[3,-2],[-2,-4],[-2,-2],[-3,-1],[-2,2],[-1,3],[0,3],[0,1],[-1,-1],[-2,2],[-5,-3],[-1,-2],[-3,-4],[-1,0],[-2,2],[0,0],[-1,0],[-1,-2],[0,0],[-1,2],[-1,0],[-2,1],[-1,-3],[-1,-2],[-1,-4],[-3,0],[-1,-1],[-2,-1],[-1,-1],[-2,-1],[-4,-1],[-1,-1],[0,0],[0,-4],[-1,0],[-1,0],[1,-2],[0,-1],[0,-1],[-2,0],[0,0],[0,-2],[0,0],[0,-1],[-3,-1],[-1,0],[0,-2],[0,0],[-2,0],[-1,-2],[0,0],[0,0],[-3,3],[-3,0],[0,-1],[-3,0],[0,-1],[0,0],[0,-1],[-2,-1],[-3,-1],[0,1],[-1,1],[-1,0],[0,-3],[1,-1],[-1,-1],[-3,1],[-4,-1],[-1,0],[0,0],[-2,0],[0,0],[-1,-1],[-1,0],[-2,0],[-1,-1],[0,-1],[-3,-2],[-3,-2],[1,-2],[2,-1],[-1,-4],[-1,0],[-2,1],[-1,-3],[0,-1],[0,-2],[-3,-4],[0,-1],[0,-8],[-2,0],[-1,-1],[-2,-1],[0,-3],[0,-1],[0,-1],[-1,0],[-1,0],[-1,1],[-1,0],[-2,-1],[-1,-2],[-1,0],[-2,-2],[0,0],[-1,0],[0,-2],[-1,0],[-1,1],[-1,0],[0,-1],[-3,1],[0,1],[-1,1],[-3,-2],[1,0],[0,-2],[-1,-1],[0,-1],[-6,2],[0,0],[-3,2],[-3,-1],[-1,2],[-2,-2],[0,0],[-1,-1],[0,0],[-1,0],[0,1],[-1,0],[-1,0],[1,2],[0,0],[0,0],[0,1],[-3,-1],[-2,0],[0,-1],[-1,-2],[1,-1],[-1,-2],[-1,-2],[6,-5],[-1,-1],[1,0],[1,-1],[0,-1],[-2,0],[0,0],[-2,-2],[0,0],[2,0],[1,0],[0,0],[0,-1],[-2,-2],[-1,0],[-2,-1],[0,-2],[0,-1],[-1,-1],[-7,0],[0,0],[-1,-1],[1,-2],[0,0],[-1,-1],[-1,0],[-1,1],[-1,-3],[0,0],[-2,-1],[0,0],[-1,2],[-3,-1],[0,-1],[0,1],[0,2],[-1,0],[0,0],[-1,0],[0,-1],[-1,0],[-2,1],[2,3],[-2,0]],[[40216,17340],[-1,-1],[-1,0]],[[40214,17339],[-1,0],[0,0],[-1,0],[0,0],[0,0],[0,0]],[[40212,17339],[-1,1],[0,0]],[[40211,17340],[-1,0],[0,0]],[[40210,17340],[-1,-2]],[[40209,17338],[1,1],[-1,-4],[-2,0],[-1,1],[-1,-2],[-1,0],[-1,-1],[-4,-2],[0,5],[-2,0],[-1,-1],[-2,0],[0,1],[-1,2],[-3,-3],[-3,-1],[-1,-3],[-1,0],[-6,-6],[-2,0],[-2,1],[-4,-20],[-3,-2],[-2,-3],[-1,-5],[-3,-6],[-3,-1],[-1,-1],[-2,-4],[-1,-1],[-1,-1],[-1,0],[-4,-2],[-2,-2],[0,-1],[1,-4],[4,0],[1,0],[2,0],[1,-3],[-6,-2],[0,-1],[0,-2],[0,0],[2,0],[0,-2],[-4,-8],[1,-2],[-2,-9],[-1,0],[-1,-1],[-1,-1],[-2,-4],[-3,0],[-2,-4],[0,-1],[1,-4],[-1,-1],[0,0],[-1,0],[-1,-1],[-3,-5],[0,-1],[3,-2],[0,-2],[-3,-4],[-1,-1],[-2,0],[0,0],[0,-4],[-4,-3],[0,0],[-2,-3],[1,0],[-1,-5],[0,-1],[-1,-2],[-1,-2],[-1,-1],[-1,0],[-1,2],[-2,1],[-4,-2],[-1,0],[-2,-1],[-1,0],[0,-2],[-2,0],[-1,0],[-3,1],[-3,2],[0,0],[-5,-1],[0,-1],[0,-1],[2,0],[1,0],[1,-1],[0,0],[-1,-1],[-1,0],[-3,0],[-1,0],[-1,0],[0,-5],[-1,-2],[0,-1],[-1,-1],[0,0],[-2,-2],[-1,0],[-1,0],[0,0],[-6,-3],[-3,1],[-2,-4],[1,-1],[-3,0],[-1,1],[-2,-1],[-1,0],[-1,-1],[0,0],[0,0],[-2,1],[-3,0],[0,0],[-2,-1],[-2,0],[-4,-4],[-1,-1],[0,-4],[0,-1],[-5,-2],[1,-4],[-2,-1],[-1,-2],[1,0],[0,0],[0,-1],[-1,0],[0,0],[-1,-1],[-2,-3],[-3,-1],[-1,0],[0,-1],[-113,0],[-551,0],[-462,0],[-384,0],[-407,0],[-320,0],[-222,0],[-180,0],[-61,0],[-170,0],[-342,0],[-394,0],[-332,0],[-271,0],[-329,0],[-329,0],[-160,0],[-9,0],[-19,0],[-59,0],[-359,0],[-645,0],[-221,0],[-256,0],[-185,0],[-182,0],[-100,0],[-131,1],[-134,0],[-561,-1],[-362,0],[-368,0],[-207,0],[-18,0]],[[31196,17142],[0,17],[0,189],[0,333],[-4,550],[1,485],[0,434],[1,440],[0,173],[2,32],[0,49],[0,98],[0,129]],[[31196,20071],[0,114],[0,268]],[[31196,20453],[0,206]],[[31196,20659],[-65,0],[-35,0]],[[31096,20659],[-153,0],[-92,0],[-93,0],[-278,0],[-536,0],[-330,0],[-376,0],[-322,0],[-277,0],[-233,0],[-358,0]],[[28048,20659],[-186,0]],[[27862,20659],[0,94],[0,293],[0,97]],[[27862,21143],[0,685],[0,194],[0,683],[0,334],[0,350],[0,97],[-1,73]],[[42451,11314],[-42,-25]],[[42409,11289],[-63,4],[-41,20],[-31,33]],[[42274,11346],[72,7]],[[42346,11353],[46,-3]],[[42392,11350],[20,-26],[39,-10]],[[42500,11371],[-11,-31],[0,-1],[-9,-13],[0,-1],[0,-1],[0,0],[-1,-1],[0,-1]],[[42479,11322],[-28,-8]],[[42392,11350],[47,36]],[[42439,11386],[61,-15]],[[42450,11468],[-39,23],[-47,-2]],[[42364,11489],[17,37],[-21,31]],[[42360,11557],[58,15]],[[42418,11572],[63,-46]],[[42481,11526],[-16,-16],[-2,-4],[-1,0],[0,-1],[3,-5],[0,0],[0,0],[2,-1],[0,0],[0,-1],[-7,2],[-1,0],[-9,-32]],[[42623,11785],[-27,-21],[0,0],[-4,1],[-1,0],[-16,-13],[-42,-19],[-4,-4],[0,-1],[-30,-9],[0,0],[-9,-23],[0,0],[-4,-14]],[[42486,11682],[-54,-22],[-25,-66],[11,-22]],[[42360,11557],[-19,-3]],[[42341,11554],[-13,61],[-39,16],[-60,51],[0,54],[-29,2]],[[42200,11738],[36,55],[-52,11],[12,34],[29,21],[-55,44],[31,5],[-19,35],[18,21],[44,-7],[50,53]],[[42294,12010],[5,-21],[44,-10],[0,-25],[33,-17],[46,-47],[46,12],[15,-53],[31,8],[9,-33],[40,4],[33,-52],[27,9]],[[42354,11444],[-8,-91]],[[42274,11346],[-2,18]],[[42272,11364],[0,41],[19,30]],[[42291,11435],[12,23]],[[42303,11458],[37,18]],[[42340,11476],[14,-32]],[[42566,11526],[-85,0]],[[42486,11682],[5,-31],[28,-19],[-12,-44],[26,-39]],[[42533,11549],[33,-23]],[[41403,11422],[-34,-14],[22,-60],[73,-9],[-36,-53],[-48,-30],[-56,-67],[-11,-68],[-56,12],[-54,28],[-3,24],[-49,6],[-30,-14],[18,-40],[-12,-51],[-20,-15],[-79,-3],[-34,-20],[-78,14],[-41,-11],[-36,9],[-46,78],[-34,2],[-88,71],[-15,33],[-55,27],[-13,-20],[-56,25],[-61,62],[-82,-7],[-46,-14],[-34,2],[-25,-17],[-44,46],[17,19],[-39,48]],[[40218,11415],[-2,18],[34,27],[30,-12],[5,62],[43,18],[18,37],[25,22],[-95,17],[-25,-5],[-21,-39],[-44,-2],[-55,-51],[-59,33],[-15,29],[21,42],[-39,20],[-1,18],[-56,17],[11,83],[-21,27],[-59,3],[-34,11],[-30,45],[-54,-10],[-30,-42],[-40,-8],[-45,16],[-16,-29],[-70,-13],[-38,30],[-45,-5],[-17,-25],[-57,-5],[-31,32],[13,52],[-9,19],[-113,31],[25,46],[52,8],[9,30],[55,42],[-36,40],[27,29],[-14,66],[34,36],[1,39]],[[39450,12214],[0,1]],[[39450,12215],[42,-5],[33,21],[7,59],[-18,21],[21,71],[-27,54],[-18,2],[-30,45],[-43,20],[-19,29],[3,70],[-7,48],[-56,41],[8,20],[-6,94],[19,30]],[[39359,12835],[3,45],[47,18],[93,-7],[29,16],[115,-44],[60,15],[68,74],[-22,92],[30,28],[-26,45],[55,18],[16,89],[41,-28],[51,63],[36,2],[49,47],[19,114],[27,8],[36,33],[12,38],[53,13],[106,-30],[43,20],[4,-48],[26,-41],[-20,-39],[-15,-90],[55,-10],[38,5],[37,-11],[45,77],[30,26],[26,46],[18,2],[21,94],[69,-8],[6,34],[36,-19],[46,3],[34,-47],[40,16],[32,-11],[26,12],[65,-9],[1,24],[49,48]],[[40969,13558],[-5,-25],[31,-28],[81,-11],[62,-26],[-10,-26],[57,-7],[61,-36],[19,-57],[-45,-74],[7,-22],[44,-22],[82,2],[24,24],[48,-14],[32,29],[30,-8],[5,-71],[43,3],[15,-41]],[[41550,13148],[-44,-17],[-36,-44],[-7,-40],[7,-67],[-12,-67],[84,-45],[-23,-87],[-17,-30],[15,-21],[58,-34],[23,-60],[-24,-30],[29,-77],[6,-92],[130,-39],[9,15],[53,-8],[9,-20],[64,-8]],[[41874,12377],[7,-43],[-14,-52],[-26,-24],[-59,-30],[6,-55],[38,-76],[21,-23],[-6,-31],[-80,-32],[-36,-24],[-4,-46],[-28,-50],[-50,5],[-43,-14],[-31,-27],[-88,21],[-7,-75],[-27,-3],[12,-38],[33,-34],[-29,-19],[-29,-43],[-21,-97],[-20,-23],[9,-71],[-22,-31],[23,-20]],[[42192,11520],[-104,25]],[[42088,11545],[-21,42],[-25,7],[5,34],[52,33]],[[42099,11661],[42,32]],[[42141,11693],[35,-84],[27,-51],[-11,-38]],[[42565,11264],[-20,-29],[-55,1],[-2,-37]],[[42488,11199],[-56,-4],[-40,26],[17,68]],[[42479,11322],[-8,-26],[0,0],[18,-13],[64,-1],[12,-18],[0,0]],[[44435,14220],[-112,19],[11,74],[-43,83],[-55,3],[-1,25],[-26,21],[-36,87],[28,23],[46,-11],[6,26],[-51,16],[1,34],[-74,3],[-47,30],[-40,-7],[-25,-39],[-76,-4],[-17,12],[-77,-12],[-41,58]],[[43806,14661],[-16,24],[11,53],[-83,61],[23,28],[6,52],[-7,35],[10,38],[-10,28],[29,59],[31,3],[35,54],[-19,72],[12,29],[-42,36],[-17,30],[22,42],[57,45],[8,57],[-5,32],[43,40]],[[43894,15479],[14,23],[42,2],[-5,48],[35,42],[46,37],[14,53],[30,3],[43,-20],[33,3],[47,37],[-5,41],[64,-9],[5,18],[53,-10],[30,-38],[48,2],[42,-10],[46,16],[52,-7],[-5,-30],[76,-47],[24,17],[11,38],[61,-1]],[[44695,15687],[-13,-26],[3,-45],[-69,-120],[-3,-33],[-28,-33],[-21,-45],[-24,-137],[8,-33],[-32,-86],[15,-37],[-5,-44],[16,-82],[28,-31],[44,-8],[9,-42],[-30,-38],[-22,-67],[7,-36],[23,-12],[-89,-116],[-27,-105],[11,-19],[3,-67],[-57,-82],[-8,-41],[26,-57],[-25,-25]],[[42380,11081],[-81,-65],[-75,-109],[5,-57],[-26,-29],[-7,-57],[19,-56],[-22,-11]],[[42193,10697],[-35,12],[10,28],[-27,18],[-40,-13],[-18,14],[-57,-13],[-64,23],[62,122]],[[42024,10888],[6,42],[73,-5],[-13,40],[53,-10],[31,26],[11,53],[-34,37]],[[42151,11071],[44,-10],[26,70]],[[42221,11131],[63,-10],[96,-40]],[[42807,11952],[-62,5],[0,0],[-55,15],[-2,19],[37,29],[-82,10],[0,40],[-95,94],[7,34],[-27,23],[11,28],[-7,43]],[[42532,12292],[51,46],[21,43],[53,17],[71,-60],[4,-47],[18,-54],[63,-20],[39,19],[24,-9]],[[42876,12227],[-4,-25],[21,-33],[39,-2],[2,-2]],[[42934,12165],[6,-49],[-69,-52],[-23,-69],[-41,-43]],[[41345,8863],[4,-36],[-13,-38],[10,-49],[-4,-40],[17,-38],[-17,-92],[-54,-55],[-18,-42],[20,-36],[-31,-60],[10,-78],[-92,-180],[-4,-74],[-42,-51],[4,-52],[-45,-88],[37,-29],[-13,-46],[14,-55],[-74,-62],[36,-20],[50,5],[42,-43],[20,-2],[17,-89],[33,-48],[-72,23],[-48,-50],[33,-54],[-25,-54],[10,-60],[18,-24],[2,-69]],[[41170,7177],[-524,215],[-339,141],[-578,245],[-539,230],[-95,-1],[-5,19],[33,43]],[[39123,8069],[56,61],[39,85],[-3,24],[-58,24],[-45,32],[17,30],[-16,71],[-42,15],[-8,35],[-25,9],[-22,57],[22,51],[-25,13],[-9,100],[15,22],[-21,35],[8,43],[-42,23],[-4,45],[11,41],[-81,5],[-12,53],[-72,10],[-42,26],[-38,-2],[-40,14],[-36,33],[-20,-10]],[[38630,9014],[1,60],[25,56],[52,-2],[14,38],[34,14],[17,56],[-20,82],[36,42],[67,21],[-54,81]],[[38802,9462],[20,17],[31,-15],[35,12],[-43,64],[15,89],[-14,63],[-43,35],[9,56],[33,4],[18,55],[65,2],[21,26],[-15,22],[106,-15],[67,-2],[71,15],[42,27],[-17,53],[11,13],[85,-14],[45,-19],[63,-4],[36,-26],[38,11],[14,87],[62,-9],[4,-16],[0,-4],[43,12],[1,28],[0,1],[6,28],[2,5],[-4,27],[3,5],[-48,30],[13,42],[-23,60],[46,113],[16,82],[-7,39],[17,88],[80,15],[12,29],[-25,31],[7,24]],[[39700,10648],[37,-19],[107,-16],[14,13],[57,-9],[64,-82],[50,-9],[-9,-51],[26,-33],[28,14],[35,-49],[4,-36],[56,-87],[35,-13],[14,-28],[39,15],[30,-20],[108,2],[1,-25],[74,-13],[31,-30],[14,32],[67,-8],[8,19],[40,12],[40,-7],[-2,-72],[29,-7],[-14,-109],[20,-3],[4,-52],[-19,-43],[53,-6],[18,30],[60,-8],[79,-52],[44,8],[30,-37],[53,-8],[6,-40],[54,28],[34,-12],[24,30],[2,29],[-22,21],[30,19],[19,-19],[36,31],[9,38],[-42,14],[54,67],[-6,41],[30,-5]],[[41253,10103],[23,-49],[64,-57],[13,-54],[32,-6],[38,-33],[-20,-26],[12,-36],[-30,-10],[-7,-36],[-123,-46],[-17,-27],[0,-87],[-34,-29],[-10,-56],[-38,-26],[-17,-61],[-21,-15],[5,-54],[-29,-29],[-57,-97],[-30,-2],[-14,-37],[42,-66],[124,-236],[53,-29],[70,-11],[33,17],[30,-42]],[[40308,9871],[-41,75],[-48,20],[-177,-110]],[[40042,9856],[-18,-12],[-5,-2],[-16,-10],[-1,-1],[-10,-6],[-8,-5],[-15,-9],[-96,-60],[-2,-2],[-16,-34],[7,-24],[1,-1],[9,-26],[-25,-31],[-26,-102],[11,-84],[-4,-42],[16,-29],[-11,-32],[28,-13],[-11,-36],[51,-50],[61,21],[9,-85],[17,-71],[51,-43],[59,-9],[41,-24],[14,47],[28,37],[16,51],[-12,46],[21,81],[-16,23],[-18,106],[69,-2],[-9,45],[21,70],[-17,43],[12,46],[66,80]],[[40314,9707],[48,18],[97,-11],[12,-12],[48,23],[-8,28],[-95,40],[-29,2],[-79,76]],[[38630,9014],[-41,-8],[-17,-21],[-92,-48],[-45,31],[-18,35],[-47,-13],[-58,17],[-49,-54],[-9,-50],[-38,-33],[-20,18],[-64,7],[-42,-13],[-75,25],[-26,33],[-20,-61],[-40,-25],[-27,-48],[-21,30],[-64,5],[-15,-36],[-37,11],[-11,27],[-73,1],[-45,29],[-40,-1],[-36,37],[-45,-16],[-9,22],[-79,42],[-100,30],[-34,-31],[-34,24],[-47,-11],[-18,-27],[-12,-43],[-46,7],[-51,-21],[-42,37],[-22,-15],[-72,-6]],[[36949,8901],[-77,31],[-53,-9],[-31,24],[-48,-22],[-35,11],[-7,32],[-49,27],[-41,-2],[-29,-32],[-57,0],[-17,26],[-34,-5],[-69,40],[-30,32],[-77,47],[-34,53],[-29,15],[-68,-7],[-32,-29],[-33,6],[-67,-41],[-31,17],[-45,-6],[-41,30],[-87,-14],[-50,15],[-56,2],[-59,-33],[-54,-5],[-25,-84],[9,-35],[-37,-31],[43,-36],[27,-53],[-45,-21],[-15,18],[-64,11],[-77,-77],[-98,13],[-28,50],[-82,35],[-39,1],[-33,42],[-41,9],[-58,63],[-29,12],[-34,38]],[[34983,9059],[-48,93],[12,21],[-26,31],[-62,45],[-32,-20],[-21,38],[-38,20],[-32,39],[-26,-1],[-50,54],[-14,41],[-47,16],[-16,25],[-65,3],[-46,61],[-32,1],[-59,23],[-53,51],[-80,57],[-42,-4],[-48,11],[-26,-22],[-53,60],[-30,7],[-4,33],[23,43],[-22,50],[-1,39],[-103,-19],[-27,35],[-56,-4],[-25,82],[-30,21],[-13,60],[3,50],[-20,50],[2,29],[23,13],[-21,56],[17,17],[23,62],[-9,25],[-87,22],[-85,57],[-103,40],[-43,7],[-28,-17],[-29,9],[-1,28],[-55,-6],[-43,31],[-56,-27],[-14,53],[-63,22],[-27,35],[-19,-20],[-71,-8],[-23,-90],[20,-47],[-89,-21],[16,-55],[-117,29],[-27,32],[14,49],[-48,28],[-14,59],[10,61],[-36,-14],[-27,27],[-38,15],[17,57],[-34,5],[4,48],[-14,61],[49,66],[-35,13],[-35,-14],[-59,27],[-46,10],[12,48],[-33,100],[-67,11],[-86,-1],[-18,23],[9,27],[-101,21],[-40,-9],[-54,10],[-23,-30],[-192,48],[-78,-29],[-3,-23],[-71,-60],[-56,-18],[-26,61],[-47,-8],[-45,14],[-8,27],[-52,19],[-27,-23],[-56,31],[-24,29],[-60,21],[-31,-33],[-29,29],[-51,4],[-17,-18],[-33,26],[-59,11],[-7,27]],[[31200,11258],[-1,512],[0,300]],[[31199,12070],[291,-32],[3,22],[47,-5],[-4,-25],[47,-5],[60,445],[190,-22],[-13,-106],[530,-56],[-17,69],[94,-6],[-2,-26],[181,-12],[31,24],[-8,24],[82,66],[24,31],[-9,30],[57,-6],[-4,-31],[137,-14],[3,30],[-38,169],[476,-51],[22,166],[341,-37],[-2,-13],[181,-20],[-17,-116],[92,-13],[6,50],[96,-11],[-7,-53],[96,-12],[-11,-17],[-10,-67],[-56,7],[-33,-7],[-23,-150],[95,-11],[30,-34],[56,29],[7,16],[76,-9],[30,13],[25,-20],[66,-8],[8,53],[384,-46],[-17,-111],[29,-27],[254,-23],[62,-9],[34,14],[36,38],[36,17],[4,22],[97,-10],[10,71],[40,8],[22,149],[128,-15],[-5,-30],[79,-10],[14,58],[39,14],[90,-14],[21,94],[42,280],[94,-12],[9,63],[97,-14],[-16,-98],[90,-11],[4,17],[58,46],[48,-6],[-7,-50],[62,-13],[-4,57],[44,-6],[-11,-68],[95,-12],[-22,-151],[19,-1],[-26,-169],[250,-7],[179,-9],[69,-112],[-39,-26],[40,-75],[-5,-51],[-25,-44],[-15,-139],[45,-150]],[[36857,11748],[-27,-176],[407,-48],[-22,-136],[84,-10],[-38,-250],[196,-22],[-12,-86],[117,-14],[-12,-72],[116,-15],[-30,-187],[128,-14],[-75,-415],[-14,-52],[14,-21],[-66,-29],[-5,-27],[31,-47],[-15,-83],[-36,-21],[-81,9],[-82,-54],[-48,-3],[-203,-134],[27,-23],[-11,-63],[-44,-39],[-11,-58],[83,-98],[124,-19],[16,-8],[128,-30],[-9,-33],[46,-16],[104,-15],[83,-1],[162,96],[78,50],[78,-22],[89,-2],[14,-23],[59,-6],[67,-21],[35,-48],[27,25],[41,3],[27,-17],[44,60],[36,-5],[61,-48],[26,-9],[61,15],[117,-20],[60,-4]],[[42272,11364],[-55,-9]],[[42217,11355],[-41,59],[-43,13]],[[42133,11427],[36,30],[45,-8],[32,-32],[45,18]],[[41253,10103],[36,19],[-31,30],[36,48],[-10,33],[-29,17],[-18,45],[3,56],[38,32],[35,-24],[24,-33],[33,-6],[59,9],[53,29],[34,30],[25,-9],[32,28],[35,5],[31,45]],[[41639,10457],[166,65],[47,-10],[36,17],[48,38],[38,8],[64,-10],[36,13],[14,-48],[64,18]],[[42152,10548],[0,-72],[-36,-94],[-41,-16],[-32,-40],[-14,-44],[2,-42],[33,-50],[4,-62],[40,-33],[15,-33],[-2,-38],[-29,-22],[-37,34],[13,40],[-11,33],[-38,13],[-60,-30],[-16,-21],[32,-103]],[[41975,9968],[-45,6],[-26,-34],[-33,4],[-15,-49]],[[41856,9895],[-61,-37],[2,-33],[-68,-53],[-9,-31],[17,-58],[-75,-68],[-32,-52],[1,-81],[-59,-79],[-10,-28],[-33,-21],[1,-42],[-31,-43],[-49,20],[-34,1],[15,-68],[25,-18],[-10,-62],[-43,-6],[-40,-68],[11,-74],[-10,-29],[10,-40],[-29,-62]],[[42506,11377],[0,-1],[-6,-5]],[[42439,11386],[-1,28]],[[42438,11414],[28,24],[1,0],[0,0],[1,1],[0,0],[1,0],[0,0],[1,0],[0,1],[2,0],[1,2],[-1,0],[-2,-1],[0,0],[-1,1],[-1,0],[6,4],[0,0],[1,1],[0,0],[0,0],[5,1],[1,0],[0,1],[0,0],[0,1],[4,-1],[1,0],[0,1],[-2,15]],[[42484,11465],[40,-6]],[[42524,11459],[-26,-52],[10,-22],[0,-1],[-2,-7]],[[42270,11540],[-16,-36]],[[42254,11504],[-62,16]],[[42141,11693],[26,-7]],[[42167,11686],[45,-28]],[[42212,11658],[1,-2],[1,-2]],[[42214,11654],[56,-114]],[[42221,11131],[15,41],[5,65],[-60,9],[2,31]],[[42183,11277],[21,18],[13,60]],[[42488,11199],[9,-17],[-55,-62],[-62,-39]],[[42024,10888],[-123,21],[-35,-26],[-37,-45],[-44,-6],[-1,-25],[-82,-30],[-81,-17],[-70,-35],[-12,-37],[-61,-68],[4,-36],[93,6],[44,-26],[39,-57],[-19,-50]],[[39700,10648],[-35,18],[-8,71],[-38,5],[-1,34],[-29,25],[25,41],[37,24],[14,49],[-16,16],[42,58],[1,37],[-12,86],[11,46],[46,29],[49,4],[36,48],[-22,20],[26,46],[41,-3],[4,24],[85,20],[8,-21],[41,-20],[42,14],[15,51],[41,-9],[19,26],[54,-2],[42,30]],[[41403,11422],[51,-3],[54,39],[51,-7],[15,-51],[25,9],[46,-56],[59,-12],[15,-15],[59,49],[92,53],[6,17]],[[41876,11445],[67,23],[54,-32]],[[41997,11436],[-18,-51],[30,-31]],[[42009,11354],[9,-16],[-1,-5],[-18,-54],[5,-29],[60,-37],[-44,-24],[12,-43],[-1,-55],[120,-20]],[[43043,12537],[-54,-30],[19,-31],[-14,-37],[16,-32],[-21,-58],[-43,0],[-3,-37],[-44,-22],[-6,-46],[-17,-17]],[[42532,12292],[-74,34]],[[42458,12326],[-35,38],[-58,-3],[-19,-46],[-70,-13],[-62,22],[-47,-4],[-17,24],[-9,60],[-51,44],[-46,6],[-19,-25],[-48,14],[-34,-19],[37,-22],[14,-28],[-98,12],[-22,-9]],[[41550,13148],[26,27],[50,7],[7,53],[84,14],[63,-35],[2,46],[-46,85],[8,17],[6,112],[145,-22],[30,-14],[242,-35],[113,24],[45,-9],[55,14],[58,-33],[101,-31],[42,13],[53,47],[17,35]],[[42651,13463],[37,-44],[6,-50],[-10,-49],[36,-35],[12,-38],[31,-30],[40,-68],[30,-25],[-19,-51],[49,-38],[-5,-62],[-18,3],[-10,-74],[-40,5],[-31,-76]],[[42759,12831],[-7,-28],[25,-24],[11,-40],[-41,-23],[13,-57],[39,-20],[49,-8],[-10,-26],[89,-1],[56,-9]],[[42983,12595],[12,-26],[48,-32]],[[42506,11377],[36,-4],[4,26]],[[42546,11399],[57,-15]],[[42603,11384],[-19,-103],[-19,-17]],[[42088,11545],[-42,-8],[3,-108]],[[42049,11429],[-52,7]],[[41876,11445],[-27,20],[59,74],[4,71],[41,113],[30,13],[82,-28],[34,-47]],[[44435,14220],[-70,-79],[-20,-74],[10,-24],[-32,-29],[-24,-53],[13,-12],[-67,-81],[-12,-35],[15,-25],[-63,-38],[-61,-50],[-64,-77],[-38,-59],[5,-43],[-44,-64],[-3,-44],[72,-59],[-49,-76],[-4,-37],[24,-30],[-26,-63],[-7,-71],[-77,-23],[-90,-44],[-70,-61],[-21,-41],[-76,-37],[-26,-34],[-5,-30],[20,-22]],[[43645,12805],[-89,1],[-80,14],[-14,-5],[-95,18],[-25,18],[-41,-8],[-56,8],[-38,-29],[-60,10],[-10,-50],[-22,-36],[-46,28],[-13,-16],[-37,26],[-31,5],[-36,-25],[-30,9],[17,36],[-66,12],[-14,57],[-80,-61],[-20,14]],[[42651,13463],[3,33],[25,34],[58,-2],[22,30],[2,30],[51,43],[-14,55],[55,83],[49,38],[46,-11],[19,77],[-29,-1],[-56,26],[17,83],[-12,20],[15,99],[38,-17],[45,4],[87,-9],[76,-28],[0,43],[51,33],[-43,38],[-3,35],[92,14],[79,-13],[-3,39],[190,-28],[-5,45],[-16,28],[1,34],[38,20],[26,133],[27,-1],[17,57],[-17,41],[58,3],[26,-17],[35,16],[68,-10],[16,89],[21,12]],[[42009,11354],[101,-15],[-8,-18],[62,-28],[19,-16]],[[42640,11568],[-81,7],[-26,-26]],[[42623,11785],[56,-12]],[[42679,11773],[6,-47],[-44,-109],[-1,-49]],[[42458,12326],[-41,-40],[0,-90],[-10,-56],[0,-65],[-28,-21],[-72,-11],[-13,-33]],[[42200,11738],[-33,-52]],[[42133,11427],[-84,2]],[[42254,11504],[42,-39],[7,-7]],[[42341,11554],[-22,-16],[-1,0],[-25,-16],[-23,18]],[[42214,11654],[-2,4]],[[40969,13558],[14,22],[57,20],[22,27],[-35,27],[20,17],[35,58],[25,23],[0,0],[52,37],[1,0],[63,38],[50,74],[6,30],[-50,57],[-40,-36],[-32,25],[-67,-7],[-46,43],[1,39],[26,18],[6,33],[23,24],[0,3],[0,1],[-12,28],[4,2],[-44,7],[18,100],[94,-7],[38,14],[-15,22],[12,77],[-14,38],[22,10],[80,-20],[28,115],[61,2],[-11,-77],[13,-60],[140,-22],[58,-15],[50,0],[38,-13],[17,39],[-15,28],[72,-18],[65,-8],[9,86],[27,18],[13,74],[-16,6],[30,186],[-53,42],[-27,49],[6,33],[-37,37],[34,7],[0,33],[29,36],[3,39],[-80,14],[-38,49],[16,14],[-11,65],[58,35],[-12,25],[-49,37],[-49,20],[-36,-15],[-15,23],[27,38],[-25,9],[-9,28],[10,58],[-18,60],[-34,9],[-22,-26],[-53,22],[-32,51],[-40,13],[8,45],[-32,108],[-24,31],[-48,12],[-30,65],[1,34],[54,44],[17,-19],[36,28],[28,0],[57,81],[49,3],[9,82],[13,33],[-21,26],[9,36],[-12,43],[-3,62],[16,17],[88,-13],[28,2],[46,-35],[35,-5],[50,-38],[97,18],[72,47],[17,72],[-4,19],[41,50],[8,78],[18,0],[54,41],[66,25],[8,66],[21,-3],[8,45],[-43,15],[-26,-5],[-6,47],[-31,68],[-48,59],[13,63],[-20,52],[7,17],[-55,78],[-34,10],[-6,21],[-44,40],[-17,28],[13,76],[-12,56],[32,54],[4,33],[23,36],[5,47],[-58,14],[-45,28],[-48,2],[-13,21],[-48,14],[5,14]],[[41733,17536],[39,3]],[[43211,17188],[23,3]],[[43234,17191],[1,10]],[[43491,17495],[-1,8],[2,3],[0,3],[1,1],[0,2]],[[43492,17514],[-4,2]],[[43957,18012],[12,3]],[[44081,17941],[1,2]],[[44082,17943],[37,-27],[-20,-23],[-56,-126],[-66,-54],[-3,-20],[-59,1],[-6,-76],[-37,-42],[-37,-84],[57,-28],[80,-20],[-21,-46],[57,-1],[7,-77],[40,-20],[-10,-28],[4,-45],[-27,-11],[16,-64],[-54,20],[-47,0],[-3,-41],[-49,-89],[39,-5],[-12,-65],[-31,-11],[9,-30],[-34,-73],[-48,-9],[-50,-40],[-9,-29],[37,-40],[133,-19],[-24,-39],[-22,-11],[-23,-52],[26,-72],[-64,-46],[-21,-111],[-82,-67],[-5,-71],[-30,4],[-28,-19],[-29,-42],[-12,-73],[92,5],[25,22],[12,-45],[-15,-30],[5,-59],[32,-21],[10,-58],[-22,-37],[5,-66],[19,-108],[33,-23],[-8,-35],[16,-114],[33,-9],[6,-24],[46,-41]],[[43207,12598],[-25,-35],[7,-22],[-62,-43]],[[43127,12498],[-59,17],[-25,22]],[[42983,12595],[72,60],[60,-9],[56,-23],[36,-25]],[[42559,11454],[-35,5]],[[42484,11465],[-34,3]],[[42566,11526],[-7,-72]],[[45134,17237],[-90,-118],[-27,-62],[-5,-48],[15,-45],[-33,-32],[-75,-119],[-12,-48],[12,-40],[26,-19],[-18,-111],[10,-19],[-12,-56],[-28,-75],[11,-19],[-20,-40],[12,-36],[-32,-47],[-14,-45],[12,-27],[-17,-25],[7,-32],[-27,-38],[2,-72],[-12,-34],[-31,-37],[-40,-70],[16,-81],[-11,-55],[-39,-50],[-19,-50]],[[44082,17943],[-1,1]],[[44648,17893],[2,0]],[[44650,17893],[2,-36],[19,-20],[-4,-30],[33,-62],[7,-47],[42,-3],[54,13],[49,-30],[36,0],[63,-51],[-8,-34],[44,-6],[5,-69],[-11,-76],[46,-5],[-3,-74],[-5,-15],[51,-49],[-12,-70],[76,8]],[[39359,12835],[-109,-7],[-134,-2],[-41,91],[-88,48],[-52,78],[-32,8],[-13,25],[-45,35],[-72,24],[-53,-4],[-8,16],[-62,26],[-13,21],[-150,-102],[-19,-112],[6,-52],[4,-90],[26,-3],[-10,-70],[33,-4],[7,-28],[-19,-86],[-18,-133],[-15,2],[-16,-85],[14,-33],[-95,12],[-72,0],[-19,-119],[-89,42],[-11,-103],[31,-19],[130,-26],[24,4],[38,-43],[18,1],[-39,-209],[-59,8],[-26,-113],[-50,6],[-42,-49],[-47,5],[-36,-10],[-4,-23],[-149,19],[-119,11],[-14,16],[-175,23],[-11,-6],[-14,-81],[-403,50],[-6,51],[-238,-63],[-146,-34]],[[31199,12070],[0,20]],[[31199,12090],[0,277],[0,411],[-1,593],[0,469],[0,364],[-1,359],[0,519],[0,331],[0,497],[0,284],[-1,393],[0,555]],[[40209,17338],[-1,1],[1,1],[1,0]],[[40211,17340],[1,-1]],[[40214,17339],[2,1]],[[41730,17535],[3,1]],[[42364,11489],[-24,-13]],[[43645,12805],[-18,-12],[-15,-50],[-54,-14],[-12,-31],[-59,10],[-123,-34],[-78,-32],[-79,-44]],[[42438,11414],[-55,3],[-29,27]],[[44650,17893],[6,11]],[[44837,18037],[36,-4]],[[45130,18113],[32,-37],[2,-53],[16,-13],[-16,-82],[7,-43],[-26,-110],[-2,-81],[20,-79],[22,-34],[44,-30],[-18,-60],[5,-24],[-25,-63],[12,-79],[-19,-37],[-50,-51]],[[39450,12215],[0,-1]],[[42807,11952],[-16,-42],[10,-30],[-30,-38],[-34,-2],[-45,-22],[-13,-45]],[[43127,12498],[-11,-56],[-59,-40],[-20,-35],[-39,-144],[-64,-58]],[[42559,11454],[-13,-55]],[[42630,11485],[-45,-34],[-26,3]],[[42640,11568],[-13,-44],[3,-39]],[[42630,11485],[-6,-74],[-21,-27]],[[42193,10697],[-22,-29],[-19,-120]],[[40042,9856],[20,-48],[46,-24],[0,0],[15,17]],[[40123,9801],[58,-18],[-27,-30],[8,-49],[35,-3],[83,15],[34,-9]],[[40123,9801],[-5,30],[48,-1],[25,46],[33,-35],[29,0],[55,30]],[[41975,9968],[18,-12],[52,2],[-5,-37],[-40,-15],[-87,14],[-57,-25]],[[35967,6640],[-16,19],[-67,9]],[[35884,6668],[-21,55]],[[35863,6723],[-5,33]],[[35858,6756],[21,30],[74,7],[41,-13]],[[35994,6780],[-23,-67],[-4,-73]],[[35148,7114],[-37,-51],[-5,-122],[-31,1],[-15,-88]],[[35060,6854],[-12,-68],[-25,-29]],[[35023,6757],[-25,21],[-6,42],[-60,-1],[-8,-37],[-55,7],[-10,20],[-82,11]],[[34777,6820],[-108,15],[-73,2],[-11,-36],[-123,3],[-23,17]],[[34439,6821],[-29,26],[11,44],[-13,38],[-62,61],[-3,54],[-83,29],[-53,32],[-33,5],[-13,28],[-75,21],[14,23],[58,310]],[[34158,7492],[54,8],[162,-5],[17,56],[82,-14]],[[34473,7537],[11,-26],[37,-15],[12,-26],[39,-10],[25,33],[15,103],[129,-21],[-6,-35],[110,-14],[9,51],[79,-18],[-58,-133],[93,-46],[27,-33],[-6,-43],[-35,4],[-3,-53],[79,-14],[25,23]],[[35055,7264],[-15,-77],[0,-58],[108,-15]],[[35312,7520],[-14,-9],[-35,14],[-47,-38],[24,-83],[-6,-29],[-33,1],[-47,-58],[-99,-54]],[[34473,7537],[15,25],[1,81],[55,48],[-44,44],[-82,9],[-17,41],[-56,7],[29,37],[-15,25],[50,54],[149,-19],[27,116],[24,38],[-3,122],[63,0],[17,51],[49,0],[-24,62],[8,48],[32,0],[11,44],[150,0],[0,119]],[[34912,8489],[28,-26],[332,1],[4,-42],[-67,-64],[16,-32],[-40,-82],[-30,-21],[-28,-50],[-21,-82],[164,-1],[0,-43],[143,14],[4,-96],[51,-46],[-49,-79],[-4,-30],[-92,-39],[13,-24],[3,-55],[-13,-61],[21,-10],[-28,-39],[6,-58],[-13,-4]],[[35993,6635],[-15,-88]],[[35978,6547],[-19,25],[-42,6]],[[35917,6578],[-62,44],[-12,-18],[-40,13]],[[35803,6617],[12,59],[69,-8]],[[35967,6640],[26,-5]],[[35610,6960],[-70,-4]],[[35540,6956],[-3,0]],[[35537,6956],[-5,-1],[-47,-38],[-22,8]],[[35463,6925],[-3,5],[-36,55]],[[35424,6985],[18,72],[-11,20],[41,40],[26,50],[21,12],[96,-12],[-27,-40],[15,-14],[-15,-47]],[[35588,7066],[6,-40],[20,-19],[-4,-47]],[[36965,7080],[-33,-9],[-35,-57],[4,-40],[32,-81],[-42,-49],[-31,37],[-59,-18],[-70,5],[-43,14],[-25,-15],[-1,-42],[-31,-22],[-38,28],[-54,-34],[3,-37],[-48,-21],[-23,-33]],[[36471,6706],[-29,26],[-55,-9],[-52,-28],[-23,22],[-32,-1],[-24,30],[-51,-31],[-73,-9],[-29,-24],[-29,4],[-8,-59],[-73,8]],[[35994,6780],[-12,79],[-20,16]],[[35962,6875],[-9,24],[14,36]],[[35967,6935],[58,66],[23,129]],[[36048,7130],[57,23],[69,-41],[64,-2],[89,-11],[65,-61],[100,59],[48,12],[11,32],[52,5],[355,-3],[7,-63]],[[35863,6723],[-121,15]],[[35742,6738],[5,35]],[[35747,6773],[25,63]],[[35772,6836],[67,-9]],[[35839,6827],[-10,-68],[29,-3]],[[35685,6850],[-42,-14]],[[35643,6836],[-17,26]],[[35626,6862],[-20,62],[4,36]],[[35610,6960],[95,-11]],[[35705,6949],[-33,-73],[13,-26]],[[33738,5710],[-39,18],[8,34],[-14,29],[34,41],[-14,29],[29,19],[-14,53],[74,26],[19,29],[-19,24],[98,-1],[68,-14],[9,49],[62,-8],[31,24],[59,-6],[15,24],[23,79],[18,111],[22,4],[53,55],[13,125],[-19,70],[-24,6],[17,99],[103,-4],[14,90],[13,19],[80,-10],[2,32],[-20,65]],[[34777,6820],[11,-59],[13,-13],[-34,-35],[-12,-43],[38,-5],[11,-53],[-7,-24],[20,-32],[10,-67],[-7,-44],[36,-30],[30,-46],[38,10],[28,-7],[30,44]],[[34982,6416],[28,18],[54,-29],[93,15],[74,52],[68,-15],[30,-31],[-10,-60],[-49,-14],[-45,-55],[-13,-41],[-72,22],[-41,-1],[-14,-20],[-71,11],[-119,-52],[-13,-23],[-73,-50],[-133,-56],[-30,-39],[-76,-8],[-63,-66],[-7,-40],[-60,-36],[-13,-34],[-73,-62],[-174,-66],[-27,-55],[-50,-15],[-67,-70],[-49,-3],[-51,55],[-121,66],[-77,-4]],[[35023,6757],[39,-36],[-6,-46],[24,-47],[51,3],[56,-39]],[[35187,6592],[-33,-33],[-51,-15],[-32,-38],[-44,-10],[-55,15],[-36,-37],[-11,-39],[57,-19]],[[35839,6827],[104,48],[19,0]],[[35907,6507],[-27,-145]],[[35880,6362],[-70,8],[-65,-26],[-36,18]],[[35709,6362],[66,80],[2,56]],[[35777,6498],[37,21],[93,-12]],[[35880,6362],[43,-26]],[[35923,6336],[7,-25],[44,-44],[53,-33],[117,4],[55,-54],[-30,-16],[-72,-5],[-47,-62],[-36,0],[-133,20],[-96,19],[-89,-46],[-27,-58],[-112,-21],[-42,23],[-51,53],[-114,93],[-80,48],[15,8],[66,-23],[39,-40],[70,-13],[92,23],[61,28],[9,36],[47,50],[10,45],[30,16]],[[35488,6835],[-1,-3]],[[35487,6832],[-39,-20],[-64,6]],[[35384,6818],[12,82],[-37,92]],[[35359,6992],[33,-16],[32,9]],[[35463,6925],[25,-90]],[[35537,6807],[-9,-23]],[[35528,6784],[-100,-46],[-10,-50],[-66,-21]],[[35352,6667],[15,48],[-41,4],[54,67],[4,32]],[[35487,6832],[0,1]],[[35487,6833],[4,-1],[6,0],[18,-2],[29,8]],[[35544,6838],[-7,-31]],[[37225,5753],[44,21],[58,-5],[6,18],[0,1],[2,84],[-108,17],[-58,14],[-16,22],[-49,14],[11,36],[-41,4],[2,33],[-41,4],[-35,66],[22,98],[16,107],[33,30],[18,39],[27,6],[14,37],[-23,36],[1,53],[22,12],[87,-32],[6,17],[61,-9],[5,33],[49,-10],[8,32],[38,-1],[20,94],[-26,-7],[-45,23],[-55,-36],[34,351],[13,19],[-30,42],[-40,32],[-19,-3]],[[37236,7045],[123,292],[112,242],[-10,35],[19,12],[69,-43],[59,10],[19,-32],[42,-29],[568,-86],[53,75],[-63,80],[-3,26],[62,26],[7,81],[-51,-2],[-63,31],[-24,-2],[30,120],[61,42],[-9,45],[-39,0],[-37,62],[24,14],[0,32],[86,5],[45,-37],[35,-42],[36,21],[64,17],[14,36],[465,147],[193,-154]],[[41170,7177],[-78,-44],[-93,-2],[-46,-12],[-47,-35],[-36,-69],[-36,-49],[-64,-18],[-25,-30],[-52,-3],[-56,-29],[-3,-17],[-180,-11],[-71,-17],[-19,12],[-141,5],[-221,-4],[-40,-7],[-90,1],[-66,-13],[-137,-13],[-16,6],[-168,2],[-105,-3],[-118,-13],[-89,-19],[-117,-38],[-138,-36],[-180,-71],[-91,-50],[-86,-56],[-179,-133],[-253,-213],[-192,-157],[-173,-162],[-96,-84],[-48,4],[-65,-22],[-74,-64],[-65,-5],[-58,-37],[-70,15],[-49,28],[-14,39]],[[35698,6613],[-23,-8],[-51,79],[0,41]],[[35624,6725],[66,2]],[[35690,6727],[10,-19]],[[35700,6708],[-6,-34]],[[35694,6674],[4,-61]],[[35384,6818],[-324,36]],[[35148,7114],[5,8],[123,-18],[83,-112]],[[35742,6738],[-7,-34],[-35,4]],[[35690,6727],[-47,43],[-16,27]],[[35627,6797],[41,-5]],[[35668,6792],[79,-19]],[[36118,6346],[-19,-15],[-76,15],[-37,-38],[-34,1],[-29,27]],[[35907,6507],[10,71]],[[35978,6547],[36,-32],[-10,-57],[63,-8],[17,-20]],[[36084,6430],[-11,-58],[45,-26]],[[35803,6617],[-42,29],[-1,1],[-23,21],[-43,6]],[[37236,7045],[-37,16],[-39,-29],[-76,45],[-48,-23],[-71,26]],[[36048,7130],[-38,7],[-42,48],[-62,13],[-18,17],[14,41],[34,22],[6,62],[9,33],[-30,39],[-63,12]],[[35858,7424],[-36,20],[16,49],[-3,36],[61,29],[1,50],[60,-2],[4,46],[36,-4],[57,11],[23,21],[0,38],[41,26],[-19,34],[57,97],[-3,40],[18,101],[-27,18],[0,51],[48,0],[-2,36],[86,-2],[81,92],[-14,69],[0,76],[111,0],[-1,66],[49,-1],[26,132],[0,37],[258,0],[7,52],[105,0],[-1,80],[100,0],[20,60],[-34,11],[8,43],[-19,53],[-23,12]],[[35777,6498],[-23,64],[-56,51]],[[35874,7000],[-13,-30],[-62,-6],[-10,-65],[-62,-14],[-12,-31]],[[35715,6854],[-30,-4]],[[35705,6949],[55,55]],[[35760,7004],[27,5],[87,-9]],[[35668,6792],[-25,44]],[[35715,6854],[57,-18]],[[36471,6706],[0,-36],[-18,-24],[35,-38],[-21,-21],[-78,34],[-21,-17],[-75,12],[-6,-34],[29,-83],[-15,-69],[-74,-19],[-143,19]],[[35352,6667],[-100,-72],[-65,-3]],[[35624,6725],[-24,41],[-72,18]],[[35537,6807],[75,1],[15,-11]],[[34983,9059],[-29,17],[-43,-12],[11,-29],[-20,-17],[-76,5],[-8,-23],[36,-41],[-13,-34],[32,-28],[-6,-28],[16,-35],[-36,-63],[4,-26],[-19,-41],[-1,-49],[11,-22],[0,-76],[56,0],[-2,-68],[16,0]],[[34158,7492],[-28,33],[-64,8],[3,20],[-106,15],[-17,-48],[-9,-66],[-67,41],[-125,28],[-77,66],[-49,-41],[-75,37],[-51,11],[-20,-49],[-85,17],[-38,48],[-105,30],[-7,43],[-29,10],[7,73],[-35,53],[-61,13],[-60,0],[0,-50],[-51,5],[-20,34],[-60,13],[-53,-7],[-35,38],[-27,0],[-16,56],[-71,0],[-22,-41],[19,-28],[1,-45],[-40,-30],[8,-26],[37,-2],[30,-50],[-74,-9],[-77,-49],[-61,-4],[-58,6],[-55,-7],[-7,-62],[-17,-7],[-5,-46],[-56,-17],[-112,21],[-29,18],[26,25],[-29,41],[-79,-22],[-31,-27],[-77,2],[-42,-7],[-38,30],[-77,-7],[-25,-31],[-95,-38],[1,-36],[35,-28],[9,-27],[-111,0],[0,-87],[-234,28],[65,-53],[-20,-42],[-104,11],[-78,-35],[-57,56],[-81,51]],[[31167,7349],[-1,342],[-3,321],[-3,490],[-3,443],[-1,290],[3,421],[-1,446],[-1,434],[0,234],[-3,401],[7,117],[39,-30]],[[35487,6833],[1,2]],[[35537,6956],[0,0],[-1,-1],[-2,-1],[-1,-2],[1,-8],[-7,-5],[30,-24],[14,-57]],[[35571,6858],[-27,-20]],[[35967,6935],[-29,10],[-2,29],[-62,26]],[[35760,7004],[10,42],[-182,20]],[[35312,7520],[0,0],[73,-10],[91,14],[82,-19],[41,13],[28,-33],[29,17],[47,-42],[68,1],[9,-36],[78,-1]],[[35571,6858],[55,4]],[[37225,5753],[-46,1],[-4,40],[-33,15],[-66,-26],[-27,9],[-78,-35],[-13,-30],[41,-41],[19,-38],[29,6],[6,-64],[23,-51],[35,0],[14,27],[36,24],[54,13],[4,45],[20,37],[45,-24],[-12,-86],[21,-39],[-28,-29],[-28,-56],[9,-45],[36,-31],[-52,-26],[8,-32],[-19,-38],[-59,-10],[-48,47],[20,40],[-76,75],[-6,28],[-39,63],[-55,57],[-67,45],[-67,23],[-60,-17],[-13,-38],[10,-22],[-30,-21],[-68,-13],[-4,40],[-48,108],[-43,60],[-78,75],[-54,23],[-64,-37],[-55,-2],[-47,28],[-24,42],[-56,64],[-77,32],[-94,-7],[-58,38],[-50,4],[-22,-25],[-86,26],[25,46],[53,21],[69,-3],[43,-69],[58,-12],[56,8],[18,24],[-15,26],[14,49],[-11,19],[65,7],[41,-8],[37,69],[-40,22],[7,43],[-27,29],[-11,45],[-65,25]],[[33738,5710],[-33,-15],[-42,12],[-108,98],[-113,59],[-86,2],[-92,22],[-9,16],[-83,34],[-64,50],[-174,115],[-80,33],[-20,-9],[-113,61],[-123,-18],[-32,-32],[-94,3],[-82,40],[-66,46],[-91,43],[-54,16],[-158,15],[-87,-26],[-62,-37],[-10,-17],[57,-83],[-79,5],[-24,-40],[-36,1],[-7,37],[-64,33],[-61,-9],[-10,37],[-44,74],[-94,84],[-50,38],[-111,63],[-100,48],[-81,23]],[[31158,6532],[6,310],[4,386],[-1,121]],[[35537,6956],[3,0]],[[39260,3196],[-49,-21],[-1,-19],[-106,17],[-30,-14],[-21,-121],[12,-25],[-22,-32],[22,-52],[-163,-43],[-51,4],[-34,-131],[-35,-111],[-263,-11],[32,-33],[9,-50],[23,-31],[-77,-41],[-44,7],[-36,-27],[-34,15],[-98,-45],[-46,51],[-109,-18],[-31,38],[-25,-17],[-135,74],[-50,11],[-26,-9],[-82,43],[-9,23],[-59,-3],[-114,18],[-81,24],[6,27]],[[37533,2694],[6,34],[59,19],[-73,137],[0,43],[-38,44]],[[37487,2971],[64,30],[62,-14],[40,-66],[12,-37],[25,-7],[37,31],[-67,30],[-13,71],[23,22],[62,29],[37,-12],[39,7],[44,36],[36,14],[57,-21],[47,5],[38,-21],[77,25],[34,41],[33,17],[27,-18],[46,21],[16,-38],[40,-38],[50,2],[55,28],[38,33],[53,63],[34,58],[65,26],[54,-42],[37,5],[44,-27],[59,-8],[49,21],[44,43],[59,106],[66,-11],[9,-26],[47,0],[38,-49],[-3,-19],[113,-17],[5,-23],[41,-45]],[[39345,4011],[-57,-27],[-28,25],[-52,-1],[-29,-46],[-72,-27],[-71,30],[-36,32],[20,14],[-26,41],[-12,78],[-57,30],[-19,50],[-52,5],[-33,18],[45,31],[-2,51],[-46,60],[-62,-23],[-62,50],[71,47],[64,55],[10,30],[87,39],[6,-41],[50,-19],[151,-162],[50,-35],[87,-24],[22,4],[-8,-61],[8,-60],[-54,-39],[18,-27],[44,15],[24,-73],[21,-40]],[[39509,3745],[-38,-2],[-66,-50],[-47,-14],[-33,69],[-34,5],[-65,-44],[-23,28],[-70,-13],[-108,5],[-31,41],[-32,-9],[-4,36],[52,34],[52,22],[53,6],[75,-18],[35,29],[36,-10],[98,39],[22,-38],[53,-44],[28,-5],[10,-32],[37,-35]],[[39250,3683],[-15,-51],[-63,-72],[-34,32],[-38,2],[2,64],[65,14],[38,-7],[45,18]],[[38264,4881],[-35,-30],[-21,29],[32,18],[24,-17]],[[39336,3918],[-51,1],[16,33],[35,-34]],[[37533,2694],[-93,9],[-40,-34],[-99,-27],[-39,38],[0,29],[-16,26],[-95,16],[12,20],[-23,29],[-32,-35],[-61,7],[-55,-12],[-12,-41],[-57,-54],[-44,-16],[-24,-43],[-11,-57],[-143,5],[-113,-16],[1,-137],[109,-120],[110,-339],[-40,-36],[10,-40],[-27,-33],[85,-168],[16,-86],[19,-25],[-9,-75],[29,-79],[-49,-47],[9,-15],[-63,-68],[-44,-60],[-43,-78],[-97,-38],[-27,-32],[116,-207],[-7,-33],[58,-57],[-17,-71]],[[36727,694],[-4,-45],[21,-27],[-15,-32],[-44,-26]],[[36685,564],[-21,-12],[-12,-37],[20,-53],[-23,-32],[15,-35],[-60,-31],[-44,47],[-50,110],[-26,-5],[-31,90],[-33,-6],[-41,29],[23,47],[-31,12],[-53,42],[-21,40],[-65,-10],[-35,5],[-7,47],[-40,39],[-32,65],[-12,56],[-43,52],[14,37],[-30,43],[1,37],[-34,30],[-61,21],[23,51],[-47,56],[2,23],[-28,38],[18,22],[-33,114],[-30,33],[19,35],[-9,52],[-33,53],[44,-5],[42,-89],[60,-10],[4,-28],[97,-64],[37,-8],[24,-28],[-5,-38],[49,18],[24,-14],[36,51],[-32,60],[-55,-8],[-4,27],[-35,11],[-7,24],[-66,54],[3,46],[-24,46],[-60,-12],[-28,-27],[0,-35],[-50,20],[37,43],[4,100],[-33,92],[-63,100],[-58,37],[-55,49],[-5,22],[-50,39],[-21,44],[-38,46],[-58,20],[9,38],[-20,25],[-21,77],[-116,170],[-40,26],[37,30],[-8,43],[-60,68],[-13,49],[-28,30],[12,34],[-24,55],[5,65],[-23,60],[-44,50],[15,10],[2,50],[-21,26],[80,36],[31,61],[-18,49],[11,69],[-31,41],[20,36],[-5,28],[39,8],[16,-47],[108,-30],[47,-32],[126,-7],[25,-38],[39,1],[17,-23],[71,-15],[44,18],[62,6],[35,-7],[91,-53],[47,1],[50,-22],[48,-3],[32,13],[68,-67],[101,-27],[90,-10],[-9,-24],[104,-76],[65,-5],[40,-27],[47,-3],[136,-61],[46,-6],[53,-35],[74,-10],[24,9],[152,-25],[79,15],[90,39],[-3,-32],[58,-75],[-16,82],[61,28],[31,33]],[[34683,4332],[-6,-52],[-33,-78],[-37,-8],[-46,-45],[-78,-22],[-64,-29],[-20,16],[-27,68],[35,9],[3,55],[-15,47],[-37,31],[-11,45],[28,54],[5,66],[-16,44],[-2,60],[49,17],[38,41],[8,28],[-9,53],[35,8],[104,-47],[64,-50],[-9,-80],[4,-47],[26,-52],[-25,-56],[6,-52],[30,-24]],[[35716,3418],[-44,10],[-57,-2],[-43,-29],[-62,-4],[-14,17],[3,51],[43,34],[68,-4],[47,-35],[33,-9],[26,-29]],[[35410,3766],[-3,-105],[-21,-31],[6,-49],[-21,-36],[-36,41],[9,25],[-24,78],[50,-3],[21,71],[19,9]],[[35607,3755],[-22,-32],[-63,-35],[-39,18],[-17,37],[44,23],[0,31],[65,-8],[32,-34]],[[35757,3325],[-62,12],[15,21],[47,-33]],[[38214,771],[-75,9],[-75,-23],[-25,11],[-14,2],[5,72]],[[38030,842],[4,93],[52,32],[0,23],[29,43]],[[38115,1033],[44,-44],[-15,-22],[77,-30],[16,-39],[-5,-41],[26,-10],[0,-49],[-44,-27]],[[36727,694],[124,-17],[148,-76],[262,37],[211,194],[8,18],[0,0],[-9,62],[84,-6],[137,-58],[10,-36],[91,12],[-12,39],[32,16],[107,-22],[110,-15]],[[38214,771],[31,-87],[-33,-13],[-39,38],[-24,-51],[48,-17],[-36,-44],[-21,-2],[-11,-62],[23,-46],[-23,-57],[-27,-19],[-53,-2],[-27,39],[-48,4],[-10,31],[27,11],[-25,34],[-42,-46],[-50,36],[-43,-15],[92,-53],[25,-27],[-9,-62],[-30,13],[-42,-14],[54,-38],[-45,-74],[-40,-14],[-44,-69],[20,-47],[-40,-4],[-35,-23],[29,-22],[9,-30],[-64,-39],[-67,35],[-64,-9],[-45,-21],[-21,37],[-37,0],[-86,84],[-76,-1],[-53,-20],[-78,14],[-48,19],[-32,-26],[-56,12],[7,32],[-71,10],[-36,-24],[-76,-19],[-40,-32],[-40,4],[7,50],[-12,47],[-36,43],[-32,73],[36,28],[74,-9],[36,8],[65,-21],[51,0],[20,41],[-30,13],[-62,-5],[-31,-31],[-41,18],[-52,-10],[-52,22],[-25,33],[16,69],[-32,7],[-20,29],[-8,49],[21,15]],[[38344,469],[-90,-42],[-35,-50],[2,-44],[63,-50],[-34,-17],[-31,-82],[7,-26],[-53,-9],[-41,44],[15,13],[-32,51],[-27,-6],[0,-36],[-25,-48],[-50,5],[0,32],[-48,45],[28,7],[40,-53],[24,25],[6,76],[60,10],[-13,28],[22,36],[62,42],[39,-13],[24,27],[-10,48],[45,28],[-10,23],[-103,7],[4,32],[43,69],[39,0],[43,-49],[-8,-44],[22,-20],[22,-59]],[[38188,985],[61,16],[23,19],[56,-31],[17,14]],[[38345,1003],[15,-27],[83,-34],[-31,-93],[47,-40],[-31,-28],[22,-49],[-62,-19],[7,45],[-30,15],[7,71],[-46,5],[-15,28],[-57,9],[-2,27],[-64,72]],[[38188,985],[-24,10],[-11,36],[-38,2]],[[39260,3196],[40,-41],[27,-50],[24,-15],[-46,-47],[-29,-95],[14,-61],[-13,-44],[29,-53],[38,-24],[-59,-12],[-23,-50],[15,-18],[60,39],[-35,-76],[-30,-96],[-2,-42],[22,-75],[32,-23],[5,-58],[-29,-43],[-10,-70],[5,-40],[-27,-58],[11,-58],[28,-25],[26,-52],[-19,-17],[-25,-120],[29,-27],[38,-78],[-27,-15],[-3,-39],[43,-27],[-11,-36],[-25,-19],[-10,-42],[-59,25],[4,30],[30,45],[-34,34],[40,25],[-3,18],[-49,12],[-10,27],[-37,16],[-56,2],[16,38],[47,9],[34,45],[-17,15],[-36,-42],[-59,4],[23,-41],[-26,-46],[-49,-7],[-28,-21],[9,-49],[-16,-41],[-58,-56],[15,-22],[-29,-59],[26,-39],[-49,-76],[33,-40],[-15,-41],[-1,-57],[-31,5],[-20,-38],[-68,9],[53,-68],[-4,-35],[34,-42],[-28,-38],[9,-29],[-51,-20],[-29,-45],[-6,-34],[-60,-91],[-59,-16],[-44,18],[-47,-16],[-77,40],[12,28],[-44,51],[-77,19],[-29,-23],[-58,31]],[[38987,481],[-70,7],[-4,24],[-56,8],[-1,46],[-25,21],[-28,-28],[8,-31],[-55,-35],[-29,-4],[-75,28],[-23,62],[45,15],[12,33],[-61,-7],[-65,35],[-10,76],[71,24],[-19,57],[67,-12],[4,-26],[-24,-41],[73,-56],[75,-7],[-5,22],[38,19],[-35,25],[-9,45],[19,26],[-34,19],[-2,38],[76,0],[-12,37],[21,24],[73,-34],[46,-50],[-14,-27],[14,-32],[-80,-58],[29,-31],[0,-26],[33,-85],[-18,-73],[50,-28]],[[39162,1152],[-46,-20],[-50,6],[-16,-20],[27,-50],[-90,-10],[51,81],[-32,42],[43,62],[58,-16],[18,-45],[37,-30]],[[39358,1512],[-42,-2],[-62,17],[1,41],[71,-12],[32,-44]],[[28559,10153],[-46,15],[-33,-18]],[[28480,10150],[-9,137],[20,1]],[[28491,10288],[78,3]],[[28569,10291],[2,-26],[-27,-47],[15,-65]],[[28849,9457],[51,-3],[32,17],[21,34],[59,6],[14,14],[109,35],[16,255],[-103,45],[1,57],[-44,33],[18,31],[-16,60],[13,98],[-23,33],[16,23],[-66,40],[37,37],[-8,34],[47,20],[-62,42],[-66,30],[-21,56],[-55,6],[-14,26]],[[28805,10486],[-64,23],[29,26],[-17,34],[27,22],[-4,34],[-82,4]],[[28694,10629],[6,53],[-10,80],[12,83],[33,38],[-6,51],[64,-3],[2,126],[72,7],[7,-13],[62,6],[14,-70],[79,10],[-17,-73],[104,-10],[39,-14],[113,37],[0,-28],[96,0],[1,129],[6,98],[-1,378],[382,3],[0,-87],[175,-1],[0,-80],[398,-1],[0,-71],[177,1],[-1,813],[698,-1]],[[31158,6532],[-137,17],[-58,-5],[-25,-13],[-56,6],[-61,-9],[-22,21],[-79,23],[-60,38],[-70,63],[-37,6],[-48,38],[-66,129],[-57,92],[-91,102],[-79,55],[17,39],[-77,68],[-50,-5],[-38,25],[-102,108],[-26,46],[-38,36],[-39,54],[-43,75],[41,57],[-14,59],[-41,25],[-3,59],[-80,76],[86,58],[36,12],[43,36],[35,53],[13,65],[-1,95],[-44,152],[-38,103],[-86,184],[-61,105],[-71,110],[-119,151],[-78,85],[-92,90],[-132,112],[-122,88],[-78,52],[-161,89]],[[28515,10067],[-30,-18],[-62,-3]],[[28423,10046],[15,34],[-9,74]],[[28429,10154],[51,-4]],[[28559,10153],[55,-11]],[[28614,10142],[-4,-60],[-26,11],[-69,-26]],[[28694,10629],[-49,-8],[13,-30],[-85,-48],[-53,-8],[-74,3],[-64,-42],[-25,2]],[[28357,10498],[-2,29],[-40,55],[-47,24],[-35,68],[-77,54],[-6,47],[-36,80],[-3,65],[-31,42],[-40,2],[9,40],[-9,34],[-77,90],[-24,-10],[-24,-35],[-21,-61],[-29,-45],[22,-27],[-16,-75],[-68,-59],[-33,-37],[-19,-73],[-15,-26],[-10,-98],[34,-20],[-33,-62],[4,-31],[-25,-92],[-29,-46],[-36,-76],[-9,-50],[-38,-91],[7,-50],[-41,-10],[36,-76],[-79,-40],[-7,-20],[-49,-3],[-92,59],[-49,-1],[-48,22],[-48,2],[-80,-42],[-20,-40],[-83,11],[-54,-29],[-26,-55],[-48,-15],[-107,24],[-52,0],[-64,-69],[-49,-5],[-19,-17],[-36,22],[-23,37],[18,24],[1,46],[48,7],[6,26],[43,27],[29,59],[-30,74],[42,35],[6,63],[40,25],[-4,27],[76,-25],[90,4],[46,17],[25,-4],[60,12],[31,-35],[48,-7],[31,-28],[38,14],[44,37],[9,24],[3,93],[19,56],[18,110],[14,25],[2,76],[-35,74],[12,46],[-7,52],[-47,9],[10,35],[28,1],[13,64],[16,28],[2,108],[-56,103],[74,4],[57,107],[-41,50],[79,77],[32,16],[-2,23],[-31,29],[46,53],[94,75],[11,35],[40,48],[27,14],[42,50],[30,18],[19,36],[95,26],[13,29],[-42,6],[6,42],[-38,82],[-43,49],[13,44],[-73,85],[-5,30],[29,63],[46,28],[108,45],[45,-19],[34,30],[-13,38],[6,30],[-26,49],[-59,22],[-28,81],[-17,86],[-14,24],[-10,90],[43,25],[-60,47],[-50,19],[29,28],[-74,85],[37,33],[-57,26],[1,28],[-40,-3],[17,-77],[-15,-94],[1,-51],[30,9],[34,-41],[-14,-35],[15,-80],[-21,-29],[-3,-52],[-44,-7],[38,-84],[-69,3],[-33,36],[-34,10],[-55,-27],[-18,-28],[0,-43],[-24,-12],[-43,-59],[-81,-39],[-22,-27],[-4,-78],[-36,-64],[-26,-28],[-6,-55],[7,-39],[-26,-44],[0,-28],[-39,-24],[-33,-55],[-21,-73],[-75,-112],[-46,-31],[-49,-12],[-60,3],[-49,-25],[-40,-8],[-44,-35],[-103,-49],[-64,-6],[-24,-33],[-56,-6],[-41,-34],[-51,-26],[-57,-13],[-24,-30],[6,-20],[-73,-46],[-71,-29],[-94,-75],[-18,-36],[8,-23],[-25,-33],[-9,-40],[-26,-16],[-39,-52],[-6,-33],[-80,-78],[-63,-10],[-30,-46],[17,-28],[3,-71],[-13,-58],[-39,13],[-15,30],[-37,-2],[-13,-31],[-66,-2],[-29,-23],[-31,-66],[9,-28],[-56,-30],[-8,-93],[28,-6],[0,-47],[-36,8],[-68,-67],[54,-10],[70,17],[37,42],[34,-18],[58,25],[-21,-76],[-38,-24],[4,-33],[33,-63],[11,-55],[-22,-15],[-47,5],[-14,43],[-72,34],[-18,45],[-93,29],[-57,-10],[-32,-95],[-72,8],[5,37],[-21,34],[-114,111],[-31,47],[-73,51],[-70,23],[4,36],[-28,48],[-28,13],[-24,35],[-54,29],[-61,-14],[-49,-41],[1,73],[48,74],[40,36],[7,-71],[51,-18],[37,1],[21,-21],[-11,-38],[51,-19],[12,-52],[36,-21],[60,9],[4,16],[73,6],[-62,28],[-18,21],[2,39],[-49,22],[-12,34],[-4,56],[-31,24],[7,44],[-24,142],[-32,70],[-26,31],[-57,32],[38,38],[7,51],[-12,66],[-21,41],[-58,68],[-19,53],[-22,0],[-37,49],[-52,37],[-63,71],[-98,61],[-103,69],[-5,46],[25,53],[-3,50],[-19,87],[-46,120],[-47,24],[-22,38],[-85,50],[61,2],[0,40],[-20,28],[-74,13],[-36,24],[-48,-23],[21,-33],[52,-7],[-16,-26],[-39,30],[-75,36],[-63,19],[-39,-5],[-51,-31],[-10,57],[-31,36],[-28,9],[-30,41],[-19,-35],[37,-41],[61,-24],[-1,-60],[-36,4],[-63,40],[7,17],[-33,102],[-42,19],[-34,-19],[-25,26],[23,23],[26,-7],[17,32],[-4,28],[-45,46],[-38,-11],[-62,25],[6,35],[61,31],[7,29],[-21,55],[-65,73],[32,13],[62,-10],[60,-35],[-3,-53],[38,16],[1,22],[36,38],[33,80],[-13,9],[-5,53],[-31,69],[-74,80],[-72,33],[-44,-19],[-41,12],[-39,-18],[-18,-35],[-77,11],[-31,-38],[-29,-11],[-22,34],[17,30],[-14,24],[19,49],[57,-9],[31,19],[-49,110],[-86,94],[-57,-30],[-20,36],[-3,34],[-78,12],[12,43],[-26,25],[2,33],[-80,26],[-30,-43],[12,-24],[-54,-28],[-67,76],[-29,-22],[-56,-21],[6,-70],[-76,20],[-64,-4],[-22,-27],[-88,41],[-48,1],[-40,42],[-50,36],[-89,37],[-79,43],[-62,50],[-76,40],[-38,12],[-87,-9],[-80,26],[-71,0],[-59,-14],[-25,-17],[-20,-38],[-104,-25],[-9,-17],[-64,6],[-8,-10],[-105,17],[-27,18],[-38,56],[-50,44],[-80,47],[-101,74],[-59,33],[-60,48],[-133,74],[-225,110],[-262,112],[-64,24],[-64,9],[-53,-31],[-27,-36],[-34,-19],[-201,-71],[-60,-10],[-133,7],[-116,18],[-88,-9],[-66,11],[-93,0],[-78,12],[-59,-7],[-72,3],[-41,-11],[-202,-3],[-117,-23],[-70,1],[-99,-11],[-73,1],[-97,-8],[-106,-17],[-70,-4],[-90,-13],[-104,-8],[-62,-11],[-99,-8],[-54,-14]],[[17866,13993],[0,297],[0,509],[0,276],[0,536],[0,586],[0,488],[0,488],[0,586],[0,417],[0,266],[0,684],[0,487],[0,489],[0,555]],[[17866,20657],[340,0],[549,0],[337,0],[438,0],[610,0],[359,0],[422,-2],[326,2],[411,0],[643,0],[567,0],[717,0],[695,0],[696,0],[442,0],[500,0],[463,1],[371,0],[462,0],[648,1]],[[27862,20659],[93,0],[93,0]],[[31096,20659],[100,0]],[[31196,20453],[0,-170],[0,-212]],[[25869,10050],[-41,-7],[-15,16],[3,43],[-52,40],[-31,34],[30,13],[40,-58],[55,-38],[11,-43]],[[24028,11610],[-33,4],[-60,-59],[5,87],[66,19],[22,-51]],[[23057,13354],[-70,-36],[-3,-44],[-50,-19],[-20,22],[6,40],[36,-4],[45,33],[56,8]],[[27177,10701],[-20,-39],[-25,5],[-5,32],[29,43],[21,-41]],[[26191,9917],[-59,12],[20,21],[39,-33]],[[28429,10154],[-37,126],[15,46],[-13,40],[42,14],[1,-46],[56,-17]],[[28493,10317],[-2,-29]],[[28377,9822],[9,10],[-3,138],[40,76]],[[28515,10067],[43,-31],[-34,-49],[-16,-58],[-46,-6],[-48,-32],[-1,-64],[-36,-5]],[[28730,10385],[-24,-22],[-13,-64]],[[28693,10299],[-124,-8]],[[28493,10317],[-18,46]],[[28475,10363],[28,-3],[35,24],[44,-28],[37,42],[84,13],[27,-26]],[[28849,9457],[-132,44],[-63,9],[-23,-22],[-66,-13],[-70,-74],[-48,-40],[-105,14],[-23,-13],[-122,3],[-39,-4],[-47,-24],[-64,1],[-77,43],[-2,24],[33,50],[50,50],[28,-6],[107,60],[57,93],[45,25],[65,24],[8,45],[-5,49],[21,27]],[[28614,10142],[-4,27],[29,35],[10,46],[38,26],[6,23]],[[28730,10385],[34,-10],[1,39],[40,72]],[[28013,9126],[-26,-8],[-78,-65],[-21,1],[-94,45],[-61,-7],[-87,22],[-68,-1],[-19,-28],[-70,-9],[-62,-41],[-9,-37],[21,-28],[-17,-40],[-73,-21],[-37,-34],[-45,-19],[-88,67],[-14,19],[-88,10],[-104,18],[-24,-41],[-51,-28],[-32,18],[-60,-10],[-57,10],[-60,-10],[-31,-19],[-62,30],[-48,-22],[-99,-10],[-21,9],[-21,38],[-41,46],[-53,5],[-69,76],[-10,25],[34,30],[-4,25],[20,39],[10,54],[122,11],[22,20],[38,-2],[36,28],[84,7],[100,23],[133,7],[58,19],[23,27],[70,6],[32,20],[37,4],[51,28],[153,-19],[49,17],[18,-17],[58,27],[79,6],[-72,-60],[15,-28],[37,8],[30,-22],[-42,-28],[-30,-41],[27,-26],[73,-4],[71,4],[53,14],[26,-40],[-66,-56],[6,-33],[50,0],[31,40],[33,6],[45,43],[16,48],[74,-3],[81,-27],[23,-44],[58,-46],[17,-26]],[[28475,10363],[-11,40],[-53,36],[-54,59]],[[3141,13092],[-3,56],[-35,46],[32,23],[-14,46],[-32,5],[-3,33],[30,2],[34,30],[-1,31],[22,50]],[[3171,13414],[137,1]],[[3308,13415],[-15,-28],[5,-103],[-16,-47],[-45,-54],[26,-32],[0,-46],[-34,-15],[-88,2]],[[3653,12419],[0,54],[-50,60],[-158,-3],[-73,3],[-18,-9],[-73,3],[-68,15],[-36,-13],[-19,17],[-117,-13]],[[3041,12533],[-28,112],[-27,200],[27,85],[43,39],[26,41],[32,7],[17,25],[10,50]],[[3308,13415],[89,1],[41,-8],[3,39],[36,37],[-3,31],[-36,2],[-20,32]],[[3418,13549],[20,13],[-14,37],[50,-10],[23,22],[78,3],[124,-11],[43,-49]],[[3742,13554],[-4,-131],[30,3],[35,-71],[16,-5]],[[3819,13350],[-149,0],[-38,-60],[45,-81],[32,-39],[0,-127],[111,0],[90,-89],[40,-64],[34,-36],[16,-35],[51,-50],[26,-47],[71,-11],[5,-40],[-10,-37],[0,-71],[-36,0],[0,-87],[-16,-31],[-28,0],[-11,-62],[-110,-1],[0,-28],[-67,0],[0,107],[-61,0],[0,-20],[-77,0],[0,-21],[-84,-1]],[[3382,13788],[-10,-30]],[[3372,13758],[-45,25],[-41,-2]],[[3286,13781],[-1,20],[-90,6]],[[3195,13807],[22,54],[-48,97]],[[3169,13958],[62,-20],[60,16],[-1,-89],[89,0],[3,-77]],[[3241,13637],[-22,-27],[-26,5],[-3,1],[-18,-21]],[[3172,13595],[-6,1],[-1,1],[-21,4]],[[3144,13601],[4,149]],[[3148,13750],[51,14],[25,-37]],[[3224,13727],[0,-1],[24,-31],[-28,-25],[21,-33]],[[17866,23663],[-556,0],[-761,0],[-2017,0],[-555,0],[-556,0],[-370,-9],[0,-1143],[0,-1171],[0,-1558],[-340,-1],[-418,-1],[-312,0],[-406,1],[-325,0],[0,75],[-92,0],[0,32],[-305,0],[0,-68],[-254,0],[0,-135],[-439,0],[0,25],[-319,0],[0,-567],[-144,0],[-717,-2],[-520,0],[-530,2],[0,-248],[18,0],[0,-129],[92,0],[-1,-153],[-6,-357],[50,1],[8,-288],[-174,-2],[5,-195],[-7,-4],[-270,-1],[0,-448],[-29,0],[0,-80],[-126,-231],[-354,2],[-159,-210],[-534,-2],[0,205],[-316,0],[1,-191],[74,-389],[642,-250],[0,7],[376,-146],[0,-6],[149,-57],[483,-188],[28,-3],[-1,-280],[-1,-401],[-3,-616],[0,-251],[0,-449],[0,-395],[-480,0],[-443,0],[-19,-13],[-275,1],[0,-28],[-108,-11],[-223,-1],[9,-44],[-336,-1],[0,17],[-141,-9],[15,57],[-144,3],[4,43],[-72,-1],[-1,22],[-103,19],[-131,9],[-13,-12],[-179,-3],[-12,-30],[-47,-1],[-41,-17],[-127,2],[-19,-23],[-106,-10],[-85,2]],[[4798,13359],[8,57],[-21,165],[-36,37],[-57,29],[-50,0],[-13,27],[10,34],[50,23],[-17,23],[35,40],[-38,67],[-54,2],[-19,32],[-41,-16],[-35,27],[-51,82],[20,10],[-112,191],[-11,31],[-36,10],[-62,-23],[-35,18],[-28,-12],[-62,13],[-55,-25],[4,63],[-7,71],[31,142],[-63,-44],[-23,41],[-55,-26],[-55,-8],[-10,17],[-42,-20],[-46,84],[-129,7],[3,58],[-15,3],[1,73],[-15,31],[-193,0],[-3,34],[-103,0],[0,66],[-53,-5],[-13,30],[-86,0],[-26,9],[-61,-10],[-50,9],[-191,0],[-25,66],[-28,24],[-55,7],[-178,2]],[[2602,14925],[-49,69],[-33,9],[-1,47],[-63,155],[-49,87],[9,31],[-44,56],[17,30],[-23,66],[-10,99],[-23,24],[20,20],[-2,55],[-42,34],[-5,43],[13,33],[-26,94],[-26,35],[11,50],[-8,37],[22,64],[-2,88],[-18,43],[-5,46],[0,116],[20,101],[-1,31],[23,53],[-2,28],[-41,100],[0,44],[-35,61],[-9,74],[-20,44],[-33,112],[-44,59],[-52,55],[-109,103],[-59,68],[-6,50],[-25,65],[15,55],[-15,48],[7,26],[-18,62],[-45,92],[-72,102],[-62,59],[-33,71],[-57,63],[-34,57],[-96,56],[-42,66],[-27,21],[-21,109],[-27,111],[-29,85],[15,74],[49,95],[-13,67],[-73,221],[-77,164],[-83,151],[-120,202],[-19,46],[-89,133],[-98,128],[-71,100],[-90,98],[-169,156],[-61,65],[13,14],[-17,35],[8,18],[-25,56],[-51,78],[-60,56],[22,7],[90,-24],[10,49],[5,79],[21,21],[13,-132],[-4,-69],[16,-85],[37,87],[-2,31],[20,12],[-5,55],[9,53],[45,-38],[19,-30],[5,-54],[15,-48],[20,-21],[0,-46],[21,-31],[-15,-65],[18,-24],[-19,-23],[-10,-49],[26,-3],[10,88],[23,52],[-18,23],[6,63],[41,-79],[-7,-34],[14,-26],[-1,-69],[19,-52],[-21,-78],[29,-27],[16,60],[-4,37],[47,12],[-6,-86],[3,-43],[26,2],[9,-39],[52,43],[26,-12],[30,34],[27,-19],[29,5],[-3,28],[24,30],[34,17],[24,40],[-3,97],[-13,21],[16,36],[-2,35],[-20,37],[-71,64],[-53,26],[-62,13],[-17,51],[-22,15],[-26,51],[-28,28],[-35,3],[-25,113],[-1,62],[-46,31],[8,43],[-14,36],[-55,48],[17,33],[-13,56],[-32,-21],[-26,33],[5,53],[15,64],[19,17],[26,61],[29,37],[18,-34],[11,-61],[14,-21],[37,-14],[16,12],[14,-84],[18,-28],[44,-26],[51,-57],[24,1],[3,-84],[42,-16],[-4,-31],[-30,-52],[3,-75],[-38,-37],[0,-54],[9,-69],[23,-35],[-3,-28],[42,-10],[30,6],[44,63],[17,40],[38,57],[8,32],[-24,106],[45,-7],[10,-29],[-23,-50],[16,-38],[-1,-64],[44,-33],[-15,-56],[10,-42],[17,-18],[-8,-32],[18,-31],[9,-62],[88,-84],[35,-58],[90,92],[56,31],[-2,26],[25,33],[0,34],[-38,46],[-13,48],[-1,42],[56,3],[14,12],[-22,59],[6,38],[-34,48],[-12,62],[52,-16],[3,80],[17,47],[-33,9],[-67,80],[-59,60],[-1,33],[-31,38],[-51,32],[-61,92],[-5,41],[-45,81],[-5,36],[-39,49],[-16,47],[0,42],[-49,79],[-12,70],[-39,63],[-69,34],[-46,48],[-35,75],[-5,56],[18,58],[-38,71],[-30,9],[15,46],[-1,67],[-14,28],[-141,188],[-41,35],[-51,72],[-8,86],[8,71],[-2,66],[-16,79],[20,4],[38,49],[-3,58],[-23,50],[3,52],[29,17],[25,75],[-1,79],[30,30],[24,49],[16,68],[38,25],[26,61],[7,43],[18,38],[40,35],[59,32],[59,56],[27,65],[14,219],[-32,122],[7,60],[47,53],[19,61],[-3,83],[-10,59],[-17,25],[-10,54],[-24,67],[-35,55],[-34,27],[-37,-9],[-6,26],[17,36],[-20,51],[6,35],[-22,15],[13,39],[35,15],[22,30],[31,70],[5,51],[52,65],[41,92],[38,145],[64,169],[10,39],[34,43],[34,71],[93,70],[65,16],[26,19],[34,-33],[-47,-61],[-9,-90],[-67,-249],[5,-41],[53,-83],[-7,-61],[57,13],[5,-48],[-66,-81],[-1,-72],[30,-51],[37,-6],[40,30],[9,31],[40,35],[52,7],[15,-33],[-4,-30],[43,-7],[26,17],[1,41],[31,141],[25,35],[4,34],[32,21],[-10,48],[35,8],[-35,48],[27,6],[42,51],[40,98],[65,49],[3,44],[28,36],[4,80],[88,59],[52,4],[61,46],[19,5],[81,72],[61,17],[43,-12],[45,4],[68,59],[25,-15],[79,55],[34,10],[81,-3],[77,48],[30,-3],[10,33],[28,-6],[22,25],[26,-29],[21,33],[-8,23],[63,81],[116,119],[28,1],[27,41],[18,-9],[48,18],[45,31],[20,-8],[14,56],[18,14],[33,78],[43,55],[22,5],[57,40],[166,55],[29,29],[26,1],[3,93],[13,62],[37,-29],[61,-20],[42,11],[35,29],[48,16],[67,9],[58,54],[8,24],[70,16],[98,69],[16,1],[91,109],[30,16],[11,51],[67,4],[-53,-63],[5,-9],[-33,-69],[12,-42],[25,-27],[75,-19],[57,25],[12,23],[36,29],[50,11],[23,-8],[32,23],[51,-21],[12,35],[27,24],[36,-34],[-29,-22],[12,-37],[113,-44],[70,-18],[39,-18],[18,25],[48,-1],[94,19],[116,59],[18,-34],[37,31],[18,-25],[81,25],[100,73],[16,54],[59,20],[18,51],[-5,18],[52,9],[44,24],[27,37],[23,7],[114,76],[-7,-40],[106,33],[39,6],[51,25],[10,-32],[74,21],[75,-7],[25,8],[26,43],[41,10],[6,-20],[45,6],[69,-24],[83,46],[78,7],[22,59],[21,5],[40,69],[51,29],[40,63],[19,64],[64,13],[29,22],[19,52],[25,-2],[55,-35],[6,40],[49,5],[45,-22],[68,-19],[26,3],[47,-15],[39,3],[26,-25],[29,8],[64,-53],[52,-23],[53,15],[56,36],[9,32],[30,-24],[39,14],[2,55],[31,-6],[76,3],[69,23],[77,19],[91,5],[84,19],[74,-2],[141,45],[272,105],[70,19],[211,97],[156,64],[122,78],[86,61],[69,56],[52,53],[94,105],[107,151],[81,127],[28,78],[70,144],[4,41],[21,13],[27,69],[4,49],[-34,19],[7,38],[49,-12],[28,16],[49,7],[11,25],[50,29],[-24,67],[-46,29],[37,22],[31,82],[35,42],[17,4],[37,-33],[40,12],[58,38],[25,28],[38,17],[52,76],[82,28],[38,42],[12,31],[33,19],[2,23],[116,45],[49,43],[20,68],[-9,90],[-21,21],[-58,2],[-60,25],[-41,-43],[-32,11],[29,53],[5,96],[-15,93],[1,104],[-17,20],[-10,70],[-34,56],[-3,83],[8,9],[0,148],[17,30],[10,77],[32,21],[27,69],[58,48],[-25,39],[53,61],[45,20],[21,50],[67,47],[27,8],[30,-27],[11,46],[-8,35],[82,-61],[44,6],[-23,30],[-2,30],[-35,61],[0,23],[44,60],[36,17],[16,-37],[46,4],[31,20],[23,-11],[26,14],[43,46],[-38,61],[31,59],[12,63],[12,14],[59,21],[27,46],[41,28],[-6,53],[28,60],[23,-15],[84,44],[10,-23],[-14,-28],[29,-61],[-37,9],[-39,-73],[27,-14],[-33,-40],[-13,-32],[29,-6],[11,-30],[49,-2],[-7,-30],[20,-52],[34,2],[14,-22],[57,0],[-13,-34],[-33,-10],[8,-45],[52,-27],[4,-65],[-14,-68],[22,-5],[74,-54],[48,-76],[14,-84],[60,-65],[19,-52],[28,-49],[6,-79],[36,-11],[38,-29],[29,-56],[32,-23],[35,-61],[0,-30],[25,-15],[14,26],[0,76],[-15,9],[8,55],[23,11],[23,106],[11,83],[23,14],[-40,49],[-25,58],[-5,70],[19,27],[49,14],[16,-12],[1,-37],[38,-19],[11,16],[64,-53],[15,-47],[36,-48],[48,-30],[13,-26],[29,-6],[-3,41],[-62,61],[-13,94],[-24,59],[33,53],[72,61],[13,23],[54,23],[-6,26],[-100,-55],[-65,-23],[-29,24],[-27,71],[-33,54],[-7,37],[-26,-3],[-48,47],[-11,23],[-53,32],[-70,3],[-8,28],[52,15],[-9,20],[66,69],[-94,7],[-37,-39],[-6,41],[-23,5],[34,64],[76,-34],[81,-16],[-23,44],[43,8],[-57,36],[-107,36],[36,27],[58,-6],[5,-18],[77,-16],[25,16],[-61,52],[86,6],[-21,40],[-42,28],[-71,-5],[-35,23],[7,26],[30,26],[-35,63],[8,30],[44,17],[45,-8],[18,19],[49,-20],[24,18],[39,-22],[22,-34],[-1,-38],[-44,-46],[37,-15],[53,-47],[30,5],[24,-38],[-31,-22],[-5,-41],[28,-21],[21,29],[16,76],[77,-51],[6,36],[-52,59],[43,29],[55,18],[24,-19],[50,1],[40,-9],[58,-38],[21,-35],[13,-61],[29,-29],[101,1],[29,-47],[57,39],[-14,12],[-54,-11],[9,42],[44,50],[17,-29],[54,-45],[120,2],[57,-5],[15,7],[88,5],[52,13],[98,-50],[55,6],[-12,21],[-71,-7],[-29,35],[-69,17],[-34,31],[-24,-6],[-114,24],[-71,-16],[-29,-15],[-55,-4],[-38,33],[9,36],[-12,23],[15,36],[-28,27],[48,59],[27,66],[-9,53],[36,0],[-1,-40],[39,-53],[22,-9],[39,50],[28,8],[-3,54],[6,106],[6,39],[27,30],[-17,23],[56,51],[22,-10],[40,30],[4,29],[-18,38],[-35,4],[-38,-16],[-35,-32],[-32,-52],[-46,-111],[-24,-37],[-21,9],[5,41],[-19,24],[-2,72],[-36,13],[-39,-13],[1,68],[-20,89],[22,74],[37,-2],[-18,125],[38,61],[14,37],[45,11],[42,-40],[76,1],[11,74],[28,-46],[15,29],[-3,29],[16,43],[41,17],[-28,26],[-34,-6],[-5,27],[53,19],[-27,26],[21,49],[67,-43],[36,-4],[66,-63],[60,-12],[49,-30],[16,-36],[26,-10],[15,-27],[-22,-24],[46,-16],[41,25],[24,68],[8,57],[-18,46],[-54,18],[-118,-66],[-24,20],[-25,40],[13,30],[36,30],[22,35],[28,14],[34,-30],[33,26],[38,45],[-16,22],[-57,-46],[-34,0],[-90,-72],[-18,27],[2,38],[-29,54],[57,51],[42,1],[54,-24],[7,20],[68,45],[-19,14],[-11,74],[61,32],[8,-35],[-25,-26],[40,-47],[11,30],[23,-1],[-4,-57],[18,-13],[7,-37],[21,-20],[68,56],[39,0],[34,-46],[27,-14],[75,14],[33,-17],[34,10],[13,22],[-64,-2],[-26,26],[30,25],[-26,21],[10,45],[-25,31],[-50,0],[-39,13],[1,24],[-30,33],[-49,-27],[19,58],[26,14],[20,-28],[39,8],[-2,51],[-51,31],[-41,-4],[-26,25],[-12,66],[-42,6],[-9,27],[17,21],[27,-5],[1,36],[39,2],[-4,43],[48,-10],[24,46],[-34,22],[19,36],[52,18],[36,27],[38,-26],[26,6],[24,-38],[35,0],[11,60],[35,38],[57,8],[7,-55],[45,25],[13,24],[-13,60],[7,35],[21,24],[-36,65],[14,16],[-21,33],[20,45],[-17,20],[40,30],[35,-18],[17,-29],[63,-42],[-24,-43],[-31,-15],[-14,-46],[-3,-49],[20,-11],[13,-50],[29,14],[29,-5],[60,23],[18,-15],[28,-52],[-5,-60],[28,-45],[79,-38],[7,34],[-36,56],[20,35],[56,19],[2,-26],[32,-11],[18,41],[29,-21],[4,76],[-18,3],[-7,45],[-23,36],[47,49],[26,-4],[21,37],[-6,32],[-28,56],[23,21],[55,5],[23,30],[10,34],[-6,63],[-57,59],[-41,1],[-33,-25],[-46,31],[-13,73],[60,-29],[4,37],[30,13],[9,-49],[26,37],[-38,65],[27,26],[52,-24],[28,-32],[-9,-48],[53,4],[29,-26],[-41,-21],[2,-26],[34,-51],[-31,-21],[6,-55],[39,1],[4,-56],[23,-16],[107,62],[-59,51],[15,51],[34,2],[-4,59],[49,-2],[13,38],[33,21],[36,-11],[30,13],[50,63],[12,-24],[-65,-100],[-32,-35],[1,-26],[41,0],[7,-37],[32,-29],[47,19],[-7,-33],[14,-72],[33,-4],[5,40],[39,15],[2,56],[15,30],[67,-4],[18,57],[19,20],[-64,54],[54,9],[3,21],[55,7],[14,-21],[70,42],[-37,31],[-34,13],[-12,38],[-28,27],[-32,83],[81,25],[44,-32],[-3,46],[31,9],[49,-30],[7,39],[28,0],[30,-29],[2,-20],[94,-61],[11,-22],[-13,-49],[38,14],[12,-91],[35,-21],[15,56],[35,-22],[38,8],[13,43],[30,6],[57,-68],[12,36],[24,27],[73,-64],[58,-40],[-19,-35],[1,-34],[45,-13],[54,-27],[66,-68],[18,4],[36,-42],[27,-15],[21,-62],[24,-14],[77,-90],[9,-64],[45,-18],[-10,-44],[39,-54],[28,19],[23,-38],[32,0],[15,-23],[-13,-40],[35,-40],[41,24],[38,-15],[59,-74],[48,-21],[29,-47],[31,-12],[-10,-88],[18,-55],[-38,-4],[-20,-36],[-35,-89],[6,-54],[-21,-59],[9,-25],[-30,-50],[10,-56],[16,-13],[-18,-112],[11,-21],[-29,-38],[2,-29],[23,-62],[-13,-52],[-23,-46],[34,-4],[35,72],[7,47],[3,98],[-16,41],[-3,56],[18,30],[70,-56],[24,-34],[48,-49],[2,-17],[40,-53],[9,49],[-25,48],[-43,37],[-21,51],[1,86],[-30,39],[11,45],[29,68],[66,31],[8,45],[28,5],[7,-50],[38,-108],[9,9],[-21,101],[5,101],[70,-75],[-4,42],[68,3],[-42,70],[-66,42],[42,22],[22,-16],[75,35],[42,12],[67,-39],[12,20],[71,-10],[46,-25],[21,-26],[34,4],[25,-26],[46,-4],[86,7],[25,-18],[77,-10]],[[17866,33682],[-1,-450],[0,-404],[0,-294],[0,-398],[0,-335],[0,-347],[0,-346],[0,-346],[0,-346],[0,-388],[0,-283],[0,-518],[0,-470],[1,-1072],[0,-1171],[-1,-274],[0,-898],[1,-292],[0,-879],[0,-508]],[[352,20530],[-31,-34],[-33,19],[-27,79],[-49,68],[-56,58],[-34,59],[-9,40],[-54,77],[6,53],[-56,129],[-9,59],[8,70],[48,56],[17,-19],[39,-5],[-16,-32],[2,-34],[32,-89],[43,-158],[23,-24],[19,-58],[-5,-34],[51,-23],[-33,-41],[12,-65],[33,-3],[30,-24],[31,-61],[18,-63]],[[2840,26824],[-7,-50],[-26,-62],[-25,-10],[-9,-34],[-48,-28],[-19,28],[-54,-2],[0,25],[21,56],[53,61],[68,96],[35,-17],[-7,-29],[18,-34]],[[13037,33074],[-93,-51],[-40,-7],[-14,14],[36,49],[-31,31],[-49,-21],[-25,21],[49,101],[70,17],[-10,-46],[31,-15],[44,-65],[32,-28]],[[13660,34132],[-23,-77],[8,-33],[-28,-49],[-30,-7],[-55,5],[-6,95],[50,3],[-23,62],[37,50],[28,1],[15,-29],[27,-21]],[[16978,33374],[-34,-40],[-51,24],[-12,51],[16,84],[29,-19],[9,-47],[43,-53]],[[1112,20791],[-16,-17],[-31,13],[-28,49],[1,41],[28,11],[33,-20],[13,-77]],[[230,21756],[-19,-55],[-8,-79],[-14,-16],[-3,-61],[-22,3],[21,53],[8,84],[-8,60],[16,43],[29,-32]],[[12822,33188],[-33,-14],[-24,16],[-30,-24],[-28,-6],[-9,34],[55,8],[29,38],[34,-14],[6,-38]],[[13676,33458],[-16,-40],[-50,-17],[-1,45],[-20,20],[2,29],[85,-37]],[[273,22082],[-9,-54],[-34,-19],[14,62],[29,11]],[[13375,33505],[-13,-16],[-56,45],[1,36],[45,24],[4,-40],[-12,-16],[31,-33]],[[4406,27119],[-13,-34],[-45,-11],[-9,31],[28,52],[19,-38],[20,0]],[[4072,27009],[-30,-12],[-6,-40],[-57,-2],[-27,32],[71,23],[49,-1]],[[13261,33241],[-9,-22],[-38,-22],[-26,7],[15,56],[35,2],[23,-21]],[[15219,34840],[-27,-10],[-55,7],[-36,-15],[-9,44],[59,-8],[41,-21],[27,3]],[[12084,32199],[-38,-4],[-74,40],[11,10],[78,-23],[23,-23]],[[4141,26881],[-53,-51],[-29,23],[22,26],[60,2]],[[14583,34325],[-28,-21],[-32,15],[12,41],[28,-8],[20,-27]],[[12972,32460],[-11,-22],[-42,-31],[-3,37],[56,16]],[[14261,34184],[-8,-18],[-37,3],[17,65],[28,-50]],[[4172,27040],[-44,-66],[-45,2],[53,51],[36,13]],[[1805,25289],[-19,-10],[-31,47],[44,7],[6,-44]],[[11789,32065],[-26,10],[-16,-39],[-23,56],[65,-27]],[[14045,34143],[-39,-4],[-18,41],[15,30],[42,-67]],[[13460,33157],[-22,-54],[-29,12],[38,51],[13,-9]],[[11433,31909],[-29,-47],[-15,54],[44,-7]],[[12628,33186],[-10,-11],[-50,17],[48,21],[12,-27]],[[13718,33956],[-50,-17],[-21,9],[46,39],[25,-31]],[[5359,26948],[-13,-31],[-24,14],[8,41],[29,-24]],[[4109,27129],[-37,-33],[-11,21],[19,26],[29,-14]],[[16614,34179],[-25,-28],[-15,25],[16,25],[24,-22]],[[3059,10715],[-92,65],[-54,17],[-139,86],[-54,23],[-119,18],[-99,-17],[-18,-56],[-21,-1],[-29,42],[-95,90],[-2,40],[17,26],[-23,73],[-30,43],[10,101],[-24,64],[14,9],[-10,85],[19,102],[-28,107],[59,80],[-25,84],[-1,38],[93,-45],[38,-65],[104,-34],[103,-1],[88,26],[59,43],[116,134],[32,32],[33,65],[21,66],[18,26],[34,14],[11,26],[10,193],[-9,89],[-25,130]],[[3653,12419],[0,-64],[-69,0],[-2,-172],[-152,0],[5,33],[-74,-22],[1,-79],[-32,0],[1,-104],[54,-27],[42,-6],[20,-39],[45,0],[0,-52],[76,-2],[0,-31],[71,-1],[1,-92],[21,-128],[2,-82],[-24,-11],[-107,1],[-19,-25],[-92,0],[2,-110],[-35,-13],[8,-60],[-35,-7],[0,-40],[37,0],[0,-103],[35,0],[-1,-48],[-73,-10],[0,-31],[-39,-6],[-4,-27],[-31,-27],[-2,-98],[-34,-4],[-19,-33],[-38,-6],[-5,-49],[37,-37],[-63,-61],[-46,-4],[-56,-27]],[[3171,13414],[-21,61],[6,27],[-12,40],[-26,23],[26,36]],[[3172,13595],[20,-35],[71,-36],[29,14]],[[3292,13538],[36,-47],[-21,-24],[1,-52]],[[2930,13622],[-77,-18],[5,27],[51,9],[21,-18]],[[3418,13549],[-63,42]],[[3355,13591],[78,82],[8,34],[-23,16],[-49,-3]],[[3369,13720],[3,38]],[[3382,13788],[69,-7],[69,42],[0,27],[0,9],[11,124],[118,29],[92,-1],[-1,-41],[67,0],[-5,-112],[17,-20],[-14,-44],[0,-58],[77,-3],[-7,-121],[-46,8],[-49,-21],[0,-46],[-38,1]],[[3195,13807],[-51,-1]],[[3144,13806],[-26,47],[5,36],[-28,75]],[[3095,13964],[74,-6]],[[3292,13538],[51,25],[12,28]],[[3819,13350],[28,0],[0,-143],[314,1],[65,10],[39,18],[65,46],[17,42],[173,0],[27,-17],[30,13],[31,-10],[30,12],[106,2],[12,21],[42,14]],[[17866,23663],[-1,-273],[1,-391],[-1,-390],[0,-586],[0,-585],[0,-586],[1,-195]],[[17866,13993],[-117,-35],[-103,-48],[-54,-35],[-104,-54],[-21,-20],[-125,-48],[-105,-50],[-27,-4],[-145,-62],[-149,-46],[-103,-40],[-168,-43],[-26,-2],[-193,-40],[-73,-23],[-101,-40],[-34,-27],[-40,-3],[-153,-37],[-21,-10],[-125,-23],[-173,-9],[-125,-17],[-109,0],[-83,7],[-46,-17],[-65,-2],[-129,10],[-173,23],[-63,21],[-156,35],[-55,-10],[-44,-28],[-45,-14],[-41,10],[-95,-26],[-167,-89],[-206,-145],[-65,-53],[-153,-61],[-57,-5],[-83,-28],[-60,-27],[-152,-90],[-85,-16],[-23,-29],[-86,-47],[-31,-40],[-89,-49],[-79,-33],[-147,-24],[-176,-20],[-115,-28],[-55,-25],[-77,-45],[-74,-71],[-51,-64],[-24,-49],[-22,-77],[-54,-114],[-38,-99],[-14,-65],[-7,-82],[-57,-44],[-40,-5],[-27,-20],[4,-29],[-69,-37],[-59,-68],[-14,-100],[-30,-5],[-68,-40],[-25,-38],[-48,-2],[-33,-26],[-16,-38],[-38,-8],[-28,37],[-83,20],[-60,-6],[-73,-88],[-41,-26],[-31,8],[-68,-32],[-6,83],[-38,56],[-68,39],[-55,8],[-12,-28],[-45,-8],[-66,-1],[-83,-24],[-20,24],[-51,14],[-35,-17],[-89,4],[-61,-14],[-48,-42],[-56,-5],[-69,25],[-95,5],[-79,-40],[-22,-22],[14,-26],[-35,-17],[-28,11],[-31,-14],[-92,-12],[6,44],[-37,90],[-61,68],[-47,20],[-61,-7],[-34,-16],[-17,-41],[-57,-6],[-56,-24],[-48,35],[-72,19],[-17,-26],[-86,46],[-60,23],[-29,-17],[-74,23],[-11,-9],[-75,15],[-48,-7],[-57,-35],[-74,8],[-21,-26],[-64,18],[-56,-11],[-66,-1],[-5,-11],[-156,17],[-68,-39],[-107,-5],[-34,10],[-46,-8],[-42,7],[-44,-12],[-6,-33],[-29,-8],[-70,-42],[-40,-4],[-147,34],[-76,10],[-130,-14],[-77,25],[-61,-16],[-8,-21],[-41,-25],[-21,8],[-84,0],[-51,-25],[-26,-42],[-54,-40],[-24,-1],[-80,-40],[-64,-67],[7,-21],[-63,-65],[-27,-59],[-6,-82],[42,-41],[-25,-33],[-38,41],[-77,1],[-25,-55],[9,-46],[-18,-29],[-41,45],[-68,-10],[0,-63],[-30,-11],[-86,38],[-36,-8],[-15,18],[-72,22],[-94,9],[-85,-16],[-6,-43],[-62,-1],[-46,-12],[-48,-32],[-26,-40],[7,-23],[36,-17],[-69,-57],[-60,-15],[-18,-25],[-100,-17],[-88,-36],[-58,-49],[-31,-77],[-6,-75],[-67,13],[-34,-18],[-45,4],[-89,-34],[-10,-31],[45,-17],[-19,-53],[-28,33],[-74,12],[-44,-16],[-13,-18],[-87,-1],[-28,19],[-32,-21],[1,-39],[22,-45],[45,-9],[-29,-30],[-68,3],[-67,42],[-89,38],[-84,8],[-34,-19],[-19,-61],[-24,-4],[-91,49],[-50,-1],[-63,35],[-68,30],[-42,-28],[-66,27],[-20,-10],[-46,14],[-48,-15],[-17,-31],[-51,27],[-37,-5],[-112,21],[-37,-20],[-10,-32],[-44,19],[-60,6],[-61,32],[-76,-16],[-55,-26],[-74,21],[-65,34],[-60,0],[-48,35],[-182,105],[-50,19],[-105,28],[-39,-4],[-73,13],[-30,22],[-48,65],[-8,41],[-171,165],[-140,119]],[[3095,13964],[-23,68],[-55,100],[-68,107],[-40,80],[-110,155],[-46,112],[-20,74],[-55,103],[-6,35],[-70,127]],[[3369,13720],[-78,-33],[-9,-25],[-35,5],[-6,-30]],[[3224,13727],[0,0],[1,0],[2,0],[0,0],[1,0],[2,0],[0,0],[20,0],[34,3],[23,20],[-21,31]],[[3148,13750],[-4,56]],[[3355,13591],[-52,13],[-34,-18],[-28,51]],[[20037,36430],[23,-9],[27,61],[-55,54],[-31,12],[17,27],[-2,78]],[[20016,36653],[51,2],[43,-22],[-10,45],[21,98],[-41,61],[10,30],[47,21],[22,-28],[53,14],[14,-33],[35,17],[26,-33],[45,-35],[36,74],[-3,32],[22,33],[-5,33],[37,12],[22,-23],[-6,-92],[15,-41],[44,-50],[33,-22],[84,-23],[76,5],[156,-6],[82,12],[84,34],[45,33],[23,2],[53,-68],[91,-27],[54,-9],[2,16],[66,37],[47,55],[99,43],[18,-58],[83,30],[40,-44],[31,17],[-1,24],[31,66],[42,9],[52,26],[39,32],[16,-21],[57,24],[-12,79],[22,88],[10,96],[-11,41],[-63,44],[75,77],[-60,-9],[-61,14],[-23,36],[-21,6],[5,53],[59,1],[18,-22],[47,0],[-72,51],[-17,37],[20,24],[-32,17],[-76,102],[-64,4],[-51,16],[-55,-28],[-78,9],[-45,-39],[-23,1],[-29,-31],[-44,-18],[-32,2],[-25,39],[-24,17],[-4,27],[31,14],[-19,31],[-37,-12],[-50,23],[-23,23],[36,19],[-20,38],[-32,-27],[-14,48],[-62,37],[-19,-23],[-76,-14],[7,39],[22,-9],[27,24],[30,-3],[-22,68],[43,2],[36,30],[20,-44],[49,-14],[24,28],[-28,50],[28,9],[9,55],[19,-7],[20,-57],[16,-22],[24,16],[14,-46],[37,-15],[-17,-31],[19,-30],[-17,-17],[63,-22],[-10,-41],[12,-45],[57,-22],[-28,57],[41,-6],[19,35],[-10,21],[-39,29],[6,33],[-10,33],[12,20],[-32,44],[-30,62],[43,7],[12,-38],[42,-43],[32,-70],[22,31],[-16,64],[43,3],[43,44],[16,-16],[8,-53],[19,-14],[-7,-106],[25,-2],[18,71],[23,31],[19,-9],[31,-48],[30,-14],[-6,-26],[21,-59],[27,4],[17,-31],[40,-41],[29,-9],[14,-25],[4,-54],[32,-44],[74,-5],[49,57],[8,29],[23,3],[20,46],[28,14],[36,-43],[24,11],[-3,93],[19,10],[55,-97],[46,-21],[42,-82],[35,-22],[-8,-32],[37,-75],[3,-24],[59,-90],[80,-27],[36,5],[35,30],[45,12],[-30,-61],[9,-25],[41,2],[18,-14],[36,52],[15,-9],[-4,-46],[29,6],[22,-32],[31,26],[53,22],[-4,-62],[27,-15],[13,22],[40,-2],[-3,-29],[30,-4],[30,15],[28,42],[67,7],[44,32],[-1,16],[69,19],[26,-33],[42,0],[5,-37],[-17,-32],[-33,7],[-42,-43],[22,-43],[18,2],[33,-35],[48,-12],[59,27],[22,36],[39,11],[27,-17],[14,-76],[62,38],[41,-64],[-21,-31],[27,-22],[19,-36],[-33,-80],[29,-5],[7,36],[38,45],[25,0],[-2,39],[40,23],[24,-30],[46,-36],[76,-29],[85,-10],[122,27],[59,40],[35,58],[92,9],[-4,-38],[35,-67],[51,-16],[-2,-62],[16,-19],[32,-4],[22,-22],[47,9],[36,-22],[23,-51],[61,-66],[76,31],[22,-1],[25,-32],[22,11],[-8,33],[38,-7],[58,11],[-43,46],[47,6],[53,40],[-12,26],[101,49],[22,-38],[52,3],[49,30],[15,29],[55,-46],[81,54],[11,18],[34,6],[48,29],[26,0],[35,21],[55,8],[-18,-38],[-47,-32],[-33,-54],[-33,-15],[-18,-29],[-50,-43],[0,-44],[27,-46],[38,-24],[22,-37],[17,37],[34,4],[3,41],[99,63],[30,-18],[71,40],[16,-40],[-35,-17],[-16,-26],[47,-60],[35,6],[10,31],[43,12],[5,-44],[-22,-2],[-65,-146],[44,-1],[-24,-52],[43,-39],[34,46],[26,-27],[73,26],[9,-31],[71,0],[57,40],[33,34],[0,39],[24,26],[41,100],[-14,53],[-71,8],[-66,-8],[-21,33],[-40,-9],[1,40],[42,8],[62,101],[40,19],[43,-9],[5,29],[26,5],[14,34],[38,48],[16,-16],[23,37],[22,-25],[-3,-45],[37,-20],[12,33],[20,-4],[27,-86],[31,-25],[5,-46],[-10,-27],[23,-63],[53,-39],[1,-40],[58,-19],[54,23],[7,21],[-58,72],[29,18],[60,15],[9,-31],[31,-31],[61,-9],[33,-31],[-4,-37],[31,-6],[20,-102],[-47,-22],[-15,-30],[-51,-45],[-48,-64],[-18,69],[-70,-52],[25,-51],[-10,-41],[-50,-71],[-12,-44],[3,-43],[-33,-6],[-24,14],[-33,-48],[27,-40],[-25,-61],[-17,6],[-2,55],[-36,27],[-74,-57],[-6,-51],[62,-45],[7,-32],[32,-13],[59,-38],[-52,-63],[-45,39],[-41,-10],[34,-80],[39,-10],[-31,-61],[-66,-69],[-4,-76],[-77,-5],[-37,-62],[-34,-40],[-15,38],[2,50],[46,1],[17,23],[-24,39],[6,66],[-10,22],[4,75],[-37,15],[-27,-31],[-3,-26],[16,-41],[-13,-43],[-51,14],[-32,-5],[5,-56],[-27,-4],[-15,-45],[-28,17],[-32,-5],[-10,50],[14,13],[3,44],[-12,24],[-48,-39],[9,-13],[-33,-54],[-30,-30],[13,-23],[-22,-33],[-24,77],[-20,12],[-29,-22],[-7,-41],[-24,16],[-33,-20],[-5,-28],[-26,-26],[-13,-53],[52,-41],[-15,-56],[-33,23],[-27,-26],[6,-26],[-9,-60],[12,-41],[-30,-13],[-5,-29],[34,-36],[7,-43],[32,-25],[-25,-24],[13,-32],[26,-20],[48,2],[55,39],[6,24],[45,52],[28,-30],[-25,-12],[-22,-42],[-32,-88],[10,-46],[-27,-33],[-2,-43],[-21,-20],[-14,-40],[-44,-36],[-5,-76],[-25,-60],[-10,-102],[-73,-56],[-30,-4],[-66,-76],[-25,-51],[-44,-68],[6,-19],[-61,-16],[-33,-70],[-49,-70],[-23,-65],[-5,-58],[-27,-26],[-33,0],[-52,-69],[-40,10],[13,-54],[0,-44],[20,-46],[-3,-18],[68,-124],[60,-45],[58,-36],[39,-15],[31,9],[56,-40],[38,-44],[21,3],[68,-47],[65,-34],[41,-39],[28,-39],[63,-45],[69,-32],[31,-28],[73,-36],[30,-27],[43,1],[41,-29],[2,-38],[24,-57],[8,-45],[22,-42],[34,-35],[78,-30],[23,1],[63,-47],[40,-46],[38,-30],[51,7],[51,33],[15,29],[87,-28],[-9,-35],[-49,-79],[7,-25],[41,-47],[1,-26],[-25,-23],[16,-40],[26,-1],[48,30],[57,8],[34,-8],[17,-19],[40,-5],[9,34],[45,28],[26,27],[78,-84],[39,-25],[83,-30],[55,-36],[48,-11],[64,-94],[112,-64],[50,-2],[35,-20],[129,-25],[88,-44],[54,-12],[44,-62],[23,-48],[44,-53],[36,-60],[86,-72],[14,-22],[55,-48]],[[27865,31732],[0,-45],[0,-98],[0,-570],[0,-286]],[[27865,30733],[0,-251],[0,-454],[0,-214]],[[27859,28857],[0,-346],[0,-361]],[[27860,26811],[0,-228],[0,-78]],[[27861,25919],[0,-206],[0,-184]],[[27861,25339],[0,-488]],[[27861,24662],[0,-221],[0,-272],[0,-488]],[[27861,23681],[1,-97],[-1,-25]],[[27862,21143],[0,-484]],[[17866,33682],[72,-14],[28,-18],[23,-33],[45,-38],[40,-22],[-22,-76],[35,-82],[-30,-33],[47,-4],[24,28],[11,39],[-12,33],[33,40],[-33,23],[5,39],[-10,34],[3,43],[-15,69],[18,19],[74,-20],[55,-23],[15,-32],[120,-39],[52,-81],[3,-26],[52,-43],[36,-51],[-6,-29],[65,-8],[32,10],[-49,61],[0,44],[-23,50],[3,50],[-44,17],[-60,115],[-33,47],[37,-4],[47,-58],[18,-41],[28,26],[-33,32],[-8,51],[57,-53],[29,9],[30,-15],[65,-2],[19,7],[45,-16],[48,18],[37,41],[-24,26],[-39,-38],[-70,-8],[-4,26],[-83,42],[-16,48],[-22,12],[-31,43],[-22,5],[-18,39],[4,32],[120,1],[27,34],[27,6],[26,42],[-71,-24],[-35,-20],[-114,21],[-51,19],[-8,19],[-45,42],[-44,21],[-30,52],[-57,16],[21,75],[-9,18],[30,26],[23,40],[-5,55],[14,4],[56,66],[46,124],[32,-23],[-14,-52],[30,-9],[2,54],[40,6],[19,43],[48,13],[71,33],[30,46],[1,66],[-35,30],[8,53],[79,81],[-9,18],[5,113],[32,72],[15,57],[-6,49],[53,19],[-6,23],[35,23],[0,-48],[30,-32],[38,-9],[51,3],[66,42],[43,48],[40,-1],[48,63],[14,33],[42,42],[47,6],[7,33],[-55,34],[-21,48],[-62,72],[-49,12],[3,36],[17,34],[-16,19],[22,96],[-11,47],[13,38],[39,28],[51,-46],[43,9],[79,55],[30,103],[-7,14],[4,70],[-11,23],[6,53],[50,-12],[-1,23],[42,29],[29,-3],[36,-34],[18,4],[13,-46],[17,-12],[21,13],[61,-24],[36,12],[46,-5],[-67,53],[-28,1],[-57,49],[38,8],[28,20],[-44,45],[25,77],[18,16],[-27,26],[42,25],[-34,22],[4,25],[29,20],[42,-9],[32,-25],[92,-28],[-11,-50],[24,-32],[-10,-20],[81,-47],[29,-40],[72,-12],[-5,32],[-48,10],[-1,64],[42,13],[7,-28],[30,0]],[[20690,37697],[-15,-25],[-35,5],[-42,-54],[-3,-84],[-11,-29],[-33,4],[-17,23],[-27,-4],[-53,-107],[-57,-66],[-17,9],[-71,-47],[-21,-23],[-82,-44],[-29,-8],[-38,-53],[-22,0],[-57,-61],[-36,-4],[-25,42],[-66,54],[-66,11],[-86,50],[-43,8],[-16,39],[-34,18],[-26,29],[-23,7],[-44,49],[-28,-6],[-45,29],[-18,40],[18,67],[-67,72],[2,27],[-17,27],[8,36],[-16,20],[-2,49],[-23,18],[20,58],[-48,59],[10,94],[34,5],[45,-44],[64,-78],[33,-16],[23,21],[48,-26],[10,-37],[-55,-50],[2,-23],[28,-23],[67,39],[44,-68],[16,-48],[68,-14],[14,17],[-51,53],[-28,-2],[7,43],[65,12],[10,13],[80,7],[57,57],[101,-35],[4,-18],[46,-15],[38,67],[51,35],[16,31],[44,-13],[1,-53],[37,-2],[-1,68],[12,29],[42,14],[5,29],[31,1],[40,-47],[-22,-43],[27,-9],[26,32],[58,-21],[24,11],[28,-34],[-15,-18],[36,-29],[-7,-29],[29,-55],[24,15],[39,-34],[6,-44]],[[26713,34381],[-41,-13],[-20,10],[-21,-27],[-26,29],[-27,-13],[-17,20],[-49,20],[-53,1],[-96,-43],[-19,34],[-102,15],[-18,24],[-37,-4],[-40,23],[-20,25],[-46,-7],[-44,-21],[-35,8],[82,42],[50,73],[-15,46],[-24,117],[31,97],[-30,72],[28,20],[30,-20],[37,-8],[50,29],[16,-7],[51,15],[27,19],[-15,69],[-24,8],[4,34],[30,-14],[63,13],[24,40],[32,-4],[-8,-60],[-43,-26],[18,-41],[35,-52],[91,-43],[32,19],[-8,44],[14,62],[67,-17],[8,-51],[-31,-41],[-29,-60],[-1,-20],[-50,7],[-24,-14],[-22,-41],[-10,-55],[19,-30],[-52,-48],[-33,-49],[26,-97],[41,-7],[20,52],[24,-3],[45,-34],[14,-29],[45,7],[24,45],[47,-1],[-17,-57],[13,-40],[-17,-16],[26,-26]],[[19688,37340],[-39,-82],[-44,16],[-60,-19],[-133,33],[-42,25],[-48,11],[-105,-35],[-111,-31],[-59,10],[-38,14],[-11,38],[14,20],[26,-11],[16,53],[-2,41],[18,20],[46,-41],[34,-2],[42,59],[15,2],[46,-53],[8,32],[-32,34],[-42,3],[11,64],[-29,32],[32,55],[-20,31],[-32,-8],[26,72],[50,20],[33,41],[10,41],[44,5],[41,23],[15,-23],[20,-66],[32,-35],[-2,-32],[-24,-37],[-1,-27],[29,-38],[25,-9],[44,-34],[-5,-48],[9,-58],[107,-48],[33,-28],[26,-3],[27,-27]],[[21899,38008],[-32,-21],[15,-32],[3,-62],[-21,-18],[-14,-51],[-33,32],[-16,75],[-47,55],[-10,59],[22,24],[2,49],[-11,41],[62,33],[-3,41],[15,25],[16,-88],[14,-30],[6,-52],[-26,-45],[58,-35]],[[20037,36430],[-27,59],[-42,2],[-45,39],[-28,-1],[11,44],[36,66],[27,28],[47,-14]],[[28386,11119],[-6,-36],[-15,-33],[-25,-26],[-31,-17],[-34,-5],[-35,5],[-30,17],[-25,26],[-16,33],[-5,36],[5,36],[16,33],[25,26],[30,16],[35,6],[34,-6],[31,-16],[25,-26],[15,-33],[6,-36]],[[44647,20256],[-6,-36],[-15,-33],[-25,-26],[-31,-16],[-34,-6],[-35,6],[-31,16],[-24,26],[-16,33],[-5,36],[5,36],[16,33],[24,26],[31,16],[35,6],[34,-6],[31,-16],[25,-26],[15,-33],[6,-36]],[[40269,9215],[-6,-36],[-15,-33],[-25,-26],[-31,-16],[-34,-6],[-35,6],[-31,16],[-24,26],[-16,33],[-5,36],[5,36],[16,33],[24,26],[31,17],[35,5],[34,-5],[31,-17],[25,-26],[15,-33],[6,-36]],[[38393,483],[-6,-37],[-16,-32],[-24,-26],[-31,-17],[-34,-5],[-35,5],[-31,17],[-24,26],[-16,32],[-6,37],[6,36],[16,32],[24,26],[31,17],[35,6],[34,-6],[31,-17],[24,-26],[16,-32],[6,-36]],[[35266,6169],[-6,-36],[-16,-32],[-24,-26],[-31,-17],[-35,-6],[-34,6],[-31,17],[-24,26],[-16,32],[-6,36],[6,37],[16,32],[24,26],[31,17],[34,6],[35,-6],[31,-17],[24,-26],[16,-32],[6,-37]],[[3369,13403],[-5,-36],[-16,-33],[-25,-26],[-31,-16],[-34,-6],[-34,6],[-31,16],[-25,26],[-16,33],[-5,36],[5,36],[16,33],[25,26],[31,17],[34,5],[34,-5],[31,-17],[25,-26],[16,-33],[5,-36]],[[20255,36627],[-5,-36],[-16,-33],[-24,-26],[-31,-16],[-35,-6],[-34,6],[-31,16],[-24,26],[-16,33],[-6,36],[6,36],[16,33],[24,26],[31,16],[34,6],[35,-6],[31,-16],[24,-26],[16,-33],[5,-36]],[[43400,10378],[-6,-37],[-15,-32],[-25,-26],[-31,-17],[-34,-5],[-35,5],[-31,17],[-24,26],[-16,32],[-5,37],[5,36],[16,33],[24,25],[31,17],[35,6],[34,-6],[31,-17],[25,-25],[15,-33],[6,-36]],[[39949,8844],[-208,-381],[-417,0],[-209,381],[209,380],[417,0],[208,-380]],[[40366,9596],[-417,0]],[[39949,9596],[-208,381],[208,380],[417,0],[209,-380],[-209,-381]],[[40366,9596],[209,-381],[-209,-381],[-417,0],[-208,381],[208,381]],[[34946,11119],[-209,-381],[-416,0],[-209,381],[209,381],[416,0],[209,-381]],[[36822,15307],[-208,-381],[-417,0],[-209,381],[209,380],[417,0],[208,-380]],[[38698,11119],[-208,-381],[-417,0],[-208,381],[208,381],[417,0],[208,-381]],[[40575,12261],[-209,-381],[-417,0],[-208,381],[208,381],[417,0],[209,-381]],[[41200,11119],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[45576,13040],[-209,-380],[-417,0],[-208,380],[208,381],[417,0],[209,-381]],[[43697,8844],[-208,-381],[-417,0],[-209,381],[209,380],[417,0],[208,-380]],[[42460,8082],[-208,-380],[-417,0],[-208,380],[208,381],[417,0],[208,-381]],[[41200,8073],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[41207,9594],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[41826,10738],[-209,-381]],[[41617,10357],[-417,0]],[[41200,10357],[-208,381],[208,381],[417,0]],[[41617,11119],[209,-381]],[[41826,9977],[-209,-381]],[[41617,9596],[-417,0]],[[41200,9596],[-208,381],[208,380]],[[41617,10357],[209,-380]],[[41826,9215],[-209,-381]],[[41617,8834],[-417,0]],[[41200,8834],[-208,381],[208,381]],[[41617,9596],[209,-381]],[[41826,8454],[-209,-381],[-417,0],[-208,381],[208,380]],[[41617,8834],[209,-380]],[[42451,12642],[-209,-381]],[[42242,12261],[-416,0],[-209,381],[209,380],[416,0]],[[42242,13022],[209,-380]],[[41214,10351],[-208,-381],[-417,0],[-209,381],[209,380],[417,0],[208,-380]],[[42451,11119],[-209,-381]],[[42242,10738],[-416,0]],[[41617,11119],[209,381],[416,0]],[[42242,11500],[209,-381]],[[42451,10357],[-209,-380]],[[42242,9977],[-416,0]],[[42242,10738],[209,-381]],[[42451,9596],[-209,-381]],[[42242,9215],[-416,0]],[[42242,9977],[209,-381]],[[42451,8834],[-209,-380],[-416,0]],[[42242,9215],[209,-381]],[[43076,16068],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[43076,13022],[-208,-380]],[[42868,12642],[-417,0]],[[42242,13022],[209,381],[417,0],[208,-381]],[[43076,12261],[-208,-381]],[[42868,11880],[-417,0]],[[42451,11880],[-209,381]],[[42868,12642],[208,-381]],[[43076,11500],[-208,-381]],[[42868,11119],[-417,0]],[[42242,11500],[209,380]],[[42868,11880],[208,-380]],[[43076,10738],[-208,-381]],[[42868,10357],[-417,0]],[[42868,11119],[208,-381]],[[43076,9977],[-208,-381]],[[42868,9596],[-417,0]],[[42868,10357],[208,-380]],[[43076,9215],[-208,-381],[-417,0]],[[42868,9596],[208,-381]],[[43702,12642],[-209,-381]],[[43493,12261],[-417,0]],[[43076,13022],[417,0]],[[43493,13022],[209,-380]],[[43702,11880],[-209,-380]],[[43493,11500],[-417,0]],[[43493,12261],[209,-381]],[[43702,11119],[-209,-381]],[[43493,10738],[-417,0]],[[43493,11500],[209,-381]],[[43702,10357],[-209,-380]],[[43493,9977],[-417,0]],[[43493,10738],[209,-381]],[[43702,9596],[-209,-381],[-417,0]],[[43493,9977],[209,-381]],[[44119,13403],[-417,0]],[[43702,13403],[-209,381],[209,381],[417,0],[208,-381],[-208,-381]],[[44119,12642],[-417,0]],[[43493,13022],[209,381]],[[44119,13403],[208,-381],[-208,-380]],[[44119,11880],[-417,0]],[[44119,12642],[208,-381],[-208,-381]],[[44119,11119],[-417,0]],[[44119,11880],[208,-380],[-208,-381]],[[44119,10357],[-417,0]],[[44119,11119],[208,-381],[-208,-381]],[[44119,10357],[208,-380],[-208,-381],[-417,0]],[[44953,17210],[-209,-380],[-417,0],[-208,380],[208,381],[417,0]],[[44744,17591],[209,-381]],[[44953,14926],[-209,-381],[-417,0],[-208,381],[208,381],[417,0],[209,-381]],[[44744,12261],[-417,0]],[[44327,12261],[-208,381],[208,380],[417,0],[209,-380],[-209,-381]],[[44953,11880],[-209,-380]],[[44744,11500],[-417,0]],[[44327,11500],[-208,380],[208,381]],[[44744,12261],[209,-381]],[[44953,11119],[-209,-381]],[[44744,10738],[-417,0]],[[44327,10738],[-208,381],[208,381]],[[44744,11500],[209,-381]],[[44953,10357],[-209,-380],[-417,0],[-208,380],[208,381]],[[44744,10738],[209,-381]],[[44744,17591],[209,381]],[[44953,17972],[417,0]],[[45370,17972],[208,-381],[-208,-381],[-417,0]],[[45370,11119],[-417,0]],[[44953,11880],[417,0],[208,-380],[-208,-381]],[[45370,11119],[208,-381],[-208,-381],[-417,0]],[[20561,36627],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[23063,29013],[-208,-381],[-417,0],[-209,381],[209,380],[417,0],[208,-380]],[[34321,21398],[-209,-381],[-417,0],[-208,381],[208,381],[417,0],[209,-381]],[[36453,32132],[-209,-380],[-417,0],[-208,380],[208,381],[417,0],[209,-381]],[[29891,28500],[-209,-380],[-417,0],[-208,380],[208,381],[417,0],[209,-381]],[[37952,28586],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[41200,22540],[-208,-380],[-417,0],[-209,380],[209,381],[417,0],[208,-381]],[[39152,27768],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[44326,22162],[-208,-380],[-417,0],[-209,380],[209,381],[417,0],[208,-381]],[[45577,22147],[-209,-381],[-417,0],[-208,381],[208,381],[417,0],[209,-381]],[[44327,20633],[-209,-381],[-417,0],[-208,381],[208,380],[417,0],[209,-380]],[[46202,18742],[-209,-381],[-417,0],[-208,381],[208,380],[417,0],[209,-380]],[[44326,22927],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[41689,24780],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[43702,21017],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[43702,19492],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[46202,20260],[-208,-380],[-417,0],[-209,380],[209,381],[417,0],[208,-381]],[[44119,19495],[-417,0]],[[43702,19495],[-209,380],[209,381],[417,0],[208,-381],[-208,-380]],[[44119,18733],[-417,0]],[[43702,18733],[-209,381],[209,381]],[[44119,19495],[208,-381],[-208,-381]],[[44119,18733],[208,-381],[-208,-380],[-417,0],[-209,380],[209,381]],[[43702,22543],[-208,-380],[-417,0],[-209,380],[209,381],[417,0],[208,-381]],[[44953,21777],[-209,-381],[-417,0],[-208,381],[208,380],[417,0],[209,-380]],[[43703,18733],[-209,-381],[-417,0],[-208,381],[208,381],[417,0],[209,-381]],[[43078,19111],[-209,-380],[-417,0],[-208,380],[208,381],[417,0],[209,-381]],[[44953,20256],[-209,-381]],[[44744,19875],[-417,0]],[[44327,19875],[-208,381],[208,381],[417,0]],[[44744,20637],[209,-381]],[[44953,19495],[-209,-381]],[[44744,19114],[-417,0]],[[44327,19114],[-208,381],[208,380]],[[44744,19875],[209,-380]],[[44953,18733],[-209,-381]],[[44744,18352],[-417,0],[-208,381],[208,381]],[[44744,19114],[209,-381]],[[44954,21016],[-209,-380],[-417,0],[-208,380],[208,381],[417,0],[209,-381]],[[45370,20256],[-417,0]],[[44744,20637],[209,380],[417,0],[208,-380],[-208,-381]],[[45370,19495],[-417,0]],[[45370,20256],[208,-381],[-208,-380]],[[45370,18733],[-417,0]],[[45370,19495],[208,-381],[-208,-381]],[[44953,17972],[-209,380]],[[45370,18733],[208,-381],[-208,-380]],[[24939,16449],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[28066,10738],[-208,-381]],[[27858,10357],[-417,0],[-209,381],[209,381],[417,0]],[[27858,11119],[208,-381]],[[28066,9215],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[28483,11500],[-417,0]],[[28066,11500],[-208,380],[208,381],[417,0],[209,-381],[-209,-380]],[[28483,10738],[-417,0]],[[27858,11119],[208,381]],[[28483,11500],[209,-381],[-209,-381]],[[28483,10738],[209,-381],[-209,-380],[-417,0],[-208,380]],[[29109,11119],[-417,0]],[[28692,11119],[-209,381],[209,380],[417,0],[208,-380],[-208,-381]],[[29109,10357],[-417,0]],[[28692,10357],[-209,381],[209,381]],[[29109,11119],[208,-381],[-208,-381]],[[29109,10357],[208,-380],[-208,-381],[-417,0],[-209,381],[209,380]],[[30568,8454],[-208,-381],[-417,0],[-209,381],[209,380],[417,0],[208,-380]],[[36197,2743],[-209,-381],[-417,0],[-208,381],[208,381],[417,0],[209,-381]],[[37448,459],[-209,-381],[-417,0],[-208,381],[208,380],[417,0],[209,-380]],[[38073,3124],[-208,-381],[-417,0],[-209,381],[209,380],[417,0],[208,-380]],[[38490,839],[-417,0]],[[38073,839],[-208,381],[208,381],[417,0],[208,-381],[-208,-381]],[[38490,839],[208,-380],[-208,-381],[-417,0],[-208,381],[208,380]],[[32444,10357],[-208,-380],[-417,0],[-209,380],[209,381],[417,0],[208,-381]],[[32444,6550],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[34320,8456],[-208,-380],[-417,0],[-209,380],[209,381],[417,0],[208,-381]],[[33695,5789],[-208,-381],[-417,0],[-209,381],[209,380],[417,0],[208,-380]],[[34321,7692],[-209,-380]],[[34112,7312],[-417,0]],[[33695,7312],[-208,380],[208,381],[417,0]],[[34112,8073],[209,-381]],[[34321,6931],[-209,-381]],[[34112,6550],[-417,0]],[[33695,6550],[-208,381],[208,381]],[[34112,7312],[209,-381]],[[34321,6169],[-209,-380]],[[34112,5789],[-417,0],[-208,380],[208,381]],[[34112,6550],[209,-381]],[[33071,5408],[-209,-381],[-417,0],[-208,381],[208,381],[417,0],[209,-381]],[[34946,8073],[-209,-381]],[[34737,7692],[-416,0]],[[34112,8073],[209,381],[416,0],[209,-381]],[[34946,7312],[-209,-381]],[[34737,6931],[-416,0]],[[34737,7692],[209,-380]],[[34946,6550],[-209,-381]],[[34737,6169],[-416,0]],[[34737,6931],[209,-381]],[[34946,5789],[-209,-381]],[[34737,5408],[-416,0],[-209,381]],[[34737,6169],[209,-380]],[[33696,5027],[-208,-380],[-417,0],[-209,380],[209,381],[417,0],[208,-381]],[[35363,7312],[-417,0]],[[34946,8073],[417,0],[208,-381],[-208,-380]],[[35363,6550],[-417,0]],[[35363,7312],[208,-381],[-208,-381]],[[35363,5789],[-417,0]],[[35363,6550],[208,-381],[-208,-380]],[[35363,5789],[208,-381],[-208,-381],[-417,0],[-209,381]],[[36197,8834],[-209,-380],[-417,0],[-208,380],[208,381],[417,0],[209,-381]],[[36197,7312],[-209,-381]],[[35988,6931],[-417,0]],[[35571,6931],[-208,381],[208,380],[417,0]],[[35988,7692],[209,-380]],[[36197,6550],[-209,-381]],[[35988,6169],[-417,0]],[[35571,6169],[-208,381],[208,381]],[[35988,6931],[209,-381]],[[36197,5789],[-209,-381]],[[35988,5408],[-417,0],[-208,381],[208,380]],[[35988,6169],[209,-380]],[[36822,7692],[-208,-380]],[[36614,7312],[-417,0]],[[35988,7692],[209,381],[417,0],[208,-381]],[[36822,6931],[-208,-381]],[[36614,6550],[-417,0]],[[36614,7312],[208,-381]],[[36822,6169],[-208,-380]],[[36614,5789],[-417,0]],[[36614,6550],[208,-381]],[[36822,5408],[-208,-381]],[[36614,5027],[-417,0]],[[36197,5027],[-209,381]],[[36614,5789],[208,-381]],[[36822,4647],[-208,-381],[-417,0],[-209,381],[209,380]],[[36614,5027],[208,-380]],[[37448,7312],[-209,-381]],[[37239,6931],[-417,0]],[[36822,7692],[417,0],[209,-380]],[[37448,6550],[-209,-381]],[[37239,6169],[-417,0]],[[37239,6931],[209,-381]],[[37448,5789],[-209,-381]],[[37239,5408],[-417,0]],[[37239,6169],[209,-380]],[[37239,5408],[209,-381],[-209,-380],[-417,0]],[[38073,8454],[-208,-381],[-417,0],[-209,381],[209,380],[417,0],[208,-380]],[[37865,6550],[-417,0]],[[37448,7312],[417,0],[208,-381],[-208,-381]],[[37865,6550],[208,-381],[-208,-380],[-417,0]],[[36198,4255],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[35573,8459],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[36199,8080],[-209,-381],[-417,0],[-208,381],[208,381],[417,0],[209,-381]],[[33699,8095],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[39949,7312],[-208,-381],[-417,0],[-209,381],[209,380],[417,0],[208,-380]],[[2841,14165],[-417,0]],[[2424,14165],[-208,380],[208,381],[417,0],[209,-381],[-209,-380]],[[2841,13403],[-417,0]],[[2424,13403],[-208,381],[208,381]],[[2841,14165],[209,-381],[-209,-381]],[[2841,13403],[209,-381],[-209,-380],[-417,0],[-208,380],[208,381]],[[3050,11500],[-209,-381],[-417,0],[-208,381],[208,380],[417,0],[209,-380]],[[3467,14545],[-417,0]],[[3050,14545],[-209,381],[209,381],[417,0],[208,-381],[-208,-381]],[[3467,13784],[-417,0]],[[3050,13784],[-209,381],[209,380]],[[3467,14545],[208,-380],[-208,-381]],[[3675,13403],[-208,-381]],[[3467,13022],[-417,0]],[[3050,13022],[-209,381],[209,381]],[[3467,13784],[208,-381]],[[3675,12642],[-208,-381]],[[3467,12261],[-417,0]],[[3050,12261],[-209,381],[209,380]],[[3467,13022],[208,-380]],[[3467,12261],[208,-381],[-208,-380],[-417,0],[-209,380],[209,381]],[[3054,12261],[-208,-381],[-417,0],[-209,381],[209,381],[417,0],[208,-381]],[[3675,13403],[417,0],[208,-381],[-208,-380],[-417,0]],[[4301,12260],[-208,-380],[-417,0],[-209,380],[209,381],[417,0],[208,-381]],[[3052,10737],[-209,-381],[-417,0],[-208,381],[208,381],[417,0],[209,-381]],[[3056,9975],[-209,-380],[-417,0],[-208,380],[208,381],[417,0],[209,-381]],[[8678,24825],[-208,-381],[-417,0],[-209,381],[209,380],[417,0],[208,-380]],[[11805,16068],[-208,-381],[-417,0],[-208,381],[208,381],[417,0],[208,-381]]],"transform":{"scale":[0.0009000643620033121,0.0008536496900245044],"translate":[112.9211144212919,-43.632079486013296]},"objects":{"sentiment-background-electorates":{"type":"GeometryCollection","geometries":[{"arcs":[[0,1,2,3,4,5,6,7,8]],"type":"Polygon","properties":{"id":"1","NAME":"Blair","Sortname":"BLAIR","fid_2":1001,"zoomState":"QLD"}},{"arcs":[[[9]],[[10,11,12,13,14,15]]],"type":"MultiPolygon","properties":{"id":"2","NAME":"Bonner","Sortname":"BONNER","fid_2":1002,"zoomState":"QLD"}},{"arcs":[[[16,17,18,-11,19]],[[20]]],"type":"MultiPolygon","properties":{"id":"3","NAME":"Bowman","Sortname":"BOWMAN","fid_2":1003,"zoomState":"QLD"}},{"arcs":[[21,22,23,24]],"type":"Polygon","properties":{"id":"4","NAME":"Brisbane","Sortname":"BRISBANE","fid_2":1004,"zoomState":"QLD"}},{"arcs":[[[25,26,27,28,29]],[[30]],[[31]],[[32]],[[33]],[[34]]],"type":"MultiPolygon","properties":{"id":"5","NAME":"Capricornia","Sortname":"CAPRICORNIA","fid_2":1005,"zoomState":"QLD"}},{"arcs":[[[-29,35,36,37]],[[38]],[[39]],[[40]],[[41]]],"type":"MultiPolygon","properties":{"id":"6","NAME":"Dawson","Sortname":"DAWSON","fid_2":1006,"zoomState":"QLD"}},{"arcs":[[42,43,-7,44,45]],"type":"Polygon","properties":{"id":"7","NAME":"Dickson","Sortname":"DICKSON","fid_2":1007,"zoomState":"QLD"}},{"arcs":[[[46]],[[47,48,49,-17,50]]],"type":"MultiPolygon","properties":{"id":"8","NAME":"Fadden","Sortname":"FADDEN","fid_2":1008,"zoomState":"QLD"}},{"arcs":[[-4,51,52,53]],"type":"Polygon","properties":{"id":"9","NAME":"Fairfax","Sortname":"FAIRFAX","fid_2":1009,"zoomState":"QLD"}},{"arcs":[[54,-5,-54,55]],"type":"Polygon","properties":{"id":"10","NAME":"Fisher","Sortname":"FISHER","fid_2":1010,"zoomState":"QLD"}},{"arcs":[[[56,57,58,-26,59]],[[60]],[[61]]],"type":"MultiPolygon","properties":{"id":"11","NAME":"Flynn","Sortname":"FLYNN","fid_2":1011,"zoomState":"QLD"}},{"arcs":[[62,63,-18,-50]],"type":"Polygon","properties":{"id":"12","NAME":"Forde","Sortname":"FORDE","fid_2":1012,"zoomState":"QLD"}},{"arcs":[[64,65,66,-22,-14]],"type":"Polygon","properties":{"id":"13","NAME":"Griffith","Sortname":"GRIFFITH","fid_2":1013,"zoomState":"QLD"}},{"arcs":[[67,68]],"type":"Polygon","properties":{"id":"14","NAME":"Groom","Sortname":"GROOM","fid_2":1014,"zoomState":"QLD"}},{"arcs":[[[-37,69,70]],[[71]],[[72]]],"type":"MultiPolygon","properties":{"id":"15","NAME":"Herbert","Sortname":"HERBERT","fid_2":1015,"zoomState":"QLD"}},{"arcs":[[73,-57,74]],"type":"Polygon","properties":{"id":"16","NAME":"Hinkler","Sortname":"HINKLER","fid_2":1016,"zoomState":"QLD"}},{"arcs":[[[-70,-36,-28,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91]],[[92]],[[93]],[[94]],[[95]],[[96]]],"type":"MultiPolygon","properties":{"id":"17","NAME":"Kennedy","Sortname":"KENNEDY","fid_2":1017,"zoomState":"QLD"}},{"arcs":[[[-91,97]],[[98]],[[99]],[[100]],[[101]],[[102]],[[103]],[[104]],[[105]]],"type":"MultiPolygon","properties":{"id":"18","NAME":"Leichhardt","Sortname":"LEICHHARDT","fid_2":1018,"zoomState":"QLD"}},{"arcs":[[-15,-25,106,-43,107,108]],"type":"Polygon","properties":{"id":"19","NAME":"Lilley","Sortname":"LILLEY","fid_2":1019,"zoomState":"QLD"}},{"arcs":[[[109,-45,-6,-55,110]],[[111]]],"type":"MultiPolygon","properties":{"id":"20","NAME":"Longman","Sortname":"LONGMAN","fid_2":1020,"zoomState":"QLD"}},{"arcs":[[112,113,114,115,116]],"type":"Polygon","properties":{"id":"22","NAME":"Mcpherson","Sortname":"MCPHERSON","fid_2":1022,"zoomState":"QLD"}},{"arcs":[[-114,117,-48,118]],"type":"Polygon","properties":{"id":"23","NAME":"Moncrieff","Sortname":"MONCRIEFF","fid_2":1023,"zoomState":"QLD"}},{"arcs":[[119,120,121,-65,-13]],"type":"Polygon","properties":{"id":"24","NAME":"Moreton","Sortname":"MORETON","fid_2":1024,"zoomState":"QLD"}},{"arcs":[[122,123,-9,124,-121]],"type":"Polygon","properties":{"id":"25","NAME":"Oxley","Sortname":"OXLEY","fid_2":1025,"zoomState":"QLD"}},{"arcs":[[-108,-46,-110,125]],"type":"Polygon","properties":{"id":"26","NAME":"Petrie","Sortname":"PETRIE","fid_2":1026,"zoomState":"QLD"}},{"arcs":[[-64,126,-123,-120,-12,-19]],"type":"Polygon","properties":{"id":"27","NAME":"Rankin","Sortname":"RANKIN","fid_2":1027,"zoomState":"QLD"}},{"arcs":[[-122,-125,-8,-44,-107,-24,127,-66]],"type":"Polygon","properties":{"id":"28","NAME":"Ryan","Sortname":"RYAN","fid_2":1028,"zoomState":"QLD"}},{"arcs":[[[-52,-3,128,-58,-74,129]],[[130]],[[131]]],"type":"MultiPolygon","properties":{"id":"29","NAME":"Wide Bay","Sortname":"WIDE BAY","fid_2":1029,"zoomState":"QLD"}},{"arcs":[[132,133,134,135,136,137,138,139,-69,140,-1,-124,-127,-63,-49,-118,-113]],"type":"Polygon","properties":{"id":"30","NAME":"Wright","Sortname":"Wright","fid_2":1030,"zoomState":"QLD"}},{"arcs":[[-140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,-76,-27,-59,-129,-2,-141,-68]],"type":"Polygon","properties":{"id":"21","NAME":"Maranoa","Sortname":"MARANOA","fid_2":1021,"zoomState":"QLD"}},{"arcs":[[166,167,168,169,170]],"type":"Polygon","properties":{"id":"1","NAME":"Banks","Sortname":"Banks","fid_2":1001,"zoomState":"NSW"}},{"arcs":[[171,172,-171,173,174]],"type":"Polygon","properties":{"id":"2","NAME":"Barton","Sortname":"Barton","fid_2":1002,"zoomState":"NSW"}},{"arcs":[[175,176,177,178,179]],"type":"Polygon","properties":{"id":"3","NAME":"Bennelong","Sortname":"Bennelong","fid_2":1003,"zoomState":"NSW"}},{"arcs":[[180,181,-178,182,183,184,185]],"type":"Polygon","properties":{"id":"4","NAME":"Berowra","Sortname":"Berowra","fid_2":1004,"zoomState":"NSW"}},{"arcs":[[186,-169,187,188,189,190,191]],"type":"Polygon","properties":{"id":"5","NAME":"Blaxland","Sortname":"Blaxland","fid_2":1005,"zoomState":"NSW"}},{"arcs":[[192,-179,-182,193,194]],"type":"Polygon","properties":{"id":"6","NAME":"Bradfield","Sortname":"Bradfield","fid_2":1006,"zoomState":"NSW"}},{"arcs":[[195,196,197,198,199,200,201,202]],"type":"Polygon","properties":{"id":"7","NAME":"Calare","Sortname":"Calare","fid_2":1007,"zoomState":"NSW"}},{"arcs":[[203,204,205,206]],"type":"Polygon","properties":{"id":"8","NAME":"Chifley","Sortname":"Chifley","fid_2":1008,"zoomState":"NSW"}},{"arcs":[[207,208,-167,-173,209]],"type":"Polygon","properties":{"id":"9","NAME":"Cook","Sortname":"Cook","fid_2":1009,"zoomState":"NSW"}},{"arcs":[[210,211,212,213]],"type":"Polygon","properties":{"id":"10","NAME":"Cowper","Sortname":"Cowper","fid_2":1010,"zoomState":"NSW"}},{"arcs":[[214,215,216,217,218]],"type":"Polygon","properties":{"id":"11","NAME":"Cunningham","Sortname":"Cunningham","fid_2":1011,"zoomState":"NSW"}},{"arcs":[[219,220,221,222]],"type":"Polygon","properties":{"id":"12","NAME":"Dobell","Sortname":"Dobell","fid_2":1012,"zoomState":"NSW"}},{"arcs":[[223,224,225,226,227,228,229],[230,231,232]],"type":"Polygon","properties":{"id":"13","NAME":"Eden-Monaro","Sortname":"Eden-Monaro","fid_2":1013,"zoomState":"NSW"}},{"arcs":[[233,234,235,236,237,238,-227]],"type":"Polygon","properties":{"id":"14","NAME":"Farrer","Sortname":"Farrer","fid_2":1014,"zoomState":"NSW"}},{"arcs":[[-189,239,240,241]],"type":"Polygon","properties":{"id":"15","NAME":"Fowler","Sortname":"Fowler","fid_2":1015,"zoomState":"NSW"}},{"arcs":[[-230,242,243,244,245,246]],"type":"Polygon","properties":{"id":"16","NAME":"Gilmore","Sortname":"Gilmore","fid_2":1016,"zoomState":"NSW"}},{"arcs":[[247,-175,248,249,250,251]],"type":"Polygon","properties":{"id":"17","NAME":"Grayndler","Sortname":"Grayndler","fid_2":1017,"zoomState":"NSW"}},{"arcs":[[252,253,-207,254,255,256,257]],"type":"Polygon","properties":{"id":"18","NAME":"Greenway","Sortname":"Greenway","fid_2":1018,"zoomState":"NSW"}},{"arcs":[[-219,258,259,-240,-188,-168,-209,260]],"type":"Polygon","properties":{"id":"19","NAME":"Hughes","Sortname":"Hughes","fid_2":1019,"zoomState":"NSW"}},{"arcs":[[261,-243,-229,262,-196,263,264,265,266,-217]],"type":"Polygon","properties":{"id":"20","NAME":"Hume","Sortname":"Hume","fid_2":1020,"zoomState":"NSW"}},{"arcs":[[267,-221,268,269,-202,270,271,272,273]],"type":"Polygon","properties":{"id":"21","NAME":"Hunter","Sortname":"Hunter","fid_2":1021,"zoomState":"NSW"}},{"arcs":[[-210,-172,-248,274,275,276]],"type":"Polygon","properties":{"id":"22","NAME":"Kingsford Smith","Sortname":"Kingsford Smith","fid_2":1022,"zoomState":"NSW"}},{"arcs":[[-205,277,278,-265,279]],"type":"Polygon","properties":{"id":"23","NAME":"Lindsay","Sortname":"Lindsay","fid_2":1023,"zoomState":"NSW"}},{"arcs":[[280,281,-272,282,-211]],"type":"Polygon","properties":{"id":"24","NAME":"Lyne","Sortname":"Lyne","fid_2":1024,"zoomState":"NSW"}},{"arcs":[[-218,-267,283,-259]],"type":"Polygon","properties":{"id":"25","NAME":"Macarthur","Sortname":"Macarthur","fid_2":1025,"zoomState":"NSW"}},{"arcs":[[284,-194,-181,285,286]],"type":"Polygon","properties":{"id":"26","NAME":"Mackellar","Sortname":"Mackellar","fid_2":1026,"zoomState":"NSW"}},{"arcs":[[287,-185,288,-255,-206,-280,-264,-203,-270]],"type":"Polygon","properties":{"id":"27","NAME":"Macquarie","Sortname":"Macquarie","fid_2":1027,"zoomState":"NSW"}},{"arcs":[[-190,-242,289,-278,-204,-254,290]],"type":"Polygon","properties":{"id":"28","NAME":"McMahon","Sortname":"McMahon","fid_2":1028,"zoomState":"NSW"}},{"arcs":[[291,-258,292,256,-257,-256,-289,-184]],"type":"Polygon","properties":{"id":"29","NAME":"Mitchell","Sortname":"Mitchell","fid_2":1029,"zoomState":"NSW"}},{"arcs":[[-212,-283,-271,-201,293,294,-150,295,296,-147,297,-145,298,-143,299,-138,300,301]],"type":"Polygon","properties":{"id":"30","NAME":"New England","Sortname":"New England","fid_2":1030,"zoomState":"NSW"}},{"arcs":[[302,303,-274,304]],"type":"Polygon","properties":{"id":"31","NAME":"Newcastle","Sortname":"Newcastle","fid_2":1031,"zoomState":"NSW"}},{"arcs":[[305,-251,306,-180,-193,307]],"type":"Polygon","properties":{"id":"32","NAME":"North Sydney","Sortname":"North Sydney","fid_2":1032,"zoomState":"NSW"}},{"arcs":[[308,-213,-302,309,-136,310,311]],"type":"Polygon","properties":{"id":"33","NAME":"Page","Sortname":"Page","fid_2":1033,"zoomState":"NSW"}},{"arcs":[[-200,312,-238,313,314,-158,315,-156,316,-154,317,-152,318,-294]],"type":"Polygon","properties":{"id":"34","NAME":"Parkes","Sortname":"Parkes","fid_2":1034,"zoomState":"NSW"}},{"arcs":[[319,-191,-291,-253,-292,-183,-177]],"type":"Polygon","properties":{"id":"35","NAME":"Parramatta","Sortname":"Parramatta","fid_2":1035,"zoomState":"NSW"}},{"arcs":[[320,-305,-273,-282]],"type":"Polygon","properties":{"id":"36","NAME":"Paterson","Sortname":"Paterson","fid_2":1036,"zoomState":"NSW"}},{"arcs":[[321,-192,-320,-176,-307,-250]],"type":"Polygon","properties":{"id":"37","NAME":"Reid","Sortname":"Reid","fid_2":1037,"zoomState":"NSW"}},{"arcs":[[-312,322,-134,323,-116,324]],"type":"Polygon","properties":{"id":"38","NAME":"Richmond","Sortname":"Richmond","fid_2":1038,"zoomState":"NSW"}},{"arcs":[[-263,-228,-239,-313,-199,325,197,-198,-197]],"type":"Polygon","properties":{"id":"39","NAME":"Riverina","Sortname":"Riverina","fid_2":1039,"zoomState":"NSW"}},{"arcs":[[-286,-186,-288,-269,-220,326]],"type":"Polygon","properties":{"id":"40","NAME":"Robertson","Sortname":"Robertson","fid_2":1040,"zoomState":"NSW"}},{"arcs":[[-222,-268,-304,327]],"type":"Polygon","properties":{"id":"41","NAME":"Shortland","Sortname":"Shortland","fid_2":1041,"zoomState":"NSW"}},{"arcs":[[-275,247,-248,-252,-306,328]],"type":"Polygon","properties":{"id":"42","NAME":"Sydney","Sortname":"Sydney","fid_2":1042,"zoomState":"NSW"}},{"arcs":[[329,-308,-195,-285,330]],"type":"Polygon","properties":{"id":"43","NAME":"Warringah","Sortname":"Warringah","fid_2":1043,"zoomState":"NSW"}},{"arcs":[[-174,-170,-187,-322,-249]],"type":"Polygon","properties":{"id":"44","NAME":"Watson","Sortname":"Watson","fid_2":1044,"zoomState":"NSW"}},{"arcs":[[331,-276,-329,-330]],"type":"Polygon","properties":{"id":"45","NAME":"Wentworth","Sortname":"Wentworth","fid_2":1045,"zoomState":"NSW"}},{"arcs":[[-260,-284,-266,-279,-290,-241]],"type":"Polygon","properties":{"id":"46","NAME":"Werriwa","Sortname":"Werriwa","fid_2":1046,"zoomState":"NSW"}},{"arcs":[[-244,-262,-216,332]],"type":"Polygon","properties":{"id":"47","NAME":"Whitlam","Sortname":"Whitlam","fid_2":1047,"zoomState":"NSW"}},{"arcs":[[-232,333,334]],"type":"Polygon","properties":{"id":"1","NAME":"Bean","Sortname":"Bean","fid_2":1001,"zoomState":"ACT"}},{"arcs":[[335,-233,-335]],"type":"Polygon","properties":{"id":"2","NAME":"Canberra","Sortname":"Canberra","fid_2":1002,"zoomState":"ACT"}},{"arcs":[[[-336,-334,-231]],[[-246,336]]],"type":"MultiPolygon","properties":{"id":"3","NAME":"Fenner","Sortname":"Fenner","fid_2":1003,"zoomState":"ACT"}},{"arcs":[[337,338,339,340,341]],"type":"Polygon","properties":{"id":"1","NAME":"Aston","Sortname":"Aston","fid_2":1001,"zoomState":"VIC"}},{"arcs":[[342,343,344,345,346,347,348,349]],"type":"Polygon","properties":{"id":"2","NAME":"Ballarat","Sortname":"Ballarat","fid_2":1002,"zoomState":"VIC"}},{"arcs":[[350,-349,351,352]],"type":"Polygon","properties":{"id":"3","NAME":"Bendigo","Sortname":"Bendigo","fid_2":1003,"zoomState":"VIC"}},{"arcs":[[353,354,355,356,-338,357]],"type":"Polygon","properties":{"id":"4","NAME":"Bruce","Sortname":"Bruce","fid_2":1004,"zoomState":"VIC"}},{"arcs":[[358,359,360,361,362,363]],"type":"Polygon","properties":{"id":"5","NAME":"Calwell","Sortname":"Calwell","fid_2":1005,"zoomState":"VIC"}},{"arcs":[[364,365,-358,-342,366,367,368,369]],"type":"Polygon","properties":{"id":"6","NAME":"Casey","Sortname":"Casey","fid_2":1006,"zoomState":"VIC"}},{"arcs":[[370,371,372,373,374,-340]],"type":"Polygon","properties":{"id":"7","NAME":"Chisholm","Sortname":"Chisholm","fid_2":1007,"zoomState":"VIC"}},{"arcs":[[375,376,377,378,379]],"type":"Polygon","properties":{"id":"8","NAME":"Cooper","Sortname":"Cooper","fid_2":1008,"zoomState":"VIC"}},{"arcs":[[380,-346,381,382]],"type":"Polygon","properties":{"id":"9","NAME":"Corangamite","Sortname":"Corangamite","fid_2":1009,"zoomState":"VIC"}},{"arcs":[[-382,-345,383,384]],"type":"Polygon","properties":{"id":"10","NAME":"Corio","Sortname":"Corio","fid_2":1010,"zoomState":"VIC"}},{"arcs":[[-341,-375,385,-367]],"type":"Polygon","properties":{"id":"11","NAME":"Deakin","Sortname":"Deakin","fid_2":1011,"zoomState":"VIC"}},{"arcs":[[386,387,388,389]],"type":"Polygon","properties":{"id":"12","NAME":"Dunkley","Sortname":"Dunkley","fid_2":1012,"zoomState":"VIC"}},{"arcs":[[-388,390,391]],"type":"Polygon","properties":{"id":"13","NAME":"Flinders","Sortname":"Flinders","fid_2":1013,"zoomState":"VIC"}},{"arcs":[[392,393,394,395,-362,396]],"type":"Polygon","properties":{"id":"14","NAME":"Fraser","Sortname":"Fraser","fid_2":1014,"zoomState":"VIC"}},{"arcs":[[397,398,399,-394,400,401,402]],"type":"Polygon","properties":{"id":"15","NAME":"Gellibrand","Sortname":"Gellibrand","fid_2":1015,"zoomState":"VIC"}},{"arcs":[[403,404,-225,405]],"type":"Polygon","properties":{"id":"16","NAME":"Gippsland","Sortname":"Gippsland","fid_2":1016,"zoomState":"VIC"}},{"arcs":[[406,407,408,409,410]],"type":"Polygon","properties":{"id":"17","NAME":"Goldstein","Sortname":"Goldstein","fid_2":1017,"zoomState":"VIC"}},{"arcs":[[411,-343,412,-395]],"type":"Polygon","properties":{"id":"18","NAME":"Gorton","Sortname":"Gorton","fid_2":1018,"zoomState":"VIC"}},{"arcs":[[-372,413,-409,414,415,416]],"type":"Polygon","properties":{"id":"19","NAME":"Higgins","Sortname":"Higgins","fid_2":1019,"zoomState":"VIC"}},{"arcs":[[417,-391,-387,418,-355,419,420]],"type":"Polygon","properties":{"id":"20","NAME":"Holt","Sortname":"Holt","fid_2":1020,"zoomState":"VIC"}},{"arcs":[[-357,421,-410,-414,-371,-339]],"type":"Polygon","properties":{"id":"21","NAME":"Hotham","Sortname":"Hotham","fid_2":1021,"zoomState":"VIC"}},{"arcs":[[-405,422,-370,423,424,-234,-226]],"type":"Polygon","properties":{"id":"22","NAME":"Indi","Sortname":"Indi","fid_2":1022,"zoomState":"VIC"}},{"arcs":[[-419,-390,425,-411,-422,-356]],"type":"Polygon","properties":{"id":"23","NAME":"Isaacs","Sortname":"Isaacs","fid_2":1023,"zoomState":"VIC"}},{"arcs":[[426,427,-380,428,429]],"type":"Polygon","properties":{"id":"24","NAME":"Jagajaga","Sortname":"Jagajaga","fid_2":1024,"zoomState":"VIC"}},{"arcs":[[-373,-417,430,-376,-428,431]],"type":"Polygon","properties":{"id":"25","NAME":"Kooyong","Sortname":"Kooyong","fid_2":1025,"zoomState":"VIC"}},{"arcs":[[-420,-354,-366,432]],"type":"Polygon","properties":{"id":"26","NAME":"La Trobe","Sortname":"La Trobe","fid_2":1026,"zoomState":"VIC"}},{"arcs":[[433,-384,-344,-412,-400]],"type":"Polygon","properties":{"id":"27","NAME":"Lalor","Sortname":"Lalor","fid_2":1027,"zoomState":"VIC"}},{"arcs":[[-408,434,-398,435,-415]],"type":"Polygon","properties":{"id":"28","NAME":"Macnamara","Sortname":"Macnamara","fid_2":1028,"zoomState":"VIC"}},{"arcs":[[436,-352,-348,437,438,-236]],"type":"Polygon","properties":{"id":"29","NAME":"Mallee","Sortname":"Mallee","fid_2":1029,"zoomState":"VIC"}},{"arcs":[[-402,439,-397,-361,440,441]],"type":"Polygon","properties":{"id":"30","NAME":"Maribyrnong","Sortname":"Maribyrnong","fid_2":1030,"zoomState":"VIC"}},{"arcs":[[-369,442,-430,443,-363,-396,-413,-350,-351,444,-424]],"type":"Polygon","properties":{"id":"31","NAME":"Mcewen","Sortname":"McEwen","fid_2":1031,"zoomState":"VIC"}},{"arcs":[[-416,-436,-403,-442,445,-377,-431]],"type":"Polygon","properties":{"id":"32","NAME":"Melbourne","Sortname":"Melbourne","fid_2":1032,"zoomState":"VIC"}},{"arcs":[[-386,-374,-432,-427,-443,-368]],"type":"Polygon","properties":{"id":"33","NAME":"Menzies","Sortname":"Menzies","fid_2":1033,"zoomState":"VIC"}},{"arcs":[[446,-421,-433,-365,-423,-404]],"type":"Polygon","properties":{"id":"34","NAME":"Monash","Sortname":"Monash","fid_2":1034,"zoomState":"VIC"}},{"arcs":[[-445,-353,-437,-235,-425]],"type":"Polygon","properties":{"id":"35","NAME":"Nicholls","Sortname":"Nicholls","fid_2":1035,"zoomState":"VIC"}},{"arcs":[[-429,-379,-364,-444]],"type":"Polygon","properties":{"id":"36","NAME":"Scullin","Sortname":"Scullin","fid_2":1036,"zoomState":"VIC"}},{"arcs":[[447,448,-438,-347,-381]],"type":"Polygon","properties":{"id":"37","NAME":"Wannon","Sortname":"Wannon","fid_2":1037,"zoomState":"VIC"}},{"arcs":[[-446,-441,449,-359,-378]],"type":"Polygon","properties":{"id":"38","NAME":"Wills","Sortname":"Wills","fid_2":1038,"zoomState":"VIC"}},{"arcs":[[[450,451,452]],[[453]],[[454]],[[455]],[[456]],[[457]]],"type":"MultiPolygon","properties":{"id":"1","NAME":"Bass","Sortname":"Bass","fid_2":1001,"zoomState":"TAS"}},{"arcs":[[[458,459,460,-452]],[[461]],[[462]],[[463]],[[464]],[[465]]],"type":"MultiPolygon","properties":{"id":"2","NAME":"Braddon","Sortname":"Braddon","fid_2":1002,"zoomState":"TAS"}},{"arcs":[[466,467,468]],"type":"Polygon","properties":{"id":"3","NAME":"Clark","Sortname":"Clark","fid_2":1003,"zoomState":"TAS"}},{"arcs":[[[-460,469,-467,470]],[[471]],[[472,473]]],"type":"MultiPolygon","properties":{"id":"4","NAME":"Franklin","Sortname":"Franklin","fid_2":1004,"zoomState":"TAS"}},{"arcs":[[[-473,474,-468,-470,-459,-451,475]],[[476]],[[477]],[[478]]],"type":"MultiPolygon","properties":{"id":"5","NAME":"Lyons","Sortname":"Lyons","fid_2":1005,"zoomState":"TAS"}},{"arcs":[[479,480,481,482]],"type":"Polygon","properties":{"id":"1","NAME":"Adelaide","Sortname":"Adelaide","fid_2":1001,"zoomState":"SA"}},{"arcs":[[483,484,485,-314,-237,-439,-449,486]],"type":"Polygon","properties":{"id":"2","NAME":"Barker","Sortname":"Barker","fid_2":1002,"zoomState":"SA"}},{"arcs":[[487,488,489,-480,490,491]],"type":"Polygon","properties":{"id":"3","NAME":"Boothby","Sortname":"Boothby","fid_2":1003,"zoomState":"SA"}},{"arcs":[[[-486,492,493,494,495,496,-163,497,-161,498,-159,-315]],[[499]],[[500]],[[501]],[[502]],[[503]]],"type":"MultiPolygon","properties":{"id":"4","NAME":"Grey","Sortname":"Grey","fid_2":1004,"zoomState":"SA"}},{"arcs":[[-481,-490,504,505]],"type":"Polygon","properties":{"id":"5","NAME":"Hindmarsh","Sortname":"Hindmarsh","fid_2":1005,"zoomState":"SA"}},{"arcs":[[506,-488,507]],"type":"Polygon","properties":{"id":"6","NAME":"Kingston","Sortname":"Kingston","fid_2":1006,"zoomState":"SA"}},{"arcs":[[508,509,-482,-506,510,511]],"type":"Polygon","properties":{"id":"7","NAME":"Makin","Sortname":"Makin","fid_2":1007,"zoomState":"SA"}},{"arcs":[[[512,-508,-492,513,-509,514,-484]],[[515]]],"type":"MultiPolygon","properties":{"id":"8","NAME":"Mayo","Sortname":"Mayo","fid_2":1008,"zoomState":"SA"}},{"arcs":[[-512,516,-493,-485,-515]],"type":"Polygon","properties":{"id":"9","NAME":"Spence","Sortname":"Spence","fid_2":1009,"zoomState":"SA"}},{"arcs":[[-491,-483,-510,-514]],"type":"Polygon","properties":{"id":"10","NAME":"Sturt","Sortname":"Sturt","fid_2":1010,"zoomState":"SA"}},{"arcs":[[517,518,519]],"type":"Polygon","properties":{"id":"1","NAME":"Brand","Sortname":"Brand","fid_2":1001,"zoomState":"WA"}},{"arcs":[[520,521,-520,522,523,524,525]],"type":"Polygon","properties":{"id":"2","NAME":"Canning","Sortname":"Canning","fid_2":1002,"zoomState":"WA"}},{"arcs":[[526,527,528,529,530]],"type":"Polygon","properties":{"id":"3","NAME":"Cowan","Sortname":"Cowan","fid_2":1003,"zoomState":"WA"}},{"arcs":[[531,532,533,534,535]],"type":"Polygon","properties":{"id":"4","NAME":"Curtin","Sortname":"Curtin","fid_2":1004,"zoomState":"WA"}},{"arcs":[[[536,537,538,539]],[[540]],[[541]],[[542]],[[543]],[[544]],[[545]],[[546]],[[547]],[[548]],[[549]],[[550]],[[551]],[[552]],[[553]],[[554]],[[555]],[[556]],[[557]],[[558]],[[559]],[[560]],[[561]],[[562]],[[563]],[[564]],[[565]],[[566]],[[567]],[[568]],[[569]],[[570]]],"type":"MultiPolygon","properties":{"id":"5","NAME":"Durack","Sortname":"Durack","fid_2":1005,"zoomState":"WA"}},{"arcs":[[571,-521,572]],"type":"Polygon","properties":{"id":"6","NAME":"Forrest","Sortname":"Forrest","fid_2":1006,"zoomState":"WA"}},{"arcs":[[[-519,573,-533,574,575]],[[576]]],"type":"MultiPolygon","properties":{"id":"7","NAME":"Fremantle","Sortname":"Fremantle","fid_2":1007,"zoomState":"WA"}},{"arcs":[[-524,577,578,579,-527,580]],"type":"Polygon","properties":{"id":"8","NAME":"Hasluck","Sortname":"Hasluck","fid_2":1008,"zoomState":"WA"}},{"arcs":[[581,582,583,-530]],"type":"Polygon","properties":{"id":"9","NAME":"Moore","Sortname":"Moore","fid_2":1009,"zoomState":"WA"}},{"arcs":[[-576,584,-578,-523]],"type":"Polygon","properties":{"id":"10","NAME":"Burt","Sortname":"Burt","fid_2":1010,"zoomState":"WA"}},{"arcs":[[-573,-526,585,-537,586,-495,587]],"type":"Polygon","properties":{"id":"11","NAME":"O'Connor","Sortname":"O'Connor","fid_2":1011,"zoomState":"WA"}},{"arcs":[[-586,-525,-581,-531,-584,588,-538]],"type":"Polygon","properties":{"id":"12","NAME":"Pearce","Sortname":"Pearce","fid_2":1012,"zoomState":"WA"}},{"arcs":[[589,-536,590,-528,-580]],"type":"Polygon","properties":{"id":"13","NAME":"Perth","Sortname":"Perth","fid_2":1013,"zoomState":"WA"}},{"arcs":[[-535,591,-582,-529,-591]],"type":"Polygon","properties":{"id":"14","NAME":"Stirling","Sortname":"Stirling","fid_2":1014,"zoomState":"WA"}},{"arcs":[[592,-590,-579]],"type":"Polygon","properties":{"id":"15","NAME":"Swan","Sortname":"Swan","fid_2":1015,"zoomState":"WA"}},{"arcs":[[-585,-575,-532,-593]],"type":"Polygon","properties":{"id":"16","NAME":"Tangney","Sortname":"Tangney","fid_2":1016,"zoomState":"WA"}},{"arcs":[[[593,594,595,596,-87,597,-85,598,-83,599,-81,600,-79,601,602,-166,603,-496,-587,-540,604]],[[605]],[[606]],[[607]],[[608]]],"type":"MultiPolygon","properties":{"id":"1","NAME":"Lingiari","Sortname":"Lingiari","fid_2":1001,"zoomState":"NT"}},{"arcs":[[609,-594]],"type":"Polygon","properties":{"id":"2","NAME":"Solomon","Sortname":"Solomon","fid_2":1002,"zoomState":"NT"}}]},"sentiment-city-cbd-electorate-points":{"type":"GeometryCollection","geometries":[{"arcs":[[610]],"type":"Polygon","properties":{"ROW":38,"COLUMN":58,"layer":"adelaide-point","path":"/Users/canee/Desktop/projects/Federal Election 2019/mapfiles/adelaide-point.shp","fid":201}},{"arcs":[[611]],"type":"Polygon","properties":{"ROW":26,"COLUMN":84,"layer":"brisbane-point","path":"/Users/canee/Desktop/projects/Federal Election 2019/mapfiles/brisbane-point.shp","fid":202}},{"arcs":[[612]],"type":"Polygon","properties":{"ROW":41,"COLUMN":77,"layer":"canberra-point","path":"/Users/canee/Desktop/projects/Federal Election 2019/mapfiles/canberra-point.shp","fid":203}},{"arcs":[[613]],"type":"Polygon","properties":{"ROW":51,"COLUMN":74,"layer":"clark-point","path":"/Users/canee/Desktop/projects/Federal Election 2019/mapfiles/clark-point.shp","fid":204}},{"arcs":[[614]],"type":"Polygon","properties":{"ROW":45,"COLUMN":69,"layer":"melbourne-point","path":"/Users/canee/Desktop/projects/Federal Election 2019/mapfiles/melbourne-point.shp","fid":205}},{"arcs":[[615]],"type":"Polygon","properties":{"ROW":35,"COLUMN":18,"layer":"perth-point","path":"/Users/canee/Desktop/projects/Federal Election 2019/mapfiles/perth-point.shp","fid":206}},{"arcs":[[616]],"type":"Polygon","properties":{"ROW":5,"COLUMN":45,"layer":"solomon-point","path":"/Users/canee/Desktop/projects/Federal Election 2019/mapfiles/solomon-point.shp","fid":207}},{"arcs":[[617]],"type":"Polygon","properties":{"ROW":37,"COLUMN":84,"layer":"sydney-point","path":"/Users/canee/Desktop/projects/Federal Election 2019/mapfiles/sydney-point.shp","fid":208}}]},"sentiment-labelled-hex-electorates":{"type":"GeometryCollection","geometries":[{"arcs":[[618]],"type":"Polygon","properties":{"fid":1,"layer":"act3-2","Elect_div":"Bean","fid_2":1,"electorate_state":"ACT","electorate_locations":"Molonglo Valley, Weston Creek, Tuggeranong"}},{"arcs":[[619,620]],"type":"Polygon","properties":{"fid":2,"layer":"act3-2","Elect_div":"Fenner","fid_2":2,"electorate_state":"ACT","electorate_locations":"Belconnen,  Gunghalin, Jervis Bay Village"}},{"arcs":[[-620,621]],"type":"Polygon","properties":{"fid":3,"layer":"act3-2","Elect_div":"Canberra","fid_2":3,"electorate_state":"ACT","electorate_locations":"Hawker, North Canberra, South Canberra"}},{"arcs":[[622]],"type":"Polygon","properties":{"fid":4,"layer":"nsw47-2","Elect_div":"Farrer","fid_2":4,"electorate_state":"NSW","electorate_locations":"Albury, Griffith, Corowa"}},{"arcs":[[623]],"type":"Polygon","properties":{"fid":5,"layer":"nsw47-2","Elect_div":"Parkes","fid_2":5,"electorate_state":"NSW","electorate_locations":"Broken Hill, Dubbo, Coonabarabran"}},{"arcs":[[624]],"type":"Polygon","properties":{"fid":6,"layer":"nsw47-2","Elect_div":"Riverina","fid_2":6,"electorate_state":"NSW","electorate_locations":"Wagga Wagga, Parkes, Forbes"}},{"arcs":[[625]],"type":"Polygon","properties":{"fid":7,"layer":"nsw47-2","Elect_div":"Calare","fid_2":7,"electorate_state":"NSW","electorate_locations":"Bathurst, Orange, Lithgow"}},{"arcs":[[626]],"type":"Polygon","properties":{"fid":8,"layer":"nsw47-2","Elect_div":"Hume","fid_2":8,"electorate_state":"NSW","electorate_locations":"Camden, Golbourn, Crookwell"}},{"arcs":[[627]],"type":"Polygon","properties":{"fid":9,"layer":"nsw47-2","Elect_div":"Newcastle","fid_2":9,"electorate_state":"NSW","electorate_locations":"Newcastle, Jesmond, Maryland"}},{"arcs":[[628]],"type":"Polygon","properties":{"fid":10,"layer":"nsw47-2","Elect_div":"Cook","fid_2":10,"electorate_state":"NSW","electorate_locations":"Cronulla, Gymea, Sans Souci"}},{"arcs":[[629]],"type":"Polygon","properties":{"fid":11,"layer":"nsw47-2","Elect_div":"Whitlam","fid_2":11,"electorate_state":"NSW","electorate_locations":"Shellharbour, Dapto, Bowral"}},{"arcs":[[630]],"type":"Polygon","properties":{"fid":12,"layer":"nsw47-2","Elect_div":"Eden-Monaro","fid_2":12,"electorate_state":"NSW","electorate_locations":"Bega, Yass, Queenbeyan"}},{"arcs":[[631]],"type":"Polygon","properties":{"fid":13,"layer":"nsw47-2","Elect_div":"Fowler","fid_2":13,"electorate_state":"NSW","electorate_locations":"Liverpool, Cabramatta, Warwick Farm"}},{"arcs":[[632,633,634,635]],"type":"Polygon","properties":{"fid":14,"layer":"nsw47-2","Elect_div":"McMahon","fid_2":14,"electorate_state":"NSW","electorate_locations":"Fairfield, Greystanes, Erskine Park"}},{"arcs":[[636,637,638,-634,639]],"type":"Polygon","properties":{"fid":15,"layer":"nsw47-2","Elect_div":"Blaxland","fid_2":15,"electorate_state":"NSW","electorate_locations":"Bankstown, Condell Park, Villawood"}},{"arcs":[[640,641,642,-638,643]],"type":"Polygon","properties":{"fid":16,"layer":"nsw47-2","Elect_div":"Macarthur","fid_2":16,"electorate_state":"NSW","electorate_locations":"Campbelltown, Minto, Rosemeadow"}},{"arcs":[[644,-642,645]],"type":"Polygon","properties":{"fid":17,"layer":"nsw47-2","Elect_div":"Gilmore","fid_2":17,"electorate_state":"NSW","electorate_locations":"Shoalhaven, Kiama, Moruya"}},{"arcs":[[646,647,648]],"type":"Polygon","properties":{"fid":18,"layer":"nsw47-2","Elect_div":"Lindsay","fid_2":18,"electorate_state":"NSW","electorate_locations":"Penrith, Colyton, Londonderry"}},{"arcs":[[649]],"type":"Polygon","properties":{"fid":19,"layer":"nsw47-2","Elect_div":"Werriwa","fid_2":19,"electorate_state":"NSW","electorate_locations":"Macquarie Fields, Hoxton Park, Badgerys Creek"}},{"arcs":[[650,651,-636,652,653]],"type":"Polygon","properties":{"fid":20,"layer":"nsw47-2","Elect_div":"Parramatta","fid_2":20,"electorate_state":"NSW","electorate_locations":"Parramatta, Granville, Westmead"}},{"arcs":[[654,655,-640,-633,-652,656]],"type":"Polygon","properties":{"fid":21,"layer":"nsw47-2","Elect_div":"Watson","fid_2":21,"electorate_state":"NSW","electorate_locations":"Canterbury, Campsie, Punchbowl"}},{"arcs":[[657,658,-644,-637,-656,659]],"type":"Polygon","properties":{"fid":22,"layer":"nsw47-2","Elect_div":"Banks","fid_2":22,"electorate_state":"NSW","electorate_locations":"East Hills, Mortdale, Padstow"}},{"arcs":[[660,-646,-641,-659,661]],"type":"Polygon","properties":{"fid":23,"layer":"nsw47-2","Elect_div":"Cunningham","fid_2":23,"electorate_state":"NSW","electorate_locations":"Wollongong, Bulli, Port Kembla"}},{"arcs":[[662]],"type":"Polygon","properties":{"fid":24,"layer":"nsw47-2","Elect_div":"New England","fid_2":24,"electorate_state":"NSW","electorate_locations":"Tamworth, Armidale, Glen Innes"}},{"arcs":[[663,664,-649,665]],"type":"Polygon","properties":{"fid":25,"layer":"nsw47-2","Elect_div":"Hunter","fid_2":25,"electorate_state":"NSW","electorate_locations":"Lake Macquarie, Cessnock, Singleton"}},{"arcs":[[666,667,668,-647,-665,669]],"type":"Polygon","properties":{"fid":26,"layer":"nsw47-2","Elect_div":"Macquarie","fid_2":26,"electorate_state":"NSW","electorate_locations":"Katoomba, Blaxland, Richmond"}},{"arcs":[[670,671,-654,672,-668,673]],"type":"Polygon","properties":{"fid":27,"layer":"nsw47-2","Elect_div":"Chifley","fid_2":27,"electorate_state":"NSW","electorate_locations":"Blacktown, Mount Druitt, Rooty Hill"}},{"arcs":[[674,675,-657,-651,-672,676]],"type":"Polygon","properties":{"fid":28,"layer":"nsw47-2","Elect_div":"Grayndler","fid_2":28,"electorate_state":"NSW","electorate_locations":"Annandale, Petersham, Summer Hill"}},{"arcs":[[677,678,-660,-655,-676,679]],"type":"Polygon","properties":{"fid":29,"layer":"nsw47-2","Elect_div":"Barton","fid_2":29,"electorate_state":"NSW","electorate_locations":"Rockdale, Kogarah, Tempe"}},{"arcs":[[680,-662,-658,-679,681]],"type":"Polygon","properties":{"fid":30,"layer":"nsw47-2","Elect_div":"Hughes","fid_2":30,"electorate_state":"NSW","electorate_locations":"Sutherland, Barden Ridge, Heathcote"}},{"arcs":[[682,683,-670,-664,684,685]],"type":"Polygon","properties":{"fid":31,"layer":"nsw47-2","Elect_div":"Berowra","fid_2":31,"electorate_state":"NSW","electorate_locations":"Berowra, Hornsby, Pennant Hills"}},{"arcs":[[686,687,-674,-667,-684,688]],"type":"Polygon","properties":{"fid":32,"layer":"nsw47-2","Elect_div":"Greenway","fid_2":32,"electorate_state":"NSW","electorate_locations":"Lalor Park, Blacktown, Riverstone"}},{"arcs":[[689,690,-677,-671,-688,691]],"type":"Polygon","properties":{"fid":33,"layer":"nsw47-2","Elect_div":"Reid","fid_2":33,"electorate_state":"NSW","electorate_locations":"Drummoyne, Homebush, Strathfield"}},{"arcs":[[692,693,-680,-675,-691,694]],"type":"Polygon","properties":{"fid":34,"layer":"nsw47-2","Elect_div":"Sydney","fid_2":34,"electorate_state":"NSW","electorate_locations":"Redfern, Glebe, Potts Point"}},{"arcs":[[695,-682,-678,-694,696]],"type":"Polygon","properties":{"fid":35,"layer":"nsw47-2","Elect_div":"Kingsford Smith","fid_2":35,"electorate_state":"NSW","electorate_locations":"Coogee, Maroubra, Mascot"}},{"arcs":[[697,698]],"type":"Polygon","properties":{"fid":36,"layer":"nsw47-2","Elect_div":"Lyne","fid_2":36,"electorate_state":"NSW","electorate_locations":"Laurieton, Taree, Foster"}},{"arcs":[[699,-686,700,-698,701]],"type":"Polygon","properties":{"fid":37,"layer":"nsw47-2","Elect_div":"Paterson","fid_2":37,"electorate_state":"NSW","electorate_locations":"Maitland, Raymond Terrace, Port Stephens"}},{"arcs":[[702,-689,-683,-700,703]],"type":"Polygon","properties":{"fid":38,"layer":"nsw47-2","Elect_div":"Bradfield","fid_2":38,"electorate_state":"NSW","electorate_locations":"Wahroonga, St Ives, Roseville"}},{"arcs":[[704,-692,-687,-703,705]],"type":"Polygon","properties":{"fid":39,"layer":"nsw47-2","Elect_div":"Mitchell","fid_2":39,"electorate_state":"NSW","electorate_locations":"Baulkham Hills, Castle Hill, Kellyville"}},{"arcs":[[706,-695,-690,-705,707]],"type":"Polygon","properties":{"fid":40,"layer":"nsw47-2","Elect_div":"North Sydney","fid_2":40,"electorate_state":"NSW","electorate_locations":"Kirribilli, Lane Cove, Artarmon"}},{"arcs":[[-697,-693,-707,708]],"type":"Polygon","properties":{"fid":41,"layer":"nsw47-2","Elect_div":"Wentworth","fid_2":41,"electorate_state":"NSW","electorate_locations":"Vaucluse, Bondi, Double Bay"}},{"arcs":[[709,710]],"type":"Polygon","properties":{"fid":42,"layer":"nsw47-2","Elect_div":"Page","fid_2":42,"electorate_state":"NSW","electorate_locations":"Lismore, Grafton, Yamba"}},{"arcs":[[711]],"type":"Polygon","properties":{"fid":43,"layer":"nsw47-2","Elect_div":"Cowper","fid_2":43,"electorate_state":"NSW","electorate_locations":"Coffs Harbour, Port Macquarie, Kempsey"}},{"arcs":[[712,713]],"type":"Polygon","properties":{"fid":44,"layer":"nsw47-2","Elect_div":"Shortland","fid_2":44,"electorate_state":"NSW","electorate_locations":"Wyong, Swansea, Charlestown"}},{"arcs":[[714,715,716,-713,717]],"type":"Polygon","properties":{"fid":45,"layer":"nsw47-2","Elect_div":"Dobell","fid_2":45,"electorate_state":"NSW","electorate_locations":"Wyong, Bateau Bay, The Entrance"}},{"arcs":[[718,719,720,-716,721]],"type":"Polygon","properties":{"fid":46,"layer":"nsw47-2","Elect_div":"Bennelong","fid_2":46,"electorate_state":"NSW","electorate_locations":"Ryde, Epping, Gladesville"}},{"arcs":[[722,-720,723]],"type":"Polygon","properties":{"fid":47,"layer":"nsw47-2","Elect_div":"Warringah","fid_2":47,"electorate_state":"NSW","electorate_locations":"Manly, Mosman, Brookvale"}},{"arcs":[[-711,724,725,726]],"type":"Polygon","properties":{"fid":48,"layer":"nsw47-2","Elect_div":"Richmond","fid_2":48,"electorate_state":"NSW","electorate_locations":"Tweed Heads, Byron Bay, Ballina"}},{"arcs":[[727,-722,-715,728]],"type":"Polygon","properties":{"fid":49,"layer":"nsw47-2","Elect_div":"Robertson","fid_2":49,"electorate_state":"NSW","electorate_locations":"Gosford, Terrigal, Woy Woy"}},{"arcs":[[-724,-719,-728,729]],"type":"Polygon","properties":{"fid":50,"layer":"nsw47-2","Elect_div":"Mackellar","fid_2":50,"electorate_state":"NSW","electorate_locations":"Dee Why, Narrabeen, French's Forest"}},{"arcs":[[730]],"type":"Polygon","properties":{"fid":51,"layer":"nt-2","Elect_div":"Solomon","fid_2":51,"electorate_state":"NT","electorate_locations":"Darwin, Lee Point, Palmerston"}},{"arcs":[[731]],"type":"Polygon","properties":{"fid":52,"layer":"nt-2","Elect_div":"Lingiari","fid_2":52,"electorate_state":"NT","electorate_locations":"Johnston, Alice Springs, Katherine"}},{"arcs":[[732]],"type":"Polygon","properties":{"fid":53,"layer":"qld-30","Elect_div":"Maranoa","fid_2":53,"electorate_state":"QLD","electorate_locations":"Kingaroy, Warwick, Dalby"}},{"arcs":[[733]],"type":"Polygon","properties":{"fid":54,"layer":"qld-30","Elect_div":"Leichhardt","fid_2":54,"electorate_state":"QLD","electorate_locations":"Cairns, Port Douglas, Cooktown"}},{"arcs":[[734]],"type":"Polygon","properties":{"fid":55,"layer":"qld-30","Elect_div":"Kennedy","fid_2":55,"electorate_state":"QLD","electorate_locations":"Mt Isa, Charters Towers, Innisfail"}},{"arcs":[[735]],"type":"Polygon","properties":{"fid":56,"layer":"qld-30","Elect_div":"Herbert","fid_2":56,"electorate_state":"QLD","electorate_locations":"Townsville, Heatley, Condon"}},{"arcs":[[736]],"type":"Polygon","properties":{"fid":57,"layer":"qld-30","Elect_div":"Flynn","fid_2":57,"electorate_state":"QLD","electorate_locations":"Gladstone, Banana, North Burnett"}},{"arcs":[[737]],"type":"Polygon","properties":{"fid":58,"layer":"qld-30","Elect_div":"Dawson","fid_2":58,"electorate_state":"QLD","electorate_locations":"Mackay, Proserpine, Ayr"}},{"arcs":[[738]],"type":"Polygon","properties":{"fid":59,"layer":"qld-30","Elect_div":"Fairfax","fid_2":59,"electorate_state":"QLD","electorate_locations":"Maroochydore, Coolum Beach, Nambour"}},{"arcs":[[739]],"type":"Polygon","properties":{"fid":60,"layer":"qld-30","Elect_div":"Longman","fid_2":60,"electorate_state":"QLD","electorate_locations":"Caboolture, Burpengary, Bribie Island"}},{"arcs":[[740]],"type":"Polygon","properties":{"fid":61,"layer":"qld-30","Elect_div":"Dickson","fid_2":61,"electorate_state":"QLD","electorate_locations":"Samford Valley, Bridgeman Downs, Petrie"}},{"arcs":[[741]],"type":"Polygon","properties":{"fid":62,"layer":"qld-30","Elect_div":"Moncrieff","fid_2":62,"electorate_state":"QLD","electorate_locations":"Miama, Southport, Nerang"}},{"arcs":[[742]],"type":"Polygon","properties":{"fid":63,"layer":"qld-30","Elect_div":"Wide Bay","fid_2":63,"electorate_state":"QLD","electorate_locations":"Noosa, Gympie, Maryborough"}},{"arcs":[[743]],"type":"Polygon","properties":{"fid":64,"layer":"qld-30","Elect_div":"Capricornia","fid_2":64,"electorate_state":"QLD","electorate_locations":"Rockhampton, Yepoon, Sarina"}},{"arcs":[[744]],"type":"Polygon","properties":{"fid":65,"layer":"qld-30","Elect_div":"Blair","fid_2":65,"electorate_state":"QLD","electorate_locations":"Ipswich, Esk, Kilcoy"}},{"arcs":[[745]],"type":"Polygon","properties":{"fid":66,"layer":"qld-30","Elect_div":"Oxley","fid_2":66,"electorate_state":"QLD","electorate_locations":"Redbank, Inala, Jindalee"}},{"arcs":[[746]],"type":"Polygon","properties":{"fid":67,"layer":"qld-30","Elect_div":"Bonner","fid_2":67,"electorate_state":"QLD","electorate_locations":"Wynnum, Mount Gravatt, Carindale"}},{"arcs":[[747,748]],"type":"Polygon","properties":{"fid":68,"layer":"qld-30","Elect_div":"Ryan","fid_2":68,"electorate_state":"QLD","electorate_locations":"Ferny Grove, Toowong, Kenmore"}},{"arcs":[[749,750,-748,751]],"type":"Polygon","properties":{"fid":69,"layer":"qld-30","Elect_div":"Moreton","fid_2":69,"electorate_state":"QLD","electorate_locations":"Fairfield, Corinda, Sunnybank Hills"}},{"arcs":[[-750,752]],"type":"Polygon","properties":{"fid":70,"layer":"qld-30","Elect_div":"Forde","fid_2":70,"electorate_state":"QLD","electorate_locations":"Beenleigh, Logan, Shailer Park"}},{"arcs":[[753]],"type":"Polygon","properties":{"fid":71,"layer":"qld-30","Elect_div":"Hinkler","fid_2":71,"electorate_state":"QLD","electorate_locations":"Bundaberg, Hervey Bay, Childers"}},{"arcs":[[754]],"type":"Polygon","properties":{"fid":72,"layer":"qld-30","Elect_div":"Fisher","fid_2":72,"electorate_state":"QLD","electorate_locations":"Caloundra, Landsborough, Maleny"}},{"arcs":[[755]],"type":"Polygon","properties":{"fid":73,"layer":"qld-30","Elect_div":"Wright","fid_2":73,"electorate_state":"QLD","electorate_locations":"Boonah, Beaudesert, Gatton"}},{"arcs":[[756]],"type":"Polygon","properties":{"fid":74,"layer":"qld-30","Elect_div":"Groom","fid_2":74,"electorate_state":"QLD","electorate_locations":"Toowoomba, Oakey, Highfields"}},{"arcs":[[757,758,759,760]],"type":"Polygon","properties":{"fid":75,"layer":"qld-30","Elect_div":"Brisbane","fid_2":75,"electorate_state":"QLD","electorate_locations":"Ashgrove, New Farm, Hendra"}},{"arcs":[[761,762,763,-759,764]],"type":"Polygon","properties":{"fid":76,"layer":"qld-30","Elect_div":"Griffith","fid_2":76,"electorate_state":"QLD","electorate_locations":"South Brisbane, Greenslopes, Morningside"}},{"arcs":[[765,766,-763,767]],"type":"Polygon","properties":{"fid":77,"layer":"qld-30","Elect_div":"Rankin","fid_2":77,"electorate_state":"QLD","electorate_locations":"Underwood, Daisy Hille, Crestmead"}},{"arcs":[[768]],"type":"Polygon","properties":{"fid":78,"layer":"qld-30","Elect_div":"Petrie","fid_2":78,"electorate_state":"QLD","electorate_locations":"Bracken Ridge, North Lakes, Redcliffe"}},{"arcs":[[769,-761,770]],"type":"Polygon","properties":{"fid":79,"layer":"qld-30","Elect_div":"Lilley","fid_2":79,"electorate_state":"QLD","electorate_locations":"Sandgate, Chermside, Nundah"}},{"arcs":[[771,-765,-758,-770,772]],"type":"Polygon","properties":{"fid":80,"layer":"qld-30","Elect_div":"Bowman","fid_2":80,"electorate_state":"QLD","electorate_locations":"Cleveland, Alexandra Hills, Redland Bay"}},{"arcs":[[773,-768,-762,-772,774]],"type":"Polygon","properties":{"fid":81,"layer":"qld-30","Elect_div":"Fadden","fid_2":81,"electorate_state":"QLD","electorate_locations":"Labrador, Helensvale, Jacobs Well"}},{"arcs":[[-726,775,-766,-774,776]],"type":"Polygon","properties":{"fid":82,"layer":"qld-30","Elect_div":"McPherson","fid_2":82,"electorate_state":"QLD","electorate_locations":"Merrimac, Palm Beach, Coolangatta"}},{"arcs":[[777]],"type":"Polygon","properties":{"fid":83,"layer":"sa-10","Elect_div":"Grey","fid_2":83,"electorate_state":"SA","electorate_locations":"Port Lincoln, Port Augusta, Coober Pedy"}},{"arcs":[[778,779,780]],"type":"Polygon","properties":{"fid":84,"layer":"sa-10","Elect_div":"Hindmarsh","fid_2":84,"electorate_state":"SA","electorate_locations":"West Beach, Taperoo, St Clair"}},{"arcs":[[781]],"type":"Polygon","properties":{"fid":85,"layer":"sa-10","Elect_div":"Mayo","fid_2":85,"electorate_state":"SA","electorate_locations":"Stirling, Victor Harbour, Kangaroo Island"}},{"arcs":[[782,783]],"type":"Polygon","properties":{"fid":86,"layer":"sa-10","Elect_div":"Spence","fid_2":86,"electorate_state":"SA","electorate_locations":"Elizabeth, Gawler, Salisbury"}},{"arcs":[[784,-781,785,-783,786]],"type":"Polygon","properties":{"fid":87,"layer":"sa-10","Elect_div":"Adelaide","fid_2":87,"electorate_state":"SA","electorate_locations":"Kilburn, North Adelaide, Malvern"}},{"arcs":[[-779,-785,787]],"type":"Polygon","properties":{"fid":88,"layer":"sa-10","Elect_div":"Boothby","fid_2":88,"electorate_state":"SA","electorate_locations":"Glenelg, Marino, Belair"}},{"arcs":[[788,789]],"type":"Polygon","properties":{"fid":89,"layer":"sa-10","Elect_div":"Makin","fid_2":89,"electorate_state":"SA","electorate_locations":"Port Adelaide, Modbury, Greenwith"}},{"arcs":[[790,791,-789,792]],"type":"Polygon","properties":{"fid":90,"layer":"sa-10","Elect_div":"Sturt","fid_2":90,"electorate_state":"SA","electorate_locations":"Highbury, Newton, Leabrook"}},{"arcs":[[-791,793]],"type":"Polygon","properties":{"fid":91,"layer":"sa-10","Elect_div":"Kingston","fid_2":91,"electorate_state":"SA","electorate_locations":"Flagstaff Hill, Aldinga, Noarlunga"}},{"arcs":[[794]],"type":"Polygon","properties":{"fid":92,"layer":"sa-10","Elect_div":"Barker","fid_2":92,"electorate_state":"SA","electorate_locations":"Mount Gambier, Murray Bridge, Barmera"}},{"arcs":[[795]],"type":"Polygon","properties":{"fid":93,"layer":"tas-5","Elect_div":"Braddon","fid_2":93,"electorate_state":"TAS","electorate_locations":"Devonport, Burnie, King Island"}},{"arcs":[[796]],"type":"Polygon","properties":{"fid":94,"layer":"tas-5","Elect_div":"Franklin","fid_2":94,"electorate_state":"TAS","electorate_locations":"Rosny, Cambridge, Huonville"}},{"arcs":[[797]],"type":"Polygon","properties":{"fid":95,"layer":"tas-5","Elect_div":"Bass","fid_2":95,"electorate_state":"TAS","electorate_locations":"Launceston, George Town, Bridgport"}},{"arcs":[[798,799]],"type":"Polygon","properties":{"fid":96,"layer":"tas-5","Elect_div":"Lyons","fid_2":96,"electorate_state":"TAS","electorate_locations":"Blackstone Heights, Richmond, New Norfolk"}},{"arcs":[[-799,800]],"type":"Polygon","properties":{"fid":97,"layer":"tas-5","Elect_div":"Clark","fid_2":97,"electorate_state":"TAS","electorate_locations":"Hobart, Granton, Bonnet Hill"}},{"arcs":[[801]],"type":"Polygon","properties":{"fid":98,"layer":"vic38-2","Elect_div":"Mallee","fid_2":98,"electorate_state":"Vic","electorate_locations":"Mildura, Horsham, Inglewood"}},{"arcs":[[802]],"type":"Polygon","properties":{"fid":99,"layer":"vic38-2","Elect_div":"Wannon","fid_2":99,"electorate_state":"Vic","electorate_locations":"Warrnambool, Colac, Stawell"}},{"arcs":[[803]],"type":"Polygon","properties":{"fid":100,"layer":"vic38-2","Elect_div":"McEwen","fid_2":100,"electorate_state":"Vic","electorate_locations":"Macedon, Sunbury, Whittlesea"}},{"arcs":[[804]],"type":"Polygon","properties":{"fid":101,"layer":"vic38-2","Elect_div":"Lalor","fid_2":101,"electorate_state":"Vic","electorate_locations":"Werribee, Wyndham, Quandong"}},{"arcs":[[805,806,807,808]],"type":"Polygon","properties":{"fid":102,"layer":"vic38-2","Elect_div":"Ballarat","fid_2":102,"electorate_state":"Vic","electorate_locations":"Ballarat, Bacchus Marsh, Daylesford"}},{"arcs":[[809,810,811,-807,812]],"type":"Polygon","properties":{"fid":103,"layer":"vic38-2","Elect_div":"Gorton","fid_2":103,"electorate_state":"Vic","electorate_locations":"Melton, Plumpton, Burnside"}},{"arcs":[[813,814,-811,815]],"type":"Polygon","properties":{"fid":104,"layer":"vic38-2","Elect_div":"Gellibrand","fid_2":104,"electorate_state":"Vic","electorate_locations":"Altona, Williamstown, Footscray"}},{"arcs":[[816]],"type":"Polygon","properties":{"fid":105,"layer":"vic38-2","Elect_div":"Corangamite","fid_2":105,"electorate_state":"Vic","electorate_locations":"Grovedale, Ocean Grove, Torquay"}},{"arcs":[[817,818,-809,819]],"type":"Polygon","properties":{"fid":106,"layer":"vic38-2","Elect_div":"Calwell","fid_2":106,"electorate_state":"Vic","electorate_locations":"Broadmeadows, Tullamarine, Coolaroo"}},{"arcs":[[820,821,-813,-806,-819,822]],"type":"Polygon","properties":{"fid":107,"layer":"vic38-2","Elect_div":"Fraser","fid_2":107,"electorate_state":"Vic","electorate_locations":"Calder Park, Sunshine, Tottenham"}},{"arcs":[[823,824,-816,-810,-822,825]],"type":"Polygon","properties":{"fid":108,"layer":"vic38-2","Elect_div":"Maribyrnong","fid_2":108,"electorate_state":"Vic","electorate_locations":"Essendon, Moonee Ponds, Flemington"}},{"arcs":[[826,827,-814,-825,828]],"type":"Polygon","properties":{"fid":109,"layer":"vic38-2","Elect_div":"Macnamara","fid_2":109,"electorate_state":"Vic","electorate_locations":"Port Melbourne, St Kilda, Caulfield"}},{"arcs":[[829]],"type":"Polygon","properties":{"fid":110,"layer":"vic38-2","Elect_div":"Corio","fid_2":110,"electorate_state":"Vic","electorate_locations":"Geelong, Belmont, Wandana Heights"}},{"arcs":[[830,-823,-818,831]],"type":"Polygon","properties":{"fid":111,"layer":"vic38-2","Elect_div":"Jagajaga","fid_2":111,"electorate_state":"Vic","electorate_locations":"Ivanhoe, Montmorency, Wattle Glen"}},{"arcs":[[832,-826,-821,-831,833]],"type":"Polygon","properties":{"fid":112,"layer":"vic38-2","Elect_div":"Wills","fid_2":112,"electorate_state":"Vic","electorate_locations":"Brunwsick, Coburg, Glen Roy"}},{"arcs":[[834,-829,-824,-833,835]],"type":"Polygon","properties":{"fid":113,"layer":"vic38-2","Elect_div":"Melbourne","fid_2":113,"electorate_state":"Vic","electorate_locations":"North Melbourne, Docklands, Richmond"}},{"arcs":[[-827,-835,836]],"type":"Polygon","properties":{"fid":114,"layer":"vic38-2","Elect_div":"Goldstein","fid_2":114,"electorate_state":"Vic","electorate_locations":"Sandringham, Brighton, Ormond"}},{"arcs":[[837]],"type":"Polygon","properties":{"fid":115,"layer":"vic38-2","Elect_div":"Nicholls","fid_2":115,"electorate_state":"Vic","electorate_locations":"Shepparton, Echuca, Seymour"}},{"arcs":[[838,839,840,841]],"type":"Polygon","properties":{"fid":116,"layer":"vic38-2","Elect_div":"Cooper","fid_2":116,"electorate_state":"Vic","electorate_locations":"Northcote, Preston, Reservoir"}},{"arcs":[[842,843,844,-840,845]],"type":"Polygon","properties":{"fid":117,"layer":"vic38-2","Elect_div":"Kooyong","fid_2":117,"electorate_state":"Vic","electorate_locations":"Hawthorn, Kew, Mont Albert"}},{"arcs":[[846,847,-844,848]],"type":"Polygon","properties":{"fid":118,"layer":"vic38-2","Elect_div":"Isaacs","fid_2":118,"electorate_state":"Vic","electorate_locations":"Mentone, Chelsea, Dandenong South"}},{"arcs":[[849,850,-842,851]],"type":"Polygon","properties":{"fid":119,"layer":"vic38-2","Elect_div":"Deakin","fid_2":119,"electorate_state":"Vic","electorate_locations":"Mitcham, Vermont, Croydon"}},{"arcs":[[852,853,-846,-839,-851,854]],"type":"Polygon","properties":{"fid":120,"layer":"vic38-2","Elect_div":"Chisholm","fid_2":120,"electorate_state":"Vic","electorate_locations":"Burwood, Chadstone, Box Hill"}},{"arcs":[[855,856,-849,-843,-854,857]],"type":"Polygon","properties":{"fid":121,"layer":"vic38-2","Elect_div":"Higgins","fid_2":121,"electorate_state":"Vic","electorate_locations":"Toorak, Glen Iris, Malvern"}},{"arcs":[[858,859,860,-847,-857,861]],"type":"Polygon","properties":{"fid":122,"layer":"vic38-2","Elect_div":"Dunkley","fid_2":122,"electorate_state":"Vic","electorate_locations":"Frankston, Sandhurst, Seaford"}},{"arcs":[[862,-860,863]],"type":"Polygon","properties":{"fid":123,"layer":"vic38-2","Elect_div":"Holt","fid_2":123,"electorate_state":"Vic","electorate_locations":"Narre Warren South, Cranbourne, Tooradin"}},{"arcs":[[864,865,-855,-850,866]],"type":"Polygon","properties":{"fid":124,"layer":"vic38-2","Elect_div":"Aston","fid_2":124,"electorate_state":"Vic","electorate_locations":"Rowville, Scoresby, Boronia"}},{"arcs":[[867,868,-858,-853,-866,869]],"type":"Polygon","properties":{"fid":125,"layer":"vic38-2","Elect_div":"Hotham","fid_2":125,"electorate_state":"Vic","electorate_locations":"Oakleigh, Clayton, Wheeler's Hill"}},{"arcs":[[870,871,-862,-856,-869,872]],"type":"Polygon","properties":{"fid":126,"layer":"vic38-2","Elect_div":"Bruce","fid_2":126,"electorate_state":"Vic","electorate_locations":"Noble Park, Dandenong North, Hallam"}},{"arcs":[[-864,-859,-872,873]],"type":"Polygon","properties":{"fid":127,"layer":"vic38-2","Elect_div":"Monash","fid_2":127,"electorate_state":"Vic","electorate_locations":"Warragul, Wonthaggi, Port Welshpool"}},{"arcs":[[874]],"type":"Polygon","properties":{"fid":128,"layer":"vic38-2","Elect_div":"Indi","fid_2":128,"electorate_state":"Vic","electorate_locations":"Wodonga, Wangaratta, Euroa"}},{"arcs":[[875,-870,-865,876]],"type":"Polygon","properties":{"fid":129,"layer":"vic38-2","Elect_div":"Casey","fid_2":129,"electorate_state":"Vic","electorate_locations":"Lilydale, Healesville, Montrose"}},{"arcs":[[-873,-868,-876,877]],"type":"Polygon","properties":{"fid":130,"layer":"vic38-2","Elect_div":"La Trobe","fid_2":130,"electorate_state":"Vic","electorate_locations":"Berwick, Narre Warren, Pakenham"}},{"arcs":[[878]],"type":"Polygon","properties":{"fid":131,"layer":"vic38-2","Elect_div":"Flinders","fid_2":131,"electorate_state":"Vic","electorate_locations":"Mornington, Hastings, Rosebud"}},{"arcs":[[879]],"type":"Polygon","properties":{"fid":132,"layer":"vic38-2","Elect_div":"Scullin","fid_2":132,"electorate_state":"Vic","electorate_locations":"Mill Park, Lalor, South Marong"}},{"arcs":[[880]],"type":"Polygon","properties":{"fid":133,"layer":"vic38-2","Elect_div":"Menzies","fid_2":133,"electorate_state":"Vic","electorate_locations":"Bulleen, Eltham, Doncaster"}},{"arcs":[[881]],"type":"Polygon","properties":{"fid":134,"layer":"vic38-2","Elect_div":"Bendigo","fid_2":134,"electorate_state":"Vic","electorate_locations":"Bendigo, Heathcote, Castlemaine"}},{"arcs":[[882]],"type":"Polygon","properties":{"fid":135,"layer":"vic38-2","Elect_div":"Gippsland","fid_2":135,"electorate_state":"Vic","electorate_locations":"Traralgon, Omeo, Mallacoota"}},{"arcs":[[883,884]],"type":"Polygon","properties":{"fid":136,"layer":"wa-16","Elect_div":"Moore","fid_2":136,"electorate_state":"WA","electorate_locations":"Marmion, Woodvale, Joondalup"}},{"arcs":[[885,886,-884,887]],"type":"Polygon","properties":{"fid":137,"layer":"wa-16","Elect_div":"Stirling","fid_2":137,"electorate_state":"WA","electorate_locations":"Trigg, Balcatta, Dianella"}},{"arcs":[[-886,888]],"type":"Polygon","properties":{"fid":138,"layer":"wa-16","Elect_div":"Curtin","fid_2":138,"electorate_state":"WA","electorate_locations":"Cottesloe, Floreat, Innaloo"}},{"arcs":[[889]],"type":"Polygon","properties":{"fid":139,"layer":"wa-16","Elect_div":"Brand","fid_2":139,"electorate_state":"WA","electorate_locations":"Kwinana, Rockingham, Port Kennedy"}},{"arcs":[[890,891]],"type":"Polygon","properties":{"fid":140,"layer":"wa-16","Elect_div":"Pearce","fid_2":140,"electorate_state":"WA","electorate_locations":"Beverley, Bullsbrook, Jindalee"}},{"arcs":[[892,893,-891,894]],"type":"Polygon","properties":{"fid":141,"layer":"wa-16","Elect_div":"Cowan","fid_2":141,"electorate_state":"WA","electorate_locations":"Ashby, Greenwood, Koondoola"}},{"arcs":[[895,896,897,-893,898]],"type":"Polygon","properties":{"fid":142,"layer":"wa-16","Elect_div":"Perth","fid_2":142,"electorate_state":"WA","electorate_locations":"Perth, Morley, Bassendean"}},{"arcs":[[899,900,901,-897,902]],"type":"Polygon","properties":{"fid":143,"layer":"wa-16","Elect_div":"Swan","fid_2":143,"electorate_state":"WA","electorate_locations":"Como, Ascot, Queens Park"}},{"arcs":[[-901,903]],"type":"Polygon","properties":{"fid":144,"layer":"wa-16","Elect_div":"Tangney","fid_2":144,"electorate_state":"WA","electorate_locations":"Attadale, Bateman, Ferndale"}},{"arcs":[[904]],"type":"Polygon","properties":{"fid":145,"layer":"wa-16","Elect_div":"Fremantle","fid_2":145,"electorate_state":"WA","electorate_locations":"Cockburn, Coogee, Fremantle"}},{"arcs":[[-903,-896,905]],"type":"Polygon","properties":{"fid":146,"layer":"wa-16","Elect_div":"Hasluck","fid_2":146,"electorate_state":"WA","electorate_locations":"Midland, Kenwick, Wooraloo"}},{"arcs":[[906]],"type":"Polygon","properties":{"fid":147,"layer":"wa-16","Elect_div":"Burt","fid_2":147,"electorate_state":"WA","electorate_locations":"Armadale, Canning Vale, Kelmscott"}},{"arcs":[[907]],"type":"Polygon","properties":{"fid":148,"layer":"wa-16","Elect_div":"Canning","fid_2":148,"electorate_state":"WA","electorate_locations":"Mandurah, Byford, Preston Beach"}},{"arcs":[[908]],"type":"Polygon","properties":{"fid":149,"layer":"wa-16","Elect_div":"Forrest","fid_2":149,"electorate_state":"WA","electorate_locations":"Bunbury, Busselton, Margaret River"}},{"arcs":[[909]],"type":"Polygon","properties":{"fid":150,"layer":"wa-16","Elect_div":"Durack","fid_2":150,"electorate_state":"WA","electorate_locations":"Geraldton, Broome, Port Hedland"}},{"arcs":[[910]],"type":"Polygon","properties":{"fid":151,"layer":"wa-16","Elect_div":"O'Connor","fid_2":151,"electorate_state":"WA","electorate_locations":"Kalgoorlie, Albany, Esperance"}}]}},"crs":{"type":"name","properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"}}}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = {"furious":{"color":"#C90000","title":"furious","iconB64":"data:image/svg+xml;base64,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"},"depressed":{"color":"#F46A00","title":"depressed","iconB64":"data:image/svg+xml;base64,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"},"worried":{"color":"#4AA80F","title":"worried","iconB64":"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICA8ZGVmcz4gICAgPHBhdGggaWQ9ImEiIGQ9Ik0wIDBoMTE0djExNEgweiIvPiAgPC9kZWZzPiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgPHBhdGggZD0iTTExNiA1OWMwIDMwLjkyNy0yNS4wNzIgNTYtNTYgNTYtMzAuOTI3IDAtNTYtMjUuMDczLTU2LTU2QzQgMjguMDcxIDI5LjA3MyAzIDYwIDNjMzAuOTI4IDAgNTYgMjUuMDcyIDU2IDU2IiBmaWxsPSIjNEFBODBGIi8+ICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiPiAgICAgIDxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj4gICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4gICAgICA8L21hc2s+ICAgICAgPHBhdGggZD0iTTU3IDIuMzI2QzI2Ljg1MiAyLjMyNiAyLjMyNiAyNi44NTIgMi4zMjYgNTdjMCAzMC4xNDkgMjQuNTI2IDU0LjY3NSA1NC42NzQgNTQuNjc1czU0LjY3NC0yNC41MjYgNTQuNjc0LTU0LjY3NWMwLTMwLjE0Ny0yNC41MjYtNTQuNjczLTU0LjY3NC01NC42NzNNNTcgMTE0QzI1LjU3IDExNCAwIDg4LjQyOCAwIDU3IDAgMjUuNTcgMjUuNTcgMCA1NyAwczU3IDI1LjU3IDU3IDU3YzAgMzEuNDI4LTI1LjU3IDU3LTU3IDU3IiBmaWxsPSIjMzMzIiBtYXNrPSJ1cmwoI2IpIi8+ICAgIDwvZz4gICAgPHBhdGggZD0iTTM2IDQwYTUgNSAwIDEgMS0xMCAwIDUgNSAwIDAgMSAxMCAwTTk0IDQwYTUgNSAwIDEgMS0xMCAwIDUgNSAwIDAgMSAxMCAwIiBmaWxsPSIjRjI2MDcxIi8+ICAgIDxwYXRoIGQ9Ik00NCAzMWEzIDMgMCAxIDEtNS45OTkuMDAxQTMgMyAwIDAgMSA0NCAzMU04MSAzMWEzIDMgMCAxIDEtNiAwIDMgMyAwIDAgMSA2IDBNODEuMjUyIDU0LjUzM2MuNTk2LjIzMS44OTguOTE4LjY3NCAxLjUzMy0uMjI4LjYxNS0uODkuOTI3LTEuNDg1LjY5NC03LjE2Ny0yLjc4Mi0xNS4yMDctMS4yOTMtMjAuOTgxIDMuODg3LTUuNzc1IDUuMTgxLTguMzIxIDEzLjE5LTYuNjQ5IDIwLjkwMy4xNC42NDEtLjI1IDEuMjc3LS44NzMgMS40MjEtLjYyLjE0My0xLjIzOC0uMjYxLTEuMzc2LS45MDItMS44Ni04LjU2Ni45NzEtMTcuNDYzIDcuMzg1LTIzLjIxNyA2LjQxNC01Ljc1NSAxNS4zNDQtNy40MSAyMy4zMDUtNC4zMTl6IiBmaWxsPSIjMzMzIi8+ICA8L2c+PC9zdmc+"},"meh":{"color":"#00838D","title":"meh","iconB64":"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICA8ZGVmcz4gICAgPHBhdGggaWQ9ImEiIGQ9Ik0wIDBoMTE0djExNEgweiIvPiAgPC9kZWZzPiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgPHBhdGggZD0iTTYwIDYxYy04LjcxNyAwLTE2LjcxLTQuNzA0LTIwLjg1OC0xMi4yNzdhMS4xNiAxLjE2IDAgMCAxIC40NzgtMS41ODIgMS4xOTEgMS4xOTEgMCAwIDEgMS42MDIuNDcyYzMuNzM2IDYuODE3IDEwLjkzIDExLjA1NCAxOC43NzkgMTEuMDU0czE1LjA0My00LjIzNyAxOC43NzctMTEuMDU0YTEuMTkgMS4xOSAwIDAgMSAxLjYwMi0uNDcyIDEuMTYgMS4xNiAwIDAgMSAuNDc4IDEuNTgyQzc2LjcxIDU2LjI5NiA2OC43MTggNjEgNjAgNjEiIGZpbGw9IiMzMzMiLz4gICAgPHBhdGggZD0iTTExNiA1OWMwIDMwLjkyOC0yNS4wNzIgNTYtNTYgNTZTNCA4OS45MjggNCA1OSAyOS4wNzIgMyA2MCAzczU2IDI1LjA3MiA1NiA1NiIgZmlsbD0iIzAwODM4RCIvPiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDMpIj4gICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+ICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+ICAgICAgPC9tYXNrPiAgICAgIDxwYXRoIGQ9Ik01NyAyLjMyNmMtMzAuMTQ4IDAtNTQuNjczIDI0LjUyNy01NC42NzMgNTQuNjc1IDAgMzAuMTQ3IDI0LjUyNSA1NC42NzMgNTQuNjczIDU0LjY3MyAzMC4xNDggMCA1NC42NzQtMjQuNTI2IDU0LjY3NC01NC42NzMgMC0zMC4xNDgtMjQuNTI2LTU0LjY3NS01NC42NzQtNTQuNjc1TTU3IDExNEMyNS41NyAxMTQgMCA4OC40MyAwIDU3IDAgMjUuNTcyIDI1LjU3IDAgNTcgMHM1NyAyNS41NzEgNTcgNTdjMCAzMS40My0yNS41NyA1Ny01NyA1NyIgZmlsbD0iIzMzMyIgbWFzaz0idXJsKCNiKSIvPiAgICA8L2c+ICAgIDxwYXRoIGQ9Ik0zNiA0MGE1LjAwMSA1LjAwMSAwIDEgMS0xMC4wMDItLjAwMSA1LjAwMSA1LjAwMSAwIDAgMSAxMC4wMDIgME05NCA0MGE1LjAwMSA1LjAwMSAwIDAgMS0xMCAwIDUgNSAwIDAgMSAxMCAwIiBmaWxsPSIjRjI2MDcxIi8+ICAgIDxwYXRoIGQ9Ik00NCAyOWEzIDMgMCAxIDEtNS45OTkuMDAxQTMgMyAwIDAgMSA0NCAyOU04MSAyOWEzIDMgMCAxIDEtNiAwIDMgMyAwIDAgMSA2IDAiIGZpbGw9IiMzMzMiLz4gICAgPHBhdGggZD0iTTY5IDUyLjU5NmgyOS42OTFNMzIuOTUgMjUuNTk2aDU0LjI0NyIgc3Ryb2tlPSIjMzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4gIDwvZz48L3N2Zz4="},"happy":{"color":"#1691DB","title":"happy","iconB64":"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICA8ZGVmcz4gICAgPHBhdGggaWQ9ImEiIGQ9Ik0wIC40MmgxMTMuNThWMTE0SDB6Ii8+ICA8L2RlZnM+ICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8cGF0aCBkPSJNMTE1IDU4LjVjMCAzMC42NTItMjQuODQ4IDU1LjUtNTUuNSA1NS41UzQgODkuMTUyIDQgNTguNSAyOC44NDggMyA1OS41IDMgMTE1IDI3Ljg0OCAxMTUgNTguNSIgZmlsbD0iIzE2OTFEQiIvPiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDIpIj4gICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+ICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+ICAgICAgPC9tYXNrPiAgICAgIDxwYXRoIGQ9Ik01Ni43OSAyLjczOGMtMzAuMDM3IDAtNTQuNDcxIDI0LjQzNi01NC40NzEgNTQuNDcyIDAgMzAuMDM3IDI0LjQzNCA1NC40NzIgNTQuNDcgNTQuNDcyIDMwLjAzOCAwIDU0LjQ3NC0yNC40MzUgNTQuNDc0LTU0LjQ3MiAwLTMwLjAzNi0yNC40MzYtNTQuNDcyLTU0LjQ3My01NC40NzJtMCAxMTEuMjYxQzI1LjQ3NiAxMTQgMCA4OC41MjQgMCA1Ny4yMSAwIDI1Ljg5NyAyNS40NzYuNDIgNTYuNzkuNDJzNTYuNzkgMjUuNDc3IDU2Ljc5IDU2Ljc5YzAgMzEuMzE0LTI1LjQ3NiA1Ni43OS01Ni43OSA1Ni43OSIgZmlsbD0iIzMzMyIgbWFzaz0idXJsKCNiKSIvPiAgICA8L2c+ICAgIDxwYXRoIGQ9Ik00NS44IDMyYy0uNjYzIDAtMS4yLS41MjMtMS4yLTEuMTY3IDAtMS45My0xLjYxNC0zLjUtMy42LTMuNS0xLjk4NSAwLTMuNiAxLjU3LTMuNiAzLjUgMCAuNjQ0LS41MzcgMS4xNjctMS4yIDEuMTY3LS42NjMgMC0xLjItLjUyMy0xLjItMS4xNjdDMzUgMjcuNjE3IDM3LjY5MiAyNSA0MSAyNWMzLjMxIDAgNiAyLjYxNyA2IDUuODMzIDAgLjY0NC0uNTM3IDEuMTY3LTEuMiAxLjE2N004Mi44IDMyYy0uNjYyIDAtMS4yLS41MjMtMS4yLTEuMTY3IDAtMS45My0xLjYxNS0zLjUtMy42LTMuNS0xLjk4NCAwLTMuNTk5IDEuNTctMy41OTkgMy41IDAgLjY0NC0uNTM3IDEuMTY3LTEuMjAyIDEuMTY3LS42NjMgMC0xLjE5OS0uNTIzLTEuMTk5LTEuMTY3QzcyIDI3LjYxNyA3NC42OTIgMjUgNzggMjVjMy4zMDkgMCA2IDIuNjE3IDYgNS44MzMgMCAuNjQ0LS41MzYgMS4xNjctMS4yIDEuMTY3TTU5LjUgNjFjLTguNTEgMC0xNi4zMTItNC43MDQtMjAuMzYtMTIuMjc3YTEuMTc0IDEuMTc0IDAgMCAxIC40NjUtMS41ODIgMS4xNDggMS4xNDggMCAwIDEgMS41NjQuNDcyYzMuNjQ3IDYuODE3IDEwLjY3IDExLjA1NCAxOC4zMzIgMTEuMDU0IDcuNjYyIDAgMTQuNjg0LTQuMjM3IDE4LjMzLTExLjA1NGExLjE0NyAxLjE0NyAwIDAgMSAxLjU2NC0uNDcyYy41Ni4zMDYuNzcgMS4wMTUuNDY2IDEuNTgyQzc1LjgxMyA1Ni4yOTYgNjguMDEgNjEgNTkuNSA2MSIgZmlsbD0iIzMzMyIvPiAgICA8cGF0aCBkPSJNMzUgNDAuNWE0LjUgNC41IDAgMSAxLTkuMDAyLS4wMDEgNC41IDQuNSAwIDAgMSA5LjAwMiAwTTkzIDQwLjVhNC41IDQuNSAwIDEgMS05LjAwMi0uMDAxIDQuNSA0LjUgMCAwIDEgOS4wMDIgMCIgZmlsbD0iI0YyNjA3MSIvPiAgPC9nPjwvc3ZnPg=="},"stoked":{"color":"#D51287","title":"stoked","iconB64":"data:image/svg+xml;base64,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"}}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingOverlay_vue__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_789a1bcb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingOverlay_vue__ = __webpack_require__(134);
function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingOverlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_789a1bcb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingOverlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'loading-overlay',
    props: ['loading']
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingOverlay",class:{ loading: _vm.loading }},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-roller"},[_c('div',{staticClass:"furious"}),_c('div',{staticClass:"depressed"}),_c('div',{staticClass:"worried"}),_c('div',{staticClass:"meh"}),_c('div',{staticClass:"happy"}),_c('div',{staticClass:"stoked"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapSVG_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c689514_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_MapSVG_vue__ = __webpack_require__(365);
function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapSVG_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c689514_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_MapSVG_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_topojson_client_src_feature__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_topojson_client_src_mesh__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_geo__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3_zoom__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_d3_scale_src_quantize__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3_scale_src_threshold__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_d3_scale_src_linear__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Poll_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AusChart_vue__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HexHover_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Search_vue__ = __webpack_require__(361);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















var d3 = {
	geoMercator: __WEBPACK_IMPORTED_MODULE_5_d3_geo__["b" /* geoMercator */],
	geoPath: __WEBPACK_IMPORTED_MODULE_5_d3_geo__["c" /* geoPath */],
	interpolate: __WEBPACK_IMPORTED_MODULE_4_d3_interpolate__["a" /* interpolate */],
	select: __WEBPACK_IMPORTED_MODULE_6_d3_selection__["f" /* select */],
	scale: {
		linear: __WEBPACK_IMPORTED_MODULE_10_d3_scale_src_linear__["a" /* default */],
		quantize: __WEBPACK_IMPORTED_MODULE_8_d3_scale_src_quantize__["a" /* default */],
		threshold: __WEBPACK_IMPORTED_MODULE_9_d3_scale_src_threshold__["a" /* default */]
	},
	zoom: __WEBPACK_IMPORTED_MODULE_7_d3_zoom__["a" /* zoom */],
	zoomIdentity: __WEBPACK_IMPORTED_MODULE_7_d3_zoom__["b" /* zoomIdentity */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "map-item-svg",
	components: { Poll: __WEBPACK_IMPORTED_MODULE_11__Poll_vue__["a" /* default */], AusChart: __WEBPACK_IMPORTED_MODULE_12__AusChart_vue__["a" /* default */], HexHover: __WEBPACK_IMPORTED_MODULE_13__HexHover_vue__["a" /* default */], Search: __WEBPACK_IMPORTED_MODULE_14__Search_vue__["a" /* default */] },
	props: {
		fullscreen: {
			type: Boolean,
			default: false
		},
		geodata: {
			type: Object,
			required: true
		},
		results: {},
		width: {
			type: Number,
			//default: 665
			// default:865
			default: 628
		},
		height: {
			type: Number,
			//default: 650
			//default: 730
			default: 538
		},
		initialScale: {
			type: Number
			//default: 900
		},
		centerPoint: {
			type: Array,
			default: function _default() {
				return [133.29024086902227, -27.772410375241137];
			}
		},
		zoomScale: {
			type: Array,
			default: function _default() {
				return [1, Infinity];
			}
		},
		filters: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		responsive: {
			type: Boolean,
			default: true
		},
		emojiData: {
			type: Object,
			required: true
		},
		environ: {
			type: String
		},
		resultDate: {
			type: Number
		}
	},

	data: function data() {
		return {
			event: __WEBPACK_IMPORTED_MODULE_6_d3_selection__["b" /* event */],
			hoverEvent: null,
			selectedID: null,
			centered: null,
			activePath: null,
			displayWidth: this.width, //0,
			displayHeight: this.height, //0
			pollData: null,
			hexHoverData: null,
			auschart: true
		};
	},

	mounted: function mounted() {
		// console.log('map-item mounted', this.$el);
		this.resize();
		this.initZoom();
		window.addEventListener('resize', this.resize);
		window.addEventListener('orientationchange', this.resize);
	},
	computed: {
		/*translateXOffset() {
  	return this.PollData ? 150 : 0;
  },*/
		scale: function scale() {
			return this.displayWidth * 1.35;
		},
		projection: function projection() {
			var projection = d3.geoMercator();
			/*
   console.log(this.initialScale)
   projection.scale(this.scale);
   return projection;
   	if (this.initialScale) {
   	projection.scale(this.initialScale);
   } else {*/
			// console.log('fitzsize')
			projection.fitSize([this.dimensions.width * 1.15, this.dimensions.height], this.topojson.electorates).center(this.centerPoint).translate([this.dimensions.width / 2, this.dimensions.height / 2]);
			//}

			return projection;
		},
		path: function path() {
			return d3.geoPath().projection(this.projection);
		},
		svg: function svg() {
			return d3.select(this.$el).select('svg.map-item_svg');
		},
		featuresGroup: function featuresGroup() {
			return this.svg.select("g.features");
		},
		topojson: function topojson() {
			//const stateBoundaries = this.geodata.objects['STE_2011_AUST'];
			var hexElectorates = this.geodata.objects['sentiment-labelled-hex-electorates'];
			var boundaries = this.geodata.objects['sentiment-background-electorates'];
			var capitals = this.geodata.objects['sentiment-city-cbd-electorate-points'];

			return {
				electorates: Object(__WEBPACK_IMPORTED_MODULE_2_topojson_client_src_feature__["a" /* default */])(this.geodata, hexElectorates),
				boundaries: Object(__WEBPACK_IMPORTED_MODULE_2_topojson_client_src_feature__["a" /* default */])(this.geodata, boundaries),
				capitals: Object(__WEBPACK_IMPORTED_MODULE_2_topojson_client_src_feature__["a" /* default */])(this.geodata, capitals),
				borders: Object(__WEBPACK_IMPORTED_MODULE_3_topojson_client_src_mesh__["a" /* default */])(this.geodata, hexElectorates, function (a, b) {
					return a !== b;
				})
			};
		},
		features: function features() {
			var _this = this;

			var createPathsHex = function createPathsHex(_ref) {
				var properties = _ref.properties,
				    feature = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['properties']);

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, feature, {
					path: _this.path(feature),
					fill: _this.getHexFillColor(_this.results.electorates[properties.fid]),
					properties: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, properties, {
						//region_name: properties.Elect_div,
						result: _this.results[properties.Elect_div]
					}),
					label: properties['id'] ? {
						coords: _this.projection(Object(__WEBPACK_IMPORTED_MODULE_5_d3_geo__["a" /* geoCentroid */])(feature))
					} : null
				});
			};

			var createPaths = function createPaths(_ref2) {
				var properties = _ref2.properties,
				    feature = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['properties']);

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, feature, {
					path: _this.path(feature),
					// fill: this.getFillColour(this.results[properties.Elect_div]),
					properties: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, properties)
					// label: properties['STE_CODE11'] ? {
					/*
     label: properties['id'] ? {
     	coords: this.projection(geoCentroid(feature))
     } : null
     */
				});
			};

			var features = {
				electorates: this.topojson.electorates.features.map(createPathsHex),
				boundaries: this.topojson.boundaries.features.map(createPaths),
				capitals: this.topojson.capitals.features.map(createPaths),
				borders: {
					path: this.path(this.topojson.borders)
				}
			};

			return features;
		},
		aspectRatio: function aspectRatio() {
			return this.height / this.width;
		},

		dimensions: {
			get: function get() {
				return {
					width: this.displayWidth,
					height: this.displayHeight
				};
			},
			// setter
			set: function set(_ref3) {
				var width = _ref3.width,
				    height = _ref3.height;

				if (height === 0) {
					//console.log('height calculated at zero. Keeping: ' + this.displayHeight);
				} else {
					if (this.fullscreen) {
						this.displayHeight = height;
					} else {
						this.displayHeight = width * this.aspectRatio;
					}
				}

				if (width === 0) {
					//console.log('width calculated at zero. Keeping: ' + this.displayWidth);
				} else {
					this.displayWidth = width;
				}
			}
		},
		zoom: function zoom() {
			var zoom = d3.zoom().scaleExtent(this.zoomScale)
			//.translateExtent([[-0, -0], [this.dimensions.width + this.translateXOffset, this.dimensions.height + 0]])
			.translateExtent([[-0, -0], [this.dimensions.width, this.dimensions.height + 0]]).on("zoom", this.onZoom);

			return zoom;
		},

		/*
  capitalStyles() {
  	let
  		max = 0.9,
  		k = this.event && this.event.transform ? max - (this.event.transform.k - max) : max;
  		console.log('k',k);
  	if (k < 0.35) k = 0;
  	return {
  		opacity: k,
  		'fill-opacity': k,
  		display: k === 0 ? 'none' : 'block'
  	}
  },
  boundaryStyles() {
  	let
  		max = 0.9,
  		k = this.event && this.event.transform ? max - (this.event.transform.k - max) : max;
  		console.log('k',k);
  	if (k < 0.35) k = 0;
  	return {
  		opacity: k,
  		'fill-opacity': k,
  		display: k === 0 ? 'none' : 'block'
  	}
  },
  */
		tooltipStyles: function tooltipStyles() {

			// make sure hovers don't go outside of map
			var topValue = this.displayHeight / 2 > this.hoverEvent.clientY ? this.hoverEvent.clientY + 10 : this.hoverEvent.clientY - 110;
			var leftValue = this.displayWidth / 2 > this.hoverEvent.clientX ? this.hoverEvent.clientX + 10 : this.hoverEvent.clientX - 210;

			return {
				top: topValue + 'px',
				left: leftValue + 'px'
			};
		}
	},
	methods: {
		pollClose: function pollClose() {
			this.pollData = null;
			this.selectedID = null;
			this.$emit('closeElecPoll');
		},
		hexHoverOut: function hexHoverOut() {
			this.hexHoverData = null;
			this.hoverEvent = null;
		},
		getHexFillColor: function getHexFillColor(sentiment) {
			return sentiment ? this.emojiData[sentiment].color : '#ccc';
		},
		resize: function resize() {
			// return;
			this.dimensions = {
				width: this.$el.clientWidth,
				height: this.$el.clientHeight
			};

			this.initZoom();
		},
		onClicked: function onClicked(d, e) {
			// console.log('click',d, e, this);
			if (this.activePath === e.target) {
				this.resetZoom();
			} else {
				this.zoomToDistrict(d, e);
			}
		},
		/*,
  updateBoundaries() {
  // this.$store.commit('loading', true);
  setTimeout(() => {
  // this.$store.commit('loading', true);
  this.topojson = topojsonFeature(this.geodata, this.boundaries);
  	// setTimeout(() => this.$store.commit('loading', false), 300);
  }, 300)
  this.resize();
  },*/
		searchClick: function searchClick(electorate) {
			var name = electorate.properties.Elect_div,
			    el = this.$el.querySelector('path[electorate-name="' + name + '"]');

			this.zoomToDistrict(electorate, { target: el });
			el.dispatchEvent(new Event("click"));
		},
		initZoom: function initZoom() {
			this.svg.call(this.zoom);
		},
		onZoom: function onZoom() {
			this.event = d3.event = __WEBPACK_IMPORTED_MODULE_6_d3_selection__["b" /* event */];
			this.featuresGroup.attr("transform", d3.event.transform).selectAll("path:not(.active)").style("stroke-width", 1 / d3.event.transform.k + "px");
			this.featuresGroup.attr("transform", d3.event.transform).select("path.active").style("stroke-width", 2 / d3.event.transform.k + "px");
			// if (k > 3 ) {}
		},
		zoomToDistrict: function zoomToDistrict(d, e) {
			//console.log(d, e)
			this.auschart = false;

			if (this.activePath) this.activePath.removeAttribute('active', 'active');
			this.activePath = e.target;
			this.activePath.setAttribute('active', 'active');

			var bounds = this.path.bounds(d),
			    dx = bounds[1][0] - bounds[0][0],
			    dy = bounds[1][1] - bounds[0][1],
			    x = (bounds[0][0] + bounds[1][0]) / 2,
			    y = (bounds[0][1] + bounds[1][1]) / 2,
			    scale = Math.max(1, Math.min(8, 0.9 / Math.max(dx / this.dimensions.width, dy / this.dimensions.height))),
			    translate = [this.dimensions.width / 2 - scale * x, this.dimensions.height / 2 - scale * y];

			this.svg.transition().duration(500).call(this.zoom.transform, d3.zoomIdentity.translate(translate[0], translate[1]).scale(scale)); // updated for d3 v4
		},
		resetZoom: function resetZoom() {
			//console.log('reset');
			if (this.activePath) {
				this.activePath.removeAttribute('active', 'active');
				this.activePath = null;
			}

			this.selectedID = null;
			this.pollData = null;

			this.svg.transition().duration(300).call(this.zoom.transform, d3.zoomIdentity);
			this.initZoom();

			this.auschart = true;
		},
		countyclicked: function countyclicked(d) {
			//console.log(d);
			this.pollData = d;
			this.selectedID = d.properties.Elect_div;
			this.initZoom();
		},
		hexHovered: function hexHovered(d, e) {
			this.hoverEvent = e;
			this.hexHoverData = d;
		},
		toggleFullscreen: function toggleFullscreen() {
			this.$emit('fullscreen', !this.fullscreen);
			this.resetZoom();
			setTimeout(this.resize, 10);
		}
	}
});

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(139), __esModule: true };

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(140);
module.exports = __webpack_require__(56).Object.assign;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(141);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(151) });


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var core = __webpack_require__(56);
var ctx = __webpack_require__(142);
var hide = __webpack_require__(144);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(143);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(145);
var createDesc = __webpack_require__(150);
module.exports = __webpack_require__(29) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(146);
var IE8_DOM_DEFINE = __webpack_require__(147);
var toPrimitive = __webpack_require__(149);
var dP = Object.defineProperty;

exports.f = __webpack_require__(29) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(29) && !__webpack_require__(30)(function () {
  return Object.defineProperty(__webpack_require__(148)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
var document = __webpack_require__(27).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(28);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(152);
var gOPS = __webpack_require__(163);
var pIE = __webpack_require__(164);
var toObject = __webpack_require__(165);
var IObject = __webpack_require__(58);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(30)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(153);
var enumBugKeys = __webpack_require__(162);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(154);
var toIObject = __webpack_require__(57);
var arrayIndexOf = __webpack_require__(156)(false);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 154 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 155 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(57);
var toLength = __webpack_require__(157);
var toAbsoluteIndex = __webpack_require__(158);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(60);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(60);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(160)('keys');
var uid = __webpack_require__(161);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 163 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(59);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, n) {
  var t, j = array.length, i = j - n;
  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
});


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(169);


/* harmony default export */ __webpack_exports__["a"] = (function(transform) {
  if (transform == null) return __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */];
  var x0,
      y0,
      kx = transform.scale[0],
      ky = transform.scale[1],
      dx = transform.translate[0],
      dy = transform.translate[1];
  return function(input, i) {
    if (!i) x0 = y0 = 0;
    var j = 2, n = input.length, output = new Array(n);
    output[0] = (x0 += input[0]) * kx + dx;
    output[1] = (y0 += input[1]) * ky + dy;
    while (j < n) output[j] = input[j], ++j;
    return output;
  };
});


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export meshArcs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__feature__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stitch__ = __webpack_require__(171);



/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__feature__["b" /* object */])(topology, meshArcs.apply(this, arguments));
});

function meshArcs(topology, object, filter) {
  var arcs, i, n;
  if (arguments.length > 1) arcs = extractArcs(topology, object, filter);
  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
  return {type: "MultiLineString", arcs: Object(__WEBPACK_IMPORTED_MODULE_1__stitch__["a" /* default */])(topology, arcs)};
}

function extractArcs(topology, object, filter) {
  var arcs = [],
      geomsByArc = [],
      geom;

  function extract0(i) {
    var j = i < 0 ? ~i : i;
    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
  }

  function extract1(arcs) {
    arcs.forEach(extract0);
  }

  function extract2(arcs) {
    arcs.forEach(extract1);
  }

  function extract3(arcs) {
    arcs.forEach(extract2);
  }

  function geometry(o) {
    switch (geom = o, o.type) {
      case "GeometryCollection": o.geometries.forEach(geometry); break;
      case "LineString": extract1(o.arcs); break;
      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
      case "MultiPolygon": extract3(o.arcs); break;
    }
  }

  geometry(object);

  geomsByArc.forEach(filter == null
      ? function(geoms) { arcs.push(geoms[0].i); }
      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });

  return arcs;
}


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(topology, arcs) {
  var stitchedArcs = {},
      fragmentByStart = {},
      fragmentByEnd = {},
      fragments = [],
      emptyIndex = -1;

  // Stitch empty arcs first, since they may be subsumed by other arcs.
  arcs.forEach(function(i, j) {
    var arc = topology.arcs[i < 0 ? ~i : i], t;
    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
    }
  });

  arcs.forEach(function(i) {
    var e = ends(i),
        start = e[0],
        end = e[1],
        f, g;

    if (f = fragmentByEnd[start]) {
      delete fragmentByEnd[f.end];
      f.push(i);
      f.end = end;
      if (g = fragmentByStart[end]) {
        delete fragmentByStart[g.start];
        var fg = g === f ? f : f.concat(g);
        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
      } else {
        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
      }
    } else if (f = fragmentByStart[end]) {
      delete fragmentByStart[f.start];
      f.unshift(i);
      f.start = start;
      if (g = fragmentByEnd[start]) {
        delete fragmentByEnd[g.end];
        var gf = g === f ? f : g.concat(f);
        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
      } else {
        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
      }
    } else {
      f = [i];
      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
    }
  });

  function ends(i) {
    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
    else p1 = arc[arc.length - 1];
    return i < 0 ? [p1, p0] : [p0, p1];
  }

  function flush(fragmentByEnd, fragmentByStart) {
    for (var k in fragmentByEnd) {
      var f = fragmentByEnd[k];
      delete fragmentByStart[f.start];
      delete f.start;
      delete f.end;
      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
      fragments.push(f);
    }
  }

  flush(fragmentByEnd, fragmentByStart);
  flush(fragmentByStart, fragmentByEnd);
  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });

  return fragments;
});


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(62);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(62);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(176);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(177);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(15);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(15);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(15);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cubehelixLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(15);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(70);
/* unused harmony reexport geoArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_bounds__ = __webpack_require__(185);
/* unused harmony reexport geoBounds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_centroid__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_centroid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_circle__ = __webpack_require__(71);
/* unused harmony reexport geoCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_clip_antimeridian__ = __webpack_require__(73);
/* unused harmony reexport geoClipAntimeridian */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_clip_circle__ = __webpack_require__(91);
/* unused harmony reexport geoClipCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_clip_extent__ = __webpack_require__(204);
/* unused harmony reexport geoClipExtent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_clip_rectangle__ = __webpack_require__(21);
/* unused harmony reexport geoClipRectangle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_contains__ = __webpack_require__(206);
/* unused harmony reexport geoContains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_distance__ = __webpack_require__(92);
/* unused harmony reexport geoDistance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_graticule__ = __webpack_require__(207);
/* unused harmony reexport geoGraticule */
/* unused harmony reexport geoGraticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_interpolate__ = __webpack_require__(208);
/* unused harmony reexport geoInterpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_length__ = __webpack_require__(93);
/* unused harmony reexport geoLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_path_index__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__src_path_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_projection_albers__ = __webpack_require__(95);
/* unused harmony reexport geoAlbers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_projection_albersUsa__ = __webpack_require__(217);
/* unused harmony reexport geoAlbersUsa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_projection_azimuthalEqualArea__ = __webpack_require__(218);
/* unused harmony reexport geoAzimuthalEqualArea */
/* unused harmony reexport geoAzimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_projection_azimuthalEquidistant__ = __webpack_require__(219);
/* unused harmony reexport geoAzimuthalEquidistant */
/* unused harmony reexport geoAzimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_projection_conicConformal__ = __webpack_require__(220);
/* unused harmony reexport geoConicConformal */
/* unused harmony reexport geoConicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_projection_conicEqualArea__ = __webpack_require__(37);
/* unused harmony reexport geoConicEqualArea */
/* unused harmony reexport geoConicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_projection_conicEquidistant__ = __webpack_require__(221);
/* unused harmony reexport geoConicEquidistant */
/* unused harmony reexport geoConicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_projection_equirectangular__ = __webpack_require__(96);
/* unused harmony reexport geoEquirectangular */
/* unused harmony reexport geoEquirectangularRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__ = __webpack_require__(222);
/* unused harmony reexport geoGnomonic */
/* unused harmony reexport geoGnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_projection_identity__ = __webpack_require__(223);
/* unused harmony reexport geoIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_projection_index__ = __webpack_require__(5);
/* unused harmony reexport geoProjection */
/* unused harmony reexport geoProjectionMutator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_projection_mercator__ = __webpack_require__(40);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_25__src_projection_mercator__["a"]; });
/* unused harmony reexport geoMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_projection_naturalEarth1__ = __webpack_require__(224);
/* unused harmony reexport geoNaturalEarth1 */
/* unused harmony reexport geoNaturalEarth1Raw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_projection_orthographic__ = __webpack_require__(225);
/* unused harmony reexport geoOrthographic */
/* unused harmony reexport geoOrthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_projection_stereographic__ = __webpack_require__(226);
/* unused harmony reexport geoStereographic */
/* unused harmony reexport geoStereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_projection_transverseMercator__ = __webpack_require__(227);
/* unused harmony reexport geoTransverseMercator */
/* unused harmony reexport geoTransverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_rotation__ = __webpack_require__(20);
/* unused harmony reexport geoRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stream__ = __webpack_require__(12);
/* unused harmony reexport geoStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_transform__ = __webpack_require__(22);
/* unused harmony reexport geoTransform */






 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).




























/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stream__ = __webpack_require__(12);






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonStart();
  },
  polygonEnd: function() {
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (__WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaRingSum */] < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi1 = 90;
    else if (deltaSum < -__WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["a" /* cartesian */])([lambda * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */], phi * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */]]);
  if (p0) {
    var normal = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(equatorial, normal);
    Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["e" /* cartesianNormalizeInPlace */])(inflection);
    inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["g" /* spherical */])(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */] * sign,
        phii,
        antimeridian = Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineEnd();
  if (Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(deltaSum) > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  Object(__WEBPACK_IMPORTED_MODULE_4__stream__["a" /* default */])(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
});


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stream__ = __webpack_require__(12);




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  centroidPointCartesian(cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  centroidStream.point = centroidRingPoint;
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(cx * cx + cy * cy + cz * cz),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  Object(__WEBPACK_IMPORTED_MODULE_2__stream__["a" /* default */])(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) return [NaN, NaN];
  }

  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(m)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
});


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(81);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(88);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(35);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(82);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(17);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(35);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(14);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(90);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rectangle__ = __webpack_require__(21);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = Object(__WEBPACK_IMPORTED_MODULE_0__rectangle__["a" /* default */])(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polygonContains__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__distance__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(0);




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], coordinates[1]),
      ao = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], point),
      ob = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(point, coordinates[1]);
  return ao + ob <= ab + __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
}

function containsPolygon(coordinates, point) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_0__polygonContains__["a" /* default */])(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */]];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export graticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



function graticuleX(y0, y1, dy) {
  var y = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* range */])(y0, y1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* range */])(x0, x1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(X0 / DX) * DX, X1, DX).map(X)
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(x0 / dx) * dx, x1, dx).filter(function(x) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x % DX) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(x))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(y0 / dy) * dy, y1, dy).filter(function(y) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y % DY) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 90 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]])
      .extentMinor([[-180, -80 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 80 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]]);
}

function graticule10() {
  return graticule()();
}


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  var x0 = a[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y0 = a[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      x1 = b[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y1 = b[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0),
      cy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1),
      sy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1),
      kx0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x0),
      ky0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x0),
      kx1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x1),
      ky1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x1),
      d = 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(y1 - y0) + cy0 * cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(x1 - x0))),
      k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d);

  var interpolate = d ? function(t) {
    var B = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(t *= d) / k,
        A = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */],
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(z, Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]
    ];
  } : function() {
    return [x0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], y0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  interpolate.distance = d;

  return interpolate;
});


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__area__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bounds__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__centroid__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measure__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__string__ = __webpack_require__(214);









/* harmony default export */ __webpack_exports__["a"] = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */].result();
  };

  path.measure = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */].result();
  };

  path.bounds = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */].result();
  };

  path.centroid = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */].result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */]) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new __WEBPACK_IMPORTED_MODULE_7__string__["a" /* default */]) : new __WEBPACK_IMPORTED_MODULE_5__context__["a" /* default */](context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(7);




var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
    areaSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

/* harmony default export */ __webpack_exports__["a"] = (areaStream);


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    x00,
    y00,
    x0,
    y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0 = x, y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0, dy = y - y0, z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);
  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;
  centroidPoint(x0 = x, y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(x00, y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00 = x0 = x, y00 = y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0,
      dy = y - y0,
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);

  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;

  z = y0 * x - x0 * y;
  X2 += z * (x0 + x);
  Y2 += z * (y0 + y);
  Z2 += z * 3;
  centroidPoint(x0 = x, y0 = y);
}

/* harmony default export */ __webpack_exports__["a"] = (centroidStream);


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(7);



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
        break;
      }
    }
  },
  result: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */]
};


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(7);




var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lengthRing,
    x00,
    y00,
    x0,
    y0;

var lengthStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum;
    lengthSum.reset();
    return length;
  }
};

function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (lengthStream);


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathString;
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(22);




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(30 * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]); // cos(minimum angular distance)

/* harmony default export */ __webpack_exports__["a"] = (function(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(a * a + b * b + c * c),
          phi2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(c /= m),
          lambda2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(c) - 1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - lambda1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] ? (lambda0 + lambda1) / 2 : Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(y * cosPhi0)];
  };

  return forward;
}


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__albers__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conicEqualArea__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(39);





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var cache,
      cacheStream,
      lower48 = Object(__WEBPACK_IMPORTED_MODULE_1__albers__["a" /* default */])(), lower48Point,
      alaska = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.120 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.214 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.166 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.115 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitSize */])(albersUsa, size, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(5);




var azimuthalEqualAreaRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(cxcy) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / 2);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(5);




var azimuthalEquidistantRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(c) {
  return (c = Object(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* acos */])(c)) && c / Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c);
});

azimuthalEquidistantRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return z;
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mercator__ = __webpack_require__(40);




function tany(y) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(cy0 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(tany(y1) / tany(y0)),
      f = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y0), n) / n;

  if (!n) return __WEBPACK_IMPORTED_MODULE_2__mercator__["c" /* mercatorRaw */];

  function project(x, y) {
    if (f > 0) { if (y < -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    else { if (y > __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    var r = f / Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y), n);
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(n * x), f - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + fy * fy);
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(fy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(fy), 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(f / r, 1 / n)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equirectangular__ = __webpack_require__(96);




function conicEquidistantRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : (cy0 - Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return __WEBPACK_IMPORTED_MODULE_2__equirectangular__["a" /* equirectangularRaw */];

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(nx), g - gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(gy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(gy), g - Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + gy * gy)];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(5);




function gnomonicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

gnomonicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_rectangle__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(39);





function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // scale, translate and reflect
      x0 = null, y0, x1, y1, // clip extent
      postclip = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */],
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    },
    postclip: function(_) {
      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    },
    clipExtent: function(_) {
      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_0__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(projection, extent, object);
    },
    fitSize: function(size, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitSize */])(projection, size, object);
    }
  };
});


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export naturalEarth1Raw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(0);



function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(naturalEarth1Raw)
      .scale(175.295);
});


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export orthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(5);




function orthographicRaw(x, y) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)];
}

orthographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]);
});


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(5);




function stereographicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = 1 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

stereographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(z);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mercator__ = __webpack_require__(40);



function transverseMercatorRaw(lambda, phi) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(x)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var m = Object(__WEBPACK_IMPORTED_MODULE_1__mercator__["b" /* mercatorProjection */])(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(46);



/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  var event = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(47);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(98);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, parents);
});


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(97);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(235);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](merges, this._parents);
});


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(42);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(41);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(47);



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(48);


function dispatchEvent(node, type, params) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(3);


/* unused harmony default export */ var _unused_webpack_default_export = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(46);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(46);



/* unused harmony default export */ var _unused_webpack_default_export = (function(node, touches) {
  if (touches == null) touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_zoom__ = __webpack_require__(262);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transform__ = __webpack_require__(107);
/* unused harmony reexport zoomTransform */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_transform__["b"]; });




/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__noevent__ = __webpack_require__(304);










// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].button;
}

function defaultExtent() {
  var e = this, w, h;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    w = e.width.baseVal.value;
    h = e.height.baseVal.value;
  } else {
    w = e.clientWidth;
    h = e.clientHeight;
  }
  return [[0, 0], [w, h]];
}

function defaultTransform() {
  return this.__zoom || __WEBPACK_IMPORTED_MODULE_7__transform__["b" /* identity */];
}

function defaultWheelDelta() {
  return -__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].deltaY * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].deltaMode ? 120 : 1) / 500;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var filter = defaultFilter,
      extent = defaultExtent,
      wheelDelta = defaultWheelDelta,
      touchable = defaultTouchable,
      k0 = 0,
      k1 = Infinity,
      x0 = -k1,
      x1 = k1,
      y0 = x0,
      y1 = x1,
      duration = 250,
      interpolate = __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["h" /* interpolateZoom */],
      gestures = [],
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection) {
    selection
        .property("__zoom", defaultTransform)
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
      .filter(touchable)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  zoom.transform = function(collection, transform) {
    var selection = collection.selection ? collection.selection() : collection;
    selection.property("__zoom", defaultTransform);
    if (collection !== selection) {
      schedule(collection, transform);
    } else {
      selection.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection, k) {
    zoom.scaleTo(selection, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    });
  };

  zoom.scaleTo = function(selection, k) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = centroid(e),
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e);
    });
  };

  zoom.translateBy = function(selection, x, y) {
    zoom.transform(selection, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments));
    });
  };

  zoom.translateTo = function(selection, x, y) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t = this.__zoom,
          p = centroid(e);
      return constrain(__WEBPACK_IMPORTED_MODULE_7__transform__["b" /* identity */].translate(p[0], p[1]).scale(t.k).translate(
        typeof x === "function" ? -x.apply(this, arguments) : -x,
        typeof y === "function" ? -y.apply(this, arguments) : -y
      ), e);
    });
  };

  function scale(transform, k) {
    k = Math.max(k0, Math.min(k1, k));
    return k === transform.k ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](transform.k, x, y);
  }

  function constrain(transform, extent) {
    var dx0 = transform.invertX(extent[0][0]) - x0,
        dx1 = transform.invertX(extent[1][0]) - x1,
        dy0 = transform.invertY(extent[0][1]) - y0,
        dy1 = transform.invertY(extent[1][1]) - y1;
    return transform.translate(
      dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
      dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
    );
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition, transform, center) {
    transition
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = center || centroid(e),
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args) {
    for (var i = 0, n = gestures.length, g; i < n; ++i) {
      if ((g = gestures[i]).that === that) {
        return g;
      }
    }
    return new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.index = -1;
    this.active = 0;
    this.extent = extent.apply(that, args);
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.index = gestures.push(this) - 1;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        gestures.splice(this.index, 1);
        this.index = -1;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(k0, Math.min(k1, t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
      g.start();
    }

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        v = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this),
        x0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientX,
        y0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientY;

    Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["a" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view);
    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    g.mouse = [p, this.__zoom.invert(p)];
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
    g.start();

    function mousemoved() {
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      if (!g.moved) {
        var dx = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientX - x0, dy = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(g.that), g.mouse[1]), g.extent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view, g.moved);
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments));

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (duration > 0) Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this).transition().duration(duration).call(schedule, t1, p0);
    else Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        started,
        n = touches.length, i, t, p;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* touch */])(this, touches, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true;
      else if (!g.touch1) g.touch1 = p;
    }

    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
    if (touchstarting) {
      touchstarting = clearTimeout(touchstarting);
      if (!g.touch1) {
        g.end();
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
        return;
      }
    }

    if (started) {
      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
      g.start();
    }
  }

  function touchmoved() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, t, p, l;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* touch */])(this, touches, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent));
  }

  function touchended() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, t;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else g.end();
  }

  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(+_), zoom) : wheelDelta;
  };

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : filter;
  };

  zoom.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : touchable;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (k0 = +_[0], k1 = +_[1], zoom) : [k0, k1];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], zoom) : [[x0, y0], [x1, y1]];
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };

  return zoom;
});


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ __webpack_exports__["a"] = (dispatch);


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_drag__ = __webpack_require__(265);
/* unused harmony reexport drag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_nodrag__ = __webpack_require__(102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["b"]; });




/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodrag__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noevent__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event__ = __webpack_require__(267);







// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].x, y: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].y} : d;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var filter = defaultFilter,
      container = defaultContainer,
      subject = defaultSubject,
      touchable = defaultTouchable,
      gestures = {},
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), __WEBPACK_IMPORTED_MODULE_1_d3_selection__["d" /* mouse */], this, arguments);
    if (!gesture) return;
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
    mousemoving = false;
    mousedownx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientX;
    mousedowny = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientY;
    gesture("start");
  }

  function mousemoved() {
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    if (!mousemoving) {
      var dx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientX - mousedownx, dy = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view).on("mousemove.drag mouseup.drag", null);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["b" /* yesdrag */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view, mousemoving);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        c = container.apply(this, arguments),
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches[i].identifier, c, __WEBPACK_IMPORTED_MODULE_1_d3_selection__["k" /* touch */], this, arguments)) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : subject;
  };

  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : touchable;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
});


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DragEvent;
function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_selection_index__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transition_index__ = __webpack_require__(9);
/* unused harmony reexport transition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_active__ = __webpack_require__(301);
/* unused harmony reexport active */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_interrupt__ = __webpack_require__(104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__src_interrupt__["a"]; });






/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interrupt__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transition__ = __webpack_require__(273);




__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype.interrupt = __WEBPACK_IMPORTED_MODULE_1__interrupt__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype.transition = __WEBPACK_IMPORTED_MODULE_2__transition__["a" /* default */];


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interrupt__ = __webpack_require__(104);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return this.each(function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__interrupt__["a" /* default */])(this, name);
  });
});


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(50);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(50);


/* unused harmony default export */ var _unused_webpack_default_export = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? Object(__WEBPACK_IMPORTED_MODULE_0__timer__["b" /* now */])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_ease__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_timer__ = __webpack_require__(105);





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: __WEBPACK_IMPORTED_MODULE_2_d3_ease__["a" /* easeCubicInOut */]
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), defaultTiming;
    }
  }
  return timing;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var id,
      timing;

  if (name instanceof __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]) {
    id = name._id, name = name._name;
  } else {
    id = Object(__WEBPACK_IMPORTED_MODULE_0__transition_index__["b" /* newId */])(), (timing = defaultTiming).time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        Object(__WEBPACK_IMPORTED_MODULE_1__transition_schedule__["e" /* default */])(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */](groups, this._parents, name, id);
});


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(106);





function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* namespace */])(name), i = fullname === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["g" /* interpolateTransformSvg */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value + ""));
});


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);


function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* namespace */])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(4);


function delayFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).delay;
});


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(4);


function durationFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).duration;
});


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(4);


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).ease = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).ease;
});


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["c" /* matcher */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, this._name, this._id);
});


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](merges, this._parents, this._name, this._id);
});


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(4);


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? __WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */] : __WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */];
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.on("end.remove", removeFunction(this._id));
});


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["h" /* selector */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(subgroup[i], name, id, i, subgroup, Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, name, id);
});


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["i" /* selectorAll */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, parents, name, id);
});


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);


var Selection = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype.constructor;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Selection(this._groups, this._parents);
});


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(106);





function styleRemove(name, interpolate) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name),
        value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var i = (name += "") === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["f" /* interpolateTransformCss */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return value == null ? this
          .styleTween(name, styleRemove(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction(name, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "style." + name, value))
          : styleConstant(name, i, value + ""), priority);
});


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tween__ = __webpack_require__(23);


function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(Object(__WEBPACK_IMPORTED_MODULE_0__tween__["b" /* tweenValue */])(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
});


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedule__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = Object(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* newId */])();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["f" /* get */])(node, id0);
        Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["e" /* default */])(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](groups, this._parents, name, id1);
});


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_linear__ = __webpack_require__(291);
/* unused harmony reexport easeLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_quad__ = __webpack_require__(292);
/* unused harmony reexport easeQuad */
/* unused harmony reexport easeQuadIn */
/* unused harmony reexport easeQuadOut */
/* unused harmony reexport easeQuadInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubic__ = __webpack_require__(293);
/* unused harmony reexport easeCubic */
/* unused harmony reexport easeCubicIn */
/* unused harmony reexport easeCubicOut */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_poly__ = __webpack_require__(294);
/* unused harmony reexport easePoly */
/* unused harmony reexport easePolyIn */
/* unused harmony reexport easePolyOut */
/* unused harmony reexport easePolyInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_sin__ = __webpack_require__(295);
/* unused harmony reexport easeSin */
/* unused harmony reexport easeSinIn */
/* unused harmony reexport easeSinOut */
/* unused harmony reexport easeSinInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_exp__ = __webpack_require__(296);
/* unused harmony reexport easeExp */
/* unused harmony reexport easeExpIn */
/* unused harmony reexport easeExpOut */
/* unused harmony reexport easeExpInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_circle__ = __webpack_require__(297);
/* unused harmony reexport easeCircle */
/* unused harmony reexport easeCircleIn */
/* unused harmony reexport easeCircleOut */
/* unused harmony reexport easeCircleInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_bounce__ = __webpack_require__(298);
/* unused harmony reexport easeBounce */
/* unused harmony reexport easeBounceIn */
/* unused harmony reexport easeBounceOut */
/* unused harmony reexport easeBounceInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_back__ = __webpack_require__(299);
/* unused harmony reexport easeBack */
/* unused harmony reexport easeBackIn */
/* unused harmony reexport easeBackOut */
/* unused harmony reexport easeBackInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_elastic__ = __webpack_require__(300);
/* unused harmony reexport easeElastic */
/* unused harmony reexport easeElasticIn */
/* unused harmony reexport easeElasticOut */
/* unused harmony reexport easeElasticInOut */





















/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linear */
function linear(t) {
  return +t;
}


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export quadIn */
/* unused harmony export quadOut */
/* unused harmony export quadInOut */
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cubicIn */
/* unused harmony export cubicOut */
/* harmony export (immutable) */ __webpack_exports__["a"] = cubicInOut;
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export polyIn */
/* unused harmony export polyOut */
/* unused harmony export polyInOut */
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sinIn */
/* unused harmony export sinOut */
/* unused harmony export sinInOut */
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expIn */
/* unused harmony export expOut */
/* unused harmony export expInOut */
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export circleIn */
/* unused harmony export circleOut */
/* unused harmony export circleInOut */
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bounceIn */
/* unused harmony export bounceOut */
/* unused harmony export bounceInOut */
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backIn */
/* unused harmony export backOut */
/* unused harmony export backInOut */
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export elasticIn */
/* unused harmony export elasticOut */
/* unused harmony export elasticInOut */
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(4);



var root = [null];

/* unused harmony default export */ var _unused_webpack_default_export = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > __WEBPACK_IMPORTED_MODULE_1__transition_schedule__["c" /* SCHEDULED */] && schedule.name === name) {
        return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]([[node]], root, name, +i);
      }
    }
  }

  return null;
});


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZoomEvent;
function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(108);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(308);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(310);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(311);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(109);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(318);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(319);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(109);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(52);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(51);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Poll_vue__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83af319c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_Poll_vue__ = __webpack_require__(352);
function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Poll_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83af319c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_Poll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_shape_src_arc__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape_src_pie__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
	name: "poll",
	components: {
		VueSlider: __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default.a
	},
	props: {
		pollData: {
			type: Object
		},
		emojiData: {
			type: Object,
			required: true
		},
		environ: {
			type: String
		},
		resultDate: {
			type: Number
		}
	},
	data: function data() {
		return {
			pollNoResults: 'Unfortunately there are no results yet',
			sliderHelp: 'Drag the slider to make your selection',
			chart_poll: {
				width: 180,
				height: 180
			},
			pollValue: 'meh',
			sliderData: ['furious', 'depressed', 'worried', 'meh', 'happy', 'stoked'],
			votedCookie: null,
			results: null,
			isMobile: null
		};
	},
	computed: {
		pollQuestion: function pollQuestion() {
			var question = 'How do you feel about the election in',
			    questionElectionNight = "How do you feel about the election results in";
			return Date.now() > this.resultDate ? questionElectionNight : question;
		},
		pollQuestionAnswered: function pollQuestionAnswered() {
			var questionAnswered = 'How do people feel about the election in',
			    questionAnsweredElectionNight = "How do people feel about the election results in";
			return Date.now() > this.resultDate ? questionAnsweredElectionNight : questionAnswered;
		},
		pie: function pie() {
			return Object(__WEBPACK_IMPORTED_MODULE_2_d3_shape_src_pie__["a" /* default */])().sort(null).value(function (d) {
				return d.value;
			});
		},
		chart_poll_transform: function chart_poll_transform() {
			return "translate(" + this.chart_poll.width / 2 + "," + this.chart_poll.height / 2 + ")";
		},
		chart_poll_total: function chart_poll_total() {
			return this.results.total;
		},
		chart_poll_data: function chart_poll_data() {

			return [{ name: 'furious', value: this.results.votes.furious.pc }, { name: 'depressed', value: this.results.votes.depressed.pc }, { name: 'worried', value: this.results.votes.worried.pc }, { name: 'meh', value: this.results.votes.meh.pc }, { name: 'happy', value: this.results.votes.happy.pc }, { name: 'stoked', value: this.results.votes.stoked.pc }];
		},
		chart_poll_paths: function chart_poll_paths() {
			var _this = this;

			var radius = Math.min(this.chart_poll.width, this.chart_poll.height) / 2,

			//arc = d3arc().outerRadius(radius - 10).innerRadius(radius - 35),
			arc = this.isMobile ? Object(__WEBPACK_IMPORTED_MODULE_1_d3_shape_src_arc__["a" /* default */])().outerRadius(radius - 10).innerRadius(radius - 25) : Object(__WEBPACK_IMPORTED_MODULE_1_d3_shape_src_arc__["a" /* default */])().outerRadius(radius - 10).innerRadius(radius - 35),
			    pieData = this.pie(this.chart_poll_data);

			return pieData.map(function (d) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, d, {
					d: arc(d),
					fill: _this.emojiColorFn(d.data.name),
					pieTexttransform: _this.pietext_transform(arc.centroid(d), d),
					b64icon: _this.emojiIconFn(d.data.name)
				});
			});
		},
		properties: function properties() {
			return this.pollData.properties;
		}
	},
	mounted: function mounted() {
		//console.log(this)
		this.checkMobile();

		window.addEventListener('resize', this.checkMobile);
		window.addEventListener('orientationchange', this.checkMobile);
	},
	created: function created() {
		this.getCookie();
	},

	methods: {
		checkMobile: function checkMobile() {

			var mq = window.matchMedia("(max-width: 500px)");

			if (mq.matches) {
				this.isMobile = true;
				this.chart_poll.width = 100;
				this.chart_poll.height = 100;
			} else {
				this.isMobile = false;
				this.chart_poll.width = 180;
				this.chart_poll.height = 180;
			}
		},
		submitClick: function submitClick() {
			//console.log('Sentiment', this.pollValue, this.properties.Elect_div, this.properties.fid);
			if (this.pollValue) {
				this.postPoll();
			}
		},
		closeClick: function closeClick() {
			this.$emit('close');
		},
		postPoll: function postPoll() {
			var _this2 = this;

			//console.log('Should Post this:', this.pollValue, this.properties.Elect_div, this.properties.fid);
			var
			// localUrl = 'http://localhost:5000/api/electorate/' + this.properties.fid + '/vote',
			uatUrl = 'https://d3l0ncuayaqpnv.cloudfront.net/api/electorate/' + this.properties.fid + '/vote',
			    prodUrl = 'https://d1pg15zwxj87d2.cloudfront.net/api/electorate/' + this.properties.fid + '/vote',
			    postUrl = this.environ.match(/development|uat/) ? uatUrl : prodUrl;

			// const postUrl = 'https://znj95mx1a2.execute-api.ap-southeast-2.amazonaws.com/uat/api/electorate/' + this.properties.fid + '/vote';
			//const pollFormData = {'vote': this.pollValue, 'token': 'asdf1234'}
			var token = this.createToken();
			var capiMeta = document.querySelector('meta[name="articleid"]');
			var capiid = capiMeta && capiMeta.getAttribute('content');

			var indexPath = !capiid ? window.location.pathname : null;
			//const skipCookie = true;
			var pollFormDataUat = { 'vote': this.pollValue, token: token, capiid: capiid, indexPath: indexPath, skipCookie: true };
			var pollFormDataProd = { 'vote': this.pollValue, token: token, capiid: capiid, indexPath: indexPath };
			var pollFormData = this.environ.match(/development|uat/) ? pollFormDataUat : pollFormDataProd;

			__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(postUrl, pollFormData, { withCredentials: true }).then(function (response) {
				if (response.status == 200) {
					var b64votevalue = Buffer.from(_this2.pollValue).toString('base64');
					var exDate = new Date();
					exDate.setTime(exDate.getTime() + 1 * 24 * 60 * 60 * 1000);
					var cookExpires = "expires=" + exDate.toUTCString();

					// LINE DISABLED TEMPORARILY TO TEST, OTHERWISE 24 HOURS BUDDY
					document.cookie = "_asw=V" + b64votevalue + ";" + cookExpires + ";path=/";

					_this2.votedCookie = _this2.pollValue;

					setTimeout(function () {
						_this2.getPollResults(token);
					}, 1000);
				}
			}).catch(function (error) {
				//.catch(function (error) {
				console.log(error);

				// get results regardless
				_this2.votedCookie = 'true';
				// set cookie for 403
				var exDate = new Date();
				exDate.setTime(exDate.getTime() + 1 * 24 * 60 * 60 * 1000);
				var cookExpires = "expires=" + exDate.toUTCString();
				document.cookie = "_asw=AV" + "403" + ";" + cookExpires + ";path=/";
				setTimeout(function () {
					_this2.getPollResults(token);
				}, 1000);
			});

			/*
   const response = await axios
   	.post(postUrl, pollFormData)
   	.then(response => {
   */
		},
		getPollResults: function getPollResults(token) {
			var _this3 = this;

			var tokenParam = token ? '?_t=' + token : '';

			var uatUrl = 'https://d3l0ncuayaqpnv.cloudfront.net/api/electorate/' + this.properties.fid + '/results' + tokenParam,
			    prodUrl = 'https://d1pg15zwxj87d2.cloudfront.net/api/electorate/' + this.properties.fid + '/results' + tokenParam,
			    getUrl = this.environ.match(/development|uat/) ? uatUrl : prodUrl;

			//const getUrl = 'https://znj95mx1a2.execute-api.ap-southeast-2.amazonaws.com/uat/api/electorate/' + this.properties.fid + '/results';
			__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(getUrl).then(function (response) {
				if (response.status == 200) {
					_this3.results = response.data.data;
				}
			}).catch(function (error) {
				console.log(error);
			});
		},
		getCookie: function getCookie() {
			var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)_asw\s*\=\s*([^;]*).*$)|^.*$/, "$1");
			if (cookieValue !== '') {
				var deB64value = cookieValue.substr(1); // remove the sneaky V
				var sentiment = new Buffer(deB64value, 'base64').toString();
				this.votedCookie = sentiment;
				this.getPollResults();
			}
		},
		emojiColorFn: function emojiColorFn(name) {
			return this.emojiData[name].color;
		},
		emojiIconFn: function emojiIconFn(name) {
			return this.emojiData[name].iconB64;
		},
		pietext_transform: function pietext_transform(arcCentroid, d) {

			var dangle = (d.endAngle + d.startAngle) / 2;
			//console.log('dangle', dangle);

			if (this.isMobile) {
				if (dangle > 0 && dangle <= 1.0) {
					arcCentroid[0] *= 2.5;
					arcCentroid[1] *= 3.0;
					//console.log('1mobile');
				} else if (dangle > 1 && dangle <= 1.9) {
					arcCentroid[0] *= 2.6;
					arcCentroid[1] *= 2.6;
					//console.log('2mobile');
				} else if (dangle > 1.9 && dangle <= 3) {
					arcCentroid[0] *= 2.3;
					arcCentroid[1] *= 2.3;
					//console.log('3mobile');
				} else if (dangle > 3 && dangle <= 4.2) {
					arcCentroid[0] *= 4.8;
					arcCentroid[1] *= 2.1;
					//console.log('4mobile');
				} else if (dangle > 4.2 && dangle <= 5.0) {
					arcCentroid[0] *= 4.0;
					arcCentroid[1] *= 1.0;
					//console.log('5mobile');
				} else {
					arcCentroid[0] *= 4.5;
					arcCentroid[1] *= 3.3;
					//console.log('6mobile');
				}
			} else {
				if (dangle > 0 && dangle <= 1.0) {
					arcCentroid[0] *= 2.0;
					arcCentroid[1] *= 2.0;
					//console.log('1');
				} else if (dangle > 1 && dangle <= 1.8) {
					arcCentroid[0] *= 1.8;
					arcCentroid[1] *= 2.0;
					//console.log('2');
				} else if (dangle > 1.8 && dangle <= 3) {
					arcCentroid[0] *= 1.7;
					arcCentroid[1] *= 1.2;
					//console.log('3');
				} else if (dangle > 3 && dangle <= 4.2) {
					arcCentroid[0] *= 3.0;
					arcCentroid[1] *= 1.5;
					//console.log('4');
				} else if (dangle > 4.2 && dangle <= 5.0) {
					arcCentroid[0] *= 2.5;
					arcCentroid[1] *= 1.0;
					//console.log('5');
				} else {
					arcCentroid[0] *= 2.9;
					arcCentroid[1] *= 2.0;
					//console.log('6');
				}
			}

			return "translate(" + arcCentroid + ")";
		},
		createToken: function createToken() {
			var now = Date.now();
			var diff = now - now % 5000;
			var rounded = new Date(diff).toISOString();
			var token = window.btoa("" + rounded);

			return token;
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(324).Buffer))

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(325)
var ieee754 = __webpack_require__(326)
var isArray = __webpack_require__(327)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 326 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 327 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_path__ = __webpack_require__(329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_path__["a"]; });



/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

(function(t,e){ true?module.exports=e(__webpack_require__(54)):"function"===typeof define&&define.amd?define([],e):"object"===typeof exports?exports["vue-slider-component"]=e(require("vue")):t["vue-slider-component"]=e(t["Vue"])})("undefined"!==typeof self?self:this,function(t){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"===typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)r.d(n,o,function(e){return t[e]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t["default"]}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s="fb15")}({2350:function(t,e){function r(t,e){var r=t[1]||"",o=t[3];if(!o)return r;if(e&&"function"===typeof btoa){var i=n(o),s=o.sources.map(function(t){return"/*# sourceURL="+o.sourceRoot+t+" */"});return[r].concat(s).concat([i]).join("\n")}return[r].join("\n")}function n(t){var e=btoa(unescape(encodeURIComponent(JSON.stringify(t)))),r="sourceMappingURL=data:application/json;charset=utf-8;base64,"+e;return"/*# "+r+" */"}t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var n=r(e,t);return e[2]?"@media "+e[2]+"{"+n+"}":n}).join("")},e.i=function(t,r){"string"===typeof t&&(t=[[null,t,""]]);for(var n={},o=0;o<this.length;o++){var i=this[o][0];"number"===typeof i&&(n[i]=!0)}for(o=0;o<t.length;o++){var s=t[o];"number"===typeof s[0]&&n[s[0]]||(r&&!s[2]?s[2]=r:r&&(s[2]="("+s[2]+") and ("+r+")"),e.push(s))}},e}},"499e":function(t,e,r){"use strict";function n(t,e){for(var r=[],n={},o=0;o<e.length;o++){var i=e[o],s=i[0],a=i[1],u=i[2],l=i[3],c={id:t+":"+o,css:a,media:u,sourceMap:l};n[s]?n[s].parts.push(c):r.push(n[s]={id:s,parts:[c]})}return r}r.r(e),r.d(e,"default",function(){return h});var o="undefined"!==typeof document;if("undefined"!==typeof DEBUG&&DEBUG&&!o)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var i={},s=o&&(document.head||document.getElementsByTagName("head")[0]),a=null,u=0,l=!1,c=function(){},d=null,f="data-vue-ssr-id",p="undefined"!==typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function h(t,e,r,o){l=r,d=o||{};var s=n(t,e);return y(s),function(e){for(var r=[],o=0;o<s.length;o++){var a=s[o],u=i[a.id];u.refs--,r.push(u)}e?(s=n(t,e),y(s)):s=[];for(o=0;o<r.length;o++){u=r[o];if(0===u.refs){for(var l=0;l<u.parts.length;l++)u.parts[l]();delete i[u.id]}}}}function y(t){for(var e=0;e<t.length;e++){var r=t[e],n=i[r.id];if(n){n.refs++;for(var o=0;o<n.parts.length;o++)n.parts[o](r.parts[o]);for(;o<r.parts.length;o++)n.parts.push(m(r.parts[o]));n.parts.length>r.parts.length&&(n.parts.length=r.parts.length)}else{var s=[];for(o=0;o<r.parts.length;o++)s.push(m(r.parts[o]));i[r.id]={id:r.id,refs:1,parts:s}}}}function v(){var t=document.createElement("style");return t.type="text/css",s.appendChild(t),t}function m(t){var e,r,n=document.querySelector("style["+f+'~="'+t.id+'"]');if(n){if(l)return c;n.parentNode.removeChild(n)}if(p){var o=u++;n=a||(a=v()),e=g.bind(null,n,o,!1),r=g.bind(null,n,o,!0)}else n=v(),e=k.bind(null,n),r=function(){n.parentNode.removeChild(n)};return e(t),function(n){if(n){if(n.css===t.css&&n.media===t.media&&n.sourceMap===t.sourceMap)return;e(t=n)}else r()}}var b=function(){var t=[];return function(e,r){return t[e]=r,t.filter(Boolean).join("\n")}}();function g(t,e,r,n){var o=r?"":n.css;if(t.styleSheet)t.styleSheet.cssText=b(e,o);else{var i=document.createTextNode(o),s=t.childNodes;s[e]&&t.removeChild(s[e]),s.length?t.insertBefore(i,s[e]):t.appendChild(i)}}function k(t,e){var r=e.css,n=e.media,o=e.sourceMap;if(n&&t.setAttribute("media",n),d.ssrId&&t.setAttribute(f,e.id),o&&(r+="\n/*# sourceURL="+o.sources[0]+" */",r+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */"),t.styleSheet)t.styleSheet.cssText=r;else{while(t.firstChild)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(r))}}},"4abb":function(t,e,r){var n=r("df80");"string"===typeof n&&(n=[[t.i,n,""]]),n.locals&&(t.exports=n.locals);var o=r("499e").default;o("3e7284f8",n,!0,{sourceMap:!1,shadowMode:!1})},"4ed8":function(t,e,r){var n=r("ae61");"string"===typeof n&&(n=[[t.i,n,""]]),n.locals&&(t.exports=n.locals);var o=r("499e").default;o("57c2b2f0",n,!0,{sourceMap:!1,shadowMode:!1})},"556c":function(t,e,r){var n=r("d5ac");"string"===typeof n&&(n=[[t.i,n,""]]),n.locals&&(t.exports=n.locals);var o=r("499e").default;o("f3ffc7f8",n,!0,{sourceMap:!1,shadowMode:!1})},"65d9":function(t,e,r){"use strict";
/**
  * vue-class-component v7.0.1
  * (c) 2015-present Evan You
  * @license MIT
  */function n(t){return t&&"object"===typeof t&&"default"in t?t["default"]:t}Object.defineProperty(e,"__esModule",{value:!0});var o=n(r("8bbf")),i="undefined"!==typeof Reflect&&Reflect.defineMetadata&&Reflect.getOwnMetadataKeys;function s(t,e){a(t,e),Object.getOwnPropertyNames(e.prototype).forEach(function(r){a(t.prototype,e.prototype,r)}),Object.getOwnPropertyNames(e).forEach(function(r){a(t,e,r)})}function a(t,e,r){var n=r?Reflect.getOwnMetadataKeys(e,r):Reflect.getOwnMetadataKeys(e);n.forEach(function(n){var o=r?Reflect.getOwnMetadata(n,e,r):Reflect.getOwnMetadata(n,e);r?Reflect.defineMetadata(n,o,t,r):Reflect.defineMetadata(n,o,t)})}var u={__proto__:[]},l=u instanceof Array;function c(t){return function(e,r,n){var o="function"===typeof e?e:e.constructor;o.__decorators__||(o.__decorators__=[]),"number"!==typeof n&&(n=void 0),o.__decorators__.push(function(e){return t(e,r,n)})}}function d(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return o.extend({mixins:t})}function f(t){var e=typeof t;return null==t||"object"!==e&&"function"!==e}function p(t,e){var r=e.prototype._init;e.prototype._init=function(){var e=this,r=Object.getOwnPropertyNames(t);if(t.$options.props)for(var n in t.$options.props)t.hasOwnProperty(n)||r.push(n);r.forEach(function(r){"_"!==r.charAt(0)&&Object.defineProperty(e,r,{get:function(){return t[r]},set:function(e){t[r]=e},configurable:!0})})};var n=new e;e.prototype._init=r;var o={};return Object.keys(n).forEach(function(t){void 0!==n[t]&&(o[t]=n[t])}),o}var h=["data","beforeCreate","created","beforeMount","mounted","beforeDestroy","destroyed","beforeUpdate","updated","activated","deactivated","render","errorCaptured","serverPrefetch"];function y(t,e){void 0===e&&(e={}),e.name=e.name||t._componentTag||t.name;var r=t.prototype;Object.getOwnPropertyNames(r).forEach(function(t){if("constructor"!==t)if(h.indexOf(t)>-1)e[t]=r[t];else{var n=Object.getOwnPropertyDescriptor(r,t);void 0!==n.value?"function"===typeof n.value?(e.methods||(e.methods={}))[t]=n.value:(e.mixins||(e.mixins=[])).push({data:function(){var e;return e={},e[t]=n.value,e}}):(n.get||n.set)&&((e.computed||(e.computed={}))[t]={get:n.get,set:n.set})}}),(e.mixins||(e.mixins=[])).push({data:function(){return p(this,t)}});var n=t.__decorators__;n&&(n.forEach(function(t){return t(e)}),delete t.__decorators__);var a=Object.getPrototypeOf(t.prototype),u=a instanceof o?a.constructor:o,l=u.extend(e);return v(l,t,u),i&&s(l,t),l}function v(t,e,r){Object.getOwnPropertyNames(e).forEach(function(n){if("prototype"!==n){var o=Object.getOwnPropertyDescriptor(t,n);if(!o||o.configurable){var i=Object.getOwnPropertyDescriptor(e,n);if(!l){if("cid"===n)return;var s=Object.getOwnPropertyDescriptor(r,n);if(!f(i.value)&&s&&s.value===i.value)return}0,Object.defineProperty(t,n,i)}}})}function m(t){return"function"===typeof t?y(t):function(e){return y(e,t)}}m.registerHooks=function(t){h.push.apply(h,t)},e.default=m,e.createDecorator=c,e.mixins=d},"8bbf":function(e,r){e.exports=t},ae61:function(t,e,r){e=t.exports=r("2350")(!1),e.push([t.i,".vue-slider-dot{position:absolute;will-change:transform;-webkit-transition:all 0s;transition:all 0s;z-index:5}.vue-slider-dot-tooltip{position:absolute;visibility:hidden}.vue-slider-dot-tooltip-show{visibility:visible}.vue-slider-dot-tooltip-top{top:-10px;left:50%;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}.vue-slider-dot-tooltip-bottom{bottom:-10px;left:50%;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}.vue-slider-dot-tooltip-left{left:-10px;top:50%;-webkit-transform:translate(-100%,-50%);transform:translate(-100%,-50%)}.vue-slider-dot-tooltip-right{right:-10px;top:50%;-webkit-transform:translate(100%,-50%);transform:translate(100%,-50%)}",""])},d5ac:function(t,e,r){e=t.exports=r("2350")(!1),e.push([t.i,".vue-slider-marks{position:relative;width:100%;height:100%}.vue-slider-mark{position:absolute;z-index:1}.vue-slider-ltr .vue-slider-mark,.vue-slider-rtl .vue-slider-mark{width:0;height:100%;top:50%}.vue-slider-ltr .vue-slider-mark-step,.vue-slider-rtl .vue-slider-mark-step{top:0}.vue-slider-ltr .vue-slider-mark-label,.vue-slider-rtl .vue-slider-mark-label{top:100%;margin-top:10px}.vue-slider-ltr .vue-slider-mark{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.vue-slider-ltr .vue-slider-mark-step{left:0}.vue-slider-ltr .vue-slider-mark-label{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.vue-slider-rtl .vue-slider-mark{-webkit-transform:translate(50%,-50%);transform:translate(50%,-50%)}.vue-slider-rtl .vue-slider-mark-step{right:0}.vue-slider-rtl .vue-slider-mark-label{right:50%;-webkit-transform:translateX(50%);transform:translateX(50%)}.vue-slider-btt .vue-slider-mark,.vue-slider-ttb .vue-slider-mark{width:100%;height:0;left:50%}.vue-slider-btt .vue-slider-mark-step,.vue-slider-ttb .vue-slider-mark-step{left:0}.vue-slider-btt .vue-slider-mark-label,.vue-slider-ttb .vue-slider-mark-label{left:100%;margin-left:10px}.vue-slider-btt .vue-slider-mark{-webkit-transform:translate(-50%,50%);transform:translate(-50%,50%)}.vue-slider-btt .vue-slider-mark-step{top:0}.vue-slider-btt .vue-slider-mark-label{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vue-slider-ttb .vue-slider-mark{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.vue-slider-ttb .vue-slider-mark-step{bottom:0}.vue-slider-ttb .vue-slider-mark-label{bottom:50%;-webkit-transform:translateY(50%);transform:translateY(50%)}.vue-slider-mark-label,.vue-slider-mark-step{position:absolute}",""])},df80:function(t,e,r){e=t.exports=r("2350")(!1),e.push([t.i,".vue-slider{position:relative;-webkit-box-sizing:content-box;box-sizing:content-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;-ms-touch-action:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.vue-slider-disabled{pointer-events:none}.vue-slider-rail{position:relative;width:100%;height:100%;-webkit-transition-property:width,height,left,right,top,bottom;transition-property:width,height,left,right,top,bottom}.vue-slider-process{position:absolute;z-index:1}.vue-slider-sr-only{clip:rect(1px,1px,1px,1px);height:1px;width:1px;overflow:hidden;position:absolute!important}",""])},fb15:function(t,e,r){"use strict";var n;(r.r(e),"undefined"!==typeof window)&&((n=window.document.currentScript)&&(n=n.src.match(/(.+\/)[^\/]+\.js(\?.*)?$/))&&(r.p=n[1]));function o(t,e,r,n){var o,i=arguments.length,s=i<3?e:null===n?n=Object.getOwnPropertyDescriptor(e,r):n;if("object"===typeof Reflect&&"function"===typeof Reflect.decorate)s=Reflect.decorate(t,e,r,n);else for(var a=t.length-1;a>=0;a--)(o=t[a])&&(s=(i<3?o(s):i>3?o(e,r,s):o(e,r))||s);return i>3&&s&&Object.defineProperty(e,r,s),s}var i=r("8bbf"),s=r.n(i),a=r("65d9"),u=r.n(a);var l="undefined"!==typeof Reflect&&"undefined"!==typeof Reflect.getMetadata;function c(t,e,r){l&&(Array.isArray(t)||"function"===typeof t||"undefined"!==typeof t.type||(t.type=Reflect.getMetadata("design:type",e,r)))}function d(t,e){return void 0===e&&(e={}),function(r,n){c(e,r,n),Object(a["createDecorator"])(function(r,n){(r.props||(r.props={}))[n]=e,r.model={prop:n,event:t||n}})(r,n)}}function f(t){return void 0===t&&(t={}),function(e,r){c(t,e,r),Object(a["createDecorator"])(function(e,r){(e.props||(e.props={}))[r]=t})(e,r)}}function p(t,e){void 0===e&&(e={});var r=e.deep,n=void 0!==r&&r,o=e.immediate,i=void 0!==o&&o;return Object(a["createDecorator"])(function(e,r){"object"!==typeof e.watch&&(e.watch=Object.create(null));var o=e.watch;"object"!==typeof o[t]||Array.isArray(o[t])?"undefined"===typeof o[t]&&(o[t]=[]):o[t]=[o[t]],o[t].push({handler:r,deep:n,immediate:i})})}r("4ed8");function h(t){return h="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},h(t)}function y(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function v(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function m(t,e,r){return e&&v(t.prototype,e),r&&v(t,r),t}function b(t,e){return!e||"object"!==h(e)&&"function"!==typeof e?g(t):e}function g(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function k(t){return k=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},k(t)}function x(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&w(t,e)}function w(t,e){return w=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},w(t,e)}var O=function(t){function e(){return y(this,e),b(this,k(e).apply(this,arguments))}return x(e,t),m(e,[{key:"dragStart",value:function(t){if(this.disabled)return!1;this.$emit("drag-start")}},{key:"render",value:function(){var t=arguments[0];return t("div",{ref:"dot",class:this.dotClasses,on:{mousedown:this.dragStart,touchstart:this.dragStart}},[this.$slots.dot||t("div",{class:this.handleClasses,style:this.dotStyle}),"none"!==this.tooltip?t("div",{class:this.tooltipClasses},[this.$slots.tooltip||t("div",{class:this.tooltipInnerClasses,style:this.tooltipStyle},[t("span",{class:"vue-slider-dot-tooltip-text"},[this.tooltipValue])])]):null])}},{key:"dotClasses",get:function(){return["vue-slider-dot",{"vue-slider-dot-disabled":this.disabled,"vue-slider-dot-focus":this.focus}]}},{key:"handleClasses",get:function(){return["vue-slider-dot-handle",{"vue-slider-dot-handle-disabled":this.disabled,"vue-slider-dot-handle-focus":this.focus}]}},{key:"tooltipClasses",get:function(){return["vue-slider-dot-tooltip",["vue-slider-dot-tooltip-".concat(this.tooltipPlacement)],{"vue-slider-dot-tooltip-show":this.showTooltip}]}},{key:"tooltipInnerClasses",get:function(){return["vue-slider-dot-tooltip-inner",["vue-slider-dot-tooltip-inner-".concat(this.tooltipPlacement)],{"vue-slider-dot-tooltip-inner-disabled":this.disabled,"vue-slider-dot-tooltip-inner-focus":this.focus}]}},{key:"showTooltip",get:function(){switch(this.tooltip){case"always":return!0;case"none":return!1;case"focus":return!!this.focus;default:return!1}}},{key:"tooltipValue",get:function(){return this.tooltipFormatter?"string"===typeof this.tooltipFormatter?this.tooltipFormatter.replace(/\{value\}/,String(this.value)):this.tooltipFormatter(this.value):this.value}}]),e}(s.a);o([f({default:0})],O.prototype,"value",void 0),o([f()],O.prototype,"tooltip",void 0),o([f()],O.prototype,"dotStyle",void 0),o([f()],O.prototype,"tooltipStyle",void 0),o([f({type:String,validator:function(t){return["top","right","bottom","left"].indexOf(t)>-1},required:!0})],O.prototype,"tooltipPlacement",void 0),o([f({type:[String,Function]})],O.prototype,"tooltipFormatter",void 0),o([f({type:Boolean,default:!1})],O.prototype,"focus",void 0),o([f({default:!1})],O.prototype,"disabled",void 0),O=o([u.a],O);var P=O;r("556c");function S(t){return S="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},S(t)}function E(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function R(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function D(t,e,r){return e&&R(t.prototype,e),r&&R(t,r),t}function A(t,e){return!e||"object"!==S(e)&&"function"!==typeof e?j(t):e}function j(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function _(t){return _=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},_(t)}function V(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&M(t,e)}function M(t,e){return M=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},M(t,e)}var C=function(t){function e(){return E(this,e),A(this,_(e).apply(this,arguments))}return V(e,t),D(e,[{key:"labelClickHandle",value:function(t){t.stopPropagation(),this.$emit("pressLabel",this.mark.pos)}},{key:"render",value:function(){var t=arguments[0],e=this.mark;return t("div",{class:this.marksClasses},[this.$slots.step||t("div",{class:this.stepClasses,style:[this.stepStyle,e.style,e.active?this.stepActiveStyle:null,e.active?e.activeStyle:null]}),this.hideLabel?null:this.$slots.label||t("div",{class:this.labelClasses,style:[this.labelStyle,e.labelStyle,e.active?this.labelActiveStyle:null,e.active?e.labelActiveStyle:null],on:{click:this.labelClickHandle}},[e.label])])}},{key:"marksClasses",get:function(){return["vue-slider-mark",{"vue-slider-mark-active":this.mark.active}]}},{key:"stepClasses",get:function(){return["vue-slider-mark-step",{"vue-slider-mark-step-active":this.mark.active}]}},{key:"labelClasses",get:function(){return["vue-slider-mark-label",{"vue-slider-mark-label-active":this.mark.active}]}}]),e}(s.a);o([f({required:!0})],C.prototype,"mark",void 0),o([f(Boolean)],C.prototype,"hideLabel",void 0),o([f()],C.prototype,"stepStyle",void 0),o([f()],C.prototype,"stepActiveStyle",void 0),o([f()],C.prototype,"labelStyle",void 0),o([f()],C.prototype,"labelActiveStyle",void 0),C=o([u.a],C);var N,T=C,I=function(t){return"number"===typeof t?"".concat(t,"px"):t},L=function(t){var e=document.documentElement,r=document.body,n=t.getBoundingClientRect(),o={y:n.top+(window.pageYOffset||e.scrollTop)-(e.clientTop||r.clientTop||0),x:n.left+(window.pageXOffset||e.scrollLeft)-(e.clientLeft||r.clientLeft||0)};return o},B=function(t,e,r){var n=t instanceof MouseEvent?t:t.targetTouches[0],o=L(e),i={x:n.pageX-o.x,y:n.pageY-o.y};return{x:r?e.offsetWidth-i.x:i.x,y:r?e.offsetHeight-i.y:i.y}};(function(t){t[t["PAGE_UP"]=33]="PAGE_UP",t[t["PAGE_DOWN"]=34]="PAGE_DOWN",t[t["END"]=35]="END",t[t["HOME"]=36]="HOME",t[t["LEFT"]=37]="LEFT",t[t["UP"]=38]="UP",t[t["RIGHT"]=39]="RIGHT",t[t["DOWN"]=40]="DOWN"})(N||(N={}));var z=function(t,e){switch(t.keyCode){case N.UP:return function(t){return"ttb"===e.direction?t-1:t+1};case N.RIGHT:return function(t){return"rtl"===e.direction?t-1:t+1};case N.DOWN:return function(t){return"ttb"===e.direction?t+1:t-1};case N.LEFT:return function(t){return"rtl"===e.direction?t+1:t-1};case N.END:return function(){return e.max};case N.HOME:return function(){return e.min};case N.PAGE_UP:return function(t){return t+10};case N.PAGE_DOWN:return function(t){return t-10};default:return null}};function H(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function U(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function F(t,e,r){return e&&U(t.prototype,e),r&&U(t,r),t}var $,W,G=function(){function t(e){H(this,t),this.num=e}return F(t,[{key:"decimal",value:function(t,e){var r=this.num,n=this.getDecimalLen(r),o=this.getDecimalLen(t),i=0;switch(e){case"+":i=this.getExponent(n,o),this.num=(this.safeRoundUp(r,i)+this.safeRoundUp(t,i))/i;break;case"-":i=this.getExponent(n,o),this.num=(this.safeRoundUp(r,i)-this.safeRoundUp(t,i))/i;break;case"*":this.num=this.safeRoundUp(this.safeRoundUp(r,this.getExponent(n)),this.safeRoundUp(t,this.getExponent(o)))/this.getExponent(n+o);break;case"/":i=this.getExponent(n,o),this.num=this.safeRoundUp(r,i)/this.safeRoundUp(t,i);break;case"%":i=this.getExponent(n,o),this.num=this.safeRoundUp(r,i)%this.safeRoundUp(t,i)/i;break}return this}},{key:"plus",value:function(t){return this.decimal(t,"+")}},{key:"minus",value:function(t){return this.decimal(t,"-")}},{key:"multiply",value:function(t){return this.decimal(t,"*")}},{key:"divide",value:function(t){return this.decimal(t,"/")}},{key:"remainder",value:function(t){return this.decimal(t,"%")}},{key:"toNumber",value:function(){return this.num}},{key:"getDecimalLen",value:function(t){return("".concat(t).split(".")[1]||"").length}},{key:"getExponent",value:function(t,e){return Math.pow(10,void 0!==e?Math.max(t,e):t)}},{key:"safeRoundUp",value:function(t,e){return Math.round(t*e)}}]),t}();function X(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},n=Object.keys(r);"function"===typeof Object.getOwnPropertySymbols&&(n=n.concat(Object.getOwnPropertySymbols(r).filter(function(t){return Object.getOwnPropertyDescriptor(r,t).enumerable}))),n.forEach(function(e){it(t,e,r[e])})}return t}function K(t,e){return J(t)||q(t,e)||Y()}function Y(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}function q(t,e){var r=[],n=!0,o=!1,i=void 0;try{for(var s,a=t[Symbol.iterator]();!(n=(s=a.next()).done);n=!0)if(r.push(s.value),e&&r.length===e)break}catch(u){o=!0,i=u}finally{try{n||null==a["return"]||a["return"]()}finally{if(o)throw i}}return r}function J(t){if(Array.isArray(t))return t}function Q(t){return et(t)||tt(t)||Z()}function Z(){throw new TypeError("Invalid attempt to spread non-iterable instance")}function tt(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}function et(t){if(Array.isArray(t)){for(var e=0,r=new Array(t.length);e<t.length;e++)r[e]=t[e];return r}}function rt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function nt(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function ot(t,e,r){return e&&nt(t.prototype,e),r&&nt(t,r),t}function it(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}(function(t){t[t["VALUE"]=1]="VALUE",t[t["INTERVAL"]=2]="INTERVAL",t[t["MIN"]=3]="MIN",t[t["MAX"]=4]="MAX",t[t["ORDER"]=5]="ORDER"})(W||(W={}));var st=($={},it($,W.VALUE,'The type of the "value" is illegal'),it($,W.INTERVAL,'The prop "interval" is invalid, "(max - min)" cannot be divisible by "interval"'),it($,W.MIN,'The "value" cannot be less than the minimum.'),it($,W.MAX,'The "value" cannot be greater than the maximum.'),it($,W.ORDER,'When "order" is false, the parameters "minRange", "maxRange", "fixed", "enabled" are invalid.'),$),at=function(){function t(e){rt(this,t),this.dotsPos=[],this.dotsValue=[],this.data=e.data,this.max=e.max,this.min=e.min,this.interval=e.interval,this.order=e.order,this.marks=e.marks,this.included=e.included,this.process=e.process,this.adsorb=e.adsorb,this.dotOptions=e.dotOptions,this.onError=e.onError,this.order?(this.minRange=e.minRange||0,this.maxRange=e.maxRange||0,this.enableCross=e.enableCross,this.fixed=e.fixed):((e.minRange||e.maxRange||!e.enableCross||e.fixed)&&this.emitError(W.ORDER),this.minRange=0,this.maxRange=0,this.enableCross=!0,this.fixed=!1),this.setValue(e.value)}return ot(t,[{key:"setValue",value:function(t){this.setDotsValue(Array.isArray(t)?Q(t):[t],!0)}},{key:"setDotsValue",value:function(t,e){var r=this;if(this.included&&this.markList.length>0){var n=function(t){var e=t,n=r.max-r.min;return r.markList.forEach(function(r){if("number"===typeof r.value&&"number"===typeof t){var o=Math.abs(r.value-t);o<n&&(n=o,e=r.value)}}),e};t=t.map(function(t){return n(t)})}this.dotsValue=t,e&&this.syncDotsPos()}},{key:"setDotsPos",value:function(t){var e=this,r=this.order?Q(t).sort(function(t,e){return t-e}):t;this.dotsPos=r,this.setDotsValue(r.map(function(t){return e.parsePos(t)}),this.adsorb)}},{key:"syncDotsPos",value:function(){var t=this;this.dotsPos=this.dotsValue.map(function(e){return t.parseValue(e)})}},{key:"getRecentDot",value:function(t){var e=this.dotsPos.map(function(e){return Math.abs(e-t)});return e.indexOf(Math.min.apply(Math,Q(e)))}},{key:"getIndexByValue",value:function(t){return this.data?this.data.indexOf(t):new G(+t).minus(this.min).divide(this.interval).toNumber()}},{key:"getValueByIndex",value:function(t){return t<0?t=0:t>this.total&&(t=this.total),this.data?this.data[t]:new G(t).multiply(this.interval).plus(this.min).toNumber()}},{key:"setDotPos",value:function(t,e){t=this.getValidPos(t,e).pos;var r=t-this.dotsPos[e];if(r){var n=new Array(this.dotsPos.length);this.fixed?n=this.getFixedChangePosArr(r,e):this.minRange||this.maxRange?n=this.getLimitRangeChangePosArr(t,r,e):n[e]=r,this.setDotsPos(this.dotsPos.map(function(t,e){return t+(n[e]||0)}))}}},{key:"getFixedChangePosArr",value:function(t,e){var r=this;return this.dotsPos.forEach(function(n,o){if(o!==e){var i=r.getValidPos(n+t,o),s=i.pos,a=i.inRange;a||(t=Math.min(Math.abs(s-n),Math.abs(t))*(t<0?-1:1))}}),this.dotsPos.map(function(e){return t})}},{key:"getLimitRangeChangePosArr",value:function(t,e,r){var n=this,o=[{index:r,changePos:e}],i=e;return[this.minRange,this.maxRange].forEach(function(s,a){if(!s)return!1;var u=0===a,l=e>0,c=0;c=u?l?1:-1:l?-1:1;var d=function(t,e){var r=Math.abs(t-e);return u?r<n.minRangeDir:r>n.maxRangeDir},f=r+c,p=n.dotsPos[f],h=t;while(n.isPos(p)&&d(p,h)){var y=n.getValidPos(p+i,f),v=y.pos;o.push({index:f,changePos:v-p}),f+=c,h=v,p=n.dotsPos[f]}}),this.dotsPos.map(function(t,e){var r=o.filter(function(t){return t.index===e});return r.length?r[0].changePos:0})}},{key:"isPos",value:function(t){return"number"===typeof t}},{key:"getValidPos",value:function(t,e){var r=this.valuePosRange[e],n=!0;return t<r[0]?(t=r[0],n=!1):t>r[1]&&(t=r[1],n=!1),{pos:t,inRange:n}}},{key:"parseValue",value:function(t){if(this.data)t=this.data.indexOf(t);else if("number"===typeof t||"string"===typeof t){if(t=+t,t<this.min)return this.emitError(W.MIN),0;if(t>this.max)return this.emitError(W.MAX),0;if("number"!==typeof t||t!==t)return this.emitError(W.VALUE),0;t=new G(t).minus(this.min).divide(this.interval).toNumber()}var e=new G(t).multiply(this.gap).toNumber();return e<0?0:e>100?100:e}},{key:"parsePos",value:function(t){var e=Math.round(t/this.gap);return this.getValueByIndex(e)}},{key:"isActiveByPos",value:function(t){return this.processArray.some(function(e){var r=K(e,2),n=r[0],o=r[1];return t>=n&&t<=o})}},{key:"getValues",value:function(){var t=this;return this.data?this.data:Array.from(new Array(this.total),function(e,r){return new G(r).multiply(t.interval).plus(t.min).toNumber()}).concat([this.max])}},{key:"emitError",value:function(t){this.onError&&this.onError(t,st[t])}},{key:"getDotRange",value:function(t,e,r){if(!this.dotOptions)return r;var n=Array.isArray(this.dotOptions)?this.dotOptions[t]:this.dotOptions;return n&&void 0!==n[e]?this.parseValue(n[e]):r}},{key:"markList",get:function(){var t=this;if(!this.marks)return[];var e=function(e,r){var n=t.parseValue(e);return X({pos:n,value:"string"===typeof e?parseFloat(e):e,label:e,active:t.isActiveByPos(n)},r)};return!0===this.marks?this.getValues().map(function(t){return e(t)}):"[object Object]"===Object.prototype.toString.call(this.marks)?Object.keys(this.marks).sort(function(t,e){return+t-+e}).map(function(r){var n=t.marks[r];return e(r,"string"!==typeof n?n:{label:n})}):Array.isArray(this.marks)?this.marks.map(function(t){return e(t)}):"function"===typeof this.marks?this.getValues().map(function(e){return{value:e,result:t.marks(e)}}).filter(function(t){var e=t.result;return!!e}).map(function(t){var r=t.value,n=t.result;return e(r,n)}):[]}},{key:"processArray",get:function(){if(this.process){if("function"===typeof this.process)return this.process(this.dotsPos);if(1===this.dotsPos.length)return[[0,this.dotsPos[0]]];if(this.dotsPos.length>1)return[[Math.min.apply(Math,Q(this.dotsPos)),Math.max.apply(Math,Q(this.dotsPos))]]}return[]}},{key:"total",get:function(){var t=0;return t=this.data?this.data.length-1:new G(this.max).minus(this.min).divide(this.interval).toNumber(),t-Math.floor(t)!==0?(this.emitError(W.INTERVAL),0):t}},{key:"gap",get:function(){return 100/this.total}},{key:"minRangeDir",get:function(){return this.minRange?this.minRange*this.gap:0}},{key:"maxRangeDir",get:function(){return this.maxRange?this.maxRange*this.gap:100}},{key:"valuePosRange",get:function(){var t=this,e=this.dotsPos,r=[];return e.forEach(function(n,o){r.push([Math.max(t.minRange?t.minRangeDir*o:0,t.enableCross?0:e[o-1]||0,t.getDotRange(o,"min",0)),Math.min(t.minRange?100-t.minRangeDir*(e.length-1-o):100,t.enableCross?100:e[o+1]||100,t.getDotRange(o,"max",100))])}),r}},{key:"dotsIndex",get:function(){var t=this;return this.dotsValue.map(function(e){return t.getIndexByValue(e)})}}]),t}();function ut(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function lt(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function ct(t,e,r){return e&&lt(t.prototype,e),r&&lt(t,r),t}var dt=function(){function t(e){ut(this,t),this.states=0,this.map=e}return ct(t,[{key:"add",value:function(t){this.states|=t}},{key:"delete",value:function(t){this.states&=~t}},{key:"toggle",value:function(t){this.has(t)?this.delete(t):this.add(t)}},{key:"has",value:function(t){return!!(this.states&t)}}]),t}();r("4abb");function ft(t){return ft="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},ft(t)}function pt(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},n=Object.keys(r);"function"===typeof Object.getOwnPropertySymbols&&(n=n.concat(Object.getOwnPropertySymbols(r).filter(function(t){return Object.getOwnPropertyDescriptor(r,t).enumerable}))),n.forEach(function(e){bt(t,e,r[e])})}return t}function ht(t,e){return mt(t)||vt(t,e)||yt()}function yt(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}function vt(t,e){var r=[],n=!0,o=!1,i=void 0;try{for(var s,a=t[Symbol.iterator]();!(n=(s=a.next()).done);n=!0)if(r.push(s.value),e&&r.length===e)break}catch(u){o=!0,i=u}finally{try{n||null==a["return"]||a["return"]()}finally{if(o)throw i}}return r}function mt(t){if(Array.isArray(t))return t}function bt(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function gt(t){return wt(t)||xt(t)||kt()}function kt(){throw new TypeError("Invalid attempt to spread non-iterable instance")}function xt(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}function wt(t){if(Array.isArray(t)){for(var e=0,r=new Array(t.length);e<t.length;e++)r[e]=t[e];return r}}function Ot(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function Pt(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function St(t,e,r){return e&&Pt(t.prototype,e),r&&Pt(t,r),t}function Et(t,e){return!e||"object"!==ft(e)&&"function"!==typeof e?Rt(t):e}function Rt(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function Dt(t){return Dt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},Dt(t)}function At(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&jt(t,e)}function jt(t,e){return jt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},jt(t,e)}var _t={None:0,Drag:1,Focus:2},Vt=4,Mt=function(t){function e(){var t;return Ot(this,e),t=Et(this,Dt(e).apply(this,arguments)),t.states=new dt(_t),t.scale=1,t.focusDotIndex=0,t}return At(e,t),St(e,[{key:"onValueChanged",value:function(){!this.states.has(_t.Drag)&&this.isNotSync&&this.control.setValue(this.value)}},{key:"created",value:function(){this.initControl()}},{key:"mounted",value:function(){this.bindEvent()}},{key:"beforeDestroy",value:function(){this.unbindEvent()}},{key:"bindEvent",value:function(){document.addEventListener("touchmove",this.dragMove,{passive:!1}),document.addEventListener("touchend",this.dragEnd,{passive:!1}),document.addEventListener("mousedown",this.blurHandle),document.addEventListener("mousemove",this.dragMove),document.addEventListener("mouseup",this.dragEnd),document.addEventListener("mouseleave",this.dragEnd),document.addEventListener("keydown",this.keydownHandle)}},{key:"unbindEvent",value:function(){document.removeEventListener("touchmove",this.dragMove),document.removeEventListener("touchend",this.dragEnd),document.removeEventListener("mousemove",this.dragMove),document.removeEventListener("mouseup",this.dragEnd),document.removeEventListener("mouseleave",this.dragEnd),document.removeEventListener("keydown",this.keydownHandle)}},{key:"setScale",value:function(){this.scale=new G(Math.floor(this.isHorizontal?this.$el.offsetWidth:this.$el.offsetHeight)).divide(100).toNumber()}},{key:"initControl",value:function(){var t=this;this.control=new at({value:this.value,data:this.data,enableCross:this.enableCross,fixed:this.fixed,max:this.max,min:this.min,interval:this.interval,minRange:this.minRange,maxRange:this.maxRange,order:this.order,marks:this.marks,included:this.included,process:this.process,adsorb:this.adsorb,dotOptions:this.dotOptions,onError:this.emitError}),["data","enableCross","fixed","max","min","interval","minRange","maxRange","order","marks","process","adsorb","included","dotOptions"].forEach(function(e){t.$watch(e,function(r){if("data"===e&&Array.isArray(t.control.data)&&Array.isArray(r)&&t.control.data.length===r.length&&r.every(function(e,r){return e===t.control.data[r]}))return!1;t.control[e]=r,["data","max","min","interval"].indexOf(e)>-1&&t.control.syncDotsPos()})})}},{key:"isDisabledByDotIndex",value:function(t){return this.dots[t].disabled}},{key:"syncValueByPos",value:function(){var t=this.control.dotsValue;this.isDiff(t,Array.isArray(this.value)?this.value:[this.value])&&this.$emit("change",1===t.length?t[0]:gt(t))}},{key:"isDiff",value:function(t,e){return t.length!==e.length||t.some(function(t,r){return t!==e[r]})}},{key:"emitError",value:function(t,e){this.silent||console.error("[VueSlider error]: ".concat(e)),this.$emit("error",t,e)}},{key:"dragStart",value:function(t){this.focusDotIndex=t,this.setScale(),this.states.add(_t.Drag),this.states.add(_t.Focus),this.$emit("drag-start")}},{key:"dragMove",value:function(t){if(!this.states.has(_t.Drag))return!1;t.preventDefault();var e=this.getPosByEvent(t);this.isCrossDot(e),this.control.setDotPos(e,this.focusDotIndex),this.lazy||this.syncValueByPos();var r=this.control.dotsValue;this.$emit("dragging",1===r.length?r[0]:gt(r))}},{key:"isCrossDot",value:function(t){if(this.canSort){var e=this.focusDotIndex,r=t;r>this.dragRange[1]?(r=this.dragRange[1],this.focusDotIndex++):r<this.dragRange[0]&&(r=this.dragRange[0],this.focusDotIndex--),e!==this.focusDotIndex&&this.control.setDotPos(r,e)}}},{key:"dragEnd",value:function(){var t=this;if(!this.states.has(_t.Drag))return!1;this.lazy&&this.syncValueByPos(),setTimeout(function(){t.included&&t.isNotSync?t.control.setValue(t.value):t.control.syncDotsPos(),t.states.delete(_t.Drag),t.useKeyboard||t.states.delete(_t.Focus),t.$emit("drag-end")})}},{key:"blurHandle",value:function(t){if(!this.states.has(_t.Focus)||!this.$refs.container||this.$refs.container.contains(t.target))return!1;this.states.delete(_t.Focus)}},{key:"clickHandle",value:function(t){if(!this.clickable)return!1;if(!this.states.has(_t.Drag)){this.setScale();var e=this.getPosByEvent(t);this.setValueByPos(e)}}},{key:"focus",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;this.states.add(_t.Focus),this.focusDotIndex=t}},{key:"blur",value:function(){this.states.delete(_t.Focus)}},{key:"getValue",value:function(){var t=this.control.dotsValue;return 1===t.length?t[0]:t}},{key:"getIndex",value:function(){var t=this.control.dotsIndex;return 1===t.length?t[0]:t}},{key:"setValue",value:function(t){this.control.setValue(Array.isArray(t)?gt(t):[t]),this.syncValueByPos()}},{key:"setIndex",value:function(t){var e=this,r=Array.isArray(t)?t.map(function(t){return e.control.getValueByIndex(t)}):this.control.getValueByIndex(t);this.setValue(r)}},{key:"setValueByPos",value:function(t){var e=this,r=this.control.getRecentDot(t);if(this.isDisabledByDotIndex(r))return!1;this.focusDotIndex=r,this.control.setDotPos(t,r),this.syncValueByPos(),this.useKeyboard&&this.states.add(_t.Focus),setTimeout(function(){e.included&&e.isNotSync?e.control.setValue(e.value):e.control.syncDotsPos()})}},{key:"keydownHandle",value:function(t){if(!this.useKeyboard||!this.states.has(_t.Focus))return!1;var e=z(t,{direction:this.direction,max:this.control.total,min:0});if(e){t.preventDefault();var r=this.control.getIndexByValue(this.control.dotsValue[this.focusDotIndex]),n=e(r),o=this.control.parseValue(this.control.getValueByIndex(n));this.isCrossDot(o),this.control.setDotPos(o,this.focusDotIndex),this.syncValueByPos()}}},{key:"getPosByEvent",value:function(t){return B(t,this.$el,this.isReverse)[this.isHorizontal?"x":"y"]/this.scale}},{key:"renderSlot",value:function(t,e,r,n){var o=this.$createElement,i=this.$scopedSlots[t];return i?n?i(e):o("template",{slot:t},[i(e)]):r}},{key:"render",value:function(){var t=this,e=arguments[0];return e("div",{ref:"container",class:this.containerClasses,style:this.containerStyles,attrs:{"aria-hidden":!0},on:{click:this.clickHandle}},[e("div",{class:"vue-slider-rail",style:this.railStyle},[this.processArray.map(function(r,n){return t.renderSlot("process",r,e("div",{class:"vue-slider-process",key:"process-".concat(n),style:r.style}),!0)}),this.marks?e("div",{class:"vue-slider-marks"},[this.control.markList.map(function(r,n){var o;return t.renderSlot("mark",r,e("vue-slider-mark",{key:"mark-".concat(n),attrs:{mark:r,hideLabel:t.hideLabel,stepStyle:t.stepStyle,stepActiveStyle:t.stepActiveStyle,labelStyle:t.labelStyle,labelActiveStyle:t.labelActiveStyle},style:(o={},bt(o,t.isHorizontal?"height":"width","100%"),bt(o,t.isHorizontal?"width":"height",t.tailSize),bt(o,t.mainDirection,"".concat(r.pos,"%")),o),on:{pressLabel:function(e){return t.setValueByPos(e)}}},[t.renderSlot("step",r,null),t.renderSlot("label",r,null)]),!0)})]):null,this.dots.map(function(r,n){var o;return e("vue-slider-dot",{ref:"dot-".concat(n),key:"dot-".concat(n),attrs:{value:r.value,disabled:r.disabled,focus:r.focus,"dot-style":[r.style,r.disabled?r.disabledStyle:null,r.focus?r.focusStyle:null],tooltip:r.tooltip||t.tooltip,"tooltip-style":[t.tooltipStyle,r.tooltipStyle,r.disabled?r.tooltipDisabledStyle:null,r.focus?r.tooltipFocusStyle:null],"tooltip-formatter":t.tooltipFormatter,"tooltip-placement":t.tooltipDirections[n]},style:[t.dotBaseStyle,(o={},bt(o,t.mainDirection,"".concat(r.pos,"%")),bt(o,"transition","".concat(t.mainDirection," ").concat(t.animateTime,"s")),o)],on:{"drag-start":function(){return t.dragStart(n)}}},[t.renderSlot("dot",r,null),t.renderSlot("tooltip",r,null)])})]),1!==this.dots.length||this.data?null:e("input",{class:"vue-slider-sr-only",attrs:{type:"range",min:this.min,max:this.max},domProps:{value:this.value}})])}},{key:"tailSize",get:function(){return I((this.isHorizontal?this.height:this.width)||Vt)}},{key:"containerClasses",get:function(){return["vue-slider",["vue-slider-".concat(this.direction)],{"vue-slider-disabled":this.disabled}]}},{key:"containerStyles",get:function(){var t=Array.isArray(this.dotSize)?this.dotSize:[this.dotSize,this.dotSize],e=ht(t,2),r=e[0],n=e[1],o=this.width?I(this.width):this.isHorizontal?"auto":I(Vt),i=this.height?I(this.height):this.isHorizontal?I(Vt):"auto";return{padding:this.contained?"".concat(n/2,"px ").concat(r/2,"px"):this.isHorizontal?"".concat(n/2,"px 0"):"0 ".concat(r/2,"px"),width:o,height:i}}},{key:"processArray",get:function(){var t=this;return this.control.processArray.map(function(e){var r,n=ht(e,3),o=n[0],i=n[1],s=n[2];if(o>i){var a=[i,o];o=a[0],i=a[1]}var u=t.isHorizontal?"width":"height";return{start:o,end:i,style:pt((r={},bt(r,t.isHorizontal?"height":"width","100%"),bt(r,t.isHorizontal?"top":"left",0),bt(r,t.mainDirection,"".concat(o,"%")),bt(r,u,"".concat(i-o,"%")),bt(r,"transitionProperty","".concat(u,",").concat(t.mainDirection)),bt(r,"transitionDuration","".concat(t.animateTime,"s")),r),t.processStyle,s)}})}},{key:"dotBaseStyle",get:function(){var t,e=Array.isArray(this.dotSize)?this.dotSize:[this.dotSize,this.dotSize],r=ht(e,2),n=r[0],o=r[1];return t=this.isHorizontal?bt({transform:"translate(".concat(this.isReverse?"50%":"-50%",", -50%)"),WebkitTransform:"translate(".concat(this.isReverse?"50%":"-50%",", -50%)"),top:"50%"},"ltr"===this.direction?"left":"right","0"):bt({transform:"translate(-50%, ".concat(this.isReverse?"50%":"-50%",")"),WebkitTransform:"translate(-50%, ".concat(this.isReverse?"50%":"-50%",")"),left:"50%"},"btt"===this.direction?"bottom":"top","0"),pt({width:"".concat(n,"px"),height:"".concat(o,"px")},t)}},{key:"mainDirection",get:function(){switch(this.direction){case"ltr":return"left";case"rtl":return"right";case"btt":return"bottom";case"ttb":return"top"}}},{key:"isHorizontal",get:function(){return"ltr"===this.direction||"rtl"===this.direction}},{key:"isReverse",get:function(){return"rtl"===this.direction||"btt"===this.direction}},{key:"tooltipDirections",get:function(){var t=this.tooltipPlacement||(this.isHorizontal?"top":"left");return Array.isArray(t)?t:Array.from(new Array(this.dots.length),function(){return t})}},{key:"dots",get:function(){var t=this;return this.control.dotsPos.map(function(e,r){return pt({pos:e,index:r,value:t.control.dotsValue[r],focus:t.states.has(_t.Focus)&&t.focusDotIndex===r,disabled:!1,style:t.dotStyle},(Array.isArray(t.dotOptions)?t.dotOptions[r]:t.dotOptions)||{})})}},{key:"animateTime",get:function(){return this.states.has(_t.Drag)?0:this.duration}},{key:"canSort",get:function(){return this.order&&!this.minRange&&!this.maxRange&&!this.fixed&&this.enableCross}},{key:"isNotSync",get:function(){var t=this.control.dotsValue;return Array.isArray(this.value)?this.value.length!==t.length||this.value.some(function(e,r){return e!==t[r]}):this.value!==t[0]}},{key:"dragRange",get:function(){var t=this.dots[this.focusDotIndex-1],e=this.dots[this.focusDotIndex+1];return[t?t.pos:-1/0,e?e.pos:1/0]}}]),e}(s.a);o([d("change",{default:0})],Mt.prototype,"value",void 0),o([f({type:Boolean,default:!1})],Mt.prototype,"silent",void 0),o([f({default:"ltr",validator:function(t){return["ltr","rtl","ttb","btt"].indexOf(t)>-1}})],Mt.prototype,"direction",void 0),o([f({type:[Number,String]})],Mt.prototype,"width",void 0),o([f({type:[Number,String]})],Mt.prototype,"height",void 0),o([f({default:14})],Mt.prototype,"dotSize",void 0),o([f({default:!1})],Mt.prototype,"contained",void 0),o([f({type:Number,default:0})],Mt.prototype,"min",void 0),o([f({type:Number,default:100})],Mt.prototype,"max",void 0),o([f({type:Number,default:1})],Mt.prototype,"interval",void 0),o([f({type:Boolean,default:!1})],Mt.prototype,"disabled",void 0),o([f({type:Boolean,default:!0})],Mt.prototype,"clickable",void 0),o([f({type:Number,default:.5})],Mt.prototype,"duration",void 0),o([f(Array)],Mt.prototype,"data",void 0),o([f({type:Boolean,default:!1})],Mt.prototype,"lazy",void 0),o([f({type:String,validator:function(t){return["none","always","focus"].indexOf(t)>-1},default:"focus"})],Mt.prototype,"tooltip",void 0),o([f({type:[String,Array],validator:function(t){return(Array.isArray(t)?t:[t]).every(function(t){return["top","right","bottom","left"].indexOf(t)>-1})}})],Mt.prototype,"tooltipPlacement",void 0),o([f({type:[String,Function]})],Mt.prototype,"tooltipFormatter",void 0),o([f({type:Boolean,default:!1})],Mt.prototype,"useKeyboard",void 0),o([f({type:Boolean,default:!0})],Mt.prototype,"enableCross",void 0),o([f({type:Boolean,default:!1})],Mt.prototype,"fixed",void 0),o([f({type:Boolean,default:!0})],Mt.prototype,"order",void 0),o([f(Number)],Mt.prototype,"minRange",void 0),o([f(Number)],Mt.prototype,"maxRange",void 0),o([f({type:[Boolean,Object,Array,Function],default:!1})],Mt.prototype,"marks",void 0),o([f({type:[Boolean,Function],default:!0})],Mt.prototype,"process",void 0),o([f(Boolean)],Mt.prototype,"included",void 0),o([f(Boolean)],Mt.prototype,"adsorb",void 0),o([f(Boolean)],Mt.prototype,"hideLabel",void 0),o([f()],Mt.prototype,"dotOptions",void 0),o([f()],Mt.prototype,"railStyle",void 0),o([f()],Mt.prototype,"processStyle",void 0),o([f()],Mt.prototype,"dotStyle",void 0),o([f()],Mt.prototype,"tooltipStyle",void 0),o([f()],Mt.prototype,"stepStyle",void 0),o([f()],Mt.prototype,"stepActiveStyle",void 0),o([f()],Mt.prototype,"labelStyle",void 0),o([f()],Mt.prototype,"labelActiveStyle",void 0),o([p("value")],Mt.prototype,"onValueChanged",null),Mt=o([u()({data:function(){return{control:null}},components:{VueSliderDot:P,VueSliderMark:T},inheritAttrs:!1})],Mt);var Ct=Mt,Nt=Ct;r.d(e,"ERROR_TYPE",function(){return W});e["default"]=Nt}})["default"]});
//# sourceMappingURL=vue-slider-component.umd.min.js.map

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);
var bind = __webpack_require__(118);
var Axios = __webpack_require__(336);
var defaults = __webpack_require__(53);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(122);
axios.CancelToken = __webpack_require__(350);
axios.isCancel = __webpack_require__(121);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(351);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(53);
var utils = __webpack_require__(2);
var InterceptorManager = __webpack_require__(345);
var dispatchRequest = __webpack_require__(346);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(120);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);
var transformData = __webpack_require__(347);
var isCancel = __webpack_require__(121);
var defaults = __webpack_require__(53);
var isAbsoluteURL = __webpack_require__(348);
var combineURLs = __webpack_require__(349);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(122);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.properties)?_c('div',{staticClass:"asw-poll"},[_c('transition',{attrs:{"appear":"appear","name":"fade","mode":"out-in"}},[_c('div',{key:_vm.properties.Elect_div,staticClass:"asw-poll_inner"},[(!_vm.votedCookie)?_c('div',{staticClass:"asw-poll-question"},[_vm._v(_vm._s(_vm.pollQuestion))]):_c('div',{staticClass:"asw-poll-question_answered"},[_vm._v(_vm._s(_vm.pollQuestionAnswered))]),_c('div',{staticClass:"asw-poll_title"},[_vm._v(_vm._s(_vm.properties.Elect_div)+", "+_vm._s(_vm.properties.electorate_state)+" ?")]),(!_vm.votedCookie)?_c('div',{staticClass:"asw-poll_question"},[_c('div',{staticClass:"asw-poll_question_hint"},[_vm._v(_vm._s(_vm.sliderHelp))]),_c('div',{staticClass:"asw-poll_slider",class:_vm.pollValue},[_c('vue-slider',{attrs:{"data":_vm.sliderData,"marks":true,"process":false},model:{value:(_vm.pollValue),callback:function ($$v) {_vm.pollValue=$$v},expression:"pollValue"}})],1),_c('div',{staticClass:"asw-poll_submit button",on:{"click":_vm.submitClick}},[_vm._v(_vm._s('submit'))])]):_vm._e(),(_vm.votedCookie && _vm.results)?_c('div',{staticClass:"asw-poll_result"},[(_vm.chart_poll_total > 0)?_c('div',{staticClass:"asw-poll_result_chart"},[_c('svg',{staticClass:"asw-poll_result_chart_svg",attrs:{"width":_vm.chart_poll.width,"height":_vm.chart_poll.height}},[_c('g',{staticClass:"poll_svg_g",attrs:{"transform":_vm.chart_poll_transform}},_vm._l((_vm.chart_poll_paths),function(item){return _c('g',{staticClass:"arc"},[_c('path',{style:({ fill: item.fill }),attrs:{"d":item.d}}),(item.data.value > 0)?_c('g',{staticClass:"arcText"},[_c('text',{style:({ fill: item.fill, 'text-anchor': 'middle' }),attrs:{"transform":item.pieTexttransform,"x":"0","y":"0"}},[_c('tspan',{staticClass:"value",attrs:{"x":"0","dy":"1.2em"}},[_vm._v(_vm._s(item.data.value)+"% ")]),_c('tspan',{staticClass:"name",attrs:{"x":"0","dy":"1.2em"}},[_vm._v(_vm._s(item.data.name))])]),(item.data.value > 9)?_c('image',{staticClass:"icon",attrs:{"transform":item.pieTexttransform,"width":"45","height":"45","x":"30","y":"-2","href":item.b64icon}}):_vm._e()]):_vm._e()])}))])]):_vm._e(),(_vm.chart_poll_total === 0)?_c('div',{staticClass:"asw-poll_result_novotes"},[_vm._v(_vm._s(_vm.pollNoResults))]):_vm._e()]):_vm._e(),_c('div',{staticClass:"asw-poll_close button",on:{"click":_vm.closeClick}},[_vm._v(_vm._s('close')+"\t")])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AusChart_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7652f094_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_AusChart_vue__ = __webpack_require__(356);
function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AusChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7652f094_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_AusChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_shape_src_arc__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape_src_pie__ = __webpack_require__(116);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: "auschart",
	props: {
		results: {
			type: Object,
			required: true
		},
		emojiData: {
			type: Object,
			required: true
		}
	},
	data: function data() {
		return {
			chart_aus: {
				width: 160,
				height: 160
			}
		};
	},
	computed: {
		ausPollResult: function ausPollResult() {
			return this.results.regions.overall;
		},
		pie: function pie() {
			return Object(__WEBPACK_IMPORTED_MODULE_2_d3_shape_src_pie__["a" /* default */])().sort(null).value(function (d) {
				return d.value;
			});
		},
		chart_aus_transform: function chart_aus_transform() {
			return "translate(" + this.chart_aus.width / 2 + "," + this.chart_aus.height / 2 + ")";
			//return "translate(" + this.chart_aus.width + "," + this.chart_aus.height + ")";
		},
		chart_aus_data: function chart_aus_data() {
			var total = this.ausPollResult.total;

			return [{ name: 'furious', value: this.percentify(this.ausPollResult.items.furious, total) }, { name: 'depressed', value: this.percentify(this.ausPollResult.items.depressed, total) }, { name: 'worried', value: this.percentify(this.ausPollResult.items.worried, total) }, { name: 'meh', value: this.percentify(this.ausPollResult.items.meh, total) }, { name: 'happy', value: this.percentify(this.ausPollResult.items.happy, total) }, { name: 'stoked', value: this.percentify(this.ausPollResult.items.stoked, total) }];
		},
		chart_aus_paths: function chart_aus_paths() {
			var _this = this;

			var radius = Math.min(this.chart_aus.width, this.chart_aus.height) / 2,
			    arc = Object(__WEBPACK_IMPORTED_MODULE_1_d3_shape_src_arc__["a" /* default */])().outerRadius(radius - 10).innerRadius(radius - 30),
			    pieData = this.pie(this.chart_aus_data);

			return pieData.map(function (d) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, d, {
					d: arc(d),
					fill: _this.emojiColorFn(d.data.name), // color(d.data.value)
					pieTexttransform: _this.pietext_transform(arc.centroid(d), d)

				});
			});
		}
	},
	mounted: function mounted() {
		//console.log('That',this);
	},

	methods: {
		emojiColorFn: function emojiColorFn(name) {
			return this.emojiData[name].color;
		},
		percentify: function percentify(count, total) {
			return Math.round(count / total * 100);
		},
		pietext_transform: function pietext_transform(arcCentroid, d) {

			var dangle = (d.endAngle + d.startAngle) / 2;

			if (dangle > 0 && dangle <= 1.0) {
				arcCentroid[0] *= 2.0;
				arcCentroid[1] *= 2.0;
			} else if (dangle > 1 && dangle <= 1.8) {
				arcCentroid[0] *= 1.8;
				arcCentroid[1] *= 2.0;
			} else if (dangle > 1.8 && dangle <= 3) {
				arcCentroid[0] *= 2.0;
				arcCentroid[1] *= 1.2;
			} else if (dangle > 3 && dangle <= 4.2) {
				arcCentroid[0] *= 2.0;
				arcCentroid[1] *= 1.1;
			} else if (dangle > 4.2 && dangle <= 5.4) {
				arcCentroid[0] *= 1.8;
				arcCentroid[1] *= 3.1;
			} else {
				arcCentroid[0] *= 2.0;
				arcCentroid[1] *= 2.0;
			}

			return "translate(" + arcCentroid + ")";
		}
	}
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.results)?_c('div',{staticClass:"asw-auschart"},[_c('transition',{attrs:{"appear":"appear","name":"fade","mode":"out-in"}},[_c('div',{staticClass:"asw-auschart_chart"},[_c('svg',{staticClass:"asw-sentiment_svg",attrs:{"width":_vm.chart_aus.width,"height":_vm.chart_aus.height}},[_c('g',{staticClass:"asw-sentiment_svg_g",attrs:{"transform":_vm.chart_aus_transform}},[_vm._l((_vm.chart_aus_paths),function(item){return _c('g',{staticClass:"arc"},[_c('path',{style:({ fill: item.fill }),attrs:{"d":item.d}}),_c('g',{staticClass:"arcText"},[_c('text',{style:({ fill: item.fill, 'text-anchor': 'middle' }),attrs:{"transform":item.pieTexttransform,"x":"0","y":"0"}},[_c('tspan',{staticClass:"value",attrs:{"x":"0","dy":"1.2em"}},[_vm._v(_vm._s(item.data.value)+"% ")]),_c('tspan',{staticClass:"name",attrs:{"x":"0","dy":"1.2em"}},[_vm._v(_vm._s(item.data.name))])])])])}),_c('text',{staticClass:"title",attrs:{"x":"0","y":"-1.2em"}},[_c('tspan',{staticClass:"aus",style:({ 'text-anchor': 'middle' }),attrs:{"x":"0","dy":"1.2em"}},[_vm._v(_vm._s('Australia'))]),_c('tspan',{staticClass:"feels",style:({ 'text-anchor': 'middle' }),attrs:{"x":"0","dy":"1.2em"}},[_vm._v(_vm._s('feels'))])])],2)])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HexHover_vue__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f98c605_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_HexHover_vue__ = __webpack_require__(360);
function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HexHover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f98c605_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_HexHover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: "hexhover",
	props: {
		hexHoverData: {
			type: Object
		}
	},
	data: function data() {
		return {};
	},
	computed: {
		properties: function properties() {
			return this.hexHoverData.properties;
		}
	},
	mounted: function mounted() {
		// console.log('Hover',this);
	},

	methods: {}
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.properties)?_c('div',{staticClass:"asw-hexhover"},[_c('div',{staticClass:"asw-hexhover-electorate"},[_vm._v(_vm._s(_vm.properties.Elect_div)+", "+_vm._s(_vm.properties.electorate_state))]),_c('div',{staticClass:"asw-hexhover-locations"},[_vm._v(_vm._s('Localities include')+" "+_vm._s(_vm.properties.electorate_locations))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295ad4d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(364);
function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295ad4d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "asw-search",
	props: {
		electorates: {
			type: Array
		}
	},
	data: function data() {
		return {
			searchValue: null,
			// showDropdown: false,
			focused: false,
			placeholderText: "Search for your electorate."
		};
	},
	computed: {
		searchResults: function searchResults() {
			var _this = this;

			return this.electorates.filter(function (_ref) {
				var properties = _ref.properties;
				return properties.Elect_div.toLowerCase().match(_this.searchValue.toLowerCase());
			});
			//.filter( ({ properties }) => properties.region_name.toLowerCase().match(this.searchValue.toLowerCase()))
		},
		noMatches: function noMatches() {
			return !this.searchResults.length;
		},
		showDropdown: function showDropdown() {
			return this.focused;
		},
		placeholder: function placeholder() {
			return this.focused ? '' : this.placeholderText;
		},
		searchInputTrackingData: function searchInputTrackingData() {
			return {
				events: 'event10',
				site: window.utag ? window.utag.data.net_site : null,
				section: window.utag ? window.utag.data.net_sec2 : null,
				container: 'federal-election-2019',
				label: 'emoji-sentiment-map',
				order: '1',
				contenttype: window.utag ? window.utag.data.net_content_type : null,
				pagename: window.utag ? window.utag.data.net_pn : null
			};
		}
	},
	methods: {
		resultClick: function resultClick(result) {
			this.$emit('searchResultClick', result);
		},
		inputBlur: function inputBlur() {
			var _this2 = this;

			setTimeout(function () {
				_this2.focused = false;
			}, 100);
		},
		focusHandler: function focusHandler() {
			this.inputClick();
			this.trackingData();
		},
		inputClick: function inputClick() {
			this.focused = true;
		},
		trackingData: function trackingData() {

			if (window.utag) {
				var metric = 'ev';

				if (this.searchInputTrackingData) {
					this.sendAnalytics(metric, {
						events: [this.searchInputTrackingData.events],
						itm: {
							site: this.searchInputTrackingData.site,
							section: this.searchInputTrackingData.section,
							container: this.searchInputTrackingData.container,
							label: this.searchInputTrackingData.label,
							order: this.searchInputTrackingData.order,
							pagename: this.searchInputTrackingData.pagename,
							contenttype: this.searchInputTrackingData.contenttype
						}
					});
				}
			}
		},
		sendAnalytics: function sendAnalytics(metricType, metricObj) {
			//console.log('metricType', metricType);
			//console.log('metricObj', metricObj);

			if (typeof metricType === 'undefined') {
				return;
			}

			window.mready = window.mready || [];
			window.mready.push(function (metrics) {
				metrics[metricType](metricObj);
				//console.log('sentiment metrics pushed');
			});
		}
	}
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asw-results_search",class:{ 'search-active': _vm.searchValue }},[_c('div',{staticClass:"asw-results_search_main"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchValue),expression:"searchValue"}],staticClass:"asw-results_search_input",attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.searchValue)},on:{"blur":_vm.inputBlur,"focus":_vm.focusHandler,"input":function($event){if($event.target.composing){ return; }_vm.searchValue=$event.target.value}}}),_c('transition',{attrs:{"appear":"appear","name":"fade"}},[(_vm.searchValue && _vm.focused)?_c('div',{key:_vm.focused,staticClass:"asw-results_search_results"},[_vm._l((_vm.searchResults),function(electorate){return _c('div',{staticClass:"asw-results_search_result",on:{"click":function($event){_vm.resultClick(electorate)}}},[_vm._v(_vm._s(electorate.properties.Elect_div))])}),(_vm.noMatches)?_c('div',{staticClass:"asw-results_search_error"},[_vm._v("No Results for:"),_c('em',[_vm._v(_vm._s(_vm.searchValue))])]):_vm._e()],2):_vm._e()])],1),_c('transition',{attrs:{"appear":"appear","name":"fade"}},[(_vm.searchValue)?_c('button',{staticClass:"tge-button all-results_filter_button",attrs:{"searchValue":_vm.searchValue},on:{"click":function($event){_vm.searchValue = null}}},[_c('div',{staticClass:"tge-button_wrapper"},[_c('span',{staticClass:"tge-button_text"},[_vm._v("Clear")]),_c('div',{staticClass:"tge-button_icon"},[_c('span',{staticClass:"tge-svg-icon tge-svg-icon_close",attrs:{"data-no-canvas":"false"}},[_c('canvas',{attrs:{"width":"24","height":"24"}}),_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',[_vm._v("nav_large_close")]),_c('g',{attrs:{"fill":"#232323","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M2.69 23L1 21.309 21.31 1 23 2.69 2.69 23"}}),_c('path',{attrs:{"d":"M21.31 23L1 2.69 2.69 1 23 21.309 21.31 23"}})])])])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asw-map",class:{ 'poll-visible': _vm.pollData }},[_c('div',{staticClass:"asw-map_container"},[_c('Search',{attrs:{"electorates":_vm.features.electorates},on:{"searchResultClick":_vm.searchClick}}),_c('div',{staticClass:"asw-map_find"},[_c('a',{staticClass:"asw-map_find_link",attrs:{"href":"https://electorate.aec.gov.au/","target":"_blank"}},[_c('span',[_vm._v(_vm._s("Don't know your electorate?"))]),_c('span',{staticClass:"tge-svg-icon tge-svg-icon_offnet-link",attrs:{"data-no-canvas":"false"}},[_c('canvas',{attrs:{"width":"25","height":"24"}}),_c('svg',{attrs:{"width":"25","height":"24","viewBox":"0 0 25 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',[_vm._v("info_external_link")]),_c('path',{attrs:{"d":"M24 0h-9.32v2.638h4.824L9.354 12.831l1.863 1.866 10.148-10.19v4.88H24V0zm-6.237 16.725v3.966H3.305V6.21h3.981l3.233-3.31H0V24h21.067V13.362l-3.304 3.363z","fill":"#222","fill-rule":"evenodd"}})])])])]),_c('div',{staticClass:"asw-map_tools"},[_c('div',{staticClass:"asw-map_tool reset",on:{"click":_vm.resetZoom}},[_c('span',{staticClass:"tge-svg-icon tge-svg-icon_refresh",attrs:{"data-no-canvas":"false"}},[_c('canvas',{attrs:{"width":"25","height":"24"}}),_c('svg',{attrs:{"width":"25","height":"24","viewBox":"0 0 25 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',[_vm._v("info_refresh")]),_c('path',{attrs:{"d":"M12.652.087c-3.814 0-7.22 1.466-9.426 4.303L.586 1.747v7.535l7.51-.005L5.418 6.59C7.079 4.315 9.704 3.05 12.653 3.05c5.012 0 9.09 4.04 9.09 9.07s-4.079 8.966-9.09 8.966c-4.832 0-8.789-3.82-9.066-8.947l-.018-.324-2.946-.003.013.283C.912 18.8 6.192 23.897 12.652 23.897c6.638 0 12.038-5.242 12.038-11.906 0-6.663-5.4-11.904-12.038-11.904","fill":"#000","fill-rule":"evenodd"}})])])])]),[_c('div',{staticClass:"map-item"},[_c('svg',{staticClass:"map-item_svg",class:{  filtered: this.filters.party, responsive: _vm.responsive },attrs:{"width":_vm.displayWidth,"height":_vm.displayHeight},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.resetZoom($event)}}},[_c('rect',{staticClass:"background",attrs:{"width":_vm.displayWidth,"height":_vm.displayHeight},on:{"click":function($event){_vm.resetZoom($event)}}}),(_vm.topojson)?_c('g',{staticClass:"features"},[_c('g',{attrs:{"id":"boundaries"}},[_vm._l((_vm.features.boundaries),function(feature,i){return [_c('path',{staticClass:"boundary",style:({ fill: feature.fill/*, opacity: boundaryStyles.opacity, display: boundaryStyles.display*/ }),attrs:{"district-id":feature.properties.id,"district-name":feature.properties.Elect_div,"d":feature.path},on:{"click":function($event){_vm.onClicked(feature, $event)}}})]})],2),_c('g',{attrs:{"id":"electorates"}},_vm._l((_vm.features.electorates),function(feature,i){return _c('path',{staticClass:"electorate",style:({ fill: feature.fill }),attrs:{"electorate-name":feature.properties.Elect_div,"electorate-locations":feature.properties.electorate_locations,"electorate-state":feature.properties.electorate_state,"electorate-id":feature.properties.fid,"d":feature.path,"active":feature.properties.Elect_div === _vm.selectedID},on:{"click":function($event){_vm.countyclicked(feature, $event)},"mouseover":function($event){_vm.hexHovered(feature, $event)},"mouseleave":_vm.hexHoverOut}})})),_c('g',{attrs:{"id":"capitals"}},[_vm._l((_vm.features.capitals),function(feature,i){return [_c('path',{staticClass:"capital",style:({ fill: feature.fill/*, opacity: capitalStyles.opacity, display: capitalStyles.display*/ }),attrs:{"district-id":feature.properties.id,"district-name":feature.properties.Elect_div,"d":feature.path},on:{"click":function($event){_vm.onClicked(feature, $event)}}})]})],2)]):_vm._e()])])],(_vm.pollData)?_c('Poll',{attrs:{"pollData":_vm.pollData,"emojiData":_vm.emojiData,"environ":_vm.environ,"resultDate":_vm.resultDate},on:{"close":_vm.pollClose}}):_vm._e(),(_vm.results && _vm.auschart)?_c('AusChart',{attrs:{"emojiData":_vm.emojiData,"results":_vm.results}}):_vm._e(),(_vm.hexHoverData)?_c('HexHover',{style:({ left: _vm.tooltipStyles.left, top: _vm.tooltipStyles.top }),attrs:{"hexHoverData":_vm.hexHoverData}}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiLegend_vue__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf52b5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_EmojiLegend_vue__ = __webpack_require__(369);
function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiLegend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf52b5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_jade_node_modules_vue_loader_lib_selector_type_template_index_0_EmojiLegend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import d3arc from "d3-shape/src/arc";

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "asw-legend",
	props: {
		emojiData: {
			type: Object
		}
	},
	data: function data() {
		return {};
	},
	computed: {},
	mounted: function mounted() {},

	methods: {}
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"appear","name":"fade"}},[_c('div',{staticClass:"asw-legend"},[_c('div',{staticClass:"bar"},[_c('span',{class:['plus','stoked']},[_vm._v("+")]),_c('span',{class:['minus','furious']},[_vm._v("-")]),_c('div',{staticClass:"colorBar"})]),_c('div',{staticClass:"icons"},_vm._l((this.emojiData),function(emoji,i){return _c('div',{staticClass:"icon",class:emoji.title},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(emoji.title))]),(emoji.title === 'furious' )?_c('div',{staticClass:"iconImg"},[_c('img',{attrs:{"src":__webpack_require__(370)}})]):_vm._e(),(emoji.title === 'depressed' )?_c('div',{staticClass:"iconImg"},[_c('img',{attrs:{"src":__webpack_require__(371)}})]):_vm._e(),(emoji.title === 'worried' )?_c('div',{staticClass:"iconImg"},[_c('img',{attrs:{"src":__webpack_require__(372)}})]):_vm._e(),(emoji.title === 'meh' )?_c('div',{staticClass:"iconImg"},[_c('img',{attrs:{"src":__webpack_require__(373)}})]):_vm._e(),(emoji.title === 'happy' )?_c('div',{staticClass:"iconImg"},[_c('img',{attrs:{"src":__webpack_require__(374)}})]):_vm._e(),(emoji.title === 'stoked' )?_c('div',{staticClass:"iconImg"},[_c('img',{attrs:{"src":__webpack_require__(375)}})]):_vm._e()])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMGgxMTR2MTE0SDB6Ii8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cGF0aCBkPSJNMTE2IDU5YzAgMzAuOTI3LTI1LjA3MiA1Ni01NiA1Ni0zMC45MjcgMC01Ni0yNS4wNzMtNTYtNTZDNCAyOC4wNzEgMjkuMDczIDMgNjAgM2MzMC45MjggMCA1NiAyNS4wNzIgNTYgNTYiIGZpbGw9IiM0QUE4MEYiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiPgogICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjYSIvPgogICAgICA8L21hc2s+CiAgICAgIDxwYXRoIGQ9Ik01NyAyLjMyNkMyNi44NTIgMi4zMjYgMi4zMjYgMjYuODUyIDIuMzI2IDU3YzAgMzAuMTQ5IDI0LjUyNiA1NC42NzUgNTQuNjc0IDU0LjY3NXM1NC42NzQtMjQuNTI2IDU0LjY3NC01NC42NzVjMC0zMC4xNDctMjQuNTI2LTU0LjY3My01NC42NzQtNTQuNjczTTU3IDExNEMyNS41NyAxMTQgMCA4OC40MjggMCA1NyAwIDI1LjU3IDI1LjU3IDAgNTcgMHM1NyAyNS41NyA1NyA1N2MwIDMxLjQyOC0yNS41NyA1Ny01NyA1NyIgZmlsbD0iIzMzMyIgbWFzaz0idXJsKCNiKSIvPgogICAgPC9nPgogICAgPHBhdGggZD0iTTM2IDQwYTUgNSAwIDEgMS0xMCAwIDUgNSAwIDAgMSAxMCAwTTk0IDQwYTUgNSAwIDEgMS0xMCAwIDUgNSAwIDAgMSAxMCAwIiBmaWxsPSIjRjI2MDcxIi8+CiAgICA8cGF0aCBkPSJNNDQgMzFhMyAzIDAgMSAxLTUuOTk5LjAwMUEzIDMgMCAwIDEgNDQgMzFNODEgMzFhMyAzIDAgMSAxLTYgMCAzIDMgMCAwIDEgNiAwTTgxLjI1MiA1NC41MzNjLjU5Ni4yMzEuODk4LjkxOC42NzQgMS41MzMtLjIyOC42MTUtLjg5LjkyNy0xLjQ4NS42OTQtNy4xNjctMi43ODItMTUuMjA3LTEuMjkzLTIwLjk4MSAzLjg4Ny01Ljc3NSA1LjE4MS04LjMyMSAxMy4xOS02LjY0OSAyMC45MDMuMTQuNjQxLS4yNSAxLjI3Ny0uODczIDEuNDIxLS42Mi4xNDMtMS4yMzgtLjI2MS0xLjM3Ni0uOTAyLTEuODYtOC41NjYuOTcxLTE3LjQ2MyA3LjM4NS0yMy4yMTcgNi40MTQtNS43NTUgMTUuMzQ0LTcuNDEgMjMuMzA1LTQuMzE5eiIgZmlsbD0iIzMzMyIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMGgxMTR2MTE0SDB6Ii8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cGF0aCBkPSJNNjAgNjFjLTguNzE3IDAtMTYuNzEtNC43MDQtMjAuODU4LTEyLjI3N2ExLjE2IDEuMTYgMCAwIDEgLjQ3OC0xLjU4MiAxLjE5MSAxLjE5MSAwIDAgMSAxLjYwMi40NzJjMy43MzYgNi44MTcgMTAuOTMgMTEuMDU0IDE4Ljc3OSAxMS4wNTRzMTUuMDQzLTQuMjM3IDE4Ljc3Ny0xMS4wNTRhMS4xOSAxLjE5IDAgMCAxIDEuNjAyLS40NzIgMS4xNiAxLjE2IDAgMCAxIC40NzggMS41ODJDNzYuNzEgNTYuMjk2IDY4LjcxOCA2MSA2MCA2MSIgZmlsbD0iIzMzMyIvPgogICAgPHBhdGggZD0iTTExNiA1OWMwIDMwLjkyOC0yNS4wNzIgNTYtNTYgNTZTNCA4OS45MjggNCA1OSAyOS4wNzIgMyA2MCAzczU2IDI1LjA3MiA1NiA1NiIgZmlsbD0iIzAwODM4RCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgIDxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHBhdGggZD0iTTU3IDIuMzI2Yy0zMC4xNDggMC01NC42NzMgMjQuNTI3LTU0LjY3MyA1NC42NzUgMCAzMC4xNDcgMjQuNTI1IDU0LjY3MyA1NC42NzMgNTQuNjczIDMwLjE0OCAwIDU0LjY3NC0yNC41MjYgNTQuNjc0LTU0LjY3MyAwLTMwLjE0OC0yNC41MjYtNTQuNjc1LTU0LjY3NC01NC42NzVNNTcgMTE0QzI1LjU3IDExNCAwIDg4LjQzIDAgNTcgMCAyNS41NzIgMjUuNTcgMCA1NyAwczU3IDI1LjU3MSA1NyA1N2MwIDMxLjQzLTI1LjU3IDU3LTU3IDU3IiBmaWxsPSIjMzMzIiBtYXNrPSJ1cmwoI2IpIi8+CiAgICA8L2c+CiAgICA8cGF0aCBkPSJNMzYgNDBhNS4wMDEgNS4wMDEgMCAxIDEtMTAuMDAyLS4wMDEgNS4wMDEgNS4wMDEgMCAwIDEgMTAuMDAyIDBNOTQgNDBhNS4wMDEgNS4wMDEgMCAwIDEtMTAgMCA1IDUgMCAwIDEgMTAgMCIgZmlsbD0iI0YyNjA3MSIvPgogICAgPHBhdGggZD0iTTQ0IDI5YTMgMyAwIDEgMS01Ljk5OS4wMDFBMyAzIDAgMCAxIDQ0IDI5TTgxIDI5YTMgMyAwIDEgMS02IDAgMyAzIDAgMCAxIDYgMCIgZmlsbD0iIzMzMyIvPgogICAgPHBhdGggZD0iTTY5IDUyLjU5NmgyOS42OTFNMzIuOTUgMjUuNTk2aDU0LjI0NyIgc3Ryb2tlPSIjMzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asw-results",class:{ 'asw-fullscreen': _vm.fullscreen }},[(_vm.title)?_c('div',{staticClass:"asw-map_title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.results)?_c('MapSVG',{attrs:{"geodata":_vm.geodata,"results":_vm.results,"fullscreen":_vm.fullscreen,"emojiData":_vm.emojiData,"environ":_vm.environ,"resultDate":_vm.resultDate},on:{"fullscreen":_vm.onFullscreen,"closeElecPoll":_vm.closeElecPoll}}):_c('LoadingOverlay'),_c('EmojiLegend',{attrs:{"emojiData":_vm.emojiData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/app.js